export type Lang = "es" | "en";

export const translations = {
  adminCheckoutGuard: {
    title: { es: "Modo administrador: sin pagos", en: "Admin mode: no payments" },
    body: { es: "Estás viendo el panel como otro plan. Los botones de pago no abren Stripe en tu cuenta de administrador.", en: "You're previewing another plan. Payment buttons don't open Stripe on your admin account." },
  },
  grantAdmin: {
    subtitle: { es: "Todo en un sitio: ayudas, a quién encajan, encargos, cobros y ofertas.", en: "All in one place: grants, who they fit, orders, payments and offers." },
    tabCatalog: { es: "Catálogo", en: "Catalogue" },
    tabRadar: { es: "Avisos y boletín", en: "Notices and newsletter" },
    tabOrders: { es: "Expedientes y cobros", en: "Cases and payments" },
    tabPricing: { es: "Tarifas y ofertas", en: "Fees and offers" },
    search: { es: "Buscar por código, título, organismo…", en: "Search by code, title, body…" },
    allSectors: { es: "Todos los sectores", en: "All sectors" },
    allRegions: { es: "Todas las comunidades", en: "All regions" },
    allStates: { es: "Todos los estados", en: "All statuses" },
    visAll: { es: "Visibles y ocultas", en: "Visible and hidden" },
    visOn: { es: "Solo visibles", en: "Visible only" },
    visOff: { es: "Solo ocultas", en: "Hidden only" },
    withRequests: { es: "Con encargos o interesados", en: "With orders or interest" },
    clear: { es: "Quitar filtros", en: "Clear filters" },
    count: { es: "{n} ayudas", en: "{n} grants" },
    expandAll: { es: "Expandir todas", en: "Expand all" },
    collapseAll: { es: "Contraer todas", en: "Collapse all" },
    updateGrants: { es: "Actualizar subvenciones", en: "Update grants" },
    importTitle: { es: "Actualizar subvenciones desde Excel", en: "Update grants from Excel" },
    catalogTitle: { es: "Catálogo de subvenciones", en: "Grant catalogue" },
    showPer: { es: "Mostrar", en: "Show" },
    showAll: { es: "Todas", en: "All" },
    showMore: { es: "Mostrar {n} más", en: "Show {n} more" },
    showingOf: { es: "Viendo {a} de {b}", en: "Showing {a} of {b}" },
    sortBy: { es: "Ordenar", en: "Sort" },
    visible: { es: "Visible", en: "Visible" },
    isNew: { es: "Nueva", en: "New" },
    highPriority: { es: "Prioridad alta", en: "High priority" },
    orders: { es: "{n} encargos", en: "{n} orders" },
    interested: { es: "{n} interesados", en: "{n} interested" },
    fits: { es: "{n} clientes encajan", en: "{n} clients fit" },
    claim: { es: "Frase pública", en: "Public line" },
    claimPh: { es: "Ej.: Hasta 12.000 € para digitalizar tu tienda de barrio.", en: "E.g.: Up to €12,000 to digitalise your local shop." },
    notes: { es: "Notas del mentor (solo Club Pro)", en: "Mentor notes (Club Pro only)" },
    category: { es: "Categoría", en: "Category" },
    sectors: { es: "Sectores (separados por coma)", en: "Sectors (comma separated)" },
    link: { es: "Enlace oficial", en: "Official link" },
    openLink: { es: "Abrir sede oficial", en: "Open official site" },
    prepMode: { es: "Tramitación en esta ayuda", en: "Preparation for this grant" },
    prepGlobal: { es: "Según la oferta general", en: "Follow the general offer" },
    prepOff: { es: "No ofrecer tramitación", en: "Don't offer preparation" },
    save: { es: "Guardar", en: "Save" },
    saved: { es: "Guardado", en: "Saved" },
    error: { es: "No se ha podido guardar", en: "Could not save" },
    loading: { es: "Cargando…", en: "Loading…" },
    docs: { es: "Documentos de la convocatoria", en: "Call documents" },
    docsHint: { es: "Bases, modelos oficiales, guías… Quedan guardados para enviarlos cuando haga falta (PDF, Word, Excel o imagen, máx. 20 MB).", en: "Rules, official forms, guides… Stored so you can send them whenever needed (PDF, Word, Excel or image, max 20 MB)." },
    docsEmpty: { es: "Aún no hay documentos.", en: "No documents yet." },
    upload: { es: "Subir documento", en: "Upload document" },
    uploadError: { es: "No se ha podido subir el archivo.", en: "Could not upload the file." },
    remove: { es: "Quitar", en: "Remove" },
    extra: { es: "Datos extra del Excel", en: "Extra Excel data" },
    radarTitle: { es: "Radar de novedades", en: "What's new radar" },
    radarHint: { es: "Ayudas nuevas o recién importadas y cuántos clientes encajan por sector y comunidad. Tú decides a quién avisar.", en: "New or freshly imported grants and how many clients fit by sector and region. You decide who to notify." },
    radarEmpty: { es: "No hay novedades en los últimos 15 días.", en: "Nothing new in the last 15 days." },
    showAllOpen: { es: "Ver también todas las abiertas", en: "Also show all open grants" },
    notify: { es: "Avisar a quien encaja", en: "Notify who fits" },
    remind: { es: "Recordar a interesados", en: "Remind interested" },
    lastNotice: { es: "Último aviso: {date} · {n} personas", en: "Last notice: {date} · {n} people" },
    noAudience: { es: "Nadie encaja todavía", en: "Nobody fits yet" },
    pick: { es: "Incluir en el boletín", en: "Include in newsletter" },
    newsletterTitle: { es: "Boletín de subvenciones", en: "Grants newsletter" },
    newsletterHint: { es: "Crea un borrador en Campañas con las ayudas marcadas y la oferta del mes. Nada se envía hasta que tú lo decidas allí. Por correo solo llega a quien se ha suscrito al boletín; para llegar a todos los registrados usa el aviso en el panel.", en: "Creates a draft in Campaigns with the selected grants and this month's offer. Nothing is sent until you decide there. Email only reaches newsletter subscribers; to reach every registered user use the in-panel notice." },
    newsletterCreate: { es: "Crear borrador ({n})", en: "Create draft ({n})" },
    newsletterDone: { es: "Borrador creado en Emails › Campañas", en: "Draft created in Emails › Campaigns" },
    broadcast: { es: "Avisar a todos los registrados", en: "Notify every registered user" },
    dialogNotify: { es: "Aviso en el panel", en: "In-panel notice" },
    dialogHint: { es: "Les llega a la campanita de su panel. Quita a quien no quieras avisar.", en: "It reaches their panel bell. Untick anyone you don't want to notify." },
    noticeTitle: { es: "Título", en: "Title" },
    noticeBody: { es: "Mensaje", en: "Message" },
    send: { es: "Enviar aviso a {n}", en: "Send notice to {n}" },
    sent: { es: "Aviso enviado a {n} personas", en: "Notice sent to {n} people" },
    noSector: { es: "sin sector", en: "no sector" },
    ordersTotal: { es: "Encargos", en: "Orders" },
    ordersPaid: { es: "Altas cobradas", en: "Paid starts" },
    ordersPromo: { es: "Altas a 0 €", en: "€0 starts" },
    ordersActive: { es: "En trámite", en: "In progress" },
    ordersDue: { es: "Pendiente de cobro", en: "Awaiting payment" },
    ordersCollected: { es: "Cobrado en total", en: "Collected in total" },
    pricingTitle: { es: "Oferta de tramitación", en: "Preparation offer" },
    pricingHint: { es: "Lo que ve el cliente al pulsar «Preparar subvención». Cada encargo guarda las condiciones con las que se firmó: cambiar la oferta no toca lo ya contratado.", en: "What clients see when they tap «Prepare grant». Each order keeps the terms it was signed with: changing the offer never touches existing orders." },
    modeStandard: { es: "Alta + porcentaje", en: "Start fee + percentage" },
    modeStandardHint: { es: "Se paga al empezar y un % si se concede.", en: "Paid at the start plus a % if awarded." },
    modeSuccess: { es: "Solo a éxito (alta 0 €)", en: "Success only (€0 start)" },
    modeSuccessHint: { es: "Promoción: no pagan nada hasta que se la conceden.", en: "Promo: nothing to pay until it's awarded." },
    modeFixed: { es: "Precio cerrado", en: "Fixed price" },
    modeFixedHint: { es: "Un único pago, sin porcentaje.", en: "One payment, no percentage." },
    modeOff: { es: "Sin tramitación", en: "No preparation" },
    modeOffHint: { es: "Las ayudas quedan solo como información.", en: "Grants stay as information only." },
    upfront: { es: "Alta (€)", en: "Start fee (€)" },
    percent: { es: "Porcentaje si se concede (%)", en: "Percentage if awarded (%)" },
    minTotal: { es: "Total mínimo si se concede menos de 2.000 € (€)", en: "Minimum total if under €2,000 is awarded (€)" },
    fixed: { es: "Precio cerrado (€)", en: "Fixed price (€)" },
    promoEs: { es: "Etiqueta de oferta (español)", en: "Offer tag (Spanish)" },
    promoEn: { es: "Etiqueta de oferta (inglés)", en: "Offer tag (English)" },
    promoPh: { es: "Ej.: Noviembre: alta gratis, solo cobramos si te la conceden", en: "E.g.: November: free start, we only charge if awarded" },
    preview: { es: "Así lo verá el cliente", en: "What the client will see" },
    savePricing: { es: "Guardar oferta", en: "Save offer" },
    readOnly: { es: "Modo solo lectura: puedes revisar pero no cambiar.", en: "Read-only mode: you can review but not change." },
  },

  grantImport: {
    title: { es: "Actualizar desde Excel", en: "Update from Excel" },
    subtitle: { es: "Sin IA y sin gastar créditos: se lee tal cual, se compara y tú decides.", en: "No AI, no credits: read as-is, compared, and you decide." },
    drop: { es: "Arrastra aquí el Excel del monitor o pulsa para elegirlo", en: "Drop the monitor Excel here or click to choose it" },
    onlyXlsx: { es: "Solo archivos .xlsx", en: ".xlsx files only" },
    reading: { es: "Leyendo el Excel…", en: "Reading the Excel…" },
    noHeader: { es: "No encuentro la fila de cabeceras con el nombre de la convocatoria.", en: "Can't find a header row with the grant name." },
    readError: { es: "No he podido leer el archivo.", en: "Couldn't read the file." },
    sheetInfo: { es: "Hoja «{sheet}», cabeceras en la fila {row}, {count} ayudas", en: "Sheet “{sheet}”, headers on row {row}, {count} grants" },
    columns: { es: "Columnas detectadas", en: "Detected columns" },
    newColumnsTitle: { es: "Columnas nuevas", en: "New columns" },
    newColumnsHelp: { es: "Se guardan como datos complementarios de cada ayuda; no se pierde nada.", en: "Saved as extra data on each grant; nothing is lost." },
    ignored: { es: "ignorada", en: "ignored" },
    extra: { es: "dato extra", en: "extra data" },
    countNew: { es: "Nuevas", en: "New" },
    countUpdate: { es: "Con cambios", en: "Changed" },
    countSame: { es: "Sin cambios", en: "Unchanged" },
    skipped: { es: "{n} filas sin nombre de convocatoria se ignoran", en: "{n} rows without a grant name are skipped" },
    protected: { es: "Las celdas vacías no borran nada, y la frase pública, los requisitos y la visibilidad no se tocan.", en: "Empty cells never erase anything, and the public claim, requirements and visibility stay untouched." },
    showDetails: { es: "Ver cambios", en: "See changes" },
    before: { es: "Antes", en: "Before" },
    after: { es: "Ahora", en: "Now" },
    empty: { es: "(vacío)", en: "(empty)" },
    cancel: { es: "Cancelar", en: "Cancel" },
    apply: { es: "Confirmar y aplicar {n} cambios", en: "Confirm and apply {n} changes" },
    nothing: { es: "Todo está ya al día", en: "Everything is already up to date" },
    applying: { es: "Guardando…", en: "Saving…" },
    applied: { es: "Monitor actualizado: {n} ayudas guardadas", en: "Monitor updated: {n} grants saved" },
    verify: { es: "Comprobar subida", en: "Check upload" },
    verifyOk: { es: "Todo cuadra: {ok} de {total} ayudas son idénticas al Excel", en: "All good: {ok} of {total} grants match the Excel" },
    verifyBad: { es: "{n} diferencias encontradas", en: "{n} differences found" },
    verifyMissing: { es: "No encontradas: {list}", en: "Not found: {list}" },
    expected: { es: "Excel", en: "Excel" },
    actual: { es: "Guardado", en: "Saved" },
    onlyImported: { es: "Ver solo la última importación", en: "Show only last import" },
    lastImport: { es: "Última importación: {file} · {date} · {n} nuevas, {u} con cambios", en: "Last import: {file} · {date} · {n} new, {u} changed" },
    viewEs: { es: "Ver ficha ES", en: "View ES page" },
    viewEn: { es: "Ver ficha EN", en: "View EN page" },
    readOnly: { es: "Modo solo lectura: puedes revisar el Excel pero no aplicarlo.", en: "Read-only mode: you can review the Excel but not apply it." },
  },
  upgradePlans: {
    trigger: { es: "Mejora tu plan", en: "Upgrade your plan" },
    current: { es: "Estás en {plan}", en: "You're on {plan}" },
    preview: { es: " · vista previa", en: " · preview" },
    includes: { es: "Esto incluye", en: "What's included" },
    switchNow: { es: "Cambiar ahora", en: "Switch now" },
    flexible: { es: "Sin permanencia. Cancela cuando quieras.", en: "No commitment. Cancel anytime." },
    month: { es: "{price} €/mes", en: "€{price}/mo" },
    basico: {
      es: ["30 consultas al Agente Retail IA al mes", "Calculadora ilimitada", "Detector exprés ilimitado", "Listado de subvenciones", "Música libre de derechos · 20 min/día"],
      en: ["30 Retail AI Agent queries per month", "Unlimited calculator", "Unlimited express detector", "Grants directory", "Royalty-free music · 20 min/day"],
    },
    club_pro: {
      es: ["60 consultas al Agente Retail IA al mes", "Subvenciones filtradas para tu negocio", "KPIs con histórico", "Hoja de ruta", "Música libre de derechos ilimitada"],
      en: ["60 Retail AI Agent queries per month", "Grants filtered for your business", "KPIs with history", "Roadmap", "Unlimited royalty-free music"],
    },
    completo: {
      es: ["100 consultas al Agente Retail IA al mes", "Objetivo del trimestre", "Acceso a Módulos Premium", "Acceso a mentores · Extra", "Extras: tramitación de licencias, consultas a abogados, música comercial y aroma"],
      en: ["100 Retail AI Agent queries per month", "Quarterly goal", "Access to Premium Modules", "Access to mentors · Extra", "Extras: licence processing, lawyer consultations, commercial music and scent"],
    },
  },
  shareLanding: {
    label: { es: "Compártelo", en: "Share it" },
    whatsapp: { es: "Compartir por WhatsApp", en: "Share on WhatsApp" },
    facebook: { es: "Compartir en Facebook", en: "Share on Facebook" },
    copy: { es: "Copiar enlace", en: "Copy link" },
    copied: { es: "Enlace copiado", en: "Link copied" },
    copyError: { es: "No se pudo copiar el enlace", en: "Couldn't copy the link" },
    calcText: { es: "Calcula gratis si tu negocio es rentable", en: "Check for free if your business is profitable" },
    leakText: { es: "Detecta gratis dónde pierde dinero tu negocio", en: "Find out for free where your business is losing money" },
    diagText: { es: "Diagnostica gratis tu local comercial", en: "Get a free diagnosis of your retail premises" },
  },
  introHistory: {
    title: { es: "Tu primera valoración", en: "Your first assessment" },
    nextTitle: { es: "Nueva valoración", en: "New assessment" },
    request: { es: "Pedir otra valoración", en: "Request another assessment" },
    error: { es: "No hemos podido generar y guardar la valoración. Inténtalo de nuevo.", en: "We couldn't generate and save the assessment. Please try again." },
    loadError: { es: "No hemos podido leer tus valoraciones.", en: "We couldn't load your assessments." },
    retry: { es: "Reintentar", en: "Retry" },
  },
  // ── Common ──
  common: {
    loading: { es: "Cargando...", en: "Loading..." },
    save: { es: "Guardar", en: "Save" },
    saving: { es: "Guardando...", en: "Saving..." },
    saved: { es: "Guardado", en: "Saved" },
    cancel: { es: "Cancelar", en: "Cancel" },
    create: { es: "Crear", en: "Create" },
    delete: { es: "Eliminar", en: "Delete" },
    back: { es: "← Volver", en: "← Back" },
    contact: { es: "Contactar", en: "Contact" },
    close: { es: "Cerrar", en: "Close" },
    new: { es: "Nuevo", en: "New" },
  },

  // ── Muro de los artículos Club Pro de Insights ──
  insightsPaywall: {
    badge: { es: "Artículo Club Pro", en: "Club Pro article" },
    notice: {
      es: "Este artículo es exclusivo para\nusuarios del Club Pro.",
      en: "This article is exclusive to\nClub Pro members.",
    },
    reinforce: {
      es: "Únete ahora y sigue leyendo sin límites.",
      en: "Join now and keep reading without limits.",
    },
    cta: { es: "Club Pro · 69 €/mes", en: "Club Pro · €69/month" },
    readArticle: { es: "Leer artículo", en: "Read article" },
  },
  articleCaseCta: {
    label: { es: "Casos Reales", en: "Real Cases" },
    title: {
      es: "Mira cómo otros comercios resolvieron retos como el tuyo",
      en: "See how other businesses solved challenges like yours",
    },
    intro: {
      es: "Descubre casos reales, conoce las soluciones propuestas y sube el tuyo para conseguir",
      en: "Explore real cases, discover the proposed solutions and upload yours for a chance to get",
    },
    highlight: {
      es: "hasta 6 meses de suscripción a Club Pro",
      en: "up to 6 months of Club Pro membership",
    },
    cta: { es: "Ver casos y subir el mío", en: "View cases and upload mine" },
  },

  planComparison: {
    title: { es: "Sin plan frente a Club Pro", en: "No plan versus Club Pro" },
    infoAbout: { es: "Información sobre", en: "Information about" },
    sheetTitle: { es: "Comparar planes", en: "Compare plans" },
    cta: { es: "Club Pro · 69 €/mes", en: "Club Pro · €69/month" },
    footer: {
      es: "Desbloquea todo el potencial para tu {sector}.",
      en: "Unlock the full potential of your {sector}.",
    },
    rows: {
      es: [
        { label: "Detector", lite: "Express", pro: "Completo", help: "Herramienta para analizar rápido por dónde dar impulso al negocio." },
        { label: "Agente Retail IA", lite: "3/mes", pro: "Ilimitado", help: "Consultas de retail para el día a día." },
        { label: "Módulos", lite: "1 de prueba", pro: "Todos + 2 premium", help: "Empiezas por Primeros pasos. En Pro se abren todos los módulos más 2 premium opcionales." },
        { label: "Herramientas", lite: "Básicas", pro: "Avanzadas", help: "Útiles para el día a día." },
        { label: "Subvenciones", lite: "Listado", pro: "Seleccionadas + alertas", help: "Listado general. En Pro, las de tu caso y alertas." },
        { label: "Proveedores", lite: "—", pro: "Acceso", help: "Proveedores con los que trabajamos, según lo que busque el local. Solo Club Pro." },
        { label: "Experto", lite: "—", pro: "Prioritario", help: "Si te bloqueas, puedes pedir la ayuda de un experto." },
        { label: "Casos Reales", lite: "Lectura", pro: "Soluciones guiadas", help: "Casos de otros comercios y cómo se resolvieron." },
      ],
      en: [
        { label: "Detector", lite: "Express", pro: "Full", help: "A tool to quickly spot where to give the business a push." },
        { label: "Retail AI Agent", lite: "3/mo", pro: "Unlimited", help: "Retail questions for the day to day." },
        { label: "Modules", lite: "1 trial", pro: "All + 2 premium", help: "You start with First Steps. Pro opens every module plus 2 optional premium modules." },
        { label: "Tools", lite: "Basic", pro: "Advanced", help: "Handy for the day to day." },
        { label: "Grants", lite: "Listing", pro: "Selected + alerts", help: "General listing. In Pro, the ones for your case plus alerts." },
        { label: "Suppliers", lite: "—", pro: "Access", help: "Suppliers we work with, based on what the shop is looking for. Club Pro only." },
        { label: "Expert", lite: "—", pro: "Priority", help: "If you get stuck, you can ask an expert for help." },
        { label: "Real Cases", lite: "Reading", pro: "Guided solutions", help: "Cases from other retailers and how they were solved." },
      ],
    },
  },

  // ── Header / Nav ──
  header: {
    methodology: { es: "Cómo funciona", en: "How it works" },
    theClub: { es: "El Club", en: "The Club" },
    thePanel: { es: "La Estrategia", en: "The Strategy" },
    agent: { es: "Agente Retail IA", en: "Retail AI Agent" },
    enterPanel: { es: "Entrar al Panel", en: "Enter Panel" },
    grants: { es: "Subvenciones", en: "Grants" },
    startFree: { es: "Acceso anticipado", en: "Early access" },
    login: { es: "Iniciar sesión", en: "Sign In" },
    logout: { es: "Cerrar sesión", en: "Sign Out" },
    clientPanel: { es: "Panel de Cliente", en: "Client Panel" },
    calculator: { es: "Calculadora", en: "Calculator" },
  },

  // ── Hero ──
  hero: {
    tagline: { es: "PARA EMPRESARIOS Y EMPRENDEDORES", en: "FOR BUSINESS OWNERS AND ENTREPRENEURS" },
    title1: { es: "Incorpora", en: "Incorporate" },
    title2: { es: "know-how", en: "know-how" },
    titleEnd: { es: "de un experto a tu día a día.", en: "of an expert into your daily routine." },
    subtitle: {
      es: "Panel de control con Agente Retail IA, mentoría senior y hoja de ruta para comercios y negocios a pie de calle. Desde el día a día operativo hasta el crecimiento.",
      en: "Control panel with Retail AI Agent, senior mentoring and roadmap for street-level shops and businesses. From daily operations to growth.",
    },
    subtitleEnd: {
      es: "",
      en: "",
    },
    // Móvil: 4 líneas fijas para que los cortes no dependan del ancho del dispositivo.
    subtitleM1: {
      es: "Panel de control con Agente Retail IA,",
      en: "Control panel with Retail AI Agent,",
    },
    subtitleM2: {
      es: "mentoría senior y hoja de ruta",
      en: "senior mentoring and roadmap",
    },
    subtitleM3: {
      es: "para comercios y negocios a pie de calle.",
      en: "for street-level shops and businesses.",
    },
    subtitleM4: {
      es: "Desde el día a día operativo hasta el crecimiento.",
      en: "From daily operations to growth.",
    },

    ctaAgent: { es: "Probar Agente Retail IA", en: "Try Retail AI Agent" },
    ctaPanel: { es: "Detector de Fugas Express", en: "Express Leak Detector" },
    ctaMicrocopy: { es: "Acceso anticipado · Te avisamos cuando abramos", en: "Early access · We'll let you know when we launch" },

    ctaChecklist: { es: "Empezar mi Mentoring", en: "Start My Mentoring" },
    ctaHelp: { es: "¿Te ayudamos? Sólo 3 preguntas", en: "Need help? Just 3 questions" },
    ctaHelpHint: { es: "", en: "" },
    heroImageAlt: {
      es: "Panel 360, agente retail IA y hoja de ruta para comercios locales — Retail Lemon",
      en: "360 panel, Retail AI Agent and roadmap for local shops — Retail Lemon",
    },

    ctaExplore: { es: "Ver planes y precios", en: "See plans & pricing" },
    timelineStudy: { es: "ESTUDIO", en: "STUDY" },
    timelineLaunch: { es: "LANZAMIENTO", en: "LAUNCH" },
    timelineConsolidation: { es: "CONSOLIDACIÓN", en: "CONSOLIDATION" },
    timelineGrowth: { es: "CRECIMIENTO", en: "GROWTH" },
  },

  // ── Detector de Fugas ──
  express: {
    firstStepsIntro: {
      es: "Hemos preparado este módulo gratis para que veas cómo trabajamos.",
      en: "We’ve prepared this free module so you can see how we work.",
    },
    premiumForMembers: {
      es: "Premium · Disponible para socios Club Pro",
      en: "Premium · Available to Club Pro members",
    },
    clubProLabel: {
      es: "CLUB PRO",
      en: "CLUB PRO",
    },
    clubProTitle: {
      es: "Da un impulso a tu negocio",
      en: "Give your business a boost",
    },
    clubProText: {
      es: "Desbloquea cada módulo y cierra las fugas cuando te encaje.",
      en: "Unlock every module and close the leaks when it suits you.",
    },
    joinClubProCta: {
      es: "Unirme al Club Pro · 69 €/mes",
      en: "Club Pro · €69/month",
    },
  },

  // ── Detector de Fugas Completo ──
  fullDiagnostic: {
    clubProLabel: {
      es: "CLUB PRO",
      en: "CLUB PRO",
    },
    joinClubProCta: {
      es: "Unirme al Club Pro · 69 €/mes",
      en: "Club Pro · €69/month",
    },
    unlockFirstSteps: {
      es: "Desbloquear Primeros Pasos",
      en: "Unlock First Steps",
    },
    unlockFirstStepsMicro: {
      es: "Si quieres probar antes, desbloquea los Primeros Pasos gratis y prueba la plataforma.",
      en: "If you want to try first, unlock First Steps for free and try the platform.",
    },
    seeFirstSteps: {
      es: "Ver mis Primeros Pasos",
      en: "See my First Steps",
    },
    retake: {
      es: "Repetir el detector",
      en: "Retake the detector",
    },
  },

  // ── Agente Lite: 3 consultas/mes solo Primeros Pasos ──
  liteAgent: {
    quotaIntro: { es: "Tienes 3 consultas gratuitas este mes · solo Primeros Pasos", en: "You have 3 free questions this month · First Steps only" },
    quotaRemaining: { es: "Te quedan {count} consultas gratuitas", en: "You have {count} free questions left" },
    quotaExhausted: { es: "Te quedan 0 consultas gratuitas. Regístrate gratis y consigue 3 consultas adicionales.", en: "You have 0 free questions left. Sign up free and get 3 additional questions." },
    subjectLocked: { es: "Sin plan, el asunto se queda en Primeros Pasos. Para cambiar de módulo únete al Club Pro.", en: "Without a plan, the topic stays on First Steps. Switch modules by joining Club Pro." },
    offTopicReply: { es: "En la prueba gratuita trabajamos solo Primeros Pasos. Si quieres hablar de {topic}, únete al Club Pro y lo vemos juntos.", en: "The free trial only covers First Steps. To talk about {topic}, join Club Pro and we'll look at it together." },
    lockedCta: { es: "Club Pro · 69 €/mes", en: "Club Pro · €69/month" },
    lockedMode: { es: "Guía paso a paso y diagnóstico son funciones del Club Pro.", en: "Step-by-step guide and diagnosis are Club Pro features." },
    offTopicFallbackTopic: { es: "otro tema", en: "another topic" },
    tasteUsedTitle: { es: "Ya tienes tu respuesta sobre {module}", en: "You've got your answer on {module}" },
    tasteUsedMessage: { es: "Para repreguntar y profundizar en este tema necesitas el Club Pro. Con tus consultas restantes puedes abrir otra Consulta resuelta o seguir en Primeros Pasos.", en: "To ask follow-ups and dig deeper into this topic you need Club Pro. Use your remaining questions on another solved question or keep going in First Steps." },
    tasteBasicsCta: { es: "Seguir con Primeros Pasos", en: "Continue with First Steps" },
    tasteProCta: { es: "Unirme al Club Pro", en: "Join Club Pro" },
  },

  saraModeCoach: {
    title: { es: "Elige cómo quieres que te ayude Sara", en: "Choose how Sara should help you" },
    direct: { es: "Directo: una respuesta rápida y al grano.", en: "Direct: a quick, straight-to-the-point answer." },
    steps: { es: "Pasos: una guía práctica para ponerte en marcha.", en: "Steps: a practical guide you can put into action." },
    diagnosis: { es: "Diagnóstico: analiza mejor la causa antes de decidir.", en: "Diagnosis: understand the cause before deciding." },
    close: { es: "Cerrar esta ayuda", en: "Close this help" },
  },


  // ── Direct Message ──
  directMessage: {
    text: {
      es: "Convertimos tus dudas en decisiones seguras. Un acompañamiento real, directo y permanente para que nunca más vuelvas a estar solo ante tu negocio.",
      en: "We turn your doubts into confident decisions. Real, direct and permanent support so you never face your business alone again.",
    },
  },

  // ── Sectors Section ──
  sectors: {
    title: { es: "Adaptado a la realidad de tu sector", en: "Adapted to the reality of your sector" },
    titleAccent: { es: "", en: "" },
    altSuffix: {
      es: "mentoring y gestión para retail y comercio local con Retail Lemon",
      en: "mentoring and management for retail and local shops with Retail Lemon",
    },

    subtitle: {
      es: "A pie de calle, la estructura organizativa que todo local necesita es la misma; pero las batallas diarias cambian. Te damos la base operativa común y la adaptamos a la dinámica exacta de tu comercio.",
      en: "On the street, the organizational structure every local business needs is the same; but the daily battles change. We give you the common operational base and adapt it to the exact dynamics of your shop.",
    },
    specializationBridge: {
      es: "Adaptado a tu sector",
      en: "Adapted to your sector",
    },
    commonLabel: {
      es: "Herramientas base comunes",
      en: "Common base tools",
    },
    pillars: {
      es: [
        { title: "Precios y Márgenes", description: "La rentabilidad por producto es la primera línea de defensa. Da igual si es una barra de pan o un corte de pelo; si el escandallo está mal hecho, trabajar más horas es perder dinero." },
        { title: "Finanzas y Flujo de Caja", description: "El margen es la teoría, la caja es la realidad. Control absoluto para garantizar nóminas, alquileres y proveedores los días uno de cada mes sin asfixias." },
        { title: "Gestión de Personal", description: "El motor del local. La batalla de cuadrar turnos, gestionar bajas, retener el talento válido y crear incentivos para que el mostrador no se quede cojo." },
        { title: "Compras y Almacén", description: "El dinero inmovilizado. Ya sean mermas de producto fresco o tallas sueltas de colecciones pasadas, el control de rotación libera liquidez." },
        { title: "Legal, fiscal y administrativo", description: "El blindaje del negocio. Revisión de la letra pequeña en contratos de alquiler, proveedores, normativas laborales y licencias municipales." },
        { title: "Operativa y Procesos", description: "El manual de instrucciones. Protocolos de apertura, cierre, cuadres de caja y checklists que permiten que el local funcione sin depender de ti." },
        { title: "IA y Seguimiento Operativo", description: "Visibilidad 24/7. Dominar el SEO local, automatizar respuestas y usar IA para optimizar tareas mecánicas y atraer tráfico físico al local." },
      ],
      en: [
        { title: "Pricing & Margins", description: "Product-level profitability is the first line of defense. Whether it's a loaf of bread or a haircut; if the costing is wrong, working more hours just means losing more money." },
        { title: "Finance & Cash Flow", description: "Margin is theory, cash is reality. Absolute control to guarantee payroll, rent and suppliers on the 1st of every month without choking." },
        { title: "People Management", description: "The engine of the shop. The daily battle of scheduling shifts, covering sick leave, retaining real talent and creating incentives so the counter is never short-staffed." },
        { title: "Purchasing & Inventory", description: "Money sitting still. Whether it's fresh-product waste or leftover sizes from past collections, rotation control unlocks liquidity." },
        { title: "Legal, Tax & Admin", description: "The shield around the business. Reviewing the fine print in lease agreements, supplier contracts, labor regulations and municipal licenses." },
        { title: "Operations & Processes", description: "The instruction manual. Opening, closing and cash-reconciliation protocols plus checklists that let the shop run without depending on you." },
        { title: "AI & Operational Tracking", description: "24/7 visibility. Mastering local SEO, automating replies and using AI to optimize mechanical tasks and drive physical foot traffic to the shop." },
      ],
    },

    cards: {
      es: [
        {
          title: "Moda & Accesorios",
          icon: "Shirt",
          image: "/src/assets/sector-fashion.webp",
          badges: ["👕 Ropa", "👞 Calzado", "💎 Joyería"],
          niches: ["Ropa", "Calzado", "Joyería"],
          tagline: "Stock que asfixia tu caja.",
          pains: [
            "Dinero atrapado en colecciones y tallas sueltas.",
            "Caída de tráfico en el local de martes a jueves.",
            "Dificultad para convertir liquidación en liquidez.",
          ],
        },

        {
          title: "Hostelería & Gourmet",
          icon: "Utensils",
          image: "/src/assets/sector-hospitality.webp",
          badges: ["🍽️ Restaurantes", "🍷 Bares", "☕ Cafeterías"],
          niches: ["Restaurantes", "Bares", "Cafeterías"],
          tagline: "Margen entre fogones y mermas.",
          pains: [
            "Márgenes devorados por no tener escandallos al céntimo.",
            "Mermas de producto fresco que arruinan la caja.",
            "Caos en los turnos y alta rotación de personal.",
          ],
        },

        {
          title: "Alimentación & Frescos",
          icon: "ShoppingCart",
          image: "/src/assets/sector-food.webp",
          badges: ["🛒 Supermercados", "🥖 Panaderías", "🍏 Tiendas locales"],
          niches: ["Supermercados", "Panaderías", "Tiendas locales"],
          tagline: "Volumen alto, margen al límite.",

          pains: [
            "Volumen alto de trabajo con margen asfixiante.",
            "Subidas imprevistas de los proveedores.",
            "Ticket medio bajo (compras solo de lo básico).",
          ],
        },
        {
          title: "Salud & Belleza",
          icon: "Scissors",
          image: "/src/assets/sector-beauty.webp",
          badges: ["✂️ Peluquerías", "✨ Centros Estética", "💊 Farmacias"],
          niches: ["Peluquerías", "Centros de Estética", "Farmacias"],
          tagline: "Agenda con huecos que no facturan.",

          pains: [
            "Horas muertas en la agenda que destruyen la rentabilidad.",
            "Falta de venta cruzada de producto físico.",
            "Baja fidelización mensual del cliente.",
          ],
        },

        {
          title: "Niños",
          icon: "Baby",
          image: "/src/assets/sector-flykids.webp",
          badges: ["🧸 Juguetes", "👶 Infantil", "✏️ Papelería"],
          niches: ["Juguetes", "Infantil", "Papelería"],
          tagline: "Temporadas cortas, stock que envejece rápido.",

          pains: [
            "Exceso de stock fuera de temporada con depreciación acelerada.",
            "Ticket medio bajo y compras impulsivas difíciles de fidelizar.",
            "Competencia feroz de grandes superficies y marketplaces online.",
          ],
        },

        {
          title: "Inmobiliarias",
          icon: "Building2",
          image: "/src/assets/sector-inmobiliarias.webp",
          badges: ["🏢 Agencias", "🔑 Alquiler", "🏠 Venta"],
          niches: ["Agencias", "Alquiler", "Venta"],
          tagline: "Captaciones que no cierran y agendas que no facturan.",

          pains: [
            "Rotación lenta de inmuebles con cartera estancada.",
            "Comisiones diluidas por la guerra de portales y descuentos.",
            "Falta de seguimiento del lead caliente que acaba comprando en otra agencia.",
          ],
        },
      ],
      en: [
        {
          title: "Fashion & Accessories",
          icon: "Shirt",
          image: "/src/assets/sector-fashion.webp",
          badges: ["👕 Clothing", "👞 Footwear", "💎 Jewelry"],
          niches: ["Clothing", "Footwear", "Jewelry"],
          tagline: "Stock that suffocates your till.",

          pains: [
            "Cash trapped in collections and stray sizes.",
            "Foot traffic drop in store from Tuesday to Thursday.",
            "Difficulty turning clearance into liquidity.",
          ],
        },
        {
          title: "Hospitality & Gourmet",
          icon: "Utensils",
          image: "/src/assets/sector-hospitality.webp",
          badges: ["🍽️ Restaurants", "🍷 Bars", "☕ Cafés"],
          niches: ["Restaurants", "Bars", "Cafés"],
          tagline: "Margins lost between stove and waste.",

          pains: [
            "Margins eaten away without cent-accurate recipe costing.",
            "Fresh produce waste that ruins the till.",
            "Shift chaos and high staff turnover.",
          ],
        },
        {
          title: "Food & Fresh Produce",
          icon: "ShoppingCart",
          image: "/src/assets/sector-food.webp",
          badges: ["🛒 Supermarkets", "🥖 Bakeries", "🍏 Local Shops"],
          niches: ["Supermarkets", "Bakeries", "Local Shops"],
          tagline: "High volume, razor-thin margins.",

          pains: [
            "High workload with suffocating margins.",
            "Unexpected supplier price hikes.",
            "Low average ticket (customers buy only basics).",
          ],
        },
        {
          title: "Health & Beauty",
          icon: "Scissors",
          image: "/src/assets/sector-beauty.webp",
          badges: ["✂️ Hair Salons", "✨ Beauty Centers", "💊 Pharmacies"],
          niches: ["Hair Salons", "Beauty Centers", "Pharmacies"],
          tagline: "Empty slots that don't bill.",

          pains: [
            "Dead hours in the agenda that crush profitability.",
            "Lack of cross-selling physical products.",
            "Low monthly customer loyalty.",
          ],
        },

        {
          title: "Kids",
          icon: "Baby",
          image: "/src/assets/sector-flykids.webp",
          badges: ["🧸 Toys", "👶 Baby & Kids", "✏️ Stationery"],
          niches: ["Toys", "Baby & Kids", "Stationery"],
          tagline: "Short seasons, stock that ages fast.",

          pains: [
            "Excess out-of-season stock with accelerated depreciation.",
            "Low average ticket and hard-to-retain impulse purchases.",
            "Fierce competition from big-box stores and online marketplaces.",
          ],
        },

        {
          title: "Real Estate",
          icon: "Building2",
          image: "/src/assets/sector-inmobiliarias.webp",
          badges: ["🏢 Agencies", "🔑 Rentals", "🏠 Sales"],
          niches: ["Agencies", "Rentals", "Sales"],
          tagline: "Listings that don't close and agendas that don't bill.",

          pains: [
            "Slow listing rotation with a stagnant portfolio.",
            "Margins diluted by the portal war and discount pressure.",
            "Lack of follow-up on hot leads who end up buying with another agency.",
          ],
        },
      ],
    },

    closingLine: {
      es: "No caminas solo. Te damos el apoyo y la estructura para llevar el rendimiento de tu negocio al siguiente nivel.",
      en: "You don't walk alone. We give you the support and structure to take your business performance to the next level.",
    },
  },

  // ── Expertise Section ──
  expertise: {
    title: { es: "Nuestras 6 Áreas de", en: "Our 6 Areas of" },
    titleAccent: { es: "Expertise", en: "Expertise" },
    motorTitle: { es: "Tecnología e IA", en: "Technology & AI" },
    motorSubtitle: { es: "MÉTODO LA COSECHA", en: "THE HARVEST METHOD" },
    motorDescription: {
      es: "Automatiza la gestión de tu negocio con IA y el Club Pro. Predice tendencias, controla tus KPIs en tiempo real y libera horas para lo que de verdad importa: vender.",
      en: "Automate your business management with AI and the Club Pro. Predict trends, control your KPIs in real time and free up hours for what really matters: selling.",
    },
    motorCta: { es: "¿Tu negocio funciona solo? Haz el Quiz", en: "Does your business run itself? Take the Quiz" },
    subtitle: {
      es: "Cinco áreas de mentoring continuo. Resolvemos cada reto de tu negocio de calle.",
      en: "Five areas of continuous mentoring. We solve every challenge for your street-facing business.",
    },
    descriptions: {
      es: [
        "Modelo de negocio, viabilidad y estructura legal. Bases financieras sólidas para que tu concepto sea rentable desde el primer día.",
        "Validación de proveedores, negociación de compras y gestión eficiente del inventario. Optimizamos cada margen de tu cadena de suministro.",
        "Selección del local ideal, interiorismo comercial y Visual Merchandising. Espacios físicos centrados al 100% en la experiencia del cliente.",
        "Estrategias de venta en tienda y online integradas. Conectamos tu punto de venta físico con el digital para una experiencia unificada que multiplica tu facturación.",
        "Selección, retención de talento y formación de equipos. KPIs y herramientas de gestión para que tu negocio funcione como un reloj, incluso sin ti.",
      ],
      en: [
        "Business model, viability and legal structure. Solid financial foundations so your concept is profitable from day one.",
        "Supplier validation, purchasing negotiation and efficient inventory management. We optimize every margin in your supply chain.",
        "Ideal location selection, commercial interior design and Visual Merchandising. Physical spaces 100% centered on client experience.",
        "Integrated in-store and online sales strategies. We connect your physical and digital points of sale into a unified experience that multiplies revenue.",
        "Talent selection, retention and team training. KPIs and management tools so your business runs like clockwork, even without you.",
      ],
    },
    ctaTexts: {
      es: [
        "¿Es tu negocio viable? Haz el Quiz",
        "¿Está tu colección lista? Haz el Quiz",
        "¿Crea tu negocio una experiencia? Quiz",
        "¿Liquidaciones sin dramas? Haz el Quiz",
        "¿Tienes el equipo ideal? Haz el Quiz",
      ],
      en: [
        "Is your business viable? Take the Quiz",
        "Is your collection ready? Take the Quiz",
        "Does your business create an experience? Quiz",
        "Clearance without drama? Take the Quiz",
        "Do you have the ideal team? Take the Quiz",
      ],
    },
    giftTexts: {
      es: [
        "Regalo: Plantilla de Plan Fiscal",
        "Regalo: Checklist de Ficha Técnica",
        "Regalo: Guía de Marketing Sensorial",
        "Regalo: Calendario Comercial Lemon",
        "Regalo: Guía de Ayudas Públicas",
      ],
      en: [
        "Gift: Tax Plan Template",
        "Gift: Tech Pack Checklist",
        "Gift: Sensory Marketing Guide",
        "Gift: Lemon Commercial Calendar",
        "Gift: Public Grants Guide",
      ],
    },
    giftNames: {
      es: [
        "Plantilla de Plan Fiscal",
        "Checklist de Ficha Técnica",
        "Guía de Marketing Sensorial",
        "Calendario Comercial Lemon",
        "Guía de Ayudas Públicas",
      ],
      en: [
        "Tax Plan Template",
        "Tech Pack Checklist",
        "Sensory Marketing Guide",
        "Lemon Commercial Calendar",
        "Public Grants Guide",
      ],
    },
  },

  // ── Mobile Control (landing impact section) ──
  mobileControl: {
    titleStart: { es: "Dirige mejor tu negocio paso a paso: el know-how que necesitas ", en: "Run your business better step by step: the know-how you need " },
    titleHighlight: { es: "asistido por el Agente Retail IA", en: "powered by the Retail AI Agent" },
    titleEnd: { es: "", en: "" },
    subtitle: {
      es: "Sin dudas sobre qué hacer. El panel integra la visión de un experto y un asistente inteligente que te marcan las prioridades.",
      en: "No doubts about what to do. The panel combines an expert's vision and a smart assistant that set your priorities.",
    },
    subtitleLine1: {
      es: "Sin dudas sobre qué hacer.",
      en: "No doubts about what to do.",
    },
    subtitleLine2: {
      es: "El panel integra la visión de un experto y un asistente inteligente que te marcan las prioridades.",
      en: "The panel combines an expert's vision and a smart assistant that set your priorities.",
    },
    cta: { es: "Probar el panel ahora", en: "Try the panel now" },
    tourCta: { es: "Ver cómo funciona tu panel, paso a paso", en: "See how your panel works, step by step" },
    tourTitle: { es: "Así funciona tu panel", en: "How your panel works" },
    tourSubtitle: {
      es: "Cuatro pasos para ver cómo trabajas dentro de Retail Lemon.",
      en: "Four steps to see how you work inside Retail Lemon.",
    },
    tourStepKickers: {
      es: [
        "Así se ve tu día a día",
        "Así ves qué te deja dinero",
        "Así te acompaña la IA",
        "Así resuelves lo complejo",
      ],
      en: [
        "This is your day to day",
        "This is what actually makes money",
        "This is how the AI backs you up",
        "This is how you solve the complex stuff",
      ],
    },
    tourSteps: {
      es: [
        "Hoja de ruta: tareas del día marcadas en un toque.",
        "Márgenes y escandallo: sabes qué te deja dinero.",
        "KPIs en tiempo real: ventas, ticket medio y rotación.",
        "Agente Retail IA 24/7: te dice el siguiente paso.",
      ],
      en: [
        "Roadmap: today's tasks ticked off in one tap.",
        "Margins and costing: know what actually makes money.",
        "Real-time KPIs: sales, average ticket and turnover.",
        "24/7 Retail AI Agent: tells you the next step.",
      ],
    },
    tourPrev: { es: "Anterior", en: "Back" },
    tourNext: { es: "Siguiente paso", en: "Next step" },
    tourFinalCta: { es: "Suscríbete al Club Pro", en: "Subscribe to Club Pro" },
    tourFinalNote: {
      es: "Alta de usuario + Club Pro mensual, sin permanencia",
      en: "Account signup + monthly Club Pro, no commitment",
    },
    tourRestart: { es: "Reiniciar tour", en: "Restart tour" },
    tourStepLabel: { es: "Paso", en: "Step" },
    tourStepTitles: {
      es: [
        "Hoja de ruta y checklists operativos",
        "Calculadoras automáticas y márgenes",
        "Agente Retail IA 24/7 integrado",
        "Mentoría experta acompañada",
      ],
      en: [
        "Roadmap and operational checklists",
        "Automatic calculators and margins",
        "24/7 Retail AI Agent built in",
        "Expert mentoring by your side",
      ],
    },
    tourStepSubs: {
      es: [
        "Tareas clave organizadas paso a paso para ejecutar día a día sin estrés.",
        "Sabe exactamente qué productos te dejan dinero con calculadoras de margen instantáneas.",
        "Un asistente inteligente integrado en tu panel que hace el seguimiento operativo por ti y te dice el siguiente paso.",
        "Si el día a día se complica o tienes una duda estratégica, cuentas con apoyo experto para no tomar decisiones a ciegas.",
      ],
      en: [
        "Key tasks organised step by step so you can execute day to day without stress.",
        "Know exactly which products make you money with instant margin calculators.",
        "A smart assistant inside your panel that tracks operations for you and tells you the next step.",
        "When the day gets messy or you face a strategic doubt, you have expert support so you never decide blind.",
      ],
    },
    tourChecklistA: { es: "Apertura y caja", en: "Opening and cash" },
    tourChecklistB: { es: "Control de mermas semanal", en: "Weekly shrinkage control" },
    tourChecklistAItems: {
      es: ["Arqueo de caja inicial", "Revisar escaparate y precios", "Fichar turno de mañana"],
      en: ["Opening cash count", "Check window display and prices", "Clock in morning shift"],
    },
    tourChecklistBItems: {
      es: ["Contar producto caducado", "Registrar roturas del turno", "Comparar con semana anterior"],
      en: ["Count expired product", "Log breakages of the shift", "Compare with last week"],
    },
    tourCalcTitle: { es: "Escandallo rápido", en: "Quick costing" },
    tourCalcCatalog: { es: "Precio de catálogo", en: "Catalogue price" },
    tourCalcMargin: { es: "Margen %", en: "Margin %" },
    tourCalcPvp: { es: "PVP final", en: "Final retail price" },
    tourCalcChart: { es: "Margen por familia", en: "Margin by category" },
    tourChatTitle: { es: "Sara · Agente Retail IA", en: "Sara · Retail AI Agent" },
    tourChatMessage: {
      es: "Sara: Llevas 3 tareas hechas hoy. Tu margen medio está en 42%. ¿Revisamos el escandallo de la semana?",
      en: "Sara: You've done 3 tasks today. Your average margin is 42%. Shall we review this week's costing?",
    },
    tourMentorButton: { es: "Consultar con tu mentor", en: "Talk to your mentor" },
    tourMentorName: { es: "Tu mentor", en: "Your mentor" },
    tourMentorQuote: {
      es: "Resuelve dudas complejas de tu negocio con acompañamiento humano directo.",
      en: "Solve complex business questions with direct human guidance.",
    },
    phonePills: {
      es: ["Checklist paso a paso", "Ejecución rápida en el negocio", "Seguimiento diario"],
      en: ["Step-by-step checklist", "Fast in-store execution", "Daily tracking"],
    },
    deskPills: {
      es: ["Análisis de márgenes", "KPIs en tiempo real", "Estrategia y compras"],
      en: ["Margin analysis", "Real-time KPIs", "Strategy & purchasing"],
    },
    phoneTitle: { es: "Hoja de ruta", en: "Roadmap" },
    phoneTasks: {
      es: ["Cuadre de caja", "Revisar stock crítico", "Escandallo semanal", "Turnos de la semana"],
      en: ["Cash reconciliation", "Check critical stock", "Weekly costing", "Weekly shifts"],
    },
    phoneKpi: { es: "Progreso semanal", en: "Weekly progress" },
    phoneAgent: { es: "Sara: 3 tareas hechas. ¡Vas bien!", en: "Sara: 3 tasks done. Nice pace!" },
    mobileLabel: { es: "A pie de calle", en: "On the shop floor" },
    mobileTitle: { es: "En el mostrador", en: "At the counter" },
    mobileCopy: {
      es: "Completa tu checklist diario, marca tareas ejecutadas y consulta la operativa desde tu teléfono.",
      en: "Complete your daily checklist, tick off tasks and review operations right from your phone.",
    },
    desktopLabel: { es: "En tu escritorio", en: "At your desk" },
    desktopTitle: { es: "En la oficina", en: "At the office" },
    desktopCopy: {
      es: "Analiza márgenes, planifica compras y mantén una visión 360º de tu negocio a pantalla completa.",
      en: "Analyse margins, plan purchases and keep a 360º view of your business on full screen.",
    },
    deskTitle: { es: "Panel de control", en: "Control panel" },
    deskKpis: {
      es: ["Margen bruto", "Ticket medio", "Rotación stock"],
      en: ["Gross margin", "Average ticket", "Stock turnover"],
    },
    deskKpiValues: { es: ["42,6 %", "38,10 €", "6,2x"], en: ["42.6%", "€38.10", "6.2x"] },
    deskModules: {
      es: ["Escandallo", "Compras", "Proveedores", "Equipo"],
      en: ["Costing", "Purchasing", "Suppliers", "Team"],
    },
    deskChart: { es: "Evolución de ventas", en: "Sales evolution" },
  },

  // ── Agente Retail IA + Asesoramiento humano ──
  aiHuman: {
    badge: { es: "AGENTE RETAIL IA + ASESORAMIENTO HUMANO", en: "RETAIL AI AGENT + HUMAN ADVISORY" },
    title: {
      es: "Un Agente Retail IA que te enseña los pasos y un asesor humano a tu disposición",
      en: "The Retail AI Agent that teaches you the steps and a human advisor at your disposal",
    },
    subtitle1: {
      es: "Aprende la metodología de gestión con asistencia virtual 24/7",
      en: "Learn the management methodology with 24/7 virtual assistance",
    },
    subtitle2: {
      es: "y cuenta con llamadas con un consultor real cuando lo necesites.",
      en: "and get calls with a real consultant whenever you need them.",
    },
    stepTitles: {
      es: [
        "1. Te enseña la metodología paso a paso",
        "2. Se ejecuta de forma visual en tu panel",
        "3. Acompañamiento humano",
      ],
      en: [
        "1. It teaches you the methodology step by step",
        "2. It runs visually inside your panel",
        "3. Human guidance",
      ],
    },
    stepTexts: {
      es: [
        "El Agente Retail IA actúa como un tutor de retail. Te explica qué hacer en cada fase del negocio, resuelve tus dudas al instante y te guía sobre el plan de trabajo.",
        "Toda la guía del agente se convierte en acciones concretas en tu pantalla: checklists diarias para el mostrador y paneles de control para la oficina.",
        "Para las decisiones clave o si prefieres hablar de persona a persona, puedes acceder a un consultor real que te acompaña en tu día a día.",
      ],
      en: [
        "The Retail AI Agent acts as a retail tutor. It explains what to do at every stage of the business, answers your questions instantly and guides you through the work plan.",
        "Everything the agent guides you on becomes concrete actions on your screen: daily checklists for the shop floor and control panels for the office.",
        "For key decisions, or if you'd rather talk person to person, you can access a real consultant who supports you in your day-to-day work.",
      ],
    },
    stepAlts: {
      es: [
        "Agente Retail IA explicando el diagnóstico y el plan de acción de una tienda de retail",
        "Panel de gestión Retail Lemon con checklist de tareas y gráfico de evolución del comercio",
        "Asesora experta en retail atendiendo una consulta de mentoring por teléfono",
      ],
      en: [
        "Retail AI Agent explaining the diagnosis and action plan for a retail shop",
        "Retail Lemon management panel with task checklist and shop performance chart",
        "Retail expert advisor handling a mentoring call",
      ],
    },

    cta: {
      es: "Únete al acceso anticipado",
      en: "Join early access",
    },
    ctaNote1: {
      es: "* Te avisamos cuando abramos, con acceso",
      en: "* We'll let you know when we launch, with access",
    },
    ctaNote2: {
      es: "a la hoja de ruta y al agente inteligente.",
      en: "to the roadmap and the intelligent agent.",
    },
  },


  // ── Online Panel ──
  panel: {
    title: { es: "Un panel inteligente para ejecutar la estrategia de tu negocio", en: "A smart panel to execute your business strategy" },
    titleAccent: { es: "", en: "" },
    subtitle: {
      es: "Sin Excels interminables ni papeles sueltos. Visualiza tus avances por módulos, gestiona tu negocio y toma el control de tu rentabilidad desde un único lugar.",
      en: "No endless spreadsheets or loose papers. Track your progress by modules, manage your business and take control of your profitability from a single place.",
    },
    features: {
      es: [
        "Progreso por módulos: visualiza el porcentaje de avance de cada área de tu negocio de forma clara.",
        "Acceso 100% móvil y desktop: revisa la operativa a pie de calle desde el teléfono o analiza datos desde la oficina.",
        "Agente Retail IA en segundo plano: soporte inteligente para llevar el seguimiento de tus avances sin complicarte.",
        "Herramientas de control: calculadoras automáticas, escandallos y red de proveedores para tu sector.",
      ],
      en: [
        "Progress by modules: clearly see the completion percentage of every area of your business.",
        "100% mobile and desktop access: review operations on the shop floor from your phone or analyse data from the office.",
        "Retail AI Agent in the background: smart support to keep track of your progress with zero hassle.",
        "Control tools: automatic calculators, cost breakdowns and a supplier network for your sector.",
      ],
    },
    ctaDiscover: { es: "Descubrir la Plataforma", en: "Discover the Platform" },
    ctaStartFree: { es: "Acceso anticipado", en: "Early access" },
    ctaStartFreeMicro: { es: "* Te avisamos cuando abramos.", en: "* We'll let you know when we launch." },
    ctaDiscoverPanel: { es: "▶ Ver Panel Demo", en: "▶ View Demo Panel" },
    pricingTitle: { es: "Cuota mensual desde 149\u00a0€/mes", en: "Monthly fee from €149/month" },
    pricingSubtitle: {
      es: "Acceso a tu mentor dedicado, panel en tiempo real y activación de módulos bajo demanda.",
      en: "Access to your dedicated mentor, real-time panel and on-demand module activation.",
    },
    yourProject: { es: "Tu Proyecto", en: "Your Project" },
    inProgress: { es: "En progreso", en: "In Progress" },
    active: { es: "Activo", en: "Active" },
    available: { es: "Disponible", en: "Available" },
    premium: { es: "Premium", en: "Premium" },
    premiumHint: { es: "Acceso bajo demanda", en: "On-demand access" },
    requestActivation: { es: "Solicitar Activación", en: "Request Activation" },
    nextMilestone: { es: "Próximo hito", en: "Next Milestone" },
    milestoneText: { es: "Revisión mensual de KPIs — 15 Mar", en: "Monthly KPI review — Mar 15" },
    completed: { es: "Completado", en: "Completed" },
    inProgressBadge: { es: "En Progreso", en: "In Progress" },
    notStarted: { es: "Por empezar", en: "Not started" },
    comingSoon: { es: "Próximamente: Más herramientas para tu negocio", en: "Coming soon: More tools for your business" },
    modules: {
      es: [
        { name: "Finanzas y Rentabilidad", subtitle: "Método La Semilla" },
        { name: "Compras y Proveedores", subtitle: "Método El Jugo" },
        { name: "El Local y la Experiencia", subtitle: "Método El Escaparate" },
        { name: "Ventas (Tienda y Online)", subtitle: "Método El Sabor" },
        { name: "Equipo y Gestión", subtitle: "Método El Equipo" },
        { name: "Tecnología e IA", subtitle: "Método La Cosecha" },
      ],
      en: [
        { name: "Finance & Profitability", subtitle: "The Seed Method" },
        { name: "Purchasing & Suppliers", subtitle: "The Juice Method" },
        { name: "The Store & Experience", subtitle: "The Showcase Method" },
        { name: "Sales (Store & Online)", subtitle: "The Flavor Method" },
        { name: "Team & Management", subtitle: "The Team Method" },
        { name: "Technology & AI", subtitle: "The Harvest Method" },
      ],
    },
  },

  // ── Sidebar / Panel navigation ──
  sidebar: {
    tryIt: { es: "Pruébalo", en: "Test it" },
    agentRetailIA: { es: "Agente Retail IA", en: "Retail AI Agent" },
  },

  marketing: {
    subtitle: { es: "Publicaciones, música y aroma para el local.", en: "Social posts, music and scent for your store." },
    postsTab: { es: "Publicaciones", en: "Posts" },
    musicTab: { es: "Música", en: "Music" },
    scentTab: { es: "Aroma", en: "Scent" },
    postsTitle: { es: "Publicaciones en redes", en: "Social media posts" },
    postsBody: { es: "Publicaciones y fichas pensadas para mantener tu negocio activo y reconocible.", en: "Posts and content designed to keep your business active and recognisable." },
    scentTitle: { es: "Marketing olfativo", en: "Scent marketing" },
    scentBody: { es: "Una identidad aromática para completar la experiencia de tu local.", en: "A scent identity to complete your store's experience." },
    premiumOptional: { es: "+ Extra · Avanzado", en: "+ Extra · Advanced" },
    proComingSoon: { es: "Próximamente para usuarios del Club Pro", en: "Coming soon for Club Pro members" },
    musicBadge: { es: "Música libre desde Básico · comercial como Extra", en: "Royalty-free music from Basic · commercial as Extra" },
    musicUnlimited: { es: "Música ilimitada y legal para tu local", en: "Unlimited, legal music for your store" },
    musicPublicBody: { es: "Hilo musical para crear el ambiente de tu negocio, con opciones RF y repertorio comercial.", en: "In-store music to set the mood of your business, with royalty-free and commercial repertoire options." },
    openMusic: { es: "Abrir música", en: "Open music" },
    tryFree: { es: "Pruébalo", en: "Try it" },
    musicTitle: { es: "Música para tu local", en: "Music for your store" },
    visitorDialogBody: { es: "Prueba el hilo en el panel.", en: "Try the music player in the dashboard." },
    tryIt: { es: "Pruébalo", en: "Try it" },
    viewPricing: { es: "Ver tarifas", en: "View pricing" },
    waveformLabel: { es: "Forma de onda del hilo musical", en: "In-store music waveform" },
    playing: { es: "En reproducción", en: "Now playing" },
    paused: { es: "En pausa", en: "Paused" },
    unlimited: { es: "Ilimitado", en: "Unlimited" },
    dailyTrial: { es: "Prueba diaria", en: "Daily trial" },
    commercialDemo: { es: "Demostración comercial", en: "Commercial demo" },
    trialEnded: { es: "Activa Club Pro para seguir.", en: "Activate Club Pro to continue." },
    play: { es: "Reproducir", en: "Play" },
    pause: { es: "Pausar", en: "Pause" },
    volume: { es: "Volumen", en: "Volume" },
    playerSafetyNote: { es: "No uses Spotify ni YouTube en la tienda. El hilo sale de este reproductor.", en: "Don't use Spotify or YouTube in your store. The music plays from this player." },
    proBenefits: { es: "Ventajas Club Pro", en: "Club Pro benefits" },
    proUnlimited: { es: "Ilimitado 24/7", en: "Unlimited 24/7" },
    proAutomation: { es: "Encendido y apagado automático", en: "Automatic on and off" },
    proLink: { es: "Enlace a tienda", en: "Store link" },
    proDifferentByLocation: { es: "Opcional: música diferente por tienda", en: "Optional: different music per store" },
    addAnotherLocation: { es: "Dar de alta otra tienda en Mis Locales", en: "Add another store in My Premises" },
    multiLocationTitle: { es: "Música en varias tiendas", en: "Music across several stores" },
    multiLocationBody: { es: "Elige si quieres repetir la configuración o personalizar cada tienda.", en: "Choose whether to reuse the same setup or customise each store." },
    sharedMusic: { es: "Misma música en todas", en: "Same music in all of them" },
    sharedMusicBody: { es: "Copia canal, horario y automatización en todas tus tiendas.", en: "Copies the channel, schedule and automation to all your stores." },
    independentMusic: { es: "Configuración distinta por tienda", en: "Different setup per store" },
    independentMusicBody: { es: "Cada tienda conserva sus propios ajustes.", en: "Each store keeps its own settings." },
    sharedConfirmTitle: { es: "¿Usar esta configuración en todas las tiendas?", en: "Use this setup in all stores?" },
    sharedConfirmBody: { es: "Se copiarán el canal, el horario y el encendido o apagado automático del local seleccionado. Las licencias comerciales y los enlaces seguirán siendo independientes.", en: "The channel, schedule and automatic on/off of the selected store will be copied. Commercial licences and links will remain independent." },
    confirmShared: { es: "Aplicar a todas", en: "Apply to all" },
    cancel: { es: "Cancelar", en: "Cancel" },
    sharedSaved: { es: "Configuración aplicada a todas tus tiendas.", en: "Setup applied to all your stores." },
    independentSaved: { es: "Cada tienda vuelve a tener su propia configuración.", en: "Each store now has its own setup again." },
    perLocationLicenseNote: { es: "La licencia comercial y el enlace del reproductor se gestionan por separado para cada tienda.", en: "The commercial licence and player link are managed separately for each store." },
    commercialNeededForLocation: { es: "Este local necesita su propia licencia comercial para usar este canal.", en: "This store needs its own commercial licence to use this channel." },
    turnOffSchedule: { es: "Apagar fuera de horario", en: "Turn off outside opening hours" },
    schedule: { es: "Horario", en: "Schedule" },
    continuousHours: { es: "Continuo 10:00–20:30", en: "Continuous 10:00–20:30" },
    splitHours: { es: "Partido 10:00–14:00 | 17:00–20:30", en: "Split 10:00–14:00 | 17:00–20:30" },
    activatePro: { es: "Activar Club Pro", en: "Activate Club Pro" },
    sendManagerLink: { es: "Enviar enlace al encargado", en: "Send link to the manager" },
    linkSent: { es: "Enlace preparado para el encargado.", en: "Link ready for the manager." },
    commercialTitle: { es: "Música comercial (SGAE / AGEDI)", en: "Commercial music (SGAE / AGEDI)" },
    license: { es: "Licencia", en: "Licence" },
    surfaceMissing: { es: "Indica los m² en Mis Locales para calcular la licencia.", en: "Enter the m² in My Premises to calculate the licence." },
    softwareCanon: { es: "Software + tramitación de canon", en: "Software + royalty fee handling" },
    conditions: { es: "Ver condiciones", en: "View terms" },
    conditionsBody: { es: "El importe es el pack Lemon de este tramo de m²: software y tramitación estimada. No es la tarifa oficial SGAE/AGEDI desglosada. Personal y autoempleo no entran en este cálculo.", en: "The amount is the Lemon pack for this m² band: software and estimated handling. It is not the official itemised SGAE/AGEDI rate. Staff and self-employment are not included in this calculation." },
    vatNote: { es: "IVA no incluido.", en: "VAT not included." },
    completeLocation: { es: "Completar ficha del local", en: "Complete store details" },
    customPrice: { es: "A medida", en: "Custom" },
    requestPrice: { es: "Pedir precio", en: "Request a quote" },
    activate: { es: "Activar", en: "Activate" },
    commercialActive: { es: "Pack activo", en: "Pack active" },
    surfaceChanged: { es: "La superficie de {local} ahora es {surface} m². El pack pasa a {price} €/mes.", en: "The floor area of {local} is now {surface} m². The pack moves to {price} €/month." },
    surfaceChangedNote: { es: "Tu suscripción no cambiará hasta que apruebes el nuevo tramo.", en: "Your subscription will not change until you approve the new band." },
    reviewChange: { es: "Revisar y aprobar cambio", en: "Review and approve change" },
    commercialPreviewTitle: { es: "Estás oyendo repertorio comercial", en: "You are listening to commercial repertoire" },
    commercialPreviewBody: { es: "Para emitirlo 24/7 en el local, activa el pack según sus m²:", en: "To play it 24/7 in your store, activate the pack based on its m²:" },
    commercialPreviewNoPrice: { es: "Completa los m² del local para calcular el pack comercial.", en: "Complete the store's m² to calculate the commercial pack." },
    continueRf: { es: "Seguir con canal RF", en: "Continue with royalty-free channel" },
    noLocationTitle: { es: "Añade primero tu local", en: "Add your store first" },
    noLocationBody: { es: "Música usa los metros y datos que ya guardas en Mis Locales.", en: "Music uses the square metres and details you already save in My Premises." },
    addLocation: { es: "Ir a Mis Locales", en: "Go to My Premises" },
    checkoutError: { es: "No se pudo iniciar el pago.", en: "The payment could not be started." },
  },

  // ── Footer ──
  footer: {
    slogan: { es: "Your brand, from zero.", en: "Your brand, from zero." },
    legal: { es: "Legal", en: "Legal" },
    legalNotice: { es: "Aviso Legal", en: "Legal Notice" },
    privacyPolicy: { es: "Política de Privacidad", en: "Privacy Policy" },
    cookies: { es: "Cookies", en: "Cookies" },
    contactTitle: { es: "Contacto", en: "Contact" },
    academy: { es: "Retail Academy", en: "Retail Academy" },
    academyDesc: {
      es: "Formación y recursos para emprendedores de retail. Próximamente.",
      en: "Training and resources for retail entrepreneurs. Coming soon.",
    },
    rights: { es: "© 2026 Retail Lemon. Todos los derechos reservados.", en: "© 2026 Retail Lemon. All rights reserved." },
    legalEntity: { es: "WP Media LLC · 8 The Green, Suite A, Dover, DE 19901, Estados Unidos · hola@retaillemon.com", en: "WP Media LLC · 8 The Green, Suite A, Dover, DE 19901, United States · hola@retaillemon.com" },
  },

  // ── Auth Modal ──
  auth: {
    title: { es: "Entra a tu panel", en: "Sign in to your panel" },
    subtitle: {
      es: "Estamos en Beta Privada: solo las personas invitadas pueden entrar. ¿Aún no tienes plaza? Únete abajo a la lista de acceso anticipado.",
      en: "We're in Private Beta: only invited people can sign in. No spot yet? Join the early access list below.",
    },
    signupTitle: { es: "Crea tu cuenta en Retail Lemon 🍋", en: "Create your Retail Lemon account 🍋" },
    signupSubtitle: {
      es: "Únete al acceso anticipado del Agente Retail IA y sus herramientas.",
      en: "Join early access to the Retail AI Agent and its tools.",
    },
    
    continueGoogle: { es: "Continuar con Google", en: "Continue with Google" },
    orEmail: { es: "o usa tu email", en: "or use your email" },
    firstName: { es: "Nombre", en: "First Name" },
    lastName: { es: "Apellido", en: "Last Name" },
    email: { es: "Email", en: "Email" },
    password: { es: "Contraseña", en: "Password" },
    loginBtn: { es: "Iniciar Sesión", en: "Sign In" },
    signupBtn: { es: "Crear mi Cuenta", en: "Create Account" },
    loadingBtn: { es: "Cargando...", en: "Loading..." },
    noAccount: { es: "¿Aún no tienes acceso?", en: "No access yet?" },
    hasAccount: { es: "¿Ya tienes cuenta?", en: "Already have an account?" },
    register: { es: "Pide tu plaza en el acceso anticipado", en: "Request your early access spot" },
    loginLink: { es: "Inicia sesión", en: "Sign In" },
    footerText: {
      es: "Al entrar, aceptas que te ayudemos a llevar tu negocio al siguiente nivel (y nuestros Términos y Condiciones).",
      en: "By signing in, you agree to let us help you take your business to the next level (and our Terms and Conditions).",
    },
    fillFields: { es: "Rellena todos los campos", en: "Fill in all fields" },
    welcomeBack: { es: "¡Bienvenido de vuelta!", en: "Welcome back!" },
    passwordMin: { es: "La contraseña debe tener al menos 6 caracteres", en: "Password must be at least 6 characters" },
    accountCreated: { es: "¡Cuenta creada! Revisa tu email para confirmar.", en: "Account created! Check your email to confirm." },
    errorGoogle: { es: "Error al iniciar sesión con Google", en: "Error signing in with Google" },
    
    forgotPassword: { es: "¿Olvidaste tu contraseña?", en: "Forgot your password?" },
    resetEmailSent: { es: "Revisa tu email para restablecer tu contraseña", en: "Check your email for a reset link" },
    sendResetLink: { es: "Enviar enlace de recuperación", en: "Send reset link" },
  },

  // ── Dashboard ──
  dashboard: {
    loadingPanel: { es: "Cargando tu panel...", en: "Loading your panel..." },
    hello: { es: "Hola,", en: "Hi," },
    panelLemon: { es: "Club Pro", en: "Club Pro" },
    notifications: { es: "Notificaciones", en: "Notifications" },
    myProfile: { es: "Mi Perfil", en: "My Profile" },
    billingHistory: { es: "Mi Suscripción", en: "My Subscription" },
    contactSupport: { es: "Contactar Soporte", en: "Contact Support" },
    helpCenter: { es: "Centro de Ayuda", en: "Help Center" },
    adminPanel: { es: "Panel de Administrador", en: "Admin Panel" },
    fullLemonade: { es: "La Limonada Completa", en: "The Full Lemonade" },
    fullLemonadeDesc: {
      es: "Nuestro servicio <strong>llave en mano</strong>. Setup inicial + acompañamiento mensual con tu propio mentor del Retail. Agenda una entrevista y te preparamos un presupuesto a medida.",
      en: "Our <strong>turnkey</strong> service. Initial setup + monthly support with your own Retail mentor. Schedule an interview and we'll prepare a custom quote.",
    },
    scheduleInterview: { es: "Agendar Entrevista", en: "Schedule Interview" },
    roadmapTab: { es: "Checklist", en: "Checklist" },
    grantsTab: { es: "Subvenciones", en: "Grants" },
    brainstormTab: { es: "Brainstorming", en: "Brainstorming" },
    listView: { es: "Vista lista", en: "List view" },
    gridView: { es: "Vista grid", en: "Grid view" },
    freeNote: { es: "Nota", en: "Note" },
    personalCard: { es: "Tarea", en: "Task" },
    freeImage: { es: "Imagen", en: "Image" },
    customerService: { es: "Contactar Atención al Cliente", en: "Contact Customer Service" },
  },

  // ── Locked Dashboard ──
  locked: {
    title: { es: "Tu Hoja de Ruta Lemon: Desbloquea tu Potencial", en: "Your Lemon Roadmap: Unlock Your Potential" },
    subtitle: {
      es: "Completa el diagnóstico global para evaluar el estado real de tu negocio y unirte al acceso anticipado del Club Pro.",
      en: "Complete the global diagnosis to evaluate the real state of your business and join Club Pro early access.",
    },
    startQuiz: { es: "🍋 Comenzar diagnóstico", en: "🍋 Start diagnosis" },
    hasAccount: { es: "¿Ya tienes cuenta?", en: "Already have an account?" },
    loginLink: { es: "Inicia sesión", en: "Sign In" },
    unlockQuiz: { es: "Haz el Quiz para desbloquear", en: "Take the Quiz to unlock" },
    completeFirst: { es: "Completa el quiz primero para desbloquear este módulo 🍋", en: "Complete the quiz first to unlock this module 🍋" },
  },

  grantPrep: {
    button: { es: "Preparar subvención", en: "Prepare grant" },
    title: { es: "Análisis y documentación", en: "Analysis and paperwork" },
    intro: { es: "Analizamos la ayuda, te decimos qué documentos subir y preparamos la memoria y los papeles. La concesión la decide la administración.", en: "We analyse the grant, tell you which documents to upload and prepare the report and paperwork. The administration decides the award." },
    feesTitle: { es: "Tarifa", en: "Fees" },
    row1Label: { es: "Al empezar", en: "To start" },
    row1: { es: "150 €, se conceda o no.", en: "€150, awarded or not." },
    row2Label: { es: "Concedida 2.000 € o más", en: "Awarded €2,000 or more" },
    row2: { es: "10 % de lo concedido, menos los 150 €.", en: "10% of the award, minus the €150." },
    row3Label: { es: "Concedida de 1.000 € a 2.000 €", en: "Awarded €1,000 to €2,000" },
    row3: { es: "100 € más (total 250 €).", en: "€100 more (€250 total)." },
    row4Label: { es: "No concedida", en: "Not awarded" },
    row4: { es: "0 €. Sin segundo cobro.", en: "€0. No second charge." },
    dueNote: { es: "El pendiente solo se paga cuando se confirma la concesión solicitada.", en: "The outstanding amount is only paid once the requested award is confirmed." },
    legalToggle: { es: "Condiciones del servicio", en: "Service terms" },
    accept: { es: "He leído y acepto las condiciones y el compromiso de pago", en: "I have read and accept the terms and the payment commitment" },
    pay: { es: "Aceptar y pagar 150 €", en: "Accept and pay €150" },
    payFree: { es: "Aceptar y encargar (0 € hoy)", en: "Accept and order (€0 today)" },
    payAmount: { es: "Aceptar y pagar {amount}", en: "Accept and pay {amount}" },
    emptyOrders: { es: "Aquí verás las ayudas que nos encargues.", en: "Grants you ask us to prepare will appear here." },
    commissionOnAward: { es: "10 % al concederse", en: "10% upon award" },
    pendingBeforeAward: { es: "0 € hasta la concesión", en: "€0 until awarded" },
    tooSmall: { es: "Esta ayuda es pequeña. Pídela por tu cuenta.", en: "This grant is small. Apply for it yourself." },
    error: { es: "No se ha podido abrir el pago. Inténtalo de nuevo.", en: "We could not open the payment. Please try again." },
    paidToast: { es: "Encargo recibido: la ayuda ya está en Solicitudes.", en: "Order received: the grant is now in Requests." },
    tableTitle: { es: "Subvenciones solicitadas", en: "Grants you requested" },
    colGrant: { es: "Ayuda", en: "Grant" },
    colMax: { es: "Máximo", en: "Maximum" },
    colAwarded: { es: "Concedido", en: "Awarded" },
    colCommission: { es: "Comisión", en: "Commission" },
    colPaid: { es: "Pagado", en: "Paid" },
    colPending: { es: "Pendiente", en: "Outstanding" },
    colStatus: { es: "Estado", en: "Status" },
    colDocs: { es: "Documentos", en: "Documents" },
    docsAsk: { es: "Sube aquí los documentos que te pidamos.", en: "Upload the documents we ask for here." },
    upload: { es: "Subir documento", en: "Upload document" },
    uploadError: { es: "No se ha podido subir el archivo (máx. 10 MB, PDF o imagen).", en: "Could not upload the file (max 10 MB, PDF or image)." },
    dueBy: { es: "Pagar antes del", en: "Pay by" },
    overdue: { es: "Vencido", en: "Overdue" },
    status_encargada: { es: "Encargada", en: "Ordered" },
    status_en_preparacion: { es: "En preparación", en: "In preparation" },
    status_presentada: { es: "Presentada", en: "Filed" },
    status_concedida: { es: "Concedida", en: "Awarded" },
    status_denegada: { es: "Denegada", en: "Refused" },
    status_cobrada: { es: "Cobrada", en: "Paid in full" },
    markPreparing: { es: "Documentos completos", en: "Documents complete" },
    markSubmitted: { es: "Marcar presentada", en: "Mark filed" },
    markAwarded: { es: "Marcar concedida", en: "Mark awarded" },
    markDenied: { es: "Denegada", en: "Refused" },
    awardedTitle: { es: "¿Cuánto te han concedido?", en: "How much was awarded?" },
    awardedLabel: { es: "Importe concedido (€)", en: "Amount awarded (€)" },
    save: { es: "Guardar", en: "Save" },
    payPending: { es: "Pagar pendiente", en: "Pay outstanding" },
    markTransfer: { es: "Marcar transferencia recibida", en: "Mark transfer received" },
    saveError: { es: "No se ha podido guardar. Inténtalo de nuevo.", en: "Could not save. Please try again." },
  },
  roadmapGuides: {
    tipCalculator: { es: "Pon tus números reales, aunque sean aproximados. Mejor una cifra imperfecta hoy que una perfecta nunca.", en: "Use your real numbers, even rough ones. A rough figure today beats a perfect one never." },
    tipSuppliers: { es: "Pide siempre precio para 50, 100 y 200 unidades: así ves dónde baja de verdad y cuánto margen te deja.", en: "Always ask prices for 50, 100 and 200 units: you'll see where it really drops and what margin it leaves." },
    tipGrants: { es: "Mira primero el plazo y si encaja tu comunidad. Si cierra en menos de 15 días, va antes que todo lo demás.", en: "Check the deadline and your region first. If it closes in under 15 days, it goes before everything else." },
    tipSara: { es: "No hace falta hacerlo perfecto: hazlo en 20 minutos, márcalo y mejóralo la semana que viene.", en: "It doesn't need to be perfect: do it in 20 minutes, tick it and improve it next week." },
  },
  roadmapTips: {
    moda_finanzas: { es: "Calcula un coeficiente sobre el coste que deje margen también en rebajas; en moda suele rondar 2,5 a 3.", en: "Work out a markup on cost that still leaves margin in the sales; in fashion it is usually around 2.5 to 3." },
    moda_marketing: { es: "No vendas prendas, vende conjuntos listos para llevar; pon en el maniquí el look completo con bolso y zapato.", en: "Don't just sell clothes, sell ready-to-wear outfits; style the mannequin with the full bag-and-shoe look." },
    moda_equipo: { es: "Enseña al equipo a doblar y reponer perchas con la tienda abierta: el movimiento en tienda invita a comprar.", en: "Train your team to fold and tidy while the shop is open: movement in store invites people to buy." },
    moda_compras: { es: "Pide muestras de tejido y lávalas una vez antes de hacer un pedido grande para no llevarte sorpresas.", en: "Ask for fabric swatches and wash them once before placing a big order to avoid surprises." },
    moda_escaparate: { es: "Cambia con frecuencia la prenda del escaparate principal; quien pasa a diario pensará que tienes colección nueva.", en: "Rotate your main window outfit regularly; daily passers-by will think you have new stock in." },
    moda_digital: { es: "Sube vídeos cortos enseñando cómo queda la prenda en movimiento y con luz natural, sin filtros exagerados.", en: "Post short videos showing how garments look in motion under natural light, without heavy filters." },
    moda_legal: { es: "Asegúrate de que la etiqueta de composición y lavado cumpla la norma antes de colgar la prenda en tienda.", en: "Check that composition and care labels meet the rules before putting garments on the shop floor." },
    alimentacion_finanzas: { es: "Apunta la merma diaria en una libreta; lo que se tira al cerrar es beneficio que estás perdiendo.", en: "Log daily waste in a notebook; whatever gets thrown away at closing is profit slipping away." },
    alimentacion_marketing: { es: "El olor a recién hecho y una pequeña degustación en el mostrador suelen vender más que un cartel.", en: "A freshly made aroma and a small tasting on the counter often sell better than a poster." },
    alimentacion_equipo: { es: "Que todo el equipo pruebe cada producto nuevo; si no saben a qué sabe, no sabrán recomendarlo con chispa.", en: "Make sure your team tastes every new product; if they don't know the flavour, they can't recommend it warmly." },
    alimentacion_compras: { es: "Pide a los productores locales cantidades pequeñas pero frecuentes: producto siempre fresco sin acumular stock.", en: "Order smaller, more frequent batches from local producers to keep stock fresh without tying up cash." },
    alimentacion_escaparate: { es: "Ilumina el producto fresco con luz cálida dirigida; el color vivo entra por los ojos y abre el apetito.", en: "Light fresh produce with warm directional spots; vivid colour catches the eye and sparks appetite." },
    alimentacion_digital: { es: "Avisa por WhatsApp o en historias de Instagram cuando llegue una partida especial.", en: "Let people know on WhatsApp or Instagram stories when a special batch arrives." },
    alimentacion_legal: { es: "Ten al día la información de alérgenos y el registro de temperaturas de las neveras.", en: "Keep allergen information and fridge temperature logs up to date." },
    hogar_finanzas: { es: "En piezas grandes por encargo, cobra una señal antes de pedir al fabricante.", en: "On large made-to-order pieces, take a deposit before ordering from the maker." },
    hogar_marketing: { es: "Monta rincones reales (un rincón de lectura, una mesa puesta) para que el cliente se imagine viviendo con ello.", en: "Stage real corners (a reading nook, a laid table) so customers picture living with them." },
    hogar_equipo: { es: "Que el equipo sepa contar la historia de cada pieza: quién la hizo, con qué material y de qué taller viene.", en: "Your team should be able to tell the story of each piece: who made it, what it's made of and which workshop it comes from." },
    hogar_compras: { es: "Agrupa los pedidos de cerámica o bultos pesados para no dejarte el margen en portes.", en: "Batch pottery and heavy orders together so freight costs don't eat your margin." },
    hogar_escaparate: { es: "Juega con alturas y texturas en el escaparate; nunca pongas todo al mismo nivel.", en: "Vary heights and textures in your window; never put everything at the same level." },
    hogar_digital: { es: "Publica fotos de casas reales de tus clientes (con su permiso); la gente compra cuando ve el resultado puesto.", en: "Share photos of real customers' homes (with their permission); people buy when they see the finished look." },
    hogar_legal: { es: "Deja claras en el tique las condiciones de devolución de piezas por encargo y de roturas en el transporte.", en: "State return terms for made-to-order pieces and transport breakage clearly on the receipt." },
    belleza_finanzas: { es: "Calcula el coste por uso para recomendar rutinas completas sin asustar con el precio total.", en: "Work out the cost per use so you can suggest full routines without scaring people with the total price." },
    belleza_marketing: { es: "Ofrece una prueba rápida en la mano antes de hablar de precio; cuando notan la textura y el olor, la decisión es mucho más fácil.", en: "Offer a quick test on the hand before talking price; once they feel the texture and scent, deciding is much easier." },
    belleza_equipo: { es: "Que tu equipo conozca cada tipo de piel y sepa qué productos no conviene combinar.", en: "Make sure your team knows each skin type and which products shouldn't be combined." },
    belleza_compras: { es: "Negocia probadores y muestras con cada pedido; son tu mejor herramienta de venta.", en: "Negotiate testers and samples with every order; they are your best sales tool." },
    belleza_escaparate: { es: "Mantén el escaparate impecable y luminoso; la cosmética pide sensación de limpieza y orden.", en: "Keep the window spotless and bright; beauty calls for a feeling of cleanliness and order." },
    belleza_digital: { es: "Resuelve dudas comunes en vídeos cortos: cómo aplicar un sérum o en qué orden va la rutina.", en: "Answer common questions in short videos: how to apply a serum or what order a routine goes in." },
    belleza_legal: { es: "Vende solo productos con lote y con fecha o símbolo de caducidad tras abrir y notificados en el portal europeo CPNP.", en: "Only sell products with a batch number and with an expiry date or period-after-opening symbol, and notified on the EU CPNP portal." },
    regalo_finanzas: { es: "Un envoltorio bonito y una tarjeta escrita a mano hacen que el cliente valore más lo que se lleva.", en: "Lovely wrapping and a handwritten card make customers value what they take home even more." },
    regalo_marketing: { es: "Ten una mesa de «regalos para salir del paso» ordenada por tramos de precio para ponérselo fácil al cliente.", en: "Keep a quick-gift table sorted by price brackets to make buying easy." },
    regalo_equipo: { es: "Entrena al equipo a envolver rápido y bonito; una cola en caja por un lazo lento espanta al siguiente cliente.", en: "Train your team to wrap fast and neatly; a queue at the till over a slow ribbon drives the next customer away." },
    regalo_compras: { es: "Busca ilustradores y marcas pequeñas que no estén en grandes superficies para tener algo único en tu zona.", en: "Look for illustrators and small brands not found in big stores, so you have something unique in your area." },
    regalo_escaparate: { es: "Tematiza el escaparate por momentos del año (cumpleaños, vuelta al cole, amigo invisible) con un toque de humor.", en: "Theme your window around moments of the year (birthdays, back to school, Secret Santa) with a touch of humour." },
    regalo_digital: { es: "Enseña ideas de lotes combinando dos o tres detalles pequeños que juntos quedan espectaculares.", en: "Show bundle ideas pairing two or three small items that look spectacular together." },
    regalo_legal: { es: "Comprueba el marcado CE en juguetes antes de ponerlos a la venta.", en: "Check the CE mark on toys before putting them on sale." },
    general_finanzas: { es: "Revisa el margen de tus productos más vendidos; son los que sostienen tu negocio cada mes.", en: "Review the margin on your bestsellers; they sustain your business every month." },
    general_marketing: { es: "Llama a tus clientes habituales por su nombre; la tienda de barrio gana en cercanía lo que otros gastan en publicidad.", en: "Greet regulars by name; a neighbourhood shop wins on warmth what others spend on ads." },
    general_equipo: { es: "Poned por escrito qué se hace antes de abrir y antes de cerrar; el orden diario evita muchos fallos.", en: "Write down what gets done before opening and before closing; a daily routine prevents lots of slips." },
    general_compras: { es: "Pide siempre precio por volumen escalonado a tus proveedores antes de cerrar el pedido.", en: "Always ask suppliers for tiered volume prices before closing the order." },
    general_escaparate: { es: "Limpia los cristales a diario y enciende la luz del escaparate al atardecer: tu fachada es tu vendedor silencioso.", en: "Clean the windows daily and switch the window lights on at dusk: your shopfront is your silent salesperson." },
    general_digital: { es: "Responde con rapidez las reseñas de Google, tanto las buenas como las quejas.", en: "Reply promptly to Google reviews, the good ones and the complaints." },
    general_legal: { es: "Guarda las facturas con NIF completo de todos los gastos deducibles del trimestre.", en: "Keep invoices with full tax IDs for every deductible expense of the quarter." },
    legalNote: { es: "Consulta tu caso con un profesional.", en: "Consult your case with a professional." },
  },
  leakExtras: {
    includedInAdvanced: { es: "Incluido en Avanzado", en: "Included in Advanced" },
    seePlans: { es: "Ver planes", en: "See plans" },
  },
  roadmapStatus: {
    pending: { es: "Pendiente", en: "To do" },
    in_progress: { es: "En curso", en: "In progress" },
    completed: { es: "Hecha", en: "Done" },
    delegated: { es: "Delegada", en: "Delegated" },
    changeStatus: { es: "Cambiar estado", en: "Change status" },
    since: { es: "desde", en: "since" },
    noRequest: { es: "Sin solicitud registrada", en: "No request on file" },
    req_pending: { es: "Solicitud en revisión", en: "Request in review" },
    req_proposal_sent: { es: "Propuesta recibida", en: "Proposal received" },
    req_accepted: { es: "Propuesta aceptada", en: "Proposal accepted" },
    req_paid: { es: "Pagada", en: "Paid" },
    req_executing: { es: "En ejecución", en: "In progress" },
    req_completed: { es: "Completada", en: "Completed" },
    req_rejected: { es: "Rechazada", en: "Rejected" },
    req_other: { es: "Solicitud", en: "Request" },
  },
  roadmapTools: {
    title: { es: "Tus herramientas y plantillas", en: "Your tools and templates" },
    sub: { es: "Lo que ya has descargado, a mano para volver a abrirlo.", en: "What you've already downloaded, at hand to open again." },
    empty: { es: "Aún no has descargado nada. Las plantillas de cada módulo aparecerán aquí.", en: "Nothing downloaded yet. Each module's templates will show up here." },
    open: { es: "Abrir", en: "Open" },
    notePlaceholder: { es: "Una nota corta (opcional)", en: "A short note (optional)" },
    saved: { es: "Nota guardada", en: "Note saved" },
    saveError: { es: "No se ha podido guardar la nota", en: "Could not save the note" },
    openError: { es: "No se ha podido abrir el archivo", en: "Could not open the file" },
    typeFile: { es: "Archivo", en: "File" },
  },
  retailCalEvents: {
    reyes_eve_t: { es: "Víspera de Reyes", en: "Twelfth Night eve" },
    reyes_eve_r: { es: "Último gran día de regalo: horario ampliado, envoltorio rápido y producto estrella a la vista.", en: "Last big gift day: longer hours, quick gift-wrapping and your star product in sight." },
    reyes_t: { es: "Reyes", en: "Epiphany" },
    reyes_r: { es: "Festivo nacional. Mira si en tu comunidad es día de apertura y organiza descansos del equipo.", en: "National holiday. Check whether shops may open in your region and plan team rest days." },
    new_year_t: { es: "Año Nuevo", en: "New Year's Day" },
    new_year_r: { es: "Festivo nacional: día flojo en la calle. Aprovecha para descansar y dejar listas las rebajas.", en: "National holiday: quiet streets. Rest and get the January sales ready." },
    winter_sales_t: { es: "Rebajas de invierno", en: "Winter sales" },
    winter_sales_r: { es: "Arrancan las rebajas: cartelería clara los primeros días y producto de temporada bien colocado.", en: "Sales kick off: clear signs in the first days and seasonal stock well placed." },
    sales_transition_t: { es: "De rebajas a nueva temporada", en: "From sales to new season" },
    sales_transition_r: { es: "Retira el cartel grande de rebajas, deja uno pequeño de «rebajas en el interior» y enseña lo nuevo en la entrada.", en: "Take down the big sale sign, leave a small 'sale inside' card and show new stock at the entrance." },
    valentine_t: { es: "San Valentín", en: "Valentine's Day" },
    valentine_r: { es: "Regalos listos para llevar y opciones fáciles para quien no sabe qué elegir.", en: "Ready-to-go gifts and easy picks for people who can't decide." },
    andalucia_day_t: { es: "Día de Andalucía", en: "Andalusia Day" },
    andalucia_day_r: { es: "Festivo autonómico. Revisa apertura, turnos y si tu calle se llena o se vacía.", en: "Regional holiday. Check opening rules, shifts and whether your street fills up or empties." },
    spring_collection_t: { es: "Avance de primavera", en: "Spring preview" },
    spring_collection_r: { es: "Cambia escaparate e interior para que la tienda no huela a saldo.", en: "Change window and interior so the shop doesn't look like a clearance." },
    terrace_permit_t: { es: "Permiso de terraza", en: "Terrace permit" },
    terrace_permit_r: { es: "Revisa con tu ayuntamiento el plazo para pedir o renovar la terraza antes del buen tiempo.", en: "Check with your town hall the deadline to request or renew your terrace before the good weather." },
    fathers_day_t: { es: "Día del Padre", en: "Father's Day" },
    fathers_day_r: { es: "Ideas de regalo a la vista y comunicación a tus clientes habituales la semana antes.", en: "Gift ideas on show and a message to your regulars the week before." },
    easter_prep_t: { es: "Preparar Semana Santa", en: "Get ready for Easter" },
    easter_prep_r: { es: "Decide horario, stock y equipo: unas calles se vacían y otras se llenan de visitantes.", en: "Decide hours, stock and team: some streets empty while others fill with visitors." },
    good_friday_t: { es: "Viernes Santo", en: "Good Friday" },
    good_friday_r: { es: "Festivo nacional. Comprueba si puedes abrir en tu comunidad y qué marca tu convenio.", en: "National holiday. Check whether you may open in your region and what your agreement says." },
    easter_monday_t: { es: "Lunes de Pascua", en: "Easter Monday" },
    easter_monday_r: { es: "Festivo en tu comunidad. Planifica apertura y descansos del equipo.", en: "Holiday in your region. Plan opening and team rest." },
    labour_day_t: { es: "Día del Trabajo", en: "Labour Day" },
    labour_day_r: { es: "Festivo nacional. Organiza turnos y compensaciones con tiempo.", en: "National holiday. Sort out shifts and time off in advance." },
    madrid_day_t: { es: "Fiesta de la Comunidad de Madrid", en: "Madrid Region Day" },
    madrid_day_r: { es: "Festivo autonómico. Revisa horario y equipo.", en: "Regional holiday. Check hours and team." },
    mothers_day_t: { es: "Día de la Madre", en: "Mother's Day" },
    mothers_day_r: { es: "Uno de los grandes días de regalo: escaparate, packs y aviso a clientes con antelación.", en: "One of the big gift days: window, packs and an early message to customers." },
    summer_menu_t: { es: "Carta de verano", en: "Summer menu" },
    summer_menu_r: { es: "Pasa a platos frescos y bebidas de temporada; revisa precios y proveedores.", en: "Switch to fresh dishes and seasonal drinks; review prices and suppliers." },
    summer_plan_t: { es: "Plan de verano", en: "Summer plan" },
    summer_plan_r: { es: "Decide vacaciones, horario de verano y qué hacer en las semanas flojas.", en: "Decide holidays, summer hours and what to do in the quiet weeks." },
    sant_joan_t: { es: "Sant Joan", en: "Saint John's Day" },
    sant_joan_r: { es: "Festivo en Cataluña tras la verbena. Prepara stock la víspera y organiza el equipo.", en: "Holiday in Catalonia after the bonfire night. Stock up the day before and plan the team." },
    summer_sales_t: { es: "Rebajas de verano", en: "Summer sales" },
    summer_sales_r: { es: "Cartelería clara al principio y plan para liquidar sin quemar el margen.", en: "Clear signs at the start and a plan to clear stock without burning margin." },
    santiago_t: { es: "Día de Galicia", en: "Galicia Day" },
    santiago_r: { es: "Festivo autonómico con mucha gente en la calle en zonas turísticas.", en: "Regional holiday with busy streets in tourist areas." },
    august_valley_t: { es: "Agosto flojo", en: "Quiet August" },
    august_valley_r: { es: "Mes flojo en muchas calles: es el momento de apretar con acciones a clientes fieles o de descansar con plan.", en: "A quiet month on many streets: push with loyal-customer actions or rest with a plan." },
    assumption_t: { es: "Asunción", en: "Assumption Day" },
    assumption_r: { es: "Festivo nacional en pleno verano: revisa si tu zona se vacía o se llena.", en: "National holiday mid-summer: check whether your area empties or fills." },
    back_to_school_t: { es: "Vuelta al cole", en: "Back to school" },
    back_to_school_r: { es: "Vuelta a la rutina: novedades de temporada y comunicación a familias.", en: "Back to routine: new season items and a message to families." },
    diada_t: { es: "Diada", en: "National Day of Catalonia" },
    diada_r: { es: "Festivo en Cataluña. Revisa apertura y turnos.", en: "Holiday in Catalonia. Check opening and shifts." },
    autumn_menu_t: { es: "Carta de otoño", en: "Autumn menu" },
    autumn_menu_r: { es: "Llegan los platos de cuchara y la temporada de setas o caza; ajusta carta y proveedores.", en: "Hearty dishes and mushroom or game season arrive; adjust menu and suppliers." },
    winter_plan_t: { es: "Plan de invierno", en: "Winter plan" },
    winter_plan_r: { es: "Prepara la campaña fuerte: compras, equipo, horarios y fechas clave hasta Reyes.", en: "Get the big season ready: purchases, team, hours and key dates up to Epiphany." },
    valencia_day_t: { es: "Día de la Comunitat Valenciana", en: "Valencian Community Day" },
    valencia_day_r: { es: "Festivo autonómico. Revisa apertura y equipo.", en: "Regional holiday. Check opening and team." },
    hispanic_day_t: { es: "Fiesta Nacional", en: "National Day" },
    hispanic_day_r: { es: "Festivo nacional y a menudo puente: mira si tu calle se llena o se vacía.", en: "National holiday, often a long weekend: see whether your street fills or empties." },
    xmas_packaging_t: { es: "Pedir packaging de Navidad", en: "Order Christmas packaging" },
    xmas_packaging_r: { es: "Bolsas, papel y cajas de regalo: si lo pides tarde, no llega o te sale más caro.", en: "Bags, wrapping and gift boxes: order late and it won't arrive or costs more." },
    xmas_supplies_t: { es: "Proveedores de Navidad", en: "Christmas suppliers" },
    xmas_supplies_r: { es: "Cierra pedidos de bebida, producto fresco y reservas de grupos antes de que se llenen las agendas.", en: "Close orders for drinks, fresh produce and group bookings before diaries fill up." },
    all_saints_t: { es: "Todos los Santos", en: "All Saints' Day" },
    all_saints_r: { es: "Festivo nacional. Revisa apertura y turnos.", en: "National holiday. Check opening and shifts." },
    xmas_lights_t: { es: "Encendido de luces y escaparate de Navidad", en: "Christmas lights and window" },
    xmas_lights_r: { es: "La calle se llena: ten el escaparate o la decoración de Navidad montados para ese día.", en: "Streets fill up: have your Christmas window or decoration ready that day." },
    black_friday_t: { es: "Black Friday", en: "Black Friday" },
    black_friday_r: { es: "Decide si entras y cómo: promoción clara, stock preparado y aviso a tus clientes la semana antes.", en: "Decide whether and how you join: a clear offer, stock ready and a message to customers the week before." },
    company_dinners_t: { es: "Cenas de empresa", en: "Company dinners" },
    company_dinners_r: { es: "Temporada de grupos: menú cerrado, reservas con señal y refuerzo del equipo.", en: "Group season: set menu, bookings with deposit and extra staff." },
    xmas_campaign_t: { es: "Campaña de Navidad", en: "Christmas campaign" },
    xmas_campaign_r: { es: "Las semanas que más venden: horario, equipo, envoltorio y stock de lo que más sale.", en: "Your best-selling weeks: hours, team, gift-wrapping and stock of your best sellers." },
    constitution_t: { es: "Día de la Constitución", en: "Constitution Day" },
    constitution_r: { es: "Festivo nacional y puente: revisa apertura, turnos y compensaciones del convenio.", en: "National holiday and long weekend: check opening, shifts and agreement compensation." },
    immaculate_t: { es: "Inmaculada", en: "Immaculate Conception" },
    immaculate_r: { es: "Festivo nacional en plena campaña. Mira si puedes abrir y qué te cuesta en equipo.", en: "National holiday mid-campaign. See whether you may open and what it costs in staff." },
    christmas_t: { es: "Navidad", en: "Christmas Day" },
    christmas_r: { es: "Festivo nacional. Organiza descansos y deja la víspera bien preparada.", en: "National holiday. Plan rest and get Christmas Eve well prepared." },
    sant_esteve_t: { es: "Sant Esteve", en: "Saint Stephen's Day" },
    sant_esteve_r: { es: "Festivo en tu comunidad. Planifica apertura y equipo.", en: "Holiday in your region. Plan opening and team." },
    new_year_eve_t: { es: "Nochevieja", en: "New Year's Eve" },
    new_year_eve_r: { es: "Reservas, menú especial y pedidos a proveedores cerrados con tiempo.", en: "Bookings, special menu and supplier orders closed in good time." },
    inventory_t: { es: "Inventario de fin de año", en: "Year-end stock count" },
    inventory_r: { es: "Cuenta el género antes de cerrar el año y decide qué liquidar en rebajas.", en: "Count stock before year end and decide what to clear in the sales." },
  },
  retailCal: {
    title: { es: "Próximas fechas clave", en: "Upcoming key dates" },
    sub: { es: "Los próximos 30 días de tu calle.", en: "The next 30 days on your street." },
    empty: { es: "No hay fechas activas en los próximos 30 días.", en: "No active dates in the next 30 days." },
    manage: { es: "Gestionar mi calendario", en: "Manage my calendar" },
    today: { es: "Hoy", en: "Today" },
    inDays: { es: "en {n} días", en: "in {n} days" },
    inOneDay: { es: "mañana", en: "tomorrow" },
    ongoing: { es: "en marcha", en: "ongoing" },
    modalTitle: { es: "Calendario comercial", en: "Business calendar" },
    modalSub: { es: "Campañas, cambios de oferta, compras y festivos. Activa lo que te sirve y añade tus fechas.", en: "Campaigns, offer changes, purchasing and holidays. Turn on what helps you and add your own dates." },
    cat_all: { es: "Todas", en: "All" },
    cat_sales: { es: "Venta", en: "Sales" },
    cat_offer: { es: "Oferta, carta y escaparate", en: "Offer, menu and window" },
    cat_purchases: { es: "Proveedores y plazos", en: "Suppliers and deadlines" },
    cat_legal: { es: "Festivos, ley y equipo", en: "Holidays, law and team" },
    src_system: { es: "Oficial", en: "Official" },
    src_ai: { es: "Sugerencia Sara IA", en: "Sara AI suggestion" },
    src_user: { es: "Creada por ti", en: "Created by you" },
    h30: { es: "30 días", en: "30 days" },
    h90: { es: "90 días", en: "90 days" },
    h365: { es: "Año", en: "Year" },
    showInactive: { es: "Ver desactivadas", en: "Show turned off" },
    active: { es: "Activa", en: "On" },
    addOwn: { es: "+ Fecha propia", en: "+ Own date" },
    backToList: { es: "Volver", en: "Back" },
    newDate: { es: "Nueva fecha", en: "New date" },
    editDate: { es: "Editar fecha", en: "Edit date" },
    moreInfo: { es: "Más información y notas", en: "More info and notes" },
    fDate: { es: "Fecha", en: "Date" },
    fEnd: { es: "Hasta (opcional)", en: "Until (optional)" },
    fTitle: { es: "Nombre", en: "Name" },
    fCategory: { es: "Tipo", en: "Type" },
    fReason: { es: "¿Por qué es importante?", en: "Why does it matter?" },
    fLead: { es: "Avísame con", en: "Remind me" },
    leadDays: { es: "{n} días antes", en: "{n} days before" },
    save: { es: "Guardar", en: "Save" },
    cancel: { es: "Cancelar", en: "Cancel" },
    edit: { es: "Editar", en: "Edit" },
    delete: { es: "Borrar", en: "Delete" },
    notes: { es: "Tu nota", en: "Your note" },
    notesPh: { es: "Ej.: abrimos solo por la mañana", en: "E.g. we only open in the morning" },
    saved: { es: "Guardado", en: "Saved" },
    saveError: { es: "No se ha podido guardar", en: "Could not save" },
    radarTitle: { es: "Novedades de Sara IA para tu zona", en: "Sara AI news for your area" },
    radarIntro: { es: "Como tu negocio es de {sector} y estás en {place}, he encontrado estas fechas. ¿Las incorporamos?", en: "As your business is in {sector} and you're in {place}, I found these dates. Shall we add them?" },
    radarIntroNoPlace: { es: "Completa tu ciudad y comunidad en Mi Perfil para que pueda buscar las fechas de tu zona.", en: "Add your city and region in My Profile so I can look up your area's dates." },
    radarLoading: { es: "Sara IA está revisando el calendario de tu zona…", en: "Sara AI is checking your area's calendar…" },
    radarNone: { es: "Este mes no hay novedades nuevas para tu zona.", en: "No new dates for your area this month." },
    radarError: { es: "Sara IA no ha podido revisar ahora tu zona. Inténtalo más tarde.", en: "Sara AI couldn't check your area right now. Try again later." },
    acceptAll: { es: "Incorporar todas", en: "Add them all" },
    accept: { es: "Incorporar", en: "Add" },
    dismiss: { es: "Descartar", en: "Dismiss" },
    legalRetail: { es: "En comercio, abrir un festivo depende de tu comunidad, el tamaño del local y la zona. Si trabaja tu equipo, mira qué marca tu convenio (plus o día de descanso compensado).", en: "For shops, opening on a holiday depends on your region, shop size and area. If your team works, check what your agreement says (extra pay or compensated rest)." },
    legalHosp: { es: "En hostelería puedes abrir. Planifica turnos, refuerzos y las compensaciones que marque tu convenio.", en: "Hospitality may open. Plan shifts, extra staff and any compensation your agreement sets." },
    legalNote: { es: "Orientativo: consulta tu caso con un profesional.", en: "For guidance only: check your case with a professional." },
    yourSector: { es: "tu sector", en: "your sector" },
    calSub: { es: "Tu mes comercial de un vistazo.", en: "Your trading month at a glance." },
    prevMonth: { es: "Mes anterior", en: "Previous month" },
    nextMonth: { es: "Mes siguiente", en: "Next month" },
    backToday: { es: "Hoy", en: "Today" },
    monthEmpty: { es: "Este mes no tienes fechas marcadas. Pídele ideas a Sara IA o añade la tuya.", en: "No dates marked this month. Ask Sara AI for ideas or add your own." },
    dayEmpty: { es: "Nada marcado este día.", en: "Nothing marked on this day." },
    showMonth: { es: "Ver todo el mes", en: "See the whole month" },
    tabMonth: { es: "Calendario", en: "Calendar" },
    tabDates: { es: "Fechas del mes", en: "This month's dates" },
    swipeHint: { es: "Desliza para cambiar de mes", en: "Swipe to change month" },
    saraCta: { es: "Configurar con Sara IA", en: "Set up with Sara AI" },
    saraCtaReview: { es: "Revisar con Sara IA", en: "Review with Sara AI" },
    saraClose: { es: "Cerrar a Sara IA", en: "Close Sara AI" },
    saraHello: { es: "Reviso {month} para tu negocio de {sector} en {place}: fiestas de tu zona, puentes que valen la pena y los días que más se vende.", en: "I'm checking {month} for your {sector} business in {place}: local festivities, long weekends worth opening and your best-selling days." },
    saraFound: { es: "Esto es lo que te propongo. Marca lo que te sirva y lo verás al momento en tu calendario.", en: "Here's what I suggest. Add what helps and you'll see it on your calendar right away." },
    saraDone: { es: "Hecho: todo lo que te propuse para este mes ya está decidido. Cambia de mes y te reviso el siguiente.", en: "Done: everything I suggested for this month is decided. Switch month and I'll check the next one." },
    saraTip: { es: "Consejo: activa solo lo que de verdad vayas a preparar. Así la misión de la semana te avisará a tiempo.", en: "Tip: only turn on what you'll really prepare. Then the weekly mission will remind you in time." },
    saraMore: { es: "Ya tienes las fechas clave de {month}. ¿Buscamos más? Dime qué fecha te falta y te la pongo en el calendario.", en: "You've got the key dates for {month}. Want more? Tell me which date is missing and I'll add it to your calendar." },
    saraAskLocal: { es: "Festivos y fiestas de mi ciudad", en: "Holidays and festivities in my city" },
    saraAskFairs: { es: "Ferias y eventos de mi sector", en: "Trade fairs and events in my sector" },
    saraAskSuppliers: { es: "Plazos de pedidos a proveedores", en: "Supplier order deadlines" },
    saraAskPh: { es: "Pídele una fecha a Sara IA", en: "Ask Sara AI for a date" },
    saraAskSend: { es: "Buscar", en: "Search" },
    saraExpand: { es: "Ampliar", en: "Expand" },
    saraBigPrefill: { es: "Quiero revisar contigo mi calendario de {month}: ", en: "I'd like to review my {month} calendar with you: " },
    brandRename: { es: "Nombre de este color", en: "Name for this colour" },
    addToCal: { es: "Marcar en mi calendario", en: "Add to my calendar" },
    note: { es: "Nota", en: "Note" },
    fColor: { es: "Color", en: "Colour" },
    color_red: { es: "Rojo · urgente", en: "Red · urgent" },
    color_orange: { es: "Naranja · campaña", en: "Orange · campaign" },
    color_gold: { es: "Dorado · hito", en: "Gold · milestone" },
    color_green: { es: "Verde · género", en: "Green · stock" },
    color_blue: { es: "Azul · proveedores", en: "Blue · suppliers" },
    color_violet: { es: "Violeta · VIP", en: "Violet · VIP" },
    color_teal: { es: "Turquesa · trámites", en: "Teal · paperwork" },
    color_graphite: { es: "Antracita · interno", en: "Charcoal · internal" },
    legendTitle: { es: "Tu código de colores", en: "Your colour code" },
    legendHint: { es: "Toca un color, elige el tono en la rueda y ponle nombre. Sara IA lo usará al proponerte fechas.", en: "Tap a colour, pick the shade on the wheel and name it. Sara AI will use it when suggesting dates." },
    legendAdd: { es: "Añadir color", en: "Add colour" },
    pickTone: { es: "Elige el tono", en: "Pick the shade" },
    colorName: { es: "Nombre del color", en: "Colour name" },
    colorNamePh: { es: "Ej.: Llegada de colección", en: "E.g. New collection arrives" },
    colorRemove: { es: "Quitar de la leyenda", en: "Remove from legend" },
    colorDone: { es: "Listo", en: "Done" },
    legendBrand: { es: "Campañas y festivos", en: "Campaigns and holidays" },
    legendOwn: { es: "Tus fechas", en: "Your dates" },
    swapSides: { es: "Cambiar de lado", en: "Swap sides" },
    collapse: { es: "Plegar calendario", en: "Collapse calendar" },
    expand: { es: "Desplegar calendario", en: "Expand calendar" },
  },
  roadmapUx: {
    advancedBadge: { es: "Incluido en Avanzado", en: "Included in Advanced" },
    advancedChip: { es: "Plan Avanzado", en: "Advanced Plan" },
    advancedGain: { es: "Este módulo forma parte del Plan Avanzado (99 €/mes). Para verlo, solo tienes que activar ese plan.", en: "This module is part of the Advanced plan (€99/month). To see it, just switch to that plan." },
    advancedCta: { es: "Ver plan Avanzado", en: "See Advanced plan" },
    advancedOnly: { es: "Plan Avanzado", en: "Advanced plan" },
    hideDone: { es: "Ocultar tareas hechas", en: "Hide done tasks" },
    allDoneHidden: { es: "Todo hecho aquí. Las tareas están ocultas.", en: "All done here. Tasks are hidden." },
    allDoneForNow: { es: "Todo completado por ahora 🎉", en: "All done for now 🎉" },
    taskOne: { es: "tarea", en: "task" },
    taskMany: { es: "tareas", en: "tasks" },
    m0: { es: "Arranque", en: "Getting going" },
    m25: { es: "Primeros pasos", en: "First steps" },
    m50: { es: "Medio camino", en: "Halfway there" },
    m100: { es: "Módulo dominado", en: "Module mastered" },
    nextMilestone: { es: "Siguiente hito", en: "Next milestone" },
    guideToggle: { es: "Truco y atajo", en: "Tip and shortcut" },
    guideTip: { es: "El truco", en: "The trick" },
    actCalculator: { es: "Abrir calculadora", en: "Open calculator" },
    actSuppliers: { es: "Ver proveedores", en: "See suppliers" },
    actGrants: { es: "Ver subvenciones", en: "See grants" },
    actSara: { es: "Preguntar a Sara IA", en: "Ask Sara AI" },
    missionTitle: { es: "Misión de la semana", en: "Mission of the week" },
    missionSub: { es: "3 cosas para esta semana. El resto puede esperar.", en: "3 things for this week. The rest can wait." },
    missionLoading: { es: "Sara IA está preparando tu misión…", en: "Sara AI is preparing your mission…" },
    missionError: { es: "No hemos podido preparar la misión ahora.", en: "We couldn't prepare the mission right now." },
    missionRetry: { es: "Reintentar", en: "Retry" },
    missionEmpty: { es: "No te queda nada pendiente. ¡Buen trabajo!", en: "Nothing left pending. Great work!" },
  },
  roadmapLocked: {
    title: { es: "Hoja de Ruta", en: "Roadmap" },
    badge: { es: "Exclusivo Club Pro", en: "Club Pro exclusive" },
    description: {
      es: "Aquí se ordena todo el negocio: qué módulo atacar, en qué orden y qué hacer esta semana. Es el tablero de trabajo del Club Pro.",
      en: "This is where your whole business gets organised: which module to tackle, in what order, and what to do this week. It is the Club Pro workspace.",
    },
    cta: { es: "Club Pro · 69 €/mes", en: "Club Pro · €69/month" },
  },
  tipsLocked: {
    title: { es: "Consejos e Ideas", en: "Tips & Ideas" },
    badge: { es: "Acceso anticipado", en: "Early access" },
    description: {
      es: "Consejos e ideas para el día a día del local.",
      en: "Tips and ideas for the day-to-day running of your premises.",
    },
    cta: { es: "Unirme al acceso anticipado", en: "Join early access" },
  },

  proposalsLocked: {
    title: { es: "Proveedores", en: "Suppliers" },
    badge: { es: "+ Extra · Avanzado", en: "+ Extra · Advanced" },
    description: {
      es: "Te proponemos proveedores con los que ya trabajamos, según lo que tu negocio esté buscando. Tú eliges.",
      en: "We suggest suppliers we already work with, based on what your business is looking for. You choose.",
    },
    cta: { es: "Club Pro · 69 €/mes", en: "Club Pro · €69/month" },
  },


  // ── Module Card ──
  moduleCard: {
    criticalArea: { es: "Área crítica", en: "Critical" },
    improvable: { es: "Mejorable", en: "Improvable" },
    controlled: { es: "Controlado", en: "Controlled" },
    lemonStatus: { es: "Estado del limón:", en: "Lemon status:" },
    unlockFull: { es: "Desbloquear Kit Completo", en: "Unlock Full Kit" },
    unlock: { es: "Desbloquear", en: "Unlock" },
    weDoItForYou: { es: "Nosotros lo hacemos por ti", en: "We do it for you" },
    moduleUnlocked: { es: "✅ Módulo desbloqueado — Nosotros lo hacemos por ti", en: "✅ Module unlocked — We do it for you" },
    moduleUnlockedShort: { es: "✅ Desbloqueado", en: "✅ Unlocked" },
    askSherpa: { es: "💬 Escribe a tu equipo...", en: "💬 Message your team..." },
    sherpaLocked: { es: "🔒 Desbloquea este módulo para chatear con tu equipo", en: "🔒 Unlock this module to chat with your team" },
    sherpaSent: { es: "Tu mensaje se ha enviado 🍋", en: "Your message has been sent 🍋" },
    sherpaError: { es: "Error al enviar", en: "Error sending" },
    sherpaRetry: { es: "Inténtalo de nuevo.", en: "Try again." },
    dato: { es: "Dato:", en: "Fact:" },
    dialedIn: { es: "Afinado", en: "Dialed in" },
    celebrationToastTitle: { es: "🍋 Módulo afinado", en: "🍋 Module dialed in" },
    celebrationToastDesc: { es: "Pero en retail nunca se acaba — vuelve mañana a pulir detalles.", en: "But in retail it's never done — come back tomorrow to refine." },
    neverDoneAdvice: { es: "El retail nunca duerme. Revisa este módulo cada mes para mantenerlo afinado.", en: "Retail never sleeps. Revisit this module monthly to keep it sharp." },
    solutionTooltip: { es: "Solución recomendada", en: "Recommended solution" },
    expandInfo: { es: "Tu evolución esta semana", en: "Your weekly focus" },
    hideInfo: { es: "Ocultar comentario", en: "Hide comment" },
    weeklyLoading: { es: "Generando tu comentario semanal…", en: "Generating your weekly comment…" },
    weeklyError: { es: "No se pudo generar el comentario. Inténtalo de nuevo en un momento.", en: "Couldn't generate the comment. Try again in a moment." },
    weeklyRetry: { es: "Reintentar", en: "Retry" },
    lockedTeaserTitle: { es: "Qué ganas al activar este módulo", en: "What you gain by unlocking this module" },
    sendMessage: { es: "Enviar mensaje", en: "Send message" },
  },

  // ── Solution Modal (Partner / Lead Generation) ──
  solution: {
    optionA: { es: "Opción A · Quiero solicitar un presupuesto / propuesta a medida.", en: "Option A · I want to request a custom quote / proposal." },
    optionADetails: { es: "Detalla qué necesitas...", en: "Tell us what you need..." },
    optionAAreas: { es: "Selecciona qué áreas necesitas cubrir:", en: "Select which areas you need to cover:" },
    optionB: { es: "Opción B · Quiero que un experto audite mi situación / proveedor actual.", en: "Option B · I want an expert to audit my current situation / provider." },
    auditLockedTitle: { es: "🔒 Servicio exclusivo de Mentoring", en: "🔒 Exclusive Mentoring service" },
    auditLockedBody: { es: "La auditoría comparativa de tus condiciones actuales es un servicio exclusivo de nuestro programa de Mentoring con tu mentor personal.", en: "The comparative audit of your current conditions is an exclusive service of our Mentoring program with your personal mentor." },
    auditLockedCta: { es: "Hablar con un mentor sobre el Mentoring", en: "Talk to a mentor about Mentoring" },
    auditVipBody: { es: "Indícanos qué proveedor tienes ahora y qué condiciones pagas. Adjunta tu contrato actual y tu mentor lo revisará en vuestra próxima sesión para buscarte una mejora.", en: "Tell us which provider you have now and what you're paying. Attach your current contract and your mentor will review it in your next session to look for improvements." },
    auditVipPlaceholder: { es: "Cuéntanos: aseguradora / proveedor actual, importe, fecha de renovación...", en: "Tell us: current provider, amount, renewal date..." },
    attachLabel: { es: "Adjuntar contrato (PDF, imagen — máx 5MB)", en: "Attach contract (PDF, image — max 5MB)" },
    submit: { es: "Enviar solicitud", en: "Send request" },
    submitting: { es: "Enviando...", en: "Sending..." },
    successTitle: { es: "¡Solicitud enviada!", en: "Request sent!" },
    successBudget: { es: "Te contactaremos en menos de 48h con una propuesta a medida.", en: "We'll contact you in less than 48h with a custom proposal." },
    successAudit: { es: "Tu mentor lo revisará en tu próxima sesión con Tu Mentor.", en: "Your mentor will review it in your next session with Your Mentor." },
    errorTitle: { es: "No se pudo enviar", en: "Could not send" },
    fileTooBig: { es: "El archivo supera 5MB", en: "File exceeds 5MB" },
    requiredDetails: { es: "Por favor, describe tu necesidad", en: "Please describe your need" },
    poweredBy: { es: "En colaboración con", en: "In collaboration with" },
  },

  // ── Module Detail Modal ──
  moduleDetail: {
    yourScore: { es: "Tu puntuación:", en: "Your score:" },
    productionKit: { es: "1. Tu Kit de Producción", en: "1. Your Production Kit" },
    activeSherpa: { es: "2. Tu Mentor Activo", en: "2. Your Active Mentor" },
    unlockModule: { es: "Desbloquear Módulo · 97€", en: "Unlock Module · €97" },
    includes1stMonth: {
      es: "(Incluye el 1º mes de mentoría. Luego 49€/mes, flexible mes a mes)",
      en: "(Includes 1st month of mentoring. Then €49/month, flexible month to month)",
    },
    orDelegate: { es: "— o si prefieres delegarlo absolutamente todo —", en: "— or if you prefer to delegate absolutely everything —" },
    scheduleInterview: { es: "📅 Agendar Entrevista (Llave en Mano)", en: "📅 Schedule Interview (Turnkey)" },
  },

  // ── Quiz Modal ──
  quiz: {
    questionOf: { es: "Pregunta", en: "Question" },
    of: { es: "de", en: "of" },
    almostDone: { es: "¡Ya casi! Déjanos tus datos para ver tu diagnóstico.", en: "Almost done! Leave your details to see your diagnosis." },
    analyzed: {
      es: "Hemos analizado tus respuestas. Introduce tus datos y descubre tu",
      en: "We've analyzed your answers. Enter your details and discover your",
    },
    lemonReport: { es: "Lemon Report", en: "Lemon Report" },
    seeResults: { es: "Ver mis Resultados", en: "See My Results" },
    preparingDiagnosis: { es: "Preparando tu diagnóstico…", en: "Preparing your diagnosis…" },
    analyzingAnswers: { es: "Analizando tus respuestas…", en: "Analyzing your answers…" },
    calculatingLevel: { es: "Calculando tu nivel de control…", en: "Calculating your control level…" },
    generatingReport: { es: "Generando tu Informe Lemon…", en: "Generating your Lemon Report…" },
    enterName: { es: "Introduce tu nombre", en: "Enter your name" },
    enterLastName: { es: "Introduce tu apellido", en: "Enter your last name" },
    invalidEmail: { es: "Introduce un email válido", en: "Enter a valid email" },
    requiredField: { es: "Este campo es obligatorio", en: "This field is required" },
    namePlaceholder: { es: "Nombre", en: "First Name" },
    lastNamePlaceholder: { es: "Apellido", en: "Last Name" },
    globalQuizTitle: { es: "Quiz Global Lemon 🍋", en: "Lemon Global Quiz 🍋" },
    globalQuizGift: { es: "Tu Lemon Report Completo", en: "Your Complete Lemon Report" },
    checklistTitle: { es: "Check-list de tu Negocio", en: "Your Business Check-list" },
    fullPack: { es: "Pack Lemon Completo", en: "Complete Lemon Pack" },
    previewTitle: { es: "Tu nota Lemon preliminar", en: "Your preliminary Lemon score" },
    previewSubtitle: {
      es: "Esto es lo que hemos detectado. Desbloquea el informe completo con tus áreas críticas, recomendaciones y radar visual.",
      en: "This is what we found. Unlock the full report with your critical areas, recommendations and visual radar.",
    },
    previewWeakAreas: { es: "Áreas con más margen de mejora", en: "Areas with most room to improve" },
    previewLockedHint: {
      es: "Recomendaciones, radar y plan de acción bloqueados",
      en: "Recommendations, radar and action plan locked",
    },
    previewAllAreas: { es: "Todas las áreas analizadas", en: "All analysed areas" },
    previewLockedHintFull: {
      es: "Déjanos tu nombre, apellido y email para ver el desglose completo, recomendaciones y radar visual.",
      en: "Leave us your first name, last name and email to see the full breakdown, recommendations and visual radar.",
    },
    previewCta: { es: "Desbloquear mi Lemon Report completo →", en: "Unlock my full Lemon Report →" },
    previewTrust: {
      es: "Sin spam. Recibirás tu diagnóstico completo al instante.",
      en: "No spam. You'll get your full diagnosis instantly.",
    },
    startDiagnosis: { es: "Comenzar Diagnóstico", en: "Start Diagnosis" },
  },

  // ── Instagram LP Quiz ──
  instagramQuiz: {
    heroChip: { es: "PARA DUEÑOS DE NEGOCIOS A PIE DE CALLE", en: "FOR STREET-LEVEL BUSINESS OWNERS" },
    heroTitleBefore: { es: "Haz ", en: "Grow " },
    heroTitleHighlight: { es: "crecer tu negocio", en: "your business" },
    heroTitleAfter: { es: " con la estrategia de los que ya lo han conseguido", en: " with the strategy of those who have already made it" },
    heroTitle: { es: "Haz crecer tu negocio con la estrategia de los que ya lo han conseguido", en: "Grow your business with the strategy of those who have already made it" },
    heroLine1Label: { es: "PERSONAL Y CONTRATOS:", en: "STAFF & CONTRACTS:" },
    heroLine1Text: { es: " Evita problemas de equipo y amarra bien tus acuerdos.", en: " Avoid team problems and lock down your agreements." },
    heroLine2Label: { es: "SUBVENCIONES Y ALQUILER:", en: "GRANTS & RENT:" },
    heroLine2Text: { es: " Consigue ayudas públicas y negocia tu local como las grandes marcas.", en: " Get public grants and negotiate your lease like the big brands." },
    heroLine3Label: { es: "MARKETING E INTERNET:", en: "MARKETING & INTERNET:" },
    heroLine3Text: { es: " Multiplica tu visibilidad, atrae clientes y domina tus reseñas en Google.", en: " Multiply your visibility, attract customers and dominate your Google reviews." },
    heroLine4Label: { es: "DÍA A DÍA Y NEGOCIACIÓN:", en: "DAY-TO-DAY & NEGOTIATION:" },
    heroLine4Text: { es: " Tengas el local abierto o vayas a inaugurar, ", en: " Whether your shop is open or about to launch, " },
    heroLine4Strong: { es: "las reglas son las mismas", en: "the rules are the same" },
    heroLine4End: { es: ".", en: "." },
    quizStart: { es: "Inicio", en: "Home" },
    quizBack: { es: "← Volver", en: "← Back" },

    q1Title: { es: "¿En qué punto está tu negocio?", en: "Where does your business stand?" },
    q1OptionA: { es: "Ya tengo un local abierto", en: "I already have a shop open" },
    q1OptionB: { es: "Voy a abrir un local nuevo", en: "I'm opening a new shop" },
    q2Title: { es: "¿Cuál es tu principal dolor de cabeza?", en: "What's your main headache?" },
    q2OptionA: { es: "No voy al día con los pagos y no llego a final de mes", en: "I can't keep up with payments and can't make it to month-end" },
    q2OptionB: { es: "Problemas con el personal, proveedores, suministros u otros", en: "Issues with staff, suppliers, supplies or other" },
    q2OptionC: { es: "Negociación de contratos y solicitud de subvenciones", en: "Contract negotiation and grant applications" },
    analyzingTitle: { es: "Analizando datos...", en: "Analyzing data..." },
    resultBadge: { es: "Podemos ayudarte", en: "We can help" },
    resultTitle: { es: "Únete a los comerciantes que ya han dado un impulso a su local y han hecho crecer su negocio.", en: "Join shop owners who have already given their business a boost and made it grow." },
    resultSubtitle: { es: "Da el primer paso hoy y toma el control de tu negocio, tus clientes y tu tranquilidad.", en: "Take the first step today and take control of your business, your customers and your peace of mind." },
    ctaFree: { es: "Acceso anticipado", en: "Early access" },
    ctaUnlock: { es: "Desbloquear todo el panel · 69 €/mes", en: "Unlock the full panel · €69/mo" },
    ctaFreeMicrocopyEarly: { es: "Acceso anticipado · Te avisamos cuando abramos", en: "Early access · We'll let you know when we launch" },
    ctaFreeMicrocopy: { es: "Acceso anticipado · Registro en 30 segundos", en: "Early access · 30-second signup" },
    questionCounter: { es: "Paso {current} de {total}", en: "Step {current} of {total}" },
    diagTitle: { es: "Lo que hemos detectado en tu caso", en: "What we spotted in your case" },
    diagOpenCash1: { es: "Tu caja manda sobre tus decisiones: pagas lo urgente y no lo importante.", en: "Cash dictates your decisions: you pay what's urgent, not what matters." },
    diagOpenCash2: { es: "Falta una foto semanal de entradas, salidas y margen real por producto.", en: "You lack a weekly view of money in, money out and real margin per product." },
    diagOpenCash3: { es: "Sin prioridades claras, cada mes se repite el mismo apretón.", en: "Without clear priorities, the same squeeze repeats every month." },
    diagOpenTeam1: { es: "El equipo depende de ti para todo y tu tiempo se va en apagar fuegos.", en: "The team depends on you for everything and your time goes to firefighting." },
    diagOpenTeam2: { es: "Los cuadrantes se hacen a última hora y no cuadran con las horas punta.", en: "Schedules are made last minute and don't match peak hours." },
    diagOpenTeam3: { es: "Sin rutinas escritas, cada semana se improvisa desde cero.", en: "Without written routines, every week is improvised from scratch." },
    diagOpenCosts1: { es: "Tienes gastos fijos que nadie ha revisado en meses.", en: "You have fixed costs nobody has reviewed in months." },
    diagOpenCosts2: { es: "El alquiler y los proveedores se negocian tarde y sin datos.", en: "Rent and suppliers get negotiated late and without data." },
    diagOpenCosts3: { es: "Falta un orden para saber qué recortar primero sin dañar la venta.", en: "You lack an order to know what to cut first without hurting sales." },
    diagNewCash1: { es: "Abrir sin colchón de caja calculado es el error más caro del primer año.", en: "Opening without a calculated cash buffer is the costliest first-year mistake." },
    diagNewCash2: { es: "Necesitas números de arranque: inversión, punto de equilibrio y stock inicial.", en: "You need startup numbers: investment, break-even and initial stock." },
    diagNewCash3: { es: "Sin plan de los tres primeros meses, se gasta donde no toca.", en: "Without a first-three-months plan, money goes where it shouldn't." },
    diagNewTeam1: { es: "Vas a necesitar horarios y tareas definidos antes de abrir la persiana.", en: "You'll need defined schedules and tasks before you raise the shutter." },
    diagNewTeam2: { es: "Contratar sin rutinas escritas multiplica tu carga desde el día uno.", en: "Hiring without written routines multiplies your load from day one." },
    diagNewTeam3: { es: "Falta un orden de apertura para no llegar tarde a lo importante.", en: "You lack an opening order to not be late on what matters." },
    diagNewCosts1: { es: "El contrato de alquiler que firmes hoy te condiciona los próximos años.", en: "The lease you sign today shapes your next few years." },
    diagNewCosts2: { es: "Los gastos fijos y proveedores se cierran mejor antes de abrir, no después.", en: "Fixed costs and suppliers close better before opening, not after." },
    diagNewCosts3: { es: "Necesitas una lista de licencias, plazos y pagos para no ir a ciegas.", en: "You need a list of licenses, deadlines and payments so you don't go blind." },
    proBadge: { es: "Club Pro · 69 €/mes", en: "Club Pro · €69/mo" },
    proTitle: { es: "Únete al Club. Estrategia y apoyo de un experto, cada mes.", en: "Join the Club. Strategy and support from an expert, every month." },
    proSubtitle: { es: "Negocios a pie de calle ya usan la hoja de ruta y el agente.", en: "High-street businesses already use the roadmap and the agent." },
    proBullet1: { es: "Hoja de ruta personalizada, semana a semana", en: "Custom roadmap, week by week" },
    proBullet2: { es: "Agente Retail IA disponible 24/7 los 365 días para tu local", en: "Retail AI Agent available 24/7, 365 days for your shop" },
    proBullet3: { es: "Tips, plantillas y checklists de aplicación inmediata", en: "Tips, templates and instantly actionable checklists" },
    proBullet5: { es: "Opcional: Soporte y trato humano cuando necesites validar una decisión", en: "Optional: human support when you need to validate a decision" },
    proCta: { es: "Unirme al Club Pro", en: "Join Club Pro" },
    proTrialNote: { es: "7 días gratis. Después, 69 €/mes.", en: "7 days free. Then €69/month." },
    proButtonNote: { es: "7 días gratis · después 69 €/mes", en: "7 days free · then €69/month" },
    proLite: { es: "O únete al acceso anticipado.", en: "Or join early access." },
    headerSignup: { es: "Acceso anticipado", en: "Early access" },
    restart: { es: "Volver a empezar", en: "Start over" },
    servicesText: { es: "Además de nuestro Club Pro (69€/mes) para la gestión diaria, contamos con servicios de mentoría operativa directa y apoyo adicional según lo que tu local necesite.", en: "Besides our Club Pro (€69/month) for daily management, we offer direct operational mentoring and extra support tailored to what your shop needs." },
    servicesLink: { es: "Conocer los servicios adicionales y tarifas →", en: "See additional services and pricing →" },
    footerTarifas: { es: "Tarifas", en: "Pricing" },
    footerInicio: { es: "Inicio", en: "Home" },
    microcopyEarly: { es: "Acceso anticipado · Básico, Club Pro y Avanzado sin permanencia", en: "Early access · Basic, Club Pro and Advanced with no commitment" },
    microcopy: { es: "Básico, Club Pro y Avanzado sin permanencia", en: "Basic, Club Pro and Advanced with no commitment" },
    whatIsTitle: { es: "Qué es Retail Lemon", en: "What is Retail Lemon" },
    whatIsBullet1: { es: "Panel y método paso a paso", en: "Panel and step-by-step method" },
    whatIsBullet2: { es: "Agente Retail IA orientado a tu tipo de negocio", en: "Retail AI Agent oriented to your type of business" },
    whatIsBullet3: { es: "Mentoría y red de apoyo cuando lo necesites", en: "Mentoring and support network when you need it" },
    whatIsDisclaimer: { es: "No sustituimos a tu abogado o gestor. Te ayudamos a ordenar y a no ir a ciegas.", en: "We don't replace your lawyer or accountant. We help you get organized and avoid going in blind." },
    closingTitlePrefix: { es: "Incorpora", en: "Bring" },
    closingTitleSuffix: { es: "de un experto a tu día a día.", en: "of an expert into your day to day." },
    closingWord1: { es: "el control", en: "the control" },
    closingWord2: { es: "el know-how", en: "the know-how" },
    closingWord3: { es: "la tranquilidad", en: "the peace of mind" },
    closingWord4: { es: "la estrategia", en: "the strategy" },
    closingSubtitle: { es: "Tu Director de Operaciones sin tener que contratar uno. Todo el apoyo que necesitas para tu negocio a pie de calle: Estrategia, Crecimiento y Consejos que nadie te cuenta.", en: "Your Operations Director without having to hire one. All the support your high-street business needs: Strategy, Growth and Advice nobody tells you." },
    footerPrivacy: { es: "Privacidad", en: "Privacy" },
    footerTerms: { es: "Condiciones", en: "Terms" },
    footerCookies: { es: "Cookies", en: "Cookies" },
    mockupPanelTitle: { es: "Mi Panel", en: "My Panel" },
    mockupRoadmap: { es: "Hoja de ruta", en: "Roadmap" },
    mockupTask1: { es: "Solicitar subvención", en: "Apply for a grant" },
    mockupTask2: { es: "Resolver detalles de contrato", en: "Sort out contract details" },
    mockupTask3: { es: "Plan de apertura", en: "Opening plan" },
    mockupAiHint: { es: "Consejo del día", en: "Tip of the day" },
  },

  // ── Lemon Report ──
  report: {
    title: { es: "Tu Lemon Report", en: "Your Lemon Report" },
    points: { es: "puntos", en: "points" },
    areasBreakdown: { es: "Desglose por áreas", en: "Score breakdown by area" },
    personalizedDiagnosis: { es: "Diagnóstico Personalizado", en: "Personalized Diagnosis" },
    scheduleAudit: { es: "Hablemos de tu negocio (Llamada gratis)", en: "Let's talk about your business (Free call)" },
    download: { es: "Ver mi hoja de ruta en el Club Pro", en: "See my roadmap in Club Pro" },
    goodNews: { es: "¿Cómo mejoramos esta nota?", en: "How do we improve this score?" },
    noNeedToLearn: {
      es: "Hemos volcado tu diagnóstico en tu propio Club Pro. Únete al acceso anticipado, descubre la hoja de ruta que necesita tu negocio y desbloquea la ayuda de tu Mentor cuando estés listo para escalar.",
      en: "We've loaded your diagnosis into your own Club Pro. Join early access, discover the roadmap your business needs and unlock your Mentor's help when you're ready to scale.",
    },
    phoneFormTitle: { es: "Déjanos tu número y te llamamos", en: "Leave your number and we'll call you" },
    phonePlaceholder: { es: "Tu teléfono", en: "Your phone" },
    phoneSubmit: { es: "¡Llamadme!", en: "Call me!" },
    phoneSuccess: { es: "¡Recibido! Un Mentor Lemon te llamará muy pronto.", en: "Received! A Lemon Mentor will call you very soon." },
    resultsSaved: { es: "¡Resultados guardados!", en: "Results saved!" },
    diagInPanel: {
      es: "Tu diagnóstico ya está en tu Club Pro. Hemos identificado las áreas donde más puedes mejorar.",
      en: "Your diagnosis is now in your Club Pro. We've identified the areas where you can improve the most.",
    },
    goToPanel: { es: "Ir a mi Club Pro", en: "Go to My Club Pro" },
    saveAndAccess: { es: "Guarda tu diagnóstico y únete al acceso anticipado del Club Pro", en: "Save your diagnosis and join Club Pro early access" },
    choosePassword: { es: "Elige una contraseña", en: "Choose a password" },
    createAccount: { es: "Crear mi Cuenta y Ver Soluciones", en: "Create Account & See Solutions" },
    creatingAccount: { es: "Creando cuenta...", en: "Creating account..." },
    noCreditCard: { es: "Te avisamos cuando abramos.", en: "We'll let you know when we launch." },
    levelVeryGreen: { es: "Limón muy verde", en: "Very green lemon" },
    levelHalfSqueezed: { es: "Limón a medio exprimir", en: "Half-squeezed lemon" },
    levelReady: { es: "Limón listo para beber", en: "Lemon ready to drink" },
    passwordMin: { es: "La contraseña debe tener al menos 6 caracteres", en: "Password must be at least 6 characters" },
    missingEmail: { es: "Falta el email", en: "Email missing" },
    errorCreating: { es: "Error al crear la cuenta", en: "Error creating account" },
    panelOfferTitle: { es: "Activa tu Club Pro — 69 €/mes", en: "Activate your Club Pro — €69/mo" },
    panelOfferSubtitle: {
      es: "Tu hoja de ruta personalizada para pasar del caos al control en menos de 30 días.",
      en: "Your personalized roadmap to go from chaos to control in less than 30 days.",
    },
    panelBenefit1: { es: "Hoja de Ruta personalizada según tu diagnóstico.", en: "Personalized Roadmap based on your diagnosis." },
    panelBenefit2: { es: "Calculadora de Rentabilidad Pro y simuladores.", en: "Pro Profitability Calculator and simulators." },
    panelBenefit3: { es: "Checklists, Tips diarios y Plantillas listas para usar.", en: "Checklists, daily Tips and ready-to-use Templates." },
    panelBenefit4: { es: "Biblioteca de Insights & artículos Club Pro.", en: "Insights & Club Pro Articles Library." },
    panelBenefit5: { es: "Soporte directo dentro del panel.", en: "Direct support inside the panel." },
    activatePanelCta: { es: "Activar Club Pro", en: "Activate Club Pro" },
    noCommitment: { es: "Sin permanencia · Cancela cuando quieras", en: "No commitment · Cancel anytime" },
    mentoringHint: { es: "¿Necesitas acompañamiento 1 a 1? Conoce a Tu Mentor →", en: "Need 1-on-1 support? Meet Your Mentor →" },
    tryFreeVersion: { es: "Unirme al acceso anticipado", en: "Join early access" },
  },

  // ── Basics Card ──
  validationUpsell: {
    title: { es: "¡Boom! Concepto Validado. 🍋🎉", en: "Boom! Concept Validated. 🍋🎉" },
    subtitle: {
      es: "Has dado el primer paso. Ahora toca proteger tu caja y recuperar tu tiempo.",
      en: "You've taken the first step. Now it's time to protect your cash and reclaim your time.",
    },
    benefit1: { es: "Checklists operativos anti-caos.", en: "Anti-chaos operational checklists." },
    benefit2: { es: "Calculadoras de rentabilidad y stock.", en: "Profitability and stock calculators." },
    benefit3: {
      es: "Acceso a proveedores de confianza (Nuestra agenda negra).",
      en: "Access to trusted suppliers (Our little black book).",
    },
    ctaPrimary: { es: "🚀 Desbloquear el Arsenal Completo", en: "🚀 Unlock the Full Arsenal" },
    ctaSecondary: {
      es: "Quizás más tarde, prefiero seguir por mi cuenta.",
      en: "Maybe later, I'd rather keep going on my own.",
    },
  },
  basics: {
    title: { es: "Primeros Pasos", en: "First Steps" },
    subtitle: { es: "CHECKLIST INICIAL", en: "INITIAL CHECKLIST" },
    checklist: {
      es: [
        "Comprobar si el @ de Instagram y el dominio web (.com/.es) están libres.",
        "Definir en 1 sola frase por qué tu concepto de retail es diferente a la competencia.",
        "Fijar el presupuesto máximo que estás dispuesto a perder si sale mal.",
      ],
      en: [
        "Check if the Instagram @ and web domain (.com/.es) are available.",
        "Define in 1 sentence why your retail concept is different from competitors.",
        "Set the maximum budget you're willing to lose if things go wrong.",
      ],
    },
    dailyTip: { es: "🍋 Tip Diario", en: "🍋 Daily Tip" },
    tipSaved: { es: "Tip guardado ✨", en: "Tip saved ✨" },
    tipUnsaved: { es: "Tip desmarcado", en: "Tip unsaved" },
    tipSavedDesc: { es: "Lo encontrarás en tus tips guardados.", en: "You'll find it in your saved tips." },
    tipUnsavedDesc: { es: "Se ha quitado de tus favoritos.", en: "Removed from your favorites." },
    tipError: { es: "Error al guardar", en: "Error saving" },
    tipCouldntLoad: { es: "No se pudo cargar el tip.", en: "Could not load the tip." },
    tipComeBack: { es: "Vuelve mañana para un nuevo consejo.", en: "Come back tomorrow for a new tip." },
    refreshTip: { es: "Actualizar tip diario", en: "Refresh tip" },
  },

  // ── Free Note Card ──
  freeNote: {
    noteTitle: { es: "Título de tu nota...", en: "Note title..." },
    cardTitle: { es: "Título de tu tarea...", en: "Task title..." },
    imageTitle: { es: "Título de tu imagen...", en: "Image title..." },
    targetDate: { es: "Fecha objetivo", en: "Target date" },
    tasks: { es: "Tareas", en: "Tasks" },
    addTask: { es: "Añadir tarea...", en: "Add task..." },
    additionalNotes: { es: "Notas adicionales...", en: "Additional notes..." },
    writeIdeas: { es: "Escribe tus ideas aquí...", en: "Write your ideas here..." },
    imageCaption: { es: "Descripción (opcional)...", en: "Caption (optional)..." },
    uploadImage: { es: "Subir imagen", en: "Upload image" },
    replaceImage: { es: "Reemplazar", en: "Replace" },
    removeImage: { es: "Quitar imagen", en: "Remove image" },
    dropHint: { es: "JPG, PNG o HEIC · máx. 10 MB", en: "JPG, PNG or HEIC · max 10 MB" },
    uploading: { es: "Subiendo...", en: "Uploading..." },
    tooLarge: { es: "La imagen supera 10 MB.", en: "Image exceeds 10 MB." },
    uploadError: { es: "No se pudo subir la imagen.", en: "Could not upload image." },
    imageMetric: { es: "Original {original} → {final} (−{pct}% optimizado)", en: "Original {original} → {final} (−{pct}% optimized)" },
  },

  // ── Notifications ──
  notif: {
    title: { es: "Notificaciones", en: "Notifications" },
    markAllRead: { es: "Marcar todo leído", en: "Mark all read" },
    none: { es: "No tienes notificaciones", en: "No notifications" },
  },

  // ── Profile ──
  profile: {
    title: { es: "Mi Perfil", en: "My Profile" },
    email: { es: "Email", en: "Email" },
    emailNote: { es: "El email no se puede cambiar desde aquí.", en: "Email cannot be changed from here." },
    firstName: { es: "Nombre", en: "First Name" },
    lastName: { es: "Apellidos", en: "Last Name" },
    firstNamePlaceholder: { es: "Tu nombre", en: "Your first name" },
    lastNamePlaceholder: { es: "Tus apellidos", en: "Your last name" },
    saveChanges: { es: "Guardar cambios", en: "Save changes" },
    errorSaving: { es: "Error al guardar los cambios", en: "Error saving changes" },
    saved: { es: "Perfil actualizado correctamente", en: "Profile updated successfully" },
  },

  // ── Billing ──
  billing: {
    title: { es: "Mi Suscripción", en: "My Subscription" },
    accountSummary: { es: "Resumen de tu cuenta", en: "Account Summary" },
    memberSince: { es: "Miembro desde", en: "Member since" },
    quizzes: { es: "Quizzes completados", en: "Quizzes completed" },
    invoices: { es: "Facturas", en: "Invoices" },
    noInvoices: {
      es: "Aún no tienes facturas. Cuando contrates un servicio, aparecerán aquí.",
      en: "No invoices yet. When you hire a service, they'll appear here.",
    },
    needHelp: { es: "¿Necesitas ayuda con una factura?", en: "Need help with an invoice?" },
    supportHours: {
      es: "Nuestro equipo de soporte está disponible de lunes a viernes.",
      en: "Our support team is available Monday to Friday.",
    },
  },

  // ── Billing — Panel Cancellation / Reactivation Modal ──
  billingCancel: {
    // Phase: scheduled
    scheduledTitle: { es: "Cancelación programada", en: "Cancellation scheduled" },
    scheduledDescWithDate: {
      es: "Tu Panel sigue activo hasta el {date}. Después no se renovará. ¿Quieres reactivar la renovación y mantener el acceso sin interrupción?",
      en: "Your Panel stays active until {date}. It won't renew after that. Want to reactivate renewal and keep access without interruption?",
    },
    scheduledDescNoDate: {
      es: "Tu Panel sigue activo hasta el final del ciclo. Después no se renovará. ¿Quieres reactivar la renovación y mantener el acceso sin interrupción?",
      en: "Your Panel stays active until the end of the cycle. It won't renew after that. Want to reactivate renewal and keep access without interruption?",
    },
    scheduledShield: {
      es: "Al reactivar volverás al ciclo de facturación normal. No se generan cargos adicionales en este momento.",
      en: "Reactivating restores your normal billing cycle. No additional charges are created right now.",
    },
    reactivateBtn: { es: "Reactivar renovación", en: "Reactivate renewal" },
    closeBtn: { es: "Cerrar", en: "Close" },

    // Phase: confirm
    confirmTitle: { es: "Tu Suscripción al Panel", en: "Your Panel Subscription" },
    confirmDesc: {
      es: "El Club Pro tiene un compromiso anual diseñado para asegurar la continuidad de tus datos y la evolución de tu negocio. Las cuotas acordadas seguirán su ciclo de facturación normal.",
      en: "The Club Pro has an annual commitment designed to ensure data continuity and your business evolution. Agreed payments will follow their normal billing cycle.",
    },
    confirmShield: {
      es: "Tu plan anual garantiza acceso continuo a todas las herramientas, datos históricos y actualizaciones de la plataforma.",
      en: "Your annual plan guarantees continuous access to all tools, historical data, and platform updates.",
    },
    disableToggle: {
      es: "Desactivar renovación automática al finalizar mi ciclo",
      en: "Disable auto-renewal at the end of my cycle",
    },

    // Phase: review
    reviewTitle: {
      es: "¿Desactivar la renovación anual automática?",
      en: "Disable annual auto-renewal?",
    },
    reviewDesc: {
      es: "Sin permanencia. Al darte de baja, tu acceso continúa hasta el final del mes ya pagado y no se renovará.",
      en: "No commitment. When you cancel, your access continues until the end of the month already paid and will not renew.",
    },
    reviewKeepAccess: {
      es: "Mantienes tu acceso hasta el final del año",
      en: "You keep access until the end of the year",
    },
    reviewApprox: { es: "Aproximadamente el ", en: "Approximately on " },
    reviewExactPrefix: { es: "El ", en: "On " },
    reviewBullet1: {
      es: "Seguirás teniendo acceso total al Panel, a tus datos y a las herramientas hasta esa fecha.",
      en: "You'll keep full access to the Panel, your data and tools until that date.",
    },
    reviewBullet2: {
      es: "No se te emitirán más cuotas mensuales: el compromiso queda liquidado.",
      en: "No further monthly instalments will be issued: your commitment is settled.",
    },
    reviewBullet3: {
      es: "Al finalizar tu año de licencia, la cuenta se desactivará por completo y no se te renovará para un segundo año.",
      en: "When your license year ends, your account will be fully deactivated and will not be renewed for a second year.",
    },
    reviewCancelBtn: { es: "Mantener renovación", en: "Keep renewal" },
    reviewConfirmBtn: {
      es: "Sí, desactivar renovación anual",
      en: "Yes, disable annual renewal",
    },
    reviewConfirmChargeBtn: {
      es: "Confirmar baja y pagar {amount}",
      en: "Confirm cancellation and pay {amount}",
    },
    penaltyLoading: { es: "Calculando tu compromiso pendiente…", en: "Calculating your remaining commitment…" },
    penaltyPaid: {
      es: "Llevas {paid} cuotas pagadas de {total} de tu compromiso anual.",
      en: "You have paid {paid} of {total} instalments of your annual commitment.",
    },
    penaltyCharge: {
      es: "Al confirmar se cargarán {amount} ({n} cuotas pendientes) en tu tarjeta guardada.",
      en: "On confirmation, {amount} ({n} remaining instalments) will be charged to your saved card.",
    },
    penaltyTerms: {
      es: "Según el apartado 3.2 de las",
      en: "As set out in section 3.2 of the",
    },
    penaltyTermsLink: { es: "Condiciones de Servicio", en: "Terms of Service" },
    penaltyNone: {
      es: "Tu compromiso anual ya está completado: no hay ningún cargo adicional.",
      en: "Your annual commitment is already complete: there is no additional charge.",
    },
    annualNoCharge: {
      es: "Tu año ya está pagado por adelantado. No se realizará ningún cargo; solo se desactiva la renovación.",
      en: "Your year is already paid upfront. Nothing will be charged; only the renewal is disabled.",
    },
    doneChargedNote: {
      es: "Se ha cargado {amount} en tu tarjeta por las cuotas pendientes. Recibirás la factura por email.",
      en: "{amount} has been charged to your card for the remaining instalments. You'll receive the invoice by email.",
    },
    paymentFailed: {
      es: "No hemos podido cobrar las cuotas pendientes en tu tarjeta. Actualiza tu método de pago e inténtalo de nuevo. No se ha cancelado nada.",
      en: "We couldn't charge the remaining instalments to your card. Update your payment method and try again. Nothing has been cancelled.",
    },
    noPaymentMethod: {
      es: "No hay ninguna tarjeta guardada para cobrar las cuotas pendientes. Añade un método de pago desde Facturación e inténtalo de nuevo.",
      en: "There is no saved card to charge the remaining instalments. Add a payment method in Billing and try again.",
    },

    // Phase: loading
    processingTitle: { es: "Procesando tu solicitud…", en: "Processing your request…" },
    loadingStep1: { es: "Conectando con el sistema de pagos", en: "Connecting to the payment system" },
    loadingStep2: { es: "Programando el fin de ciclo", en: "Scheduling end of cycle" },
    loadingStep3: { es: "Confirmando los cambios", en: "Confirming changes" },
    dontClose: {
      es: "No cierres esta ventana hasta que termine.",
      en: "Please don't close this window until it finishes.",
    },

    // Phase: done
    doneTitle: { es: "Renovación desactivada", en: "Auto-renewal disabled" },
    doneDescWithDate: {
      es: "Disfruta de tu acceso hasta el {date}. No se renovará automáticamente. Si cambias de opinión podrás reactivarla desde aquí mientras siga vigente.",
      en: "Enjoy your access until {date}. It won't renew automatically. You can reactivate it from here while it's still active.",
    },
    doneDescNoDate: {
      es: "Disfruta de tu acceso hasta el final del ciclo. No se renovará automáticamente. Si cambias de opinión podrás reactivarla desde aquí mientras siga vigente.",
      en: "Enjoy your access until the end of the cycle. It won't renew automatically. You can reactivate it from here while it's still active.",
    },
    gotItBtn: { es: "Entendido", en: "Got it" },

    // Phase: error
    errorTitle: { es: "No se ha podido desactivar la renovación", en: "We couldn't disable auto-renewal" },
    errorDesc: {
      es: "Ha ocurrido un problema al procesar tu solicitud. Tu suscripción no ha sufrido cambios. Puedes reintentarlo o contactar con soporte si el problema persiste.",
      en: "Something went wrong while processing your request. Your subscription has not changed. You can retry or contact support if the issue persists.",
    },
    retryBtn: { es: "Reintentar", en: "Retry" },
    retryingBtn: { es: "Reintentando…", en: "Retrying…" },

    // Phase: reactivating
    reactivatingTitle: { es: "Reactivando tu renovación…", en: "Reactivating your renewal…" },
    reactivatingStep1: { es: "Conectando con el sistema de pagos", en: "Connecting to the payment system" },
    reactivatingStep2: { es: "Restableciendo la renovación", en: "Restoring renewal" },
    reactivatingStep3: { es: "Confirmando los cambios", en: "Confirming changes" },

    // Phase: reactivated
    reactivatedTitle: { es: "Renovación reactivada", en: "Renewal reactivated" },
    reactivatedDescWithDate: {
      es: "Tu Panel se renovará con normalidad el {date}. Mantienes acceso continuo a todas las herramientas y a tus datos.",
      en: "Your Panel will renew normally on {date}. You keep continuous access to every tool and your data.",
    },
    reactivatedDescNoDate: {
      es: "Tu Panel se renovará con normalidad. Mantienes acceso continuo a todas las herramientas y a tus datos.",
      en: "Your Panel will renew normally. You keep continuous access to every tool and your data.",
    },

    // Phase: reactivation_error
    reactivationErrorTitle: { es: "No se ha podido reactivar", en: "We couldn't reactivate" },
    reactivationErrorDesc: {
      es: "Ha ocurrido un problema al reactivar la renovación. La cancelación programada sigue intacta. Puedes reintentarlo o contactar con soporte.",
      en: "Something went wrong while reactivating the renewal. Your scheduled cancellation is unchanged. You can retry or contact support.",
    },
    backBtn: { es: "Volver", en: "Back" },

    // Toasts
    toastCancelTitle: { es: "No se pudo desactivar", en: "Could not disable" },
    toastReactivateTitle: { es: "No se pudo reactivar", en: "Could not reactivate" },
  },

  // ── Mentoring — Cancellation / Reactivation Modal ──
  mentoringCancel: {
    // Phase: scheduled
    scheduledTitle: { es: "Cancelación programada", en: "Cancellation scheduled" },
    scheduledDescWithDate: {
      es: "Tu mentoría sigue activa hasta el {date}. Después no se renovará. ¿Quieres mantener tu mentoría y reactivar la renovación mensual?",
      en: "Your mentoring stays active until {date}. It won't renew after that. Want to keep your mentoring and reactivate the monthly renewal?",
    },
    scheduledDescNoDate: {
      es: "Tu mentoría sigue activa hasta el final del mes. Después no se renovará. ¿Quieres mantener tu mentoría y reactivar la renovación mensual?",
      en: "Your mentoring stays active until month end. It won't renew after that. Want to keep your mentoring and reactivate the monthly renewal?",
    },
    scheduledShield: {
      es: "Al reactivar volverás al ciclo mensual habitual. No se generan cargos adicionales en este momento.",
      en: "Reactivating restores your normal monthly cycle. No additional charges are created right now.",
    },
    reactivateBtn: { es: "Reactivar mentoría", en: "Reactivate mentoring" },
    closeBtn: { es: "Cerrar", en: "Close" },

    // Phase: confirm
    confirmTitle: { es: "Gestionar mentoría con Tu Mentor", en: "Manage mentoring with Your Mentor" },
    confirmDesc: {
      es: "Desde aquí puedes gestionar tu nivel de mentoría. Si decides cancelar, tu plan actual seguirá 100% operativo hasta el final de tu ciclo de facturación mensual en curso. Al terminar el mes, no se te volverá a cobrar.",
      en: "From here you can manage your mentoring level. If you decide to cancel, your current plan will remain 100% operational until the end of your current monthly billing cycle. You won't be charged again next month.",
    },
    confirmShield: {
      es: "Nota: Esta acción solo afecta a la mentoría. Tu suscripción base al Club Pro se mantendrá activa.",
      en: "Note: This action only affects mentoring. Your base Club Pro subscription will remain active.",
    },
    keepBtn: { es: "Mantener Mentoría", en: "Keep Mentoring" },
    cancelMonthEndBtn: { es: "Cancelar Mentoría a fin de mes", en: "Cancel Mentoring at month end" },

    // Phase: done
    doneTitle: { es: "Cancelación confirmada", en: "Cancellation confirmed" },
    doneDescWithDate: {
      es: "Disfruta de tu mentoría hasta el {date}. No se te renovará al finalizar el ciclo actual. Si cambias de opinión podrás reactivarla desde aquí.",
      en: "Enjoy your mentoring until {date}. It won't renew at the end of the current cycle. You can reactivate it from here.",
    },
    doneDescNoDate: {
      es: "Disfruta de tu mentoría hasta el final del mes en curso. No se te renovará al finalizar el ciclo actual. Si cambias de opinión podrás reactivarla desde aquí.",
      en: "Enjoy your mentoring until the end of the current month. It won't renew at the end of the current cycle. You can reactivate it from here.",
    },
    gotItBtn: { es: "Entendido", en: "Got it" },

    // Phase: reactivating
    reactivatingTitle: { es: "Reactivando tu mentoría…", en: "Reactivating your mentoring…" },

    // Phase: reactivated
    reactivatedTitle: { es: "Mentoría reactivada", en: "Mentoring reactivated" },
    reactivatedDesc: {
      es: "Tu mentoría se renovará con normalidad en el próximo ciclo. Mantienes acceso continuo a todos los beneficios.",
      en: "Your mentoring will renew normally on the next cycle. You keep continuous access to all benefits.",
    },

    // Phase: reactivation_error
    reactivationErrorTitle: { es: "No se ha podido reactivar", en: "We couldn't reactivate" },
    reactivationErrorDesc: {
      es: "Ha ocurrido un problema al reactivar la mentoría. La cancelación programada sigue intacta. Puedes reintentarlo o contactar con soporte.",
      en: "Something went wrong while reactivating the mentoring. Your scheduled cancellation is unchanged. You can retry or contact support.",
    },
    backBtn: { es: "Volver", en: "Back" },
    retryBtn: { es: "Reintentar", en: "Retry" },
    retryingBtn: { es: "Reintentando…", en: "Retrying…" },

    // Internal fallbacks
    couldNotReactivate: { es: "No se pudo reactivar", en: "Could not reactivate" },
    toastCancelTitle: { es: "No se pudo cancelar", en: "Could not cancel" },
    toastReactivateTitle: { es: "No se pudo reactivar", en: "Could not reactivate" },
  },

  // ── Subscription Panel & Mentoring Section (cards) ──
  subscriptionPanel: {
    // Section titles
    panelTitle: { es: "Suscripción: Club Pro", en: "Subscription: Club Pro" },
    mentoringSectionTitle: { es: "Mentoría", en: "The Mentoring" },
    currentMentoringLevel: { es: "Tu nivel de Mentoría Actual", en: "Your Current Mentoring Level" },

    // Badges
    badgeActive: { es: "Activo", en: "Active" },
    badgeScheduled: { es: "Cancelación programada", en: "Cancellation scheduled" },

    // Manage buttons (titles)
    manageSubscription: { es: "Gestionar suscripción", en: "Manage subscription" },
    manageMentoring: { es: "Gestionar mentoría", en: "Manage mentoring" },

    // Plan badges
    annualBaseSubscription: { es: "Suscripción Base Anual", en: "Annual Base Subscription" },
    monthlyFlexible: { es: "Pago mensual flexible", en: "Flexible monthly payment" },
    recommended: { es: "Recomendado", en: "Recommended" },
    priceSuffixMonth: { es: "/mes", en: "/mo" },
    annualLicenseFractioned: { es: "Licencia anual (pago fraccionado)", en: "Annual license (split payment)" },
    contractStartDate: { es: "Fecha de alta", en: "Start date" },
    contractEndDate: { es: "Fecha de finalización", en: "End date" },
    contractStatus: { es: "Estado", en: "Status" },
    contractStatusFractioned: { es: "Pago fraccionado (Mensual)", en: "Split payment (Monthly)" },
    contractStatusManual: { es: "Manual / Sin cobros automáticos", en: "Manual / No automatic charges" },
    contractPending: { es: "Pendiente de abono", en: "Outstanding balance" },
    contractPendingNoneManual: { es: "Sin abonos pendientes", en: "No pending payments" },
    settleRemaining: { es: "Liquidar cuotas pendientes", en: "Settle remaining installments" },
    contractSummaryTitle: { es: "Resumen de contrato", en: "Contract summary" },
    mentoringAddonNote: { es: "Plus de mentoría adicional a la cuota de tu panel", en: "Mentoring add-on on top of your panel fee" },
    mentoringAddonShort: { es: "Suma a tu Panel", en: "On top of your Panel" },

    // Value bullets — Panel card
    panelIncludesTitle: { es: "Tu suscripción incluye:", en: "Your subscription includes:" },
    panelIncludes: {
      es: [
        "Acceso 24/7 a los módulos del Método Lemon.",
        "Checklists de implementación rápida para tu negocio.",
        "Soporte técnico y actualizaciones constantes de la plataforma.",
      ],
      en: [
        "24/7 access to the Lemon Method modules.",
        "Quick-implementation checklists for your business.",
        "Technical support and constant platform updates.",
      ],
    },

    // Value bullets — Mentoring card
    mentoringIncludesTitle: { es: "Tu mentoría incluye:", en: "Your mentoring includes:" },
    mentoringIncludes: {
      es: [
        "2h/mes (1 sesión cada 15 días)",
        "Aclaramos tus ideas y definimos tu plan de acción.",
        "El respaldo profesional que necesitas para avanzar.",
      ],
      en: [
        "2h/mo (1 session every 15 days)",
        "We clarify your ideas and define your action plan.",
        "The professional backing you need to move forward.",
      ],
    },

    // Mentoring benefits (3 entries)
    mentoringBenefits: {
      es: [
        "Más horas de mentoría privada",
        "Soporte prioritario y auditorías",
        "Crecimiento acelerado para tu negocio",
      ],
      en: [
        "More private mentoring hours",
        "Priority support & audits",
        "Accelerated growth for your business",
      ],
    },

    // Access type labels
    accessCourtesy: { es: "Cortesía", en: "Courtesy" },
    accessCommercial: { es: "Acuerdo comercial", en: "Commercial agreement" },
    accessManual: { es: "Pago manual", en: "Manual payment" },

    // VIP plan labels (used by manual + Stripe plans)
    plan_arranque: { es: "Tu Mentor — Quincenal", en: "Your Mentor — Biweekly" },
    plan_crucero:  { es: "Tu Mentor — Semanal",  en: "Your Mentor — Weekly" },
    plan_partner:  { es: "Tu Mentor — Intensivo",  en: "Your Mentor — Intensive" },
    // Legacy keys (kept for backwards compatibility with old client_plans rows)
    plan_brujula: { es: "Tu Mentor — Quincenal", en: "Your Mentor — Biweekly" },
    plan_sherpa: { es: "Tu Mentor — Semanal", en: "Your Mentor — Weekly" },
    plan_fractional: { es: "Tu Mentor — Intensivo", en: "Your Mentor — Intensive" },
    planPrefix: { es: "Plan", en: "Plan" },
    vipMentorPrefix: { es: "Tu Mentor", en: "Your Mentor" },

    // Toasts (Billing.tsx)
    toastPortalErrorTitle: { es: "No se pudo abrir el portal de pagos", en: "Could not open the billing portal" },
    toastCheckoutErrorTitle: { es: "No se pudo iniciar el pago", en: "Could not start checkout" },
    cancelNoActiveMentoringTitle: { es: "No hay mentoría que cancelar", en: "No mentoring to cancel" },
    cancelNoActiveMentoringDesc: {
      es: "No tienes una mentoría activa que cancelar en este momento.",
      en: "You don't have an active mentoring to cancel right now.",
    },
    loading: { es: "Cargando...", en: "Loading..." },

    // ── Expansion Modules (Add-ons) ──
    expansionSectionTitle: { es: "Módulos de Expansión", en: "Expansion Modules" },
    expansionSectionDesc: {
      es: "Amplía tu plan activando extras cuando los necesites. Los extras se pagan aparte y verás su precio antes de pagar. Sin permanencia.",
      en: "Extend your plan by activating extras whenever you need them. Extras are paid separately and you see the price before paying. No commitment.",
    },
    expansionEmpty: {
      es: "No hay módulos extra disponibles ahora mismo.",
      en: "No expansion modules available right now.",
    },
    expansionActivateBtn: { es: "Activar Módulo", en: "Activate Module" },
    expansionActiveBadge: { es: "Activo", en: "Active" },
    expansionDisableRenewal: { es: "Desactivar renovación", en: "Disable renewal" },
    expansionScheduledBadge: { es: "Baja programada", en: "Cancellation scheduled" },
    expansionReactivate: { es: "Mantener activo", en: "Keep active" },
    expansionCancelToastTitle: { es: "Renovación desactivada", en: "Renewal disabled" },
    expansionCancelToastDesc: {
      es: "Mantendrás el acceso hasta el final del periodo en curso.",
      en: "You will keep access until the end of the current period.",
    },
    expansionCancelErrorTitle: { es: "No se pudo desactivar", en: "Could not disable" },
    expansionReactivateToastTitle: { es: "Renovación reactivada", en: "Renewal reactivated" },
    expansionPriceFromShort: { es: "Plus adicional a tu panel", en: "Add-on on top of your panel" },

    // SubscriptionCard
    sectionPanel: { es: "El Panel", en: "The Panel" },
    litePlanTitle: { es: "Sin plan", en: "No plan" },
    litePlanDesc: {
      es: "Todavía no tienes plan. Desbloquea todo el potencial de Retail Lemon con el Club Pro.",
      en: "You don't have a plan yet. Unlock the full potential of Retail Lemon with the Club Pro.",
    },
    viewPlans: { es: "Ver planes disponibles", en: "View available plans" },
    monthsSuffix: { es: "meses", en: "months" },
    nextRenewal: { es: "Próxima renovación:", en: "Next renewal:" },
    manageSubscriptionBtn: { es: "Gestionar Suscripción", en: "Manage Subscription" },

    // MentoringSection — upsell
    powerGrowthTitle: { es: "Potencia tu crecimiento", en: "Power your growth" },
    powerGrowthDesc: {
      es: "Más horas de acompañamiento estratégico y soporte prioritario para acelerar tu rentabilidad.",
      en: "More strategic mentoring hours and priority support to accelerate your profitability.",
    },
    startMentoringTitle: {
      es: "¿Qué te gustaría que empezásemos a trabajar?",
      en: "What would you like us to start working on?",
    },
    startMentoringDesc: {
      es: "Elige el ritmo que mejor encaje contigo. Sin permanencia, lo cambias cuando quieras.",
      en: "Choose the pace that suits you best. No commitment, change it whenever you want.",
    },
    startBiweekly: { es: "Seguimiento quincenal", en: "Biweekly follow-up" },
    startWeekly: { es: "Seguimiento semanal", en: "Weekly follow-up" },
    startIntensive: { es: "Seguimiento intensivo", en: "Intensive follow-up" },
    diffVsCurrent: {
      es: "Por +{diff}€/mes vs tu plan actual",
      en: "For +€{diff}/mo vs your current plan",
    },
    selectPlan: { es: "Seleccionar", en: "Select" },
    yourPlanBadge: { es: "Tu plan", en: "Your plan" },
    activePlanBadge: { es: "Plan activo", en: "Active plan" },
    changeToPlan: { es: "Cambiar a {plan}", en: "Switch to {plan}" },
    downgradeHint: {
      es: "Para bajar a este plan, escríbenos desde Gestionar y lo dejamos listo al final de tu periodo.",
      en: "To switch to this plan, message us from Manage and we'll set it up at the end of your period.",
    },
    // Upsell tier bullets (per VIP level)
    upsellBulletsArranque: {
      es: [
        "2h/mes · 1 sesión cada 15 días",
        "Ordenamos ideas y plan de acción",
        "Respaldo para arrancar sin errores",
      ],
      en: [
        "2h/mo · 1 session every 15 days",
        "We shape your ideas and action plan",
        "Backing to start without mistakes",
      ],
    },
    upsellBulletsCrucero: {
      es: [
        "4h/mes · 1 sesión semanal",
        "Decisiones revisadas cada semana",
        "Optimización continua de tu operativa",
      ],
      en: [
        "4h/mo · 1 weekly session",
        "Decisions reviewed every week",
        "Continuous optimization of your operations",
      ],
    },
    upsellBulletsPartner: {
      es: [
        "8h/mes · 2 sesiones semanales",
        "Respaldo directivo continuo",
        "Línea directa para urgencias",
      ],
      en: [
        "8h/mo · 2 weekly sessions",
        "Continuous executive-level backing",
        "Direct line for urgent matters",
      ],
    },
  },

  // ── User Menu ──
  userMenu: {
    myProfile: { es: "Mi Perfil", en: "My Profile" },
    billing: { es: "Mi Suscripción", en: "My Subscription" },
    tourPanel: { es: "Cómo funciona tu panel", en: "How your panel works" },
    restartTour: { es: "Reiniciar tour", en: "Restart tour" },
    admin: { es: "Panel de Administrador", en: "Admin Panel" },
    support: { es: "Contactar Atención al Cliente", en: "Contact Customer Service" },
    helpCenter: { es: "Centro de Ayuda", en: "Help Center" },
    logout: { es: "Cerrar sesión", en: "Sign Out" },
  },

  // ── Quiz Categories (titles & subtitles) ──
  categories: {
    titles: {
      es: ["Finanzas y Rentabilidad", "Compras y Proveedores", "El Local y la Experiencia", "Ventas (Tienda y Online)", "Equipo y Gestión"],
      en: ["Finance & Profitability", "Purchasing & Suppliers", "The Store & Experience", "Sales (Store & Online)", "Team & Management"],
    },
    subtitles: {
      es: ["Método La Semilla", "Método El Jugo", "Método El Escaparate", "Método El Sabor", "Método El Equipo"],
      en: ["The Seed Method", "The Juice Method", "The Showcase Method", "The Flavor Method", "The Team Method"],
    },
  },

  // ── Module Content (Dashboard) ──
  moduleContent: {
    diagnostics: {
      es: {
        semilla: "En el test nos dijiste que el papeleo y la burocracia te dan alergia. No tienes la marca registrada y estás dejando pasar miles de euros en optimización fiscal.",
        jugo: "Ir a negociar cantidades mínimas (MOQs) sin fichas técnicas cerradas es como ir al casino: la banca (la fábrica) siempre gana. Tus márgenes están en riesgo.",
        escaparate: "Si tu negocio no genera deseo, estás dejando dinero en la mesa. Un Visual Merchandising estratégico y una experiencia sensorial pueden multiplicar tus ventas sin tocar el producto.",
        sabor: "Comerse la ropa de final de temporada es la causa nº1 de cierre en retail. Necesitas un calendario comercial agresivo y una buena integración de tu e-commerce.",
        equipo: "Sin manuales, sin motivación estructurada y sin aprovechar las ayudas públicas, estás perdiendo dinero y talento. Deja de improvisar y monta un sistema que funcione solo.",
      },
      en: {
        semilla: "In the test you told us paperwork and bureaucracy give you allergies. You haven't registered your brand and you're missing out on thousands in tax optimization.",
        jugo: "Negotiating minimum order quantities (MOQs) without finalized tech packs is like going to a casino: the house (the factory) always wins. Your margins are at risk.",
        escaparate: "If your business doesn't create desire, you're leaving money on the table. Strategic Visual Merchandising and a sensory experience can multiply your sales without changing the product.",
        sabor: "Eating unsold end-of-season stock is the #1 cause of retail closures. You need an aggressive commercial calendar and solid e-commerce integration.",
        equipo: "Without manuals, structured motivation and leveraging public grants, you're losing money and talent. Stop improvising and build a system that runs itself.",
      },
    },
    checklists: {
      es: {
        semilla: ["Revisar si tu marca está disponible en OEPM", "Consultar con un asesor fiscal tu estructura óptima", "Redactar tu propuesta de valor diferencial"],
        jugo: ["Buscar 3 proveedores y pedir presupuesto", "Crear fichas técnicas de tus prendas estrella", "Calcular el escandallo real de cada prenda"],
        escaparate: ["Diseñar tu mapa de calor de el negocio", "Planificar rotación quincenal de escaparate", "Definir tu experiencia sensorial (olor, música, luz)"],
        sabor: ["Crear tu calendario comercial anual", "Configurar email marketing automatizado", "Definir tu estrategia de liquidación sin devaluar"],
        equipo: ["Redactar protocolo de apertura y cierre de tienda", "Buscar subvenciones activas en tu comunidad", "Definir objetivos de venta y comisiones para el equipo"],
      },
      en: {
        semilla: ["Check if your brand is available at OEPM", "Consult a tax advisor about your optimal structure", "Draft your unique value proposition"],
        jugo: ["Find 3 suppliers and request quotes", "Create tech packs for your hero garments", "Calculate the true cost breakdown of each garment"],
        escaparate: ["Design your business heat map", "Plan bi-weekly window rotation", "Define your sensory experience (scent, music, lighting)"],
        sabor: ["Create your annual commercial calendar", "Set up automated email marketing", "Define your clearance strategy without devaluing"],
        equipo: ["Draft store opening/closing protocols", "Search for active grants in your region", "Define sales targets and team commissions"],
      },
    },
    downloadLabels: {
      es: {
        semilla: "📄 Descargar Plantilla Plan Fiscal",
        jugo: "📄 Descargar Checklist Fichas Técnicas",
        escaparate: "📄 Descargar Guía Marketing Sensorial",
        sabor: "📄 Descargar Calendario Comercial",
        equipo: "📄 Descargar Buscador de Ayudas",
      },
      en: {
        semilla: "📄 Download Tax Plan Template",
        jugo: "📄 Download Tech Pack Checklist",
        escaparate: "📄 Download Sensory Marketing Guide",
        sabor: "📄 Download Commercial Calendar",
        equipo: "📄 Download Grants Finder",
      },
    },
    premiumDescriptions: {
      es: {
        semilla: "Creación de empresa, registro de marca en OEPM/EUIPO, alta en Hacienda, optimización fiscal completa y redacción de contratos con proveedores.",
        jugo: "Acceso a nuestra red de talleres certificados en Portugal y Asia, patronaje profesional, negociación de MOQs e inspección de calidad pre-envío.",
        escaparate: "Proyecto completo de interiorismo retail, licencia de obras, branding olfativo y visual merchandising con rotación programada.",
        sabor: "Creación del e-commerce, estrategia omnicanal, automatizaciones de email marketing, campañas de Ads y gestión de ventas privadas.",
        equipo: "Tramitación de subvenciones a éxito, selección de personal retail, manuales de operaciones y sistema de incentivos por ventas.",
      },
      en: {
        semilla: "Company formation, brand registration at OEPM/EUIPO, tax registration, full tax optimization and supplier contract drafting.",
        jugo: "Access to our certified workshop network in Portugal and Asia, professional pattern-making, MOQ negotiation and pre-shipment quality inspection.",
        escaparate: "Complete retail interior design project, building permits, scent branding and visual merchandising with scheduled rotation.",
        sabor: "E-commerce creation, omnichannel strategy, email marketing automations, Ad campaigns and private sales management.",
        equipo: "Success-based grant processing, retail staff recruitment, operations manuals and sales incentive system.",
      },
    },
    premiumServiceNames: {
      es: {
        semilla: "Pack Legalización Retail",
        jugo: "Pack Producción & Fábrica",
        escaparate: "Pack Visual Merchandising",
        sabor: "Pack Marketing & Ventas",
        equipo: "Pack Operaciones & RRHH",
      },
      en: {
        semilla: "Retail Legalization Pack",
        jugo: "Production & Factory Pack",
        escaparate: "Visual Merchandising Pack",
        sabor: "Marketing & Sales Pack",
        equipo: "Operations & HR Pack",
      },
    },
    statusAdvice: {
      es: {
        semilla: { weak: "Tu limón está muy verde aquí. Sin estructura legal ni fiscal estás expuesto. Prioriza registrar tu marca y revisar tu fiscalidad.", medium: "Vas por buen camino pero aún tienes agujeros legales que tapar. Revisa los checks pendientes.", good: "¡Excelente! Tienes la base legal bien montada. Mantén al día tus obligaciones fiscales." },
        jugo: { weak: "Tu limón necesita jugo urgente. Sin fichas técnicas ni escandallos claros, las fábricas se comerán tus márgenes.", medium: "Tienes algo de estructura de producción pero necesitas pulir tus fichas técnicas y negociar mejor los MOQs.", good: "¡Tu cadena de producción está bien exprimida! Sigue optimizando costes y diversificando proveedores." },
        escaparate: { weak: "Tu escaparate no está vendiendo. Necesitas urgentemente un plan de visual merchandising y experiencia sensorial.", medium: "Tu negocio tiene potencial pero le falta ese factor WOW. Trabaja la rotación de escaparate y la ambientación.", good: "¡Tu negocio ya genera deseo! Sigue innovando con la experiencia sensorial para fidelizar." },
        sabor: { weak: "Alerta: sin calendario comercial ni e-commerce integrado, estás perdiendo ventas cada día. Es tu área más urgente.", medium: "Tienes algo de estructura comercial pero necesitas automatizar más y crear un calendario agresivo.", good: "¡Tus ventas están bien canalizadas! Optimiza tu email marketing y campañas de Ads para escalar." },
        equipo: { weak: "Tu equipo funciona a ciegas. Sin manuales ni incentivos claros estás perdiendo talento y dinero. Actúa ya.", medium: "Tienes algo de estructura operativa pero necesitas protocolos claros y buscar ayudas públicas.", good: "¡Gran trabajo con tu equipo! Tu operativa está bien engrasada. Busca subvenciones para seguir creciendo." },
      },
      en: {
        semilla: { weak: "Your lemon is very green here. Without legal or tax structure you're exposed. Prioritize registering your brand and reviewing your taxes.", medium: "You're on the right track but still have legal gaps to fill. Check pending items.", good: "Excellent! Your legal foundation is solid. Keep your tax obligations up to date." },
        jugo: { weak: "Your lemon needs juice urgently. Without tech packs or clear cost breakdowns, factories will eat your margins.", medium: "You have some production structure but need to polish your tech packs and negotiate MOQs better.", good: "Your production chain is well squeezed! Keep optimizing costs and diversifying suppliers." },
        escaparate: { weak: "Your showcase isn't selling. You urgently need a visual merchandising and sensory experience plan.", medium: "Your business has potential but lacks that WOW factor. Work on window rotation and ambiance.", good: "Your business already creates desire! Keep innovating with sensory experience to build loyalty." },
        sabor: { weak: "Alert: without a commercial calendar or integrated e-commerce, you're losing sales every day. This is your most urgent area.", medium: "You have some commercial structure but need more automation and an aggressive calendar.", good: "Your sales are well channeled! Optimize your email marketing and Ad campaigns to scale." },
        equipo: { weak: "Your team is flying blind. Without manuals or clear incentives you're losing talent and money. Act now.", medium: "You have some operational structure but need clear protocols and to look for public grants.", good: "Great work with your team! Your operations are well-oiled. Look for grants to keep growing." },
      },
    },
    microDatos: {
      es: {
        semilla: "El 60% de las marcas nuevas cierra por no tener su fiscalidad en orden desde el día 1.",
        jugo: "Un mal escandallo es la causa nº1 de quiebra en negocios de retail.",
        escaparate: "Las tiendas con rotación quincenal de escaparate venden un 23% más que las que no lo cambian.",
        sabor: "El 70% de los clientes que abandonan el carrito online nunca vuelven sin un email de recuperación.",
        equipo: "Las tiendas con protocolos de venta escritos facturan un 35% más que las que improvisan.",
      },
      en: {
        semilla: "60% of new brands close because they didn't have their taxes in order from day 1.",
        jugo: "A bad cost breakdown is the #1 cause of bankruptcy in retail businesses.",
        escaparate: "Stores with bi-weekly window rotation sell 23% more than those that don't change it.",
        sabor: "70% of customers who abandon an online cart never return without a recovery email.",
        equipo: "Stores with written sales protocols bill 35% more than those that improvise.",
      },
    },
    setupDescriptions: {
      es: {
        semilla: "Acceso inmediato a plantillas legales, guía de registro de marca y calculadora fiscal para retail.",
        jugo: "Acceso inmediato a plantillas de Tech Packs, calculadoras de escandallos y validación de tus bocetos.",
        escaparate: "Guías de visual merchandising, plantillas de rotación de escaparate y checklist de experiencia sensorial.",
        sabor: "Calendario comercial plantilla, secuencias de email marketing y guía de estrategia de liquidación.",
        equipo: "Manuales de operaciones, plantillas de objetivos de venta y buscador de subvenciones activas.",
      },
      en: {
        semilla: "Immediate access to legal templates, brand registration guide and retail tax calculator.",
        jugo: "Immediate access to Tech Pack templates, cost calculators and sketch validation.",
        escaparate: "Visual merchandising guides, window rotation templates and sensory experience checklist.",
        sabor: "Commercial calendar template, email marketing sequences and clearance strategy guide.",
        equipo: "Operations manuals, sales target templates and active grants finder.",
      },
    },
    sherpaDescriptions: {
      es: {
        semilla: "Tramitamos tu alta, registramos tu marca y optimizamos tu fiscalidad mientras la cuota esté activa.",
        jugo: "Buscamos talleres a medida (Sourcing), auditamos presupuestos y negociamos mínimos por ti.",
        escaparate: "Diseñamos tu layout de tienda, programamos rotaciones y supervisamos la implantación.",
        sabor: "Gestionamos tus campañas, configuramos automatizaciones y optimizamos tu e-commerce.",
        equipo: "Seleccionamos personal, tramitamos subvenciones a éxito y montamos tu sistema de incentivos.",
      },
      en: {
        semilla: "We handle your registration, register your brand and optimize your taxes while the plan is active.",
        jugo: "We find custom workshops (Sourcing), audit budgets and negotiate minimums for you.",
        escaparate: "We design your business layout, schedule rotations and supervise implementation.",
        sabor: "We manage your campaigns, set up automations and optimize your e-commerce.",
        equipo: "We recruit staff, process success-based grants and set up your incentive system.",
      },
    },
  },

  // ── Public Calculator ──
  calc: {
    badge: { es: "Incluida en todos los planes", en: "Included in every plan" },
    title: { es: "Calculadora de Rentabilidad Retail", en: "Retail Profitability Calculator" },
    subtitle: { es: "Descubre al instante la salud financiera de tu punto de venta y si tu alquiler es sostenible.\nUna herramienta gratuita de Retail Lemon.", en: "Instantly discover the financial health of your business and whether your rent is sustainable.\nA free tool by Retail Lemon." },
    cardTitle: { es: "Rentabilidad por m²", en: "Profitability per m²" },
    labelRevenue: { es: "Facturación Mensual (€)", en: "Monthly Revenue (€)" },
    labelArea: { es: "Metros Cuadrados de Venta (m²)", en: "Sales Area (m²)" },
    labelRent: { es: "Alquiler Mensual (€)", en: "Monthly Rent (€)" },
    placeholderRevenue: { es: "Ej: 25.000", en: "e.g. 25,000" },
    placeholderArea: { es: "Ej: 80", en: "e.g. 80" },
    placeholderRent: { es: "Ej: 3.000", en: "e.g. 3,000" },
    cta: { es: "Calcular mi Rentabilidad", en: "Calculate My Profitability" },
    resultsTitle: { es: "Análisis RetailLemon", en: "RetailLemon Analysis" },
    salesPerM2: { es: "Ventas por m²", en: "Sales per m²" },
    rentEffort: { es: "Tasa de esfuerzo del alquiler", en: "Rent Effort Rate" },
    faqTitle: { es: "Preguntas frecuentes sobre rentabilidad retail", en: "Frequently asked questions about retail profitability" },
    faq1q: { es: "¿Qué es la venta por metro cuadrado en retail?", en: "What is sales per square meter in retail?" },
    faq1a: { es: "La venta por metro cuadrado es un indicador clave (KPI) que mide la facturación de una tienda dividida entre su superficie comercial. Sirve para evaluar la productividad del espacio de venta y comparar el rendimiento entre locales.", en: "Sales per square meter is a key performance indicator (KPI) that measures a store's revenue divided by its commercial area. It helps evaluate sales space productivity and compare performance across locations." },
    faq2q: { es: "¿Qué es la tasa de esfuerzo en retail?", en: "What is the rent effort rate in retail?" },
    faq2a: { es: "La tasa de esfuerzo es el porcentaje que representa el alquiler mensual sobre la facturación mensual. Es un indicador fundamental para saber si tu local comercial es financieramente sostenible. Una tasa de esfuerzo sana debe estar por debajo del 15%.", en: "The rent effort rate is the percentage of monthly rent relative to monthly revenue. It is a fundamental indicator to know if your commercial premises are financially sustainable. A healthy effort rate should be below 15%." },
    faq3q: { es: "¿Cuál es una buena rentabilidad por m² en retail?", en: "What is a good profitability per m² in retail?" },
    faq3a: { es: "Depende del sector y la ubicación, pero como regla general, si tu tasa de esfuerzo (alquiler/facturación) es inferior al 15%, tu negocio tiene una buena salud financiera. Esta calculadora gratuita de Retail Lemon te ayuda a descubrirlo al instante.", en: "It depends on the sector and location, but as a general rule, if your effort rate (rent/revenue) is below 15%, your premises have good financial health. This free Retail Lemon calculator helps you find out instantly." },
    // Diagnosis
    statusHealthy: { es: "Saludable", en: "Healthy" },
    statusWarning: { es: "Atención", en: "Warning" },
    statusRisk: { es: "Riesgo", en: "Risk" },
    diagnosisText: { es: "Tu alquiler representa el", en: "Your rent represents" },
    diagnosisTextEnd: { es: "de tu facturación.\nEn retail, lo recomendable es mantenerse entre el 8% y el 12%.", en: "of your revenue.\nIn retail, the recommended range is between 8% and 12%." },
    // Locked PRO
    lockedMetric1: { es: "Ventas necesarias al día", en: "Required daily sales" },
    lockedMetric2: { es: "Punto de equilibrio de el negocio", en: "Store break-even point" },
    lockedMetric3: { es: "Impacto de mejorar el ticket medio", en: "Impact of improving average ticket" },
    lockedFake1: { es: "2.847€/día", en: "€2,847/day" },
    lockedFake2: { es: "18.320€/mes", en: "€18,320/mo" },
    lockedFake3: { es: "+12,4% margen", en: "+12.4% margin" },
    proTitle: { es: "Análisis Avanzado RetailLemon", en: "Advanced RetailLemon Analysis" },
    proCta: { es: "Descubre si tu negocio es realmente rentable", en: "Find out if your business is truly profitable" },
    proDesc: { es: "La Calculadora Retail PRO analiza tu negocio en profundidad y calcula el punto de equilibrio real de tu negocio, cuánto debes vender cada día y cómo mejorar tu rentabilidad.", en: "The Retail PRO Calculator analyzes your business in depth and calculates the real break-even point of your business, how much you need to sell each day and how to improve your profitability." },
    proBullet1: { es: "Punto de equilibrio de tu negocio", en: "Your business's break-even point" },
    proBullet2: { es: "Ventas mínimas necesarias al día", en: "Minimum daily sales required" },
    proBullet3: { es: "Simulador de ticket medio", en: "Average ticket simulator" },
    proBullet4: { es: "Diagnóstico financiero del punto de venta", en: "Point-of-sale financial diagnosis" },
    proCtaLoggedIn: { es: "Ir a mi Análisis PRO", en: "Go to My PRO Analysis" },
    proCtaLoggedOut: { es: "Pedir acceso anticipado 🍋", en: "Request early access 🍋" },
    proSocialProof: { es: "Más de 1.000 retailers ya han analizado la rentabilidad de su tienda con RetailLemon.", en: "Over 1,000 retailers have already analyzed their store's profitability with RetailLemon." },
  },

  // ── PRO Calculator ──
  calcPro: {
    verifying: { es: "Verificando acceso...", en: "Verifying access..." },
    restricted: { es: "Acceso Restringido", en: "Restricted Access" },
    restrictedDesc: { es: "Esta herramienta avanzada forma parte del módulo de <strong>Finanzas</strong>. Optimiza tu flujo de caja, calcula tu punto de equilibrio y toma el control total de tu rentabilidad.", en: "This advanced tool is part of the <strong>Finance</strong> module. Optimize your cash flow, calculate your break-even point and take full control of your profitability." },
    breakEvenLabel: { es: "Punto de equilibrio", en: "Break-even point" },
    ticketSimLabel: { es: "Simulador de ticket", en: "Ticket simulator" },
    activateModule: { es: "Activar módulo de Finanzas", en: "Activate Finance Module" },
    activateNote: { es: "Al activar este módulo tendrás acceso completo a la Calculadora Retail PRO y todas las herramientas financieras.", en: "By activating this module you will get full access to the Retail PRO Calculator and all financial tools." },
    badge: { es: "Análisis PRO", en: "PRO Analysis" },
    title: { es: "Calculadora Retail PRO", en: "Retail PRO Calculator" },
    subtitle: { es: "Simulador avanzado de rentabilidad para tu punto de venta. Los resultados se actualizan en tiempo real.", en: "Advanced profitability simulator for your point of sale. Results update in real time." },
    prefilled: { es: "✨ Hemos recuperado los datos de tu cálculo anterior", en: "✨ We've recovered data from your previous calculation" },
    storeInfo: { es: "Información de la Tienda", en: "Store Information" },
    surface: { es: "Superficie", en: "Area" },
    monthlyRent: { es: "Alquiler mensual", en: "Monthly rent" },
    locationType: { es: "Tipo de ubicación", en: "Location type" },
    highStreet: { es: "Calle principal", en: "High street" },
    mall: { es: "Centro comercial", en: "Shopping mall" },
    secondary: { es: "Calle secundaria", en: "Secondary street" },
    daysOpen: { es: "Días abiertos al mes", en: "Days open per month" },
    salesInfo: { es: "Información de Ventas", en: "Sales Information" },
    revenueType: { es: "Tipo de facturación", en: "Revenue type" },
    revenueTooltip: { es: "El retail es estacional. Recomendamos usar la media de los últimos 12 meses para obtener un diagnóstico real de tu tasa de esfuerzo.", en: "Retail is seasonal. We recommend using the average from the last 12 months for an accurate effort rate diagnosis." },
    lastMonth: { es: "Último mes", en: "Last month" },
    specificMonth: { es: "Mes específico", en: "Specific month" },
    specificMonthSub: { es: "Datos de un mes concreto", en: "Data from a specific month" },
    quickAnalysis: { es: "Análisis rápido", en: "Quick analysis" },
    annualAvg: { es: "Media anualizada", en: "Annual average" },
    realDiagnosis: { es: "Diagnóstico real ⭐", en: "Real diagnosis ⭐" },
    monthlyNote: { es: "💡 Los datos de un solo mes pueden estar influenciados por la estacionalidad. Usaremos simulación estacional para darte una foto más completa.", en: "💡 Single-month data may be influenced by seasonality. We'll use seasonal simulation to give you a more complete picture." },
    avgTicket: { es: "Ticket medio", en: "Average ticket" },
    avgTicketTooltip: { es: "Usa la media de ticket de los últimos 12 meses.", en: "Use the average ticket from the last 12 months." },
    customersDay: { es: "Tickets por día", en: "Tickets per day" },
    customersDayTooltip: { es: "Usa la media diaria de tickets del último año.", en: "Use the average daily tickets from the last year." },
    grossMargin: { es: "Margen bruto", en: "Gross margin" },
    staffCosts: { es: "Costes de Personal", en: "Staff Costs" },
    numEmployees: { es: "Nº empleados", en: "No. employees" },
    costPerEmployee: { es: "Coste por empleado", en: "Cost per employee" },
    weeklyHours: { es: "Horas semanales totales", en: "Total weekly hours" },
    weeklyHoursTooltip: { es: "Suma las horas de todo el equipo: si tienes 2 a 40h y 1 a 20h = 100h", en: "Sum all team hours: if you have 2 at 40h and 1 at 20h = 100h" },
    hourlyRate: { es: "Coste medio/hora", en: "Average cost/hour" },
    numLocales: { es: "Nº de locales", en: "No. of locations" },
    numLocalesTooltip: { es: "Si tienes más de 1 local, introduce los datos del total de la operación", en: "If you have more than 1 location, enter total operation data" },
    multiLocaleNote: { es: "📍 Con varios locales, introduce los datos agregados de toda tu operación (facturación total, alquiler total, personal total).", en: "📍 With multiple locations, enter aggregated data for your entire operation (total revenue, total rent, total staff)." },
    totalStaffCost: { es: "Coste total de personal", en: "Total staff cost" },
    otherCosts: { es: "Otros Costes Mensuales", en: "Other Monthly Costs" },
    utilities: { es: "Suministros", en: "Utilities" },
    marketingLabel: { es: "Marketing", en: "Marketing" },
    otherFixed: { es: "Otros costes fijos", en: "Other fixed costs" },
    financialAnalysis: { es: "Análisis Financiero", en: "Financial Analysis" },
    annualizedAvg: { es: "Media anualizada", en: "Annual average" },
    monthlyRevenue: { es: "Facturación mensual", en: "Monthly revenue" },
    grossProfit: { es: "Beneficio bruto", en: "Gross profit" },
    fixedCosts: { es: "Costes fijos", en: "Fixed costs" },
    netProfit: { es: "Beneficio neto", en: "Net profit" },
    revenueVsCosts: { es: "Ingresos vs Costes", en: "Revenue vs Costs" },
    costBreakdown: { es: "Desglose de Costes", en: "Cost Breakdown" },
    chartRevenue: { es: "Facturación", en: "Revenue" },
    chartGrossProfit: { es: "B. Bruto", en: "Gross P." },
    chartFixedCosts: { es: "Costes fijos", en: "Fixed costs" },
    chartNetProfit: { es: "B. Neto", en: "Net P." },
    chartRent: { es: "Alquiler", en: "Rent" },
    chartStaff: { es: "Personal", en: "Staff" },
    chartUtilities: { es: "Suministros", en: "Utilities" },
    chartMarketing: { es: "Marketing", en: "Marketing" },
    chartOther: { es: "Otros", en: "Other" },
    seasonalAnalysis: { es: "Análisis Estacional", en: "Seasonal Analysis" },
    seasonalSubtitle: { es: "Cómo varían tus números según la temporada del año", en: "How your numbers vary by season" },
    lowSeason: { es: "Temporada Baja", en: "Low Season" },
    currentMonth: { es: "Mes Actual", en: "Current Month" },
    avgMonth: { es: "Mes medio", en: "Average Month" },
    highSeason: { es: "Temporada Alta", en: "High Season" },
    profit: { es: "beneficio", en: "profit" },
    loss: { es: "pérdida", en: "loss" },
    cashReserve: { es: "En temporada baja, tu negocio necesitaría una", en: "In low season, your business would need a" },
    cashReserveLabel: { es: "reserva de caja de", en: "cash reserve of" },
    cashReserveEnd: { es: "para cubrir los costes fijos.\nPlanifica ahorrando parte del beneficio de temporada alta.", en: "to cover fixed costs.\nPlan by saving part of the high-season profit." },
    lemonAdvice: { es: "Consejo Estratégico Lemon", en: "Lemon Strategic Advice" },
    lemonAdviceText1: { es: "No te asustes por los números de este mes. En retail,", en: "Don't be scared by this month's numbers. In retail," },
    lemonAdviceText2: { es: "lo que cuenta es la foto anual", en: "what matters is the annual picture" },
    lemonAdviceText3: { es: "Tu tasa de esfuerzo actual", en: "Your current effort rate" },
    lemonAdviceText4: { es: "puede parecer alta, pero es normal en temporada baja.\nTu objetivo es que la media de esfuerzo", en: "may seem high, but it's normal in low season.\nYour goal is to keep the average effort rate" },
    lemonAdviceText5: { es: "no supere el 15% al cierre del ejercicio", en: "below 15% at year-end" },
    lemonAdviceTip: { es: "💡 Prueba a cambiar a \"Media anualizada\" para ver tu diagnóstico real.", en: "💡 Try switching to \"Annual average\" to see your real diagnosis." },
    breakEvenTitle: { es: "Punto de Equilibrio", en: "Break-Even Point" },
    breakEvenMonthly: { es: "Break-even mensual", en: "Monthly break-even" },
    dailyRevenueNeeded: { es: "Facturación diaria necesaria", en: "Required daily revenue" },
    breakEvenMsg: { es: "Tu negocio necesita facturar", en: "Your business needs to bill" },
    breakEvenMsgEnd: { es: "al día para cubrir todos los costes.", en: "per day to cover all costs." },
    aboveBreakEven: { es: "¡Estás por encima del punto de equilibrio!", en: "You're above the break-even point!" },
    belowBreakEven: { es: "Actualmente estás por debajo del punto de equilibrio.", en: "You're currently below the break-even point." },
    ticketSimTitle: { es: "Simulador de Ticket Medio", en: "Average Ticket Simulator" },
    ticketCurrent: { es: "Ticket actual:", en: "Current ticket:" },
    ticketSimulated: { es: "Simulado:", en: "Simulated:" },
    ticketUp: { es: "sube", en: "goes up" },
    ticketDown: { es: "baja", en: "goes down" },
    ticketRevenueUp: { es: "aumentaría", en: "would increase" },
    ticketRevenueDown: { es: "disminuiría", en: "would decrease" },
    ticketImpactPrefix: { es: "Si tu ticket medio", en: "If your average ticket" },
    ticketImpactMid: { es: "tu facturación mensual", en: "your monthly revenue" },
    healthIndicators: { es: "Indicadores de Salud Retail", en: "Retail Health Indicators" },
    revenue: { es: "Facturación", en: "Revenue" },
    breakEven: { es: "Break-even", en: "Break-even" },
    dailySales: { es: "Venta diaria", en: "Daily sales" },
    dailySalesSub: { es: "necesaria/día", en: "needed/day" },
    rentRate: { es: "Tasa alquiler", en: "Rent rate" },
    diagnosisTitle: { es: "Diagnóstico del Negocio", en: "Business Diagnosis" },
    diagRentHealthy: { es: "Alquiler Saludable", en: "Healthy Rent" },
    diagRentWarning: { es: "Alquiler en Zona de Atención", en: "Rent in Warning Zone" },
    diagRentDanger: { es: "Alquiler Peligroso", en: "Dangerous Rent" },
    diagRentHealthyDesc: { es: "Tu alquiler representa solo el {ratio}% de la facturación. Excelente ratio.", en: "Your rent represents only {ratio}% of revenue. Excellent ratio." },
    diagRentWarningDesc: { es: "Tu alquiler es el {ratio}% de tu facturación. Vigila que no suba más.", en: "Your rent is {ratio}% of your revenue. Watch that it doesn't go higher." },
    diagRentDangerDesc: { es: "Tu alquiler representa el {ratio}% de tu facturación. Negocia o busca alternativas.", en: "Your rent represents {ratio}% of your revenue. Negotiate or look for alternatives." },
    diagLoss: { es: "Pérdidas Mensuales", en: "Monthly Losses" },
    diagLossDesc: { es: "Tu negocio pierde {amount}€ al mes. Necesitas reducir costes o aumentar ventas.", en: "Your business loses €{amount} per month. You need to cut costs or increase sales." },
    diagTightMargin: { es: "Margen Muy Ajustado", en: "Very Tight Margin" },
    diagTightMarginDesc: { es: "Tu beneficio neto es inferior al 5% de la facturación. Cualquier imprevisto te pone en pérdidas.", en: "Your net profit is below 5% of revenue. Any unexpected expense puts you in the red." },
    diagProfitable: { es: "Negocio Rentable", en: "Profitable Business" },
    diagProfitableDesc: { es: "Tu negocio genera {amount}€ de beneficio neto mensual. ¡Buen trabajo!", en: "Your business generates €{amount} in monthly net profit. Great job!" },
    diagLowM2: { es: "Baja Productividad por m²", en: "Low Productivity per m²" },
    diagLowM2Desc: { es: "Solo {amount}€/m². Considera optimizar el espacio o aumentar rotación.", en: "Only €{amount}/m². Consider optimizing space or increasing turnover." },
    healthScore: { es: "Retail Business Health Score", en: "Retail Business Health Score" },
    scoreGood: { es: "Tu negocio tiene una salud financiera sólida. ¡Sigue así!", en: "Your business has solid financial health. Keep it up!" },
    scoreMedium: { es: "Tu negocio necesita ajustes. Revisa los diagnósticos para mejorar.", en: "Your business needs adjustments. Review the diagnostics to improve." },
    scoreBad: { es: "Tu negocio tiene problemas financieros urgentes. Actúa cuanto antes.", en: "Your business has urgent financial problems. Act as soon as possible." },
    aiAnalysisTitle: { es: "Análisis Experto IA", en: "AI Expert Analysis" },
    aiAnalysisLoading: { es: "Generando análisis personalizado...", en: "Generating personalized analysis..." },
    aiAnalysisRetry: { es: "Generar análisis IA", en: "Generate AI analysis" },
    aiAnalysisError: { es: "No se ha podido generar el análisis. Revisa tu acceso o inténtalo de nuevo en unos segundos.", en: "The analysis could not be generated. Check your access or try again in a few seconds." },
    historyTitle: { es: "Mi historial de cálculos", en: "My calculation history" },
    lastCalcTitle: { es: "Mi último cálculo", en: "My last calculation" },
    lastCalcSaveError: { es: "No se pudo guardar el último cálculo", en: "The last calculation could not be saved" },
    historyLoad: { es: "Cargar", en: "Load" },
    exportBtn: { es: "Descargar Retail Health Report", en: "Download Retail Health Report" },
    exportDate: { es: "Fecha", en: "Date" },
    exportAnalysisType: { es: "Tipo de análisis", en: "Analysis type" },
    exportAnnualized: { es: "Media anualizada", en: "Annualized average" },
    exportMonthly: { es: "Mes puntual", en: "Single month" },
    exportStoreData: { es: "DATOS DE LA TIENDA", en: "STORE DATA" },
    exportSurface: { es: "Superficie", en: "Area" },
    exportRent: { es: "Alquiler", en: "Rent" },
    exportDays: { es: "Días operativos", en: "Operating days" },
    exportSales: { es: "VENTAS", en: "SALES" },
    exportAvgTicket: { es: "Ticket medio", en: "Average ticket" },
    exportCustomers: { es: "Clientes/día", en: "Customers/day" },
    exportGrossMargin: { es: "Margen bruto", en: "Gross margin" },
    exportRevenueAnalysis: { es: "ANÁLISIS DE INGRESOS", en: "REVENUE ANALYSIS" },
    exportMonthlyRevenue: { es: "Facturación mensual", en: "Monthly revenue" },
    exportGrossProfit: { es: "Beneficio bruto", en: "Gross profit" },
    exportTotalFixed: { es: "Costes fijos totales", en: "Total fixed costs" },
    exportNetProfit: { es: "Beneficio neto", en: "Net profit" },
    exportBreakEven: { es: "PUNTO DE EQUILIBRIO", en: "BREAK-EVEN" },
    exportBreakEvenVal: { es: "Break-even", en: "Break-even" },
    exportDailyNeeded: { es: "Facturación diaria necesaria", en: "Required daily revenue" },
    exportSeasonality: { es: "ESTACIONALIDAD", en: "SEASONALITY" },
    exportHighSeason: { es: "Temporada Alta (×1.5)", en: "High Season (×1.5)" },
    exportLowSeason: { es: "Temporada Baja (×0.7)", en: "Low Season (×0.7)" },
    exportCashNeeded: { es: "Caja necesaria en temporada baja", en: "Cash needed in low season" },
    // Seasonality Equalizer
    eqTitle: { es: "Ecualizador de Estacionalidad y Cash Flow", en: "Seasonality & Cash Flow Equalizer" },
    eqToggle: { es: "Activar estacionalidad", en: "Enable seasonality" },
    eqOff: { es: "Calculando con ventas planas los 12 meses. Activa el ecualizador para simular estacionalidad y condiciones de pago a proveedores.", en: "Calculating with flat sales across 12 months. Enable the equalizer to simulate seasonality and supplier payment terms." },
    eqWinter: { es: "❄️ Invierno Fuerte", en: "❄️ Strong Winter" },
    eqSummer: { es: "☀️ Verano Fuerte", en: "☀️ Strong Summer" },
    eqRebajas: { es: "🛒 Rebajas", en: "🛒 Sales" },
    eqFlat: { es: "⚖️ Plano", en: "⚖️ Flat" },
    eqSupplier: { es: "Condiciones de pago a proveedores", en: "Supplier payment terms" },
    eqChartTitle: { es: "Impacto en tu Cash Flow", en: "Cash Flow Impact" },
    eqRevenue: { es: "Ingresos mensuales", en: "Monthly Revenue" },
    eqCash: { es: "Impacto estacional", en: "Seasonal Impact" },
    eqAlertDynamic: { es: "Cuidado: Al pagar a {terms}, la estacionalidad genera un déficit de liquidez de {amount}€ en {month} vs. un escenario plano. Necesitas ese colchón extra.", en: "Warning: Paying at {terms}, seasonality creates a {amount}€ liquidity gap in {month} vs. a flat scenario. You need that extra cushion." },
    exportNotNeeded: { es: "No necesaria (rentable)", en: "Not needed (profitable)" },
    exportIndicators: { es: "INDICADORES", en: "INDICATORS" },
    exportRentRate: { es: "Tasa de esfuerzo (alquiler)", en: "Effort rate (rent)" },
    exportSalesM2: { es: "Venta por m²", en: "Sales per m²" },
    exportHealthScore: { es: "HEALTH SCORE", en: "HEALTH SCORE" },
    exportScore: { es: "Puntuación", en: "Score" },
    // Fiscal config
    taxConfig: { es: "Configuración fiscal", en: "Tax Configuration" },
    taxConfigSummary: { es: "{legalForm} · {vatStatus} · {ssStatus}", en: "{legalForm} · {vatStatus} · {ssStatus}" },
    legalForm: { es: "Forma jurídica", en: "Legal form" },
    autonomo: { es: "Autónomo (estimación directa)", en: "Self-employed (direct estimation)" },
    autonomoModulos: { es: "Autónomo (módulos)", en: "Self-employed (simplified)" },
    sociedadLimitada: { es: "Sociedad Limitada (SL)", en: "Limited Company (Ltd)" },
    vatIncluded: { es: "IVA incluido", en: "VAT included" },
    vatExcluded: { es: "IVA no incluido", en: "VAT excluded" },
    ssIncluded: { es: "SS incluida", en: "SS included" },
    ssExcluded: { es: "SS no incluida", en: "SS excluded" },
    includesVat: { es: "¿Tus ventas incluyen IVA?", en: "Do your sales include VAT?" },
    ticketIncludesVat: { es: "¿El ticket medio incluye IVA?", en: "Does the average ticket include VAT?" },
    vatRate: { es: "Tipo de IVA", en: "VAT rate" },
    vatNote: { es: "En retail, los tickets del TPV normalmente ya incluyen IVA.", en: "In retail, POS tickets usually already include VAT." },
    recargoEquivalencia: { es: "Recargo de equivalencia", en: "Equivalence surcharge" },
    recargoNote: { es: "En módulos tienes recargo de equivalencia (5.2%) en tus compras. Esto aumenta el coste de tus mercancías.", en: "In simplified regime you have an equivalence surcharge (5.2%) on purchases. This increases your merchandise cost." },
    staffTaxDetail: { es: "Detalle fiscal del personal", en: "Staff tax detail" },
    staffIncludesSS: { es: "¿El coste/hora incluye Seguridad Social?", en: "Does hourly cost include Social Security?" },
    ssRate: { es: "% Seguridad Social", en: "% Social Security" },
    ssNote: { es: "El coste empresa incluye salario bruto + ~30% de Seg. Social. Si introduces el coste total empresa, deja esto activado.", en: "Employer cost includes gross salary + ~30% Social Security. If you enter total employer cost, leave this on." },
    realHourlyCost: { es: "Coste real/hora", en: "Real hourly cost" },
    costsTaxDetail: { es: "Detalle fiscal de costes", en: "Costs tax detail" },
    costsIncludeVat: { es: "¿Estos importes incluyen IVA?", en: "Do these amounts include VAT?" },
    costsVatNote: { es: "ℹ️ Consejo de simulación: Para una proyección de tesorería más fiel a la realidad de tu banco, te recomendamos introducir los importes de tus costes tal y como los pagas mensualmente (con impuestos incluidos).", en: "ℹ️ Simulation tip: For a cash-flow projection that matches what your bank actually shows, we recommend entering costs exactly as you pay them each month (taxes included)." },
    marginSectorTooltip: { es: "Hemos aplicado el margen medio estimado para tu sector por defecto. Puedes modificar este porcentaje aumentándolo o disminuyéndolo según la realidad de tu stock.", en: "We've applied the average estimated margin for your sector by default. You can adjust this percentage up or down to match the reality of your stock." },
    marginManualTooltip: { es: "Introduce tu margen bruto manual. Te ofreceremos una recomendación automática en cuanto selecciones el sector de tu negocio en la configuración del local.", en: "Enter your gross margin manually. We'll suggest an automatic value as soon as you select your store's sector in the location settings." },
    clearCells: { es: "Limpiar celdas", en: "Clear cells" },
    clearCellsConfirm: { es: "Celdas limpias", en: "Cells cleared" },
    fiscalDetailToggle: { es: "Ver detalle fiscal", en: "View tax detail" },
    // Progressive disclosure
    monthlyRevenueSimple: { es: "Facturación mensual media", en: "Average monthly revenue" },
    monthlyRevenueSimpleTooltip: { es: "Introduce tu facturación mensual media (con o sin IVA según tu configuración fiscal).", en: "Enter your average monthly revenue (with or without VAT per your tax config)." },
    calcByTraffic: { es: "⚙️ Calcular por tráfico y ticket medio (Avanzado)", en: "⚙️ Calculate by traffic and avg. ticket (Advanced)" },
    backToDirectRevenue: { es: "← Volver a facturación directa", en: "← Back to direct revenue" },
    totalStaffCostSimple: { es: "Coste total de personal mensual", en: "Total monthly staff cost" },
    totalStaffCostHelper: { es: "Incluye sueldos netos y seguros sociales", en: "Includes net salaries and social security" },
    breakdownByHours: { es: "⚙️ Desglosar por horas y coste (Avanzado)", en: "⚙️ Break down by hours and cost (Advanced)" },
    backToTotalCost: { es: "← Volver a coste total", en: "← Back to total cost" },
    allAmountsIncludeVat: { es: "¿Los importes incluyen IVA?", en: "Do amounts include VAT?" },
    advancedTaxOptions: { es: "⚙️ Opciones Fiscales Avanzadas", en: "⚙️ Advanced Tax Options" },
    // Country switcher
    countryLabel: { es: "Fiscalidad: España", en: "Tax: Spain" },
    countrySpain: { es: "España", en: "Spain" },
    countryOther: { es: "Adaptar a otro país...", en: "Adapt to another country..." },
    countryDialogTitle: { es: "Personaliza la fiscalidad para tu país", en: "Customize tax settings for your country" },
    countryDialogDesc: { es: "Nuestra calculadora está optimizada para España por defecto. Dinos dónde está tu negocio y nuestro equipo ajustará la moneda, impuestos (IVA/VAT) y costes laborales de tu panel.", en: "Our calculator is optimized for Spain by default. Tell us where your business is and our team will adjust currency, taxes (VAT) and labor costs for your panel." },
    countryInputLabel: { es: "¿En qué país operas?", en: "Which country do you operate in?" },
    countryInputPlaceholder: { es: "Ej: México, Colombia, Francia...", en: "e.g. Mexico, Colombia, France..." },
    countrySubmitBtn: { es: "Solicitar Configuración", en: "Request Configuration" },
    countrySuccess: { es: "✓ Solicitud recibida. Te contactaremos en breve para activar tu país.", en: "✓ Request received. We'll contact you shortly to activate your country." },
    // Recalculate
    saveAndCalc: { es: "Calcular", en: "Calculate" },
    recalculate: { es: "Recalcular", en: "Recalculate" },
  },

  kpisAccess: {
    badge: { es: "DESDE CLUB PRO · 69 €/MES", en: "FROM CLUB PRO · €69/MONTH" },
    description: { es: "Los KPIs y el histórico por local están incluidos en Club Pro y Avanzado. No están disponibles en Básico.", en: "KPIs and history per location are included in Club Pro and Advanced. They are not available in Basic." },
    signup: { es: "Crear cuenta · Club Pro 7 días gratis", en: "Sign up · Club Pro 7-day free trial" },
    upgrade: { es: "Pasar a Club Pro", en: "Upgrade to Club Pro" },
    transferDescription: { es: "Lleva los datos de la calculadora a KPIs y revisa el registro antes de guardarlo.", en: "Transfer your calculator data to KPIs and review the record before saving it." },
    transfer: { es: "Llevar datos a KPIs", en: "Transfer data to KPIs" },
  },

  // ── Dashboard extras (VIP + sidebar) ──
  dashboardExtra: {
    planLoadError: { es: "No hemos podido cargar tu plan", en: "We couldn't load your plan" },
    planLoadRetry: { es: "Reintentar", en: "Retry" },
    vipTitle: { es: "✨ Desbloquea Tu Mentor", en: "✨ Unlock Your Mentor" },
    vipShort: { es: "✨ Tu Mentor", en: "✨ Your Mentor" },
    vipDesc: { es: "Accede al seguimiento directo de un profesional del retail. Setup inicial + acompañamiento mensual para que dejes de gestionar a ciegas.", en: "Get direct follow-up from a retail professional. Initial setup + monthly support so you stop managing blindly." },
    vipDescBold: { es: "Cuéntanos tu proyecto y activaremos tu hoja de ruta personalizada.", en: "Tell us about your project and we'll activate your personalized roadmap." },
    vipRequestBtn: { es: "Solicitar Acceso a Tu Mentor", en: "Request Mentor Access" },
    vipRequestShort: { es: "Solicitar Tu Mentor", en: "Request Your Mentor" },
    vipRequestShortest: { es: "Solicitar", en: "Request" },
    vipFormTitle: { es: "Cuéntanos sobre tu negocio", en: "Tell us about your business" },
    vipLabelStore: { es: "Nombre y Web/IG de el negocio", en: "Store name & website/IG" },
    vipPlaceholderStore: { es: "Ej: María – @mitienda_ig / mitienda.com", en: "e.g. Maria – @mystore_ig / mystore.com" },
    vipLabelBlocker: { es: "¿Cuál es el bloqueo nº1 de tu negocio ahora mismo?", en: "What's the #1 blocker in your business right now?" },
    vipPlaceholderBlocker: { es: "Ej: No consigo aumentar el ticket medio...", en: "e.g. I can't seem to increase the average ticket..." },
    vipLabelType: { es: "¿Buscas acompañamiento recurrente o una intervención puntual?", en: "Are you looking for ongoing support or a one-time intervention?" },
    vipOptionSelect: { es: "Selecciona una opción", en: "Select an option" },
    vipOptionRecurring: { es: "Acompañamiento recurrente", en: "Ongoing support" },
    vipOptionOneTime: { es: "Intervención puntual", en: "One-time intervention" },
    vipSending: { es: "Enviando...", en: "Sending..." },
    vipSendBtn: { es: "Enviar Solicitud", en: "Send Request" },
    vipErrorTitle: { es: "Error al enviar", en: "Error sending" },
    vipErrorDesc: { es: "Inténtalo de nuevo.", en: "Try again." },
    vipSuccessTitle: { es: "¡Solicitud enviada!", en: "Request sent!" },
    vipSuccessDesc: { es: "Revisaremos tu caso y te contactaremos pronto.", en: "We'll review your case and contact you soon." },
    tipsTab: { es: "Consejos e Ideas", en: "Tips & Ideas" },
    brainstormTab: { es: "Brainstorming", en: "Brainstorming" },
    brainstormDesc: {
      es: "La bomba de ideas de la comunidad. Comparte tus conceptos, lanza preguntas y opina sobre las propuestas de otros comerciantes para validar estrategias y hacer crecer nuestros negocios juntos.",
      en: "The community's idea generator. Share your concepts, ask questions and give feedback on other retailers' proposals to validate strategies and grow our businesses together.",
    },
    createBtn: { es: "Añadir", en: "Add" },
    financialMgmt: { es: "Gestión Financiera", en: "Financial Management" },
    calculatorPro: { es: "Calculadora PRO", en: "PRO Calculator" },
    signOut: { es: "Cerrar sesión", en: "Sign Out" },
    loading: { es: "Cargando tu panel...", en: "Loading your panel..." },
    loadingRecoveryText: { es: "Tu sesión o caché parece estar bloqueada. Haz una carga limpia para continuar.", en: "Your session or cache seems to be stuck. Run a clean reload to continue." },
    loadingRecoveryBtn: { es: "Reintentar carga limpia", en: "Retry clean load" },
  },

  // ── Waitlist ──
  waitlist: {
    title: { es: "Acceso Beta Privada", en: "Private Beta Access" },
    subtitle: { es: "El Club Pro está en fase Beta Privada, solo para clientes seleccionados. Déjanos tus datos y te enviaremos una invitación en cuanto abramos nuevas plazas.", en: "The Club Pro is in Private Beta, for selected clients only. Leave your details and we'll send you an invitation as soon as new spots open." },
    subtitlePlan: { es: "Estamos en Beta Privada. Déjanos tus datos y anotaremos tu solicitud de {plan} para avisarte en cuanto abramos plazas.", en: "We're in Private Beta. Leave your details and we'll register your {plan} request to notify you as soon as spots open." },
    servicePro: { es: "Club Pro", en: "Club Pro" },
    serviceMentoring: { es: "Mentoring", en: "Mentoring" },
    serviceFree: { es: "Gratis", en: "Free" },
    serviceAddon: { es: "Extra", en: "Add-on" },
    serviceColumn: { es: "Servicio", en: "Service" },
    filterAll: { es: "Todos", en: "All" },
    joinBtn: { es: "Solicitar invitación", en: "Request invitation" },
    joining: { es: "Enviando solicitud…", en: "Submitting…" },
    successTitle: { es: "¡Solicitud recibida! 🎉", en: "Request received! 🎉" },
    successMessage: { es: "Te contactaremos por email cuando haya plazas disponibles. Gracias por tu interés.", en: "We'll contact you by email when spots are available. Thanks for your interest." },
    alreadyJoined: { es: "Este email ya está en la lista de espera.", en: "This email is already on the waitlist." },
    onListToast: {
      es: "Estás en la lista de espera. Te avisaremos por email en cuanto tu turno esté listo. 🍋",
      en: "You're on the waiting list. We'll email you the moment your turn is ready. 🍋",
    },
    blockedGoogleToast: {
      es: "El Panel está en Beta Privada. Regístrate en la lista de espera y te avisaremos.",
      en: "The Panel is in Private Beta. Join the waiting list and we'll let you know.",
    },
  },

  // ── Anti-Master Section ──
  antiMaster: {
    tag: { es: "El Anti-Máster", en: "The Anti-Master" },
    title1: { es: "⚡ La alternativa real (y rentable)", en: "⚡ The real (and profitable) alternative" },
    titleAccent: { es: "a los másters tradicionales.", en: "to traditional master's degrees." },
    subtitle: {
      es: "No pagues miles de euros por escuchar casos de éxito de terceros. Invierte en aplicar la estrategia directamente en tu negocio, con un mentor a tu lado.",
      en: "Don't pay thousands to hear about other people's success stories. Invest in applying strategy directly to your business, with a mentor by your side.",
    },
    tradTitle: { es: "Formación Tradicional", en: "Traditional Training" },
    tradItems: {
      es: [
        "Analizas el modelo de negocio de multinacionales.",
        "Mucha teoría de aula, cero ejecución.",
        "Inversión alta de golpe (10.000€+).",
        "Al terminar, vuelves a estar solo frente a tu negocio.",
      ],
      en: [
        "You analyze the business model of multinationals.",
        "Lots of classroom theory, zero execution.",
        "High upfront investment (€10,000+).",
        "When it's over, you're alone again facing your business.",
      ],
    },
    lemonTitle: { es: "Mentoring Lemon", en: "Lemon Mentoring" },
    lemonItems: {
      es: [
        "Optimizas el modelo de negocio de TU local.",
        "100% Ejecución y decisiones a pie de calle.",
        "Suscripción mensual flexible y sin riesgos.",
        "Un respaldo experto a tu lado de forma permanente.",
      ],
      en: [
        "You optimize YOUR store's business model.",
        "100% Execution and street-level decisions.",
        "Flexible monthly subscription with no risk.",
        "Expert support by your side permanently.",
      ],
    },
    ctaLead: { es: "Quiero resultados reales, no diplomas.", en: "I want real results, not diplomas." },
    cta: { es: "Empieza a profesionalizar tu negocio", en: "Start professionalizing your business" },
  },

  // ── Lemon Retail Club ──
  club: {
    tag: { es: "Networking de Alto Valor", en: "High-Value Networking" },
    title1: { es: "El fin de la soledad del emprendedor.", en: "The end of entrepreneurial loneliness." },
    titleAccent: { es: "Bienvenido al Lemon Retail Club.", en: "Welcome to the Lemon Retail Club." },
    subtitle: {
      es: "Con tu mentoring no solo ganas un asesor estratégico, accedes a una red privada de fundadores de retail. Emprender a pie de calle es solitario; escalar no debería serlo.",
      en: "With your mentoring you don't just gain a strategic advisor — you access a private network of retail founders. Street-level entrepreneurship is lonely; scaling shouldn't be.",
    },
    benefitTitles: {
      es: ["Brainstorming de Trinchera", "El Repositorio de Errores", "Sinergias y Colaboraciones"],
      en: ["Trench Brainstorming", "The Error Repository", "Synergies & Collaborations"],
    },
    benefitTexts: {
      es: [
        "¿Bloqueado con tu próximo escaparate o campaña de ventas? Lanza tu reto a la comunidad y recibe una lluvia de ideas y feedback directo de otros fundadores que ya han resuelto ese mismo problema.",
        "Aprender del éxito está bien; aprender de los fracasos es más barato. Accede a nuestra sección privada donde los miembros comparten abiertamente los errores típicos que les hicieron perder dinero, para que tú nunca caigas en la misma trampa.",
        "Conecta con marcas complementarias de todo el mundo. Haz match con otros negocios de la comunidad para cruzar audiencias, organizar pop-ups conjuntos o compartir proveedores de confianza.",
      ],
      en: [
        "Stuck with your next window display or sales campaign? Throw your challenge to the community and get a flood of ideas and direct feedback from other founders who've already solved that exact problem.",
        "Learning from success is fine; learning from failures is cheaper. Access our private section where members openly share the typical mistakes that cost them money, so you never fall into the same trap.",
        "Connect with complementary brands worldwide. Match with other community businesses to cross audiences, organize joint pop-ups or share trusted suppliers.",
      ],
    },
    closingBanner: {
      es: "Un ecosistema seguro, sin filtros y 100% enfocado en la rentabilidad del retail físico.",
      en: "A safe ecosystem, unfiltered and 100% focused on physical retail profitability.",
    },
  },

  // ── Services Grid ──
  servicesGrid: {
    title: { es: "Los", en: "The" },
    titleAccent: { es: "Gajos", en: "Slices" },
    subtitle: {
      es: "Cinco áreas de mentoring continuo. Resolvemos cada reto de tu negocio de calle.",
      en: "Five areas of continuous mentoring. We solve every challenge for your street-facing business.",
    },
    titles: {
      es: ["La Semilla", "El Jugo", "El Escaparate", "El Sabor", "El Equipo"],
      en: ["The Seed", "The Juice", "The Showcase", "The Flavor", "The Team"],
    },
    subtitles: {
      es: [
        "Finanzas y Rentabilidad",
        "Compras y Proveedores",
        "El Local y la Experiencia",
        "Ventas (Tienda y Online)",
        "Equipo y Gestión",
      ],
      en: [
        "Finance & Profitability",
        "Purchasing & Suppliers",
        "The Store & Experience",
        "Sales (Store & Online)",
        "Team & Management",
      ],
    },
    descriptions: {
      es: [
        "Definición del modelo de negocio, análisis de viabilidad y estructura legal. Sentamos unas bases financieras sólidas para que tu concepto sea rentable desde el primer día.",
        "Búsqueda de proveedores (sourcing), control de calidad y gestión eficiente del inventario. Optimizamos tus márgenes cuidando cada eslabón hasta que el producto llega a el negocio.",
        "Selección del local ideal (Real Estate), interiorismo comercial y Visual Merchandising. Diseñamos espacios físicos centrados al 100% en la experiencia y psicología del cliente.",
        "Estrategias de Retail Marketing y digitalización. Conectamos tu negocio físico con el entorno digital para crear una experiencia de compra unificada, sin fisuras y que multiplique tu facturación.",
        "Selección, retención de talento y formación de equipos de venta. Te dotamos de los KPIs y herramientas de gestión directiva para que tu negocio funcione como un reloj, incluso si tú no estás.",
      ],
      en: [
        "Business model definition, viability analysis and legal structure. We lay solid financial foundations so your concept is profitable from day one.",
        "Supplier sourcing, quality control and efficient inventory management. We optimize your margins by caring for every link until the product reaches the store.",
        "Selection of the ideal location (Real Estate), commercial interior design and Visual Merchandising. We design physical spaces 100% centered on client experience and psychology.",
        "Retail Marketing strategies and digitalization. We connect your physical business with the digital environment to create a unified, seamless shopping experience that multiplies your revenue.",
        "Talent selection, retention and sales team training. We equip you with KPIs and management tools so your business runs like clockwork, even when you're not there.",
      ],
    },
  },

  // ── Solucion 360 Section ──
  solucion360: {
    tag: { es: "Managing Retail, Made Simple", en: "Managing Retail, Made Simple" },
    title: { es: "Tu Negocio, Bajo Control.", en: "Your Business, Under Control." },
    titleAccent: { es: "360º.", en: "360º." },
    centerLabel: { es: "MÉTODO 360º", en: "360º METHOD" },
    tapHint: { es: "Toca cada área para descubrir más", en: "Tap each area to discover more" },
    labels: {
      es: ["Finanzas", "Compras", "Local", "Ventas", "Equipo", "Tecnología"],
      en: ["Finance", "Purchasing", "Store", "Sales", "Team", "Technology"],
    },
  },

  // ── Choose Path ──
  choosePath: {
    title: { es: "Elige tu", en: "Choose Your" },
    titleAccent: { es: "Camino", en: "Path" },
    subtitle: { es: "Dos formas de trabajar con nosotros.", en: "Two ways to work with us." },
    leftTitle: { es: "La Limonada Completa", en: "The Full Lemonade" },
    leftTag: { es: "Llave en Mano", en: "Turnkey" },
    leftDesc: {
      es: "Setup + Cuota mensual para delegarlo todo. Desde la constitución de tu marca hasta la apertura de tu primera tienda. Sin preocupaciones.",
      en: "Setup + Monthly fee to delegate everything. From brand formation to opening your first store. Worry-free.",
    },
    rightTitle: { es: "Elige tus Gajos", en: "Choose Your Slices" },
    rightTag: { es: "Por Etapas", en: "Step by Step" },
    rightDesc: {
      es: "Contrata solo el área donde estás atascado. Elige uno o varios servicios puntuales y avanza a tu ritmo, sin suscripción.",
      en: "Hire only the area where you're stuck. Choose one or more one-off services and move at your own pace, with no subscription.",
    },
  },

  // ── Contact page (flat keys so t() finds them without dot-path traversal) ──
  contactPage: {
    title: { es: "¿En qué podemos ayudarte?", en: "How can we help you?" },
    subtitle: {
      es: "Resolvemos tus dudas sobre el panel, las tarifas o cómo aplicar la estrategia a tu local.",
      en: "We answer your questions about the panel, pricing, or how to apply the strategy to your store.",
    },
    typeLabel: { es: "Tipo de consulta", en: "Type of inquiry" },
    typePlaceholder: { es: "Selecciona una opción", en: "Select an option" },
    typeOptionSupport: { es: "Dudas sobre el panel / soporte", en: "Panel / support questions" },
    typeOptionPricing: { es: "Planes y tarifas", en: "Plans and pricing" },
    typeOptionSuggestion: { es: "Sugerencia", en: "Suggestion" },
    typeOptionGeneral: { es: "Contacto general", en: "General contact" },
    nameLabel: { es: "Nombre", en: "Name" },
    namePlaceholder: { es: "Tu nombre", en: "Your name" },
    emailLabel: { es: "Email", en: "Email" },
    emailPlaceholder: { es: "tu@email.com", en: "you@email.com" },
    messageLabel: { es: "Mensaje", en: "Message" },
    messagePlaceholder: {
      es: "Cuéntanos en qué podemos ayudarte...",
      en: "Tell us how we can help...",
    },
    submit: { es: "Enviar mensaje", en: "Send message" },
    submitting: { es: "Enviando...", en: "Sending..." },
    required: { es: "Este campo es obligatorio", en: "This field is required" },
    invalidEmail: { es: "Introduce un email válido", en: "Enter a valid email" },
    successTitle: { es: "¡Mensaje enviado!", en: "Message sent!" },
    successDesc: { es: "Te responderemos lo antes posible.", en: "We'll get back to you as soon as possible." },
    sentTitle: { es: "¡Gracias por escribirnos!", en: "Thanks for reaching out!" },
    sentDesc: {
      es: "Hemos recibido tu mensaje y te responderemos en breve a tu email.",
      en: "We've received your message and will reply to your email shortly.",
    },
    errorTitle: { es: "Error al enviar", en: "Error sending" },
    errorDesc: { es: "Inténtalo de nuevo más tarde.", en: "Please try again later." },
    closeSupportTitle: { es: "Atención cercana", en: "Close support" },
    closeSupportDesc: {
      es: "Leemos cada mensaje detenidamente. Te responderemos directamente a tu email en menos de 24 horas laborables.",
      en: "We read every message carefully. We'll reply directly to your email within less than 24 business hours.",
    },
    immediateHelpTitle: { es: "¿Dudas inmediatas?", en: "Need immediate answers?" },
    immediateHelpCta: { es: "Ver Preguntas Frecuentes", en: "View FAQ" },
  },

  // ── FAQ Page (full /faq route) ──
  faqPage: {
    metaTitle: {
      es: "Preguntas frecuentes sobre planes y herramientas | Retail Lemon",
      en: "Plans and tools FAQ | Retail Lemon",
    },
    metaDescription: {
      es: "Resuelve tus dudas sobre Básico, Club Pro y Avanzado: precios, prueba de 7 días, cancelación, herramientas y extras.",
      en: "Answers about Basic, Club Pro and Advanced: prices, 7-day trial, cancellation, tools and extras.",
    },
    metaKeywords: {
      es: "retail lemon preguntas frecuentes, retail lemon panel, retail lemon mentoría, retail lemon seguridad, retail lemon funcionamiento, retail lemon comercio",
      en: "retail lemon faq, retail lemon panel, retail lemon mentoring, retail lemon security, retail lemon how it works, retail lemon store",
    },
    title: { es: "Preguntas Frecuentes", en: "Frequently Asked Questions" },
    subtitle: {
      es: "Planes, herramientas, prueba, cancelación y extras explicados sin letra pequeña.",
      en: "Plans, tools, trial, cancellation and extras explained without the small print.",
    },
    intro: {
      es: "Busca tu duda o abre la categoría que te interese. Si no está, escríbenos: contestamos en menos de 24 horas laborables.",
      en: "Search your question or open the category you need. If it is not here, write to us: we reply within 24 business hours.",
    },
    searchPlaceholder: {
      es: "Buscador",
      en: "Search",
    },
    searchNoResults: {
      es: "No hemos encontrado preguntas con ese texto. Prueba con otra palabra o escríbenos.",
      en: "No questions match that text. Try another word or write to us.",
    },
    searchClear: { es: "Borrar búsqueda", en: "Clear search" },
    categoryPricing: { es: "Dudas sobre planes y suscripción", en: "Questions about plans and subscription" },
    categoryMethodology: { es: "Metodología y Funcionamiento", en: "Methodology & How It Works" },
    categoryWho: { es: "¿Para quién es Retail Lemon?", en: "Who is Retail Lemon for?" },
    categorySector: { es: "¿Encaja con mi sector?", en: "Does it fit my sector?" },
    categorySecurity: { es: "Seguridad, Datos y Soporte", en: "Security, Data & Support" },

    qSectorHoreca: {
      es: "Tengo un restaurante, bar o cafetería, ¿me sirve Retail Lemon?",
      en: "I run a restaurant, bar or café — is Retail Lemon useful for me?",
    },
    aSectorHoreca: {
      es: "Sí, y de hecho la hostelería es uno de los sectores donde más rápido se ven los números. Trabajamos escandallo plato a plato, control de mermas y compras, coste real de personal frente a las horas punta de sala, precio de carta y rotación de mesas. El panel te ordena todo eso en una hoja de ruta con lo que toca revisar cada semana, y el Agente Retail IA está entrenado con el contexto de un negocio de barrio, no con jerga de consultoría. Si tienes terraza, licencias o un contrato de alquiler pendiente de renegociar, también entra en el plan de trabajo.",
      en: "Yes — hospitality is one of the sectors where numbers improve fastest. We work on dish-by-dish costing, waste and purchasing control, real staff cost against peak service hours, menu pricing and table turnover. The panel organises all of it into a roadmap telling you what to review each week, and the Retail AI Agent is trained on the context of a neighbourhood business, not consultancy jargon. Terrace, licences or a lease due for renegotiation also go into the plan.",
    },

    qSectorBeauty: {
      es: "Tengo una peluquería o centro de estética, ¿funciona para mí?",
      en: "I run a hair or beauty salon — does it work for me?",
    },
    aSectorBeauty: {
      es: "Funciona muy bien, porque tu negocio vive de la agenda y del valor por hora de silla o cabina. Medimos ocupación real, precio por servicio, margen del producto que revendes, recurrencia de cliente y coste de las horas de equipo. A partir de ahí el panel te propone acciones concretas: reordenar la carta de servicios, subir precios donde tienes cola, empaquetar bonos para rellenar los huecos flojos y reactivar clientes que no vuelven. Todo con tus datos, sin plantillas genéricas.",
      en: "It works well, because your business lives off the calendar and the value per chair or cabin hour. We measure real occupancy, price per service, margin on retail products, client recurrence and team hour costs. From there the panel proposes concrete actions: reorganising your service menu, raising prices where you have a waiting list, bundling packages to fill weak slots and reactivating lapsed clients. All with your data, no generic templates.",
    },

    qSectorFashion: {
      es: "Tengo una tienda de ropa o zapatería, ¿está pensado para retail de moda?",
      en: "I run a clothing or shoe store — is it built for fashion retail?",
    },
    aSectorFashion: {
      es: "Sí. La moda es retail puro y es donde nació el método: compras y presupuesto de temporada, rotación por referencia, control de stock parado, política de rebajas y márgenes reales después de descuentos. También trabajamos escaparate, ritmo de reposición y las campañas que de verdad mueven caja. El panel te avisa de la mercancía que se te está quedando quieta antes de que se convierta en un problema de tesorería.",
      en: "Yes. Fashion is pure retail and it is where the method was born: seasonal buying and budget, rotation by SKU, dead-stock control, markdown policy and real margins after discounts. We also work on windows, replenishment rhythm and the campaigns that actually move cash. The panel flags stock going stale before it turns into a cash-flow problem.",
    },

    qSectorMulti: {
      es: "Gestiono varias tiendas, ¿puedo usarlo?",
      en: "I manage several stores — can I use it?",
    },
    aSectorMulti: {
      es: "Sí. Puedes registrar cada local por separado y comparar sus datos entre sí, que es justo donde aparecen las decisiones importantes: qué tienda tira del grupo, cuál se come el margen y qué prácticas conviene replicar. Si gestionas una cadena, una franquicia o un grupo con varios puntos de venta, tenemos un enfoque específico para estructura, cuadro de mando común y comité de dirección. Cuéntanos cuántos locales llevas y te decimos cómo montarlo.",
      en: "Yes. You can register each location separately and compare their data, which is exactly where the important decisions appear: which store carries the group, which one eats the margin and which practices are worth replicating. For chains, franchises or groups with several outlets we have a specific approach for structure, a shared dashboard and management committee. Tell us how many locations you run and we will tell you how to set it up.",
    },

    qSectorOther: {
      es: "Mi negocio no está en la lista, ¿también sirve?",
      en: "My business is not on the list — does it still work?",
    },
    aSectorOther: {
      es: "Sirve para cualquier negocio con local a pie de calle y clientes que entran por la puerta: floristería, óptica, panadería, ferretería, clínica dental, tienda de mascotas, gimnasio de barrio o taller. La lógica es la misma en todos: márgenes, costes fijos, personal, tesorería, precio y captación local. Lo que cambia son los indicadores del sector, y eso lo ajustamos en el diagnóstico inicial cuando eliges tu actividad. Si tienes dudas de si tu caso encaja, escríbenos y te lo decimos con honestidad.",
      en: "It works for any business with a street-level location and customers walking in: florist, optician, bakery, hardware store, dental clinic, pet shop, neighbourhood gym or workshop. The logic is the same everywhere: margins, fixed costs, staff, cash flow, pricing and local acquisition. What changes are the sector indicators, and we tune those in the initial diagnosis when you pick your activity. If you are unsure whether your case fits, write to us and we will tell you honestly.",
    },

    qProIncludes: {
      es: "¿Qué incluye exactamente el Club Pro de 69 €/mes?",
      en: "What exactly does the 69 €/month Club Pro include?",
    },
    aProIncludes: {
      es: "Club Pro (69 €/mes, el más popular) incluye todo lo de Básico y suma: 60 consultas al mes al Agente Retail IA, hoja de ruta, KPIs, detector completo, subvenciones que encajan con tu negocio, casos y soluciones y 4 anuncios IA al mes. Tiene 7 días de prueba gratis y no tiene permanencia. Los extras opcionales se contratan aparte: redes y música comercial desde Club Pro; módulo laboral, mentores, licencias, abogados, aroma y alarma con Avanzado.",
      en: "Club Pro (€69/month, most popular) includes everything in Basic plus: 60 Retail AI Agent queries a month, roadmap, KPIs, full leak detector, grants that fit your business, cases and solutions and 4 AI ads a month. It has a 7-day free trial and no commitment. Optional extras are contracted separately: social media and commercial music from Club Pro; labour module, mentors, licensing, lawyers, scent and alarm with Advanced.",
    },

    qCommitment: {
      es: "¿Hay permanencia? ¿Puedo cancelar cuando quiera?",
      en: "Is there a lock-in period? Can I cancel whenever I want?",
    },
    aCommitment: {
      es: "No. Ningún plan tiene permanencia: Básico (39 €/mes), Club Pro (69 €/mes) y Avanzado (99 €/mes) son mensuales y puedes cancelar cuando quieras; la baja surte efecto al final del mes ya pagado. Los tres incluyen 7 días de prueba gratis: si no cancelas, el cobro se hace el día 8. Los extras se pagan aparte y siempre ves su precio antes de pagar. Tienes el detalle en las condiciones de contratación.",
      en: "No. No plan has a minimum term: Basic (€39/month), Club Pro (€69/month) and Advanced (€99/month) are monthly and you can cancel anytime; cancellation takes effect at the end of the month already paid. All three include a 7-day free trial: if you don't cancel, you're charged on day 8. Extras are paid separately and you always see the price before paying. Full detail is in our terms.",
    },

    qVipMentor: {
      es: "¿Qué tipos de mentoría hay?",
      en: "What types of mentoring are there?",
    },
    aVipMentor: {
      es: "Tenemos tres niveles de mentoría, todos con acompañamiento humano real. La diferencia está en la intensidad del apoyo:\n\n· Mentor Quincenal → 1 sesión cada 15 días.\nIdeal para poner orden, revisar números y arrancar con método.\n\n· Mentor Semanal → 1 sesión semanal.\nPara mantener el ritmo, optimizar y avanzar de forma constante.\n\n· Mentor Intensivo → 2 horas semanales (codo a codo).\nAcompañamiento intensivo. La opción de quien quiere un director de operaciones externo sin contratarlo en plantilla.\n\nSobre las horas no utilizadas:\nLas horas que no uses en un mes se pueden acumular al mes siguiente siempre que mantengas la suscripción activa. Si no se utilizan, caducan.\n\nTodas las mentorías son flexibles (se activan y se cancelan mes a mes) y se trabajan siempre sobre los datos reales de tu panel. No son charlas motivacionales: saldrás de cada sesión con decisiones concretas y fechas.",
      en: "There are three mentoring levels, all with real human support. The difference is the intensity of that support:\n\n· Mentor Biweekly → 1 session every two weeks.\nIdeal to put things in order, review your numbers and start with a method.\n\n· Mentor Weekly → 1 session per week.\nTo keep the pace, optimise and move forward consistently.\n\n· Mentor Intensive → 2 hours per week (side by side).\nIntensive support. The option for owners who want an external operations director without hiring one in-house.\n\nAbout unused hours:\nHours you do not use in a month can roll over to the next month as long as your subscription stays active. If they are not used, they expire.\n\nAll mentoring plans are flexible (activate and cancel month to month) and always work on the real data in your panel. These are not motivational chats: you leave every session with concrete decisions and dates.",
    },

    qInvoice: {
      es: "¿Emitís factura deducible?",
      en: "Do you issue deductible invoices?",
    },
    aInvoice: {
      es: "Sí. Cada cobro genera automáticamente una factura a nombre de Retail Lemon que puedes descargar en cualquier momento. Las facturas las emite WP Media LLC (sociedad estadounidense) sin repercutir impuestos locales del cliente. La factura llega sin IVA/VAT europeo ni impuestos equivalentes. Cada cliente es responsable de sus obligaciones fiscales según el país en el que resida. Nosotros no damos asesoramiento fiscal, pero sí entregamos el documento correcto y a tiempo, mes a mes.",
      en: "Yes. Every charge automatically generates a Retail Lemon invoice that you can download at any time. Invoices are issued by WP Media LLC (a US company) without charging the customer's local taxes. The invoice arrives without EU VAT or equivalent taxes. Each customer is responsible for their own tax obligations in their country of residence. We do not provide tax advice, but we do deliver the correct document, on time, month after month.",
    },

    qWhyInvest: {
      es: "¿Por qué invertir 69 €/mes si creo que ya llevo bien mi negocio?",
      en: "Why invest €69/month if I think I already run my business well?",
    },
    aWhyInvest: {
      es: "Porque lo que no mides te está costando dinero, aunque el negocio vaya bien. La mayoría de comercios que entran con la sensación de tenerlo controlado descubren en la primera semana tres cosas: productos que venden mucho y dejan poquísimo margen, un seguro o un suministro que llevaba años sin revisarse, y horas de plantilla mal repartidas frente a las horas punta reales. Ajustar cualquiera de esas tres suele pagar los 69 €/mes del Club Pro durante todo el año. Y además está el tiempo: dejar de improvisar cada mañana y tener una hoja de ruta con lo que toca hoy ahorra horas de cabeza cada semana. Empieza gratis con el diagnóstico y compruébalo con tus propios números.",
      en: "Because what you do not measure is costing you money, even when the business is doing fine. Most owners who arrive feeling in control discover three things in the first week: products that sell a lot but leave almost no margin, an insurance or utility contract untouched for years, and staff hours poorly matched to real peak times. Fixing any one of those usually pays the 69 €/month of Club Pro for the whole year. And then there is time: replacing daily improvisation with a roadmap that tells you what to do today saves hours every week. Start free with the diagnosis and check it with your own numbers.",
    },

    qDifference: {
      es: "¿En qué se diferencia de una gestoría o un TPV?",
      en: "How is it different from an accountant or a POS?",
    },
    aDifference: {
      es: "La diferencia entre Retail Lemon y una gestoría o un TPV es el momento en el que actúan. La gestoría mira hacia atrás: presenta impuestos y cierra lo que ya pasó. El TPV mira el mostrador: registra ventas y tickets. Retail Lemon mira hacia delante: coge tu realidad (márgenes, gastos fijos, personal, stock, contratos, clientes) y la convierte en estrategia y operativa del día a día, con una metodología probada y un Agente Retail IA que te dice qué hacer hoy y en qué orden. No sustituimos a tu gestor ni a tu TPV, trabajamos con ellos: ellos registran, nosotros decidimos contigo. Si quieres verlo por dentro, el diagnóstico gratuito enseña el método en diez minutos.",
      en: "The difference between Retail Lemon and an accountant or a POS is timing. The accountant looks backwards: files taxes and closes what already happened. The POS looks at the counter: it records sales and receipts. Retail Lemon looks ahead: it takes your reality (margins, fixed costs, staff, stock, contracts, customers) and turns it into daily strategy and operations, with a proven methodology and an Retail AI Agent that tells you what to do today and in what order. We do not replace your accountant or your POS, we work alongside them: they record, we decide with you. The free diagnosis shows the method in ten minutes.",
    },

    qAiAgent: {
      es: "¿Cómo funciona el Agente Retail IA?",
      en: "How does the Retail AI Agent work?",
    },
    aAiAgent: {
      es: "El Agente Retail IA actúa como un asistente para la gestión diaria de tu panel. Su función principal es acompañarte en el seguimiento de tu hoja de ruta: analiza semana a semana el progreso que vas realizando por módulos, te ofrece una explicación clara de los siguientes pasos y te ayuda a priorizar, marcar o revisar tus tareas pendientes.\n\nPara darte indicaciones precisas, tiene en cuenta el diagnóstico que configuraste al inicio y el avance real registrado en tu cuenta. No sustituye la gestión ni la consultoría humana, sino que te guía para que saques el máximo partido a la metodología y mantengas tu plan de acción siempre al día.",
      en: "The Retail AI Agent acts as an assistant for the daily management of your panel. Its main function is to accompany you in tracking your roadmap: it analyzes week by week the progress you make through modules, offers you a clear explanation of the next steps, and helps you prioritise, mark, or review your pending tasks.\n\nTo give you precise guidance, it takes into account the diagnosis you configured at the start and the real progress recorded in your account. It does not replace management or human consultancy, but guides you to get the most out of the methodology and keep your action plan always up to date.",
    },

    qInstall: {
      es: "¿Hay que instalar algo?",
      en: "Do I need to install anything?",
    },
    aInstall: {
      es: "No hay que instalar nada. Retail Lemon funciona 100 % en la nube y se abre desde cualquier navegador: el móvil detrás del mostrador, la tablet del almacén o el ordenador de casa. No necesitas servidores, ni licencias, ni que venga un técnico, ni conectarlo a tu TPV para empezar. Entras con tu email o con Google, y en el mismo momento tienes el panel disponible. Además puedes añadirlo a la pantalla de inicio del móvil y usarlo como una app, que es como lo usa la mayoría de nuestros comerciantes: consultas rápidas entre cliente y cliente. Cambias de dispositivo y sigues donde lo dejaste, porque todo está sincronizado en tu cuenta.",
      en: "Nothing to install. Retail Lemon runs 100 % in the cloud and opens in any browser: the phone behind the counter, the stockroom tablet or your computer at home. No servers, no licences, no technician visit and no POS integration needed to start. You sign in with your email or Google and the panel is available immediately. You can also add it to your phone's home screen and use it like an app, which is how most of our shopkeepers use it: quick checks between customers. Switch devices and carry on where you left off, everything syncs to your account.",
    },

    qSetup: {
      es: "¿Es difícil de configurar?",
      en: "Is it hard to set up?",
    },
    aSetup: {
      es: "No. Está pensado para tenderos y hosteleros, no para informáticos. La configuración es guiada paso a paso: dices a qué te dedicas, en qué punto está tu negocio y qué te preocupa ahora mismo, y el panel se monta solo con las hojas de ruta y las herramientas de tu sector. En unos diez o quince minutos tienes tu diagnóstico hecho y las primeras tareas priorizadas. No hay que subir hojas de Excel enormes ni volcar años de contabilidad para empezar: puedes ir metiendo datos a medida que avanzas y el sistema afina las recomendaciones. Y si te atascas, el Agente Retail IA te explica cada campo y el equipo humano te responde en menos de 24 horas laborables.",
      en: "No. It is designed for shopkeepers and hospitality owners, not for IT people. Setup is guided step by step: you say what you do, where your business stands and what worries you right now, and the panel builds itself with the roadmaps and tools for your sector. In about ten to fifteen minutes you have your diagnosis and your first prioritised tasks. There is no need to upload huge spreadsheets or years of accounting to begin: you can add data as you go and the system refines its recommendations. If you get stuck, the Retail AI Agent explains each field and our team replies within 24 business hours.",
    },

    qRoi: {
      es: "¿Cuándo noto el ROI?",
      en: "When will I see the ROI?",
    },
    aRoi: {
      es: "Depende de tu punto de partida, pero hay dos velocidades. A corto plazo, en las primeras semanas, las mejoras suelen venir de liquidez: revisar precios y márgenes, ajustar compras y mermas, renegociar suministros o seguros y ordenar los cobros. Son cambios que se ven en la caja del mes siguiente y que, en la mayoría de comercios, ya superan el coste del Club Pro. A medio plazo, entre tres y seis meses, llegan los cambios estructurales: surtido, plantilla ajustada a las horas punta, captación de clientes y procesos que dejan de depender de que estés tú delante. Nosotros no prometemos porcentajes mágicos: te damos el orden correcto para que cada cambio se note.",
      en: "It depends on your starting point, but there are two speeds. Short term, in the first weeks, gains usually come from liquidity: reviewing prices and margins, adjusting purchasing and waste, renegotiating utilities or insurance and tidying up collections. Those show up in next month's till and, for most businesses, already exceed the cost of Club Pro. Medium term, three to six months, the structural changes arrive: assortment, staffing matched to peak hours, customer acquisition and processes that no longer depend on you being there. We do not promise magic percentages: we give you the right order so each change shows.",
    },

    qOpenYears: {
      es: "Tengo el local abierto desde hace años, ¿me sirve?",
      en: "My shop has been open for years, is it useful for me?",
    },
    aOpenYears: {
      es: "Sí, y de hecho es el perfil donde más rápido se ven resultados. Un negocio con años de rodaje acumula gastos fijos que nadie ha vuelto a mirar, precios heredados de otra época, un surtido que creció sin criterio y horarios de plantilla que ya no encajan con cuándo entra la gente. Retail Lemon pone eso encima de la mesa con números: qué te sobra, qué te falta y por dónde empezar. Trabajamos gasto fijo, plantilla, stock y mermas, y atracción de clientes, en ese orden, para que el efecto se note en caja pronto. Y sin cambiar tu forma de trabajar de un día para otro: una tarea al día, hecha de verdad, vale más que un plan de cien páginas.",
      en: "Yes, and it is actually the profile where results show fastest. A business with years behind it accumulates fixed costs nobody has reviewed, prices inherited from another era, an assortment that grew without criteria and staff hours that no longer match when customers actually come in. Retail Lemon puts that on the table with numbers: what is excess, what is missing and where to start. We work on fixed costs, staffing, stock and waste, and customer attraction, in that order, so the effect reaches the till early. And without turning your routine upside down: one task a day, actually done, beats a hundred-page plan.",
    },

    qProject: {
      es: "Estoy en fase de proyecto / aún no he abierto, ¿puedo usarlo?",
      en: "I'm still planning and haven't opened yet, can I use it?",
    },
    aProject: {
      es: "Es el mejor momento para usarlo, porque los errores caros se cometen antes de levantar la persiana. Retail Lemon te acompaña en lo que casi nadie te explica: cómo leer y negociar el contrato de alquiler y sus cláusulas, qué licencias y trámites necesitas según tu actividad, qué subvenciones y ayudas hay abiertas, cuánto dinero necesitas realmente para arrancar y cuándo llegas a punto muerto con la calculadora de viabilidad. Muchos proyectos descubren aquí que la renta que iban a firmar se comía todo su margen, o que faltaba colchón para los tres primeros meses. Puedes empezar gratis con el diagnóstico y la calculadora, y activar el Club Pro cuando entres en la fase de obra y contratos.",
      en: "It is the best moment to use it, because the expensive mistakes happen before you raise the shutter. Retail Lemon guides you through what almost nobody explains: how to read and negotiate the lease and its clauses, which licences and permits your activity needs, which grants are open, how much money you really need to start and when you break even, using the viability calculator. Many projects discover here that the rent they were about to sign would eat their whole margin, or that they lacked a buffer for the first three months. Start free with the diagnosis and calculator, and activate Club Pro for the works and contracts phase.",
    },

    qRealDay: {
      es: "¿Me ayudará Retail Lemon con los problemas reales de mi día a día?",
      en: "Will Retail Lemon help with the real problems of my day-to-day?",
    },
    aRealDay: {
      es: "Sí. La plataforma te da una hoja de ruta clara con los pasos estructurados que debes seguir en cada momento para mantener el control de tu local.\n\nSabemos perfectamente que gestionar un negocio a pie de calle puede ser un camino muy solitario, de abrir la persiana cada mañana y tomar decisiones sin saber a quién consultar. Por eso, además del panel y la metodología guiada, siempre tienes la opción de contar con el apoyo y el trato humano de nuestro equipo para orientarte cuando lo necesites.",
      en: "Yes. The platform gives you a clear roadmap with the structured steps you should follow at each moment to keep your shop under control.\n\nWe know perfectly well that running a street-level business can be a very lonely road, opening the shutter every morning and making decisions without knowing who to ask. That is why, besides the panel and guided methodology, you always have the option of counting on the human support and treatment of our team to guide you when you need it.",
    },

    qAnyBusiness: {
      es: "¿Sirve para cualquier negocio a pie de calle?",
      en: "Does it work for any street-level business?",
    },
    aAnyBusiness: {
      es: "Sirve para cualquier negocio que dependa de que entre gente por la puerta: tiendas de ropa y moda, hostelería (bares, restaurantes, cafeterías), alimentación y frutería, salud y belleza (peluquerías, centros de estética, clínicas), puericultura, inmobiliarias y servicios presenciales de todo tipo. Las palancas son las mismas en todos: margen, gasto fijo, personal, stock o materia prima, y clientes. Lo que cambia es el detalle, y ahí sí personalizamos: en hostelería trabajamos escandallo y mermas de cocina; en tienda de ropa, rotación, temporadas y rebajas; en servicios, agenda y ocupación de horas. Al configurar el panel eliges tu sector y las hojas de ruta y ejemplos se adaptan a tu vocabulario y a tus números.",
      en: "It works for any business that depends on people walking through the door: fashion and clothing stores, hospitality (bars, restaurants, cafés), food and grocery, health and beauty (hair salons, beauty and clinics), kids, real estate and in-person services of all kinds. The levers are the same everywhere: margin, fixed costs, staff, stock or raw materials, and customers. What changes is the detail, and that is where we personalise: hospitality works on food costing and kitchen waste; clothing on rotation, seasons and sales periods; services on schedule and hour occupancy. When setting up the panel you choose your sector and the roadmaps adapt.",
    },

    qMultipleStores: {
      es: "Tengo varias tiendas, ¿me sirve?",
      en: "I have several stores, does it work for me?",
    },
    aMultipleStores: {
      es: "Sí. Cuando tienes varias tiendas el problema deja de ser el mostrador y pasa a ser la falta de estándar: cada local hace las cosas a su manera y comparar es imposible. Retail Lemon estandariza los procesos (aperturas, cierres, compras, control de mermas, protocolos de atención) y te deja controlar el rendimiento global con los mismos indicadores en todos los puntos de venta, para ver qué local tira y cuál necesita ayuda. También ayuda a formar a encargados nuevos sin tener que estar tú explicando lo mismo diez veces, porque el método queda escrito en el panel. Si gestionas una cadena o una franquicia con estructura propia, tenemos un enfoque específico para ese caso; cuéntanos cuántos locales llevas.",
      en: "Yes. With several stores the problem is no longer the counter but the lack of standard: each location does things its own way and comparing is impossible. Retail Lemon standardises processes (openings, closings, purchasing, waste control, service protocols) and lets you monitor overall performance with the same indicators across every point of sale, so you can see which shop pulls and which needs help. It also helps train new managers without you explaining the same thing ten times, because the method is written in the panel. If you run a chain or franchise with its own structure, we have a specific approach.",
    },

    qDataSafe: {
      es: "¿Mis datos están seguros?",
      en: "Is my data safe?",
    },
    aDataSafe: {
      es: "Sí. Aplicamos medidas técnicas y organizativas de protección: cifrado en tránsito, control de acceso por usuario y aislamiento de la información de cada cuenta, de forma que nadie más puede ver los números de tu negocio. Los datos se alojan principalmente en Estados Unidos y no vendemos ni cedemos información a terceros con fines comerciales. Te ofrecemos derechos equivalentes al RGPD (acceso, rectificación, supresión, portabilidad y oposición); basta con pedirlo desde el formulario de contacto. Las conversaciones con el Agente Retail IA se almacenan para darte soporte, mantener el histórico de tus hojas de ruta y mejorar el servicio, y puedes solicitar su eliminación. Tienes el detalle completo en la política de privacidad.",
      en: "Yes. We apply technical and organisational protection measures: encryption in transit, per-user access control and isolation of each account's information, so nobody else can see your business numbers. Data is hosted mainly in the United States and we do not sell or share information with third parties for commercial purposes. We offer GDPR-equivalent rights (access, rectification, erasure, portability and objection); just ask through the contact form. Conversations with the Retail AI Agent are stored to give you support, keep your roadmap history and improve the service, and you can request their deletion. Full detail is in our privacy policy.",
    },

    qNotHere: {
      es: "¿Qué pasa si mi duda no está aquí?",
      en: "What if my question isn't here?",
    },
    aNotHere: {
      es: "Nos escribes y ya está. Usa el formulario de contacto, cuéntanos tu caso con el detalle que puedas (sector, si ya estás abierto, qué te preocupa) y te respondemos directamente a tu email en menos de 24 horas laborables. No hay centralita ni respuestas automáticas de tres líneas: leemos cada mensaje y contesta alguien que entiende de comercio. Si tu duda es sobre precios o sobre qué plan te encaja, dínoslo con tus números encima y te decimos honestamente si te compensa el Club Pro, o el Mentor. Y si ya eres cliente, tienes además el Agente Retail IA dentro del panel para las dudas del día a día, a cualquier hora.",
      en: "You write to us, simple as that. Use the contact form, tell us your case with as much detail as you can (sector, whether you are already open, what worries you) and we reply directly to your email within 24 business hours. No call centre and no three-line automated replies: we read every message and someone who understands retail answers. If your question is about pricing or which plan fits, give us your numbers and we will honestly tell you whether Club Pro or Mentor makes more sense. And if you are already a customer, the Retail AI Agent is inside the panel for day-to-day questions, any time.",
    },

    lnkStartFree: { es: "Empezar con el diagnóstico", en: "Start with the diagnosis" },
    lnkPlans: { es: "Ver planes y tarifas", en: "See plans and pricing" },
    lnkTerms: { es: "Leer las condiciones de contratación", en: "Read the terms of service" },
    lnkMentoring: { es: "Conocer la mentoría", en: "Discover mentoring" },
    lnkCalculator: { es: "Probar la calculadora de rentabilidad", en: "Try the profitability calculator" },
    lnkMethod: { es: "Ver cómo funciona el método", en: "See how the method works" },
    lnkAiAgent: { es: "Descubrir el Agente Retail IA", en: "Discover the Retail AI Agent" },
    lnkStoreProblems: { es: "Problemas típicos en tienda", en: "Typical store problems" },
    lnkOpenStore: { es: "Guía para abrir tienda en España", en: "Guide to opening a store in Spain" },
    lnkEverything: { es: "Todo para tu comercio", en: "Everything for your store" },
    lnkChains: { es: "Soluciones para cadenas y franquicias", en: "Solutions for chains and franchises" },
    lnkPrivacy: { es: "Política de privacidad", en: "Privacy policy" },
    lnkContact: { es: "Ir al formulario de contacto", en: "Go to the contact form" },

    ctaTitle: { es: "¿No encuentras lo que buscas?", en: "Can't find what you're looking for?" },
    ctaSubtitle: {
      es: "Escríbenos y lo vemos contigo.",
      en: "Write to us and we'll look at it with you.",
    },
    ctaPrimary: { es: "Pregunta a un experto", en: "Ask an expert" },
  },

  // ── Footer (public) ──
  footerPublic: {
    explore: { es: "Explorar", en: "Explore" },
    howItWorks: { es: "Cómo funciona", en: "How it works" },
    survivalTest: { es: "Test de supervivencia", en: "Survival test" },
    strategy: { es: "La Estrategia", en: "The Strategy" },
    aiAgent: { es: "Agente Retail IA", en: "Retail AI Agent" },
    pricing: { es: "Tarifas", en: "Pricing" },
    everythingForShop: { es: "Todo para tu comercio", en: "Everything for your store" },
    storeProblems: { es: "Problemas en mi tienda", en: "Problems in my store" },
    openStoreSpain: { es: "Abrir tienda en España", en: "Open a store in Spain" },


    method360: { es: "Método 360º", en: "360º Method" },
    thePanel: { es: "El Panel", en: "The Panel" },
    lemonClub: { es: "Lemon Club", en: "Lemon Club" },
    diagnosis: { es: "Diagnóstico", en: "Diagnosis" },
    contact: { es: "Contacto", en: "Contact" },
    faq: { es: "Preguntas Frecuentes", en: "FAQ" },
    contactForm: { es: "Formulario de contacto", en: "Contact form" },
    missionPhrase: {
      es: "Hecho con ❤️ para los que levantan la persiana cada día.",
      en: "Made with ❤️ for those who raise the shutters every day.",
    },
    rights: { es: "© 2026 Retail Lemon. Todos los derechos reservados.", en: "© 2026 Retail Lemon. All rights reserved." },
    legalEntity: { es: "WP Media LLC · 8 The Green, Suite A, Dover, DE 19901, Estados Unidos · hola@retaillemon.com", en: "WP Media LLC · 8 The Green, Suite A, Dover, DE 19901, United States · hola@retaillemon.com" },
    legalNotice: { es: "Aviso Legal", en: "Legal Notice" },
    privacy: { es: "Privacidad", en: "Privacy" },
    cookies: { es: "Cookies", en: "Cookies" },
    terms: { es: "Condiciones", en: "Terms" },
    tools: { es: "Herramientas", en: "Tools" },
    retailCalculator: { es: "Calculadora Retail", en: "Retail Calculator" },
    locationEvaluator: { es: "Diagnóstico de Locales", en: "Location Diagnosis" },
    budgets: { es: "Proveedores", en: "Suppliers" },
    insightsGuides: { es: "Insights & Guías", en: "Insights & Guides" },
    vipMentoring: { es: "Tu Mentor", en: "Your Mentor" },
    lemonThermometer: { es: "Detector de Fugas", en: "Leak Detector" },
    corporateSolutions: { es: "Soluciones Corporativas", en: "Corporate Solutions" },
    chainsFranchises: { es: "Cadenas y Franquicias", en: "Chains & Franchises" },
    familyOffices: { es: "Family Offices e Inversores", en: "Family Offices & Investors" },
    retailServices: { es: "Servicios Retail", en: "Retail Services" },
    resolvedQueries: { es: "Consultas resueltas", en: "Resolved queries" },
    retailExperts: { es: "Profesionales retail", en: "Retail professionals" },
    partnersAccess: { es: "Acceso colaboradores", en: "Partner access" },
  },

  // ── SEO per-page ──
  seo: {
    homeTitle: {
      es: "Club Pro | Plataforma Retail & Mentoría de Negocios",
      en: "Club Pro | Retail Platform & Business Mentoring",
    },
    homeDesc: {
      es: "Descubre Club Pro, la plataforma inteligente para el control de tu negocio. Combina gestión avanzada con mentoría retail (retail mentoring) para escalar tus márgenes día a día.",
      en: "Discover Club Pro, the smart platform to manage your business. It combines advanced management with retail mentoring to scale your margins day by day.",
    },
    homeKeywords: {
      es: "plataforma retail, mentoría para tiendas, retail management platform, retail mentoring, panel de control retail",
      en: "retail platform, store mentoring, retail management platform, retail mentoring, retail control panel",
    },
    contactTitle: {
      es: "Contacto · Asesoría Retail — Retail Lemon",
      en: "Contact · Retail Consulting — Retail Lemon",
    },
    contactDesc: {
      es: "¿Tienes una idea, una duda o simplemente quieres charlar sobre tu marca? Escríbenos y te respondemos en menos de 24 h.",
      en: "Have an idea, a question, or just want to chat about your brand? Write to us and we'll reply within 24 hours.",
    },
    contactKeywords: {
      es: "contacto retail lemon, asesoría retail, consultoría tienda, mentoring retail contacto",
      en: "contact retail lemon, retail consulting, store consulting, retail mentoring contact",
    },
    calcTitle: {
      es: "Calculadora de Rentabilidad y Margen Retail | Retail Lemon",
      en: "Retail Profitability & Margin Calculator | Retail Lemon",
    },
    calcDesc: {
      es: "Calcula gratis el punto de equilibrio, margen comercial y viabilidad financiera de tu comercio o local a pie de calle.",
      en: "Free online calculator to measure break-even point, retail profit margin, and financial viability for your shop.",
    },
    calcKeywords: {
      es: "calculadora rentabilidad retail, márgenes producto, stock, punto de equilibrio, tasa de esfuerzo, alquiler comercial, viabilidad tienda",
      en: "retail profitability calculator, product margins, stock, break-even, rent effort rate, commercial rent, store viability",
    },
    diagTitle: {
      es: "Diagnóstico de Locales Comerciales | Análisis de Viabilidad | Retail Lemon",
      en: "Retail Location Analysis | Commercial Lease Viability | Retail Lemon",
    },
    diagDesc: {
      es: "Analiza el riesgo financiero de tu próximo local. Cruza datos de tráfico, renta y competencia con nuestro motor de Location Intelligence.",
      en: "Analyze the financial risk of your next commercial space. Cross-reference foot traffic, rent, and local market data with our Location Intelligence engine.",
    },
    diagKeywords: {
      es: "diagnóstico locales comerciales, análisis viabilidad local, location intelligence retail, riesgo alquiler comercial, evaluación tienda",
      en: "retail location analysis, commercial lease viability, location intelligence, foot traffic analysis, commercial real estate risk",
    },
    diagImageAlt: {
      es: "Diagnóstico de locales comerciales — análisis de viabilidad y riesgo retail",
      en: "Retail location analysis — viability and risk assessment tool",
    },
    legalTitle: {
      es: "Aviso Legal — Retail Lemon",
      en: "Legal Notice — Retail Lemon",
    },
    legalDesc: {
      es: "Aviso legal y condiciones de uso del sitio web Retail Lemon.",
      en: "Legal notice and terms of use for the Retail Lemon website.",
    },
    privacyTitle: {
      es: "Política de Privacidad — Retail Lemon",
      en: "Privacy Policy — Retail Lemon",
    },
    privacyDesc: {
      es: "Conoce cómo Retail Lemon recoge, trata y protege tus datos personales conforme al RGPD.",
      en: "Learn how Retail Lemon collects, processes and protects your personal data under GDPR.",
    },
    cookiesTitle: {
      es: "Política de Cookies — Retail Lemon",
      en: "Cookie Policy — Retail Lemon",
    },
    cookiesDesc: {
      es: "Información sobre las cookies que utiliza Retail Lemon y cómo gestionarlas.",
      en: "Information about the cookies used by Retail Lemon and how to manage them.",
    },
    termsTitle: {
      es: "Condiciones de Contratación — Retail Lemon",
      en: "Terms of Service — Retail Lemon",
    },
    termsDesc: {
      es: "Duración, sin permanencia, renovación y cancelación de Club Pro, Tu Mentor y Módulos Extra de Retail Lemon.",
      en: "Duration, commitment, renewal and cancellation for Club Pro, Your Mentor and Extra Modules at Retail Lemon.",
    },
    notFoundTitle: {
      es: "Página no encontrada — Retail Lemon",
      en: "Page Not Found — Retail Lemon",
    },
    notFoundDesc: {
      es: "La página que buscas no existe o ha sido movida.",
      en: "The page you are looking for does not exist or has been moved.",
    },
    notFoundHeading: { es: "Página no encontrada", en: "Page not found" },
    notFoundText: { es: "La página que buscas no existe.", en: "The page you're looking for doesn't exist." },
    notFoundCta: { es: "Volver al inicio", en: "Return to Home" },
    footerCalcAlt: { es: "Limón con calculadora — herramienta de rentabilidad retail", en: "Lemon with calculator — retail profitability tool" },
    homeImageAlt: {
      es: "Mentoring Retail 360º — Consultoría y asesoría para tiendas y negocios retail",
      en: "Retail Mentoring 360° — Store consulting and advisory for retail businesses",
    },
    contactImageAlt: {
      es: "Contacto Retail Lemon — Asesoría y mentoring para tiendas retail",
      en: "Contact Retail Lemon — Retail store consulting and mentoring",
    },
    calcImageAlt: {
      es: "Calculadora de rentabilidad retail por metro cuadrado — herramienta gratuita para tiendas",
      en: "Retail profitability calculator per square meter — free tool for stores",
    },
  },

  // ── FAQ Home ──
  faq: {
    title: { es: "Preguntas Frecuentes", en: "Frequently Asked Questions" },
    viewAll: { es: "Ver todas las preguntas", en: "See all questions" },
    q1: {
      es: "¿Qué plan me conviene?",
      en: "Which plan is right for me?",
    },
    a1: {
      es: "Básico (39 €/mes) ayuda a preparar una apertura. Club Pro (69 €/mes) añade control con Hoja de Ruta, KPIs y Detector completo. Avanzado (99 €/mes) suma alta en Google Business, módulos premium y acceso al servicio de SEO como extra.",
      en: "Basic (€39/month) helps prepare an opening. Club Pro (€69/month) adds control with the Roadmap, KPIs and Full Detector. Advanced (€99/month) adds online presence, Google Business profile and automations.",
    },
    q2: {
      es: "¿Cómo funciona la prueba de 7 días?",
      en: "How does the 7-day trial work?",
    },
    a2: {
      es: "Básico, Club Pro y Avanzado tienen 7 días de prueba, una sola vez por persona. Básico puede empezar sin tarjeta; Club Pro y Avanzado la solicitan y empiezan a cobrarse al terminar si no cancelas. Cambiar de plan no inicia una prueba nueva.",
      en: "Basic, Club Pro and Advanced include a 7-day trial, once per person. Basic can start without a card; Club Pro and Advanced require one and start billing when the trial ends unless you cancel. Changing plan does not start a new trial.",
    },
    q3: {
      es: "¿Cuántas consultas incluye el Agente Retail IA?",
      en: "How many Retail AI Agent queries are included?",
    },
    a3: {
      es: "El cupo mensual es de 30 en Básico, 60 en Club Pro y 100 en Avanzado. El panel te avisa cuando te acercas al límite. El Agente ayuda a interpretar y priorizar, pero no sustituye a un abogado, gestor o mentor humano.",
      en: "The monthly allowance is 30 on Basic, 60 on Club Pro and 100 on Advanced. The panel warns you as you approach the limit. The Agent helps interpret and prioritise, but does not replace a lawyer, accountant or human mentor.",
    },
    q4: {
      es: "¿Qué significa «Extra»?",
      en: "What does ‘Extra’ mean?",
    },
    a4: {
      es: "Es un servicio opcional con tarifa propia, no incluido en la cuota del plan. Música comercial y publicaciones en otras redes están disponibles desde Club Pro. Mentores, proveedores, abogados, licencias, módulo laboral, aroma y alarma están disponibles desde Avanzado.",
      en: "It is an optional service with its own price, not included in the plan fee. Commercial music and posts on other networks are available from Club Pro. Mentors, suppliers, lawyers, licences, the labour module, scent and alarm are available from Advanced.",
    },
    q5: {
      es: "¿Puedo cambiar o cancelar mi plan?",
      en: "Can I change or cancel my plan?",
    },
    a5: {
      es: "Sí. Una subida se aplica de inmediato; durante una prueba conserva los días restantes y no crea otra prueba. Una bajada o cancelación se aplica al final del periodo en curso. No hay permanencia ni penalización.",
      en: "Yes. An upgrade takes effect immediately; during a trial it keeps the remaining days and does not create another trial. A downgrade or cancellation takes effect at the end of the current period. There is no commitment or penalty.",
    },
    q6: {
      es: "¿Tengo que instalar algo o cambiar mi TPV?",
      en: "Do I need to install anything or replace my POS?",
    },
    a6: {
      es: "No. Retail Lemon funciona en el navegador desde ordenador, móvil o tableta. No sustituye tu TPV, gestoría ni sistemas actuales; los complementa para ordenar datos, detectar señales y convertir prioridades en acciones.",
      en: "No. Retail Lemon runs in a browser on desktop, mobile or tablet. It does not replace your POS, accountant or current systems; it complements them by organising data, detecting signals and turning priorities into actions.",
    },
  },

  // ── Public Pricing Section ──
  publicPricing: {
    title: { es: "Elige tu nivel de", en: "Choose your level of" },
    titleAccent: { es: "acompañamiento.", en: "support." },
    tabPymes: { es: "Tiendas y PYMES", en: "Shops & SMBs" },
    tabCadenas: { es: "Cadenas y Grupos", en: "Chains & Groups" },
    tabInversores: { es: "Inversores y M&A", en: "Investors & M&A" },
    pymesIntro: {
      es: "¿Qué trabajaremos en tu plan con Tu Mentor? Nuestro acompañamiento 1-a-1 se adapta a tu fase actual para atacar donde tu negocio más lo necesita:",
      en: "What will we work on in your Your Mentor plan? Our 1-to-1 support adapts to your current stage to tackle where your business needs it most:",
    },
    requestInfo: { es: "Agendar Sesión de Valoración Gratuita", en: "Book a Free Assessment Call" },
    requestProposal: { es: "Solicitar Propuesta a Medida", en: "Request Custom Proposal" },
    contactIn48: {
      es: "Te contactaremos en menos de 48 horas para diseñar tu plan personalizado.",
      en: "We'll contact you within 48 hours to design your personalized plan.",
    },
    customQuote: { es: "Cotización a medida", en: "Custom quote" },
    // PYMES values
    pymesTitle1: { es: "Estrategia y Negociación", en: "Strategy & Negotiation" },
    pymesDesc1: {
      es: "Acompañamiento en negociaciones con proveedores, revisión de contratos y validación de decisiones estratégicas clave.",
      en: "Support in supplier negotiations, contract review and validation of key strategic decisions.",
    },
    pymesB1: {
      es: ["Negociación directa con proveedores", "Revisión de contratos y condiciones", "Validación de decisiones de compra"],
      en: ["Direct supplier negotiation", "Contract and terms review", "Purchase decision validation"],
    },
    pymesTitle2: { es: "Optimización Operativa", en: "Operational Optimization" },
    pymesDesc2: {
      es: "Análisis de márgenes, control de mermas, mejora de procesos y seguimiento de KPIs para maximizar rentabilidad.",
      en: "Margin analysis, shrinkage control, process improvement and KPI tracking to maximize profitability.",
    },
    pymesB2: {
      es: ["Análisis de márgenes por categoría", "Control y reducción de mermas", "Seguimiento de KPIs clave"],
      en: ["Margin analysis by category", "Shrinkage control and reduction", "Key KPI tracking"],
    },
    pymesTitle3: { es: "Crecimiento y Expansión", en: "Growth & Expansion" },
    pymesDesc3: {
      es: "Planificación de aperturas, búsqueda de localizaciones, formación de equipos y escalabilidad del modelo de negocio.",
      en: "Opening planning, location scouting, team building and business model scalability.",
    },
    pymesB3: {
      es: ["Planificación de nuevas aperturas", "Formación y gestión de equipos", "Escalabilidad del modelo de negocio"],
      en: ["New opening planning", "Team training and management", "Business model scalability"],
    },
    // Cadenas
    cadenaTitle1: { es: "Consultoría Operativa", en: "Operational Consulting" },
    cadenaB1: {
      es: ["Estandarización de operaciones", "Optimización de compras", "Formación de equipos"],
      en: ["Operations standardization", "Purchasing optimization", "Team training"],
    },
    cadenaTitle2: { es: "Interim Management", en: "Interim Management" },
    cadenaB2: {
      es: ["Dirección de operaciones temporal", "Reestructuración de equipos", "Escalabilidad para franquicias"],
      en: ["Temporary operations management", "Team restructuring", "Franchise scalability"],
    },
    cadenaTitle3: { es: "Auditoría de Rentabilidad", en: "Profitability Audit" },
    cadenaB3: {
      es: ["Análisis de márgenes por tienda", "Optimización de surtido", "Reducción de mermas"],
      en: ["Per-store margin analysis", "Assortment optimization", "Shrinkage reduction"],
    },
    // Inversores
    inversorTitle1: { es: "Red Flag Report (Pre-LOI)", en: "Red Flag Report (Pre-LOI)" },
    inversorB1: {
      es: ["Auditoría visual rápida", "Detección de riesgos inminentes", "Evaluación de proveedores clave"],
      en: ["Quick visual audit", "Imminent risk detection", "Key supplier assessment"],
    },
    inversorTitle2: { es: "Due Diligence Operativa", en: "Operational Due Diligence" },
    inversorB2: {
      es: ["Análisis profundo de stock tóxico", "Trazabilidad de cadena de suministro", "Realidad vs Balance"],
      en: ["Deep toxic stock analysis", "Supply chain traceability", "Reality vs Balance Sheet"],
    },
    inversorTitle3: { es: "Post-Deal Restructuring", en: "Post-Deal Restructuring" },
    inversorB3: {
      es: ["Toma de control operativo", "Limpieza de inventario", "Preparación para nuevo CEO"],
      en: ["Operational takeover", "Inventory cleanup", "New CEO preparation"],
    },
    // Corp modal
    modalTitle: { es: "Solicitar Información", en: "Request Information" },
    modalDesc: {
      es: "Completa tus datos y nuestro equipo preparará una propuesta personalizada.",
      en: "Fill in your details and our team will prepare a personalized proposal.",
    },
    labelName: { es: "Nombre *", en: "Name *" },
    labelCompany: { es: "Empresa *", en: "Company *" },
    labelEmail: { es: "Email *", en: "Email *" },
    labelPhone: { es: "Teléfono *", en: "Phone *" },
    labelMessage: { es: "¿En qué podemos ayudarte?", en: "How can we help you?" },
    placeholderName: { es: "Tu nombre", en: "Your name" },
    placeholderCompany: { es: "Nombre de la empresa", en: "Company name" },
    placeholderEmail: { es: "tu@empresa.com", en: "you@company.com" },
    placeholderPhone: { es: "+34 600 000 000", en: "+1 555 000 0000" },
    placeholderMessage: {
      es: "Cuéntanos brevemente tu situación o necesidad...",
      en: "Briefly tell us about your situation or needs...",
    },
    submitBtn: { es: "Enviar Solicitud", en: "Send Request" },
    responseTime: {
      es: "Responderemos en menos de 48 horas laborables.",
      en: "We'll respond within 48 business hours.",
    },
    toastSuccess: { es: "Solicitud enviada", en: "Request sent" },
    toastSuccessDesc: {
      es: "Nuestro equipo se pondrá en contacto contigo en breve.",
      en: "Our team will contact you shortly.",
    },
    valName: { es: "Nombre requerido", en: "Name required" },
    valCompany: { es: "Empresa requerida", en: "Company required" },
    valEmail: { es: "Email no válido", en: "Invalid email" },
    valPhone: { es: "Teléfono requerido", en: "Phone required" },
  },

  // ── VIP Pricing Section ──
  vipPricing: {
    title: { es: "Taller 1:1", en: "Workroom 1:1" },
    titleShort: { es: "Taller 1:1", en: "Workroom 1:1" },
    titleNoplan: { es: "Taller 1:1", en: "Workroom 1:1" },
    addOnPremium: { es: "Add-on premium", en: "Premium add-on" },
    requestSession: { es: "Reservar", en: "Book" },
    book: { es: "Reservar", en: "Book" },
    hoursLeftShort: { es: "{h} restantes", en: "{h} left" },
    renewsShort: { es: "Renueva: {date}", en: "Renews: {date}" },
    activePlan: { es: "Plan Activo:", en: "Active Plan:" },
    monthlyIncluded: { es: "mensuales incluidas", en: "monthly included" },
    manageSubscription: { es: "Gestionar Suscripción", en: "Manage Subscription" },
    extraHours: { es: "Horas Extra", en: "Extra Hours" },
    buyExtra: {
      es: "Compra horas adicionales sin cambiar de plan.",
      en: "Buy extra hours without changing your plan.",
    },
    upgradeTo: { es: "Sube a", en: "Upgrade to" },
    upgradePlan: { es: "Mejorar Plan", en: "Upgrade Plan" },
    proExclusive: {
      es: "El Taller 1:1 es exclusivo para miembros del",
      en: "The 1:1 Workroom is exclusive to members of",
    },
    proPlanName: { es: "Plan Lemon", en: "Lemon Plan" },
    proPlanPrice: { es: "(69€/mes).", en: "(€69/month)." },
    requiresPro: { es: "🔒 Desbloquear Mentoría", en: "🔒 Unlock Mentoring" },
    request: { es: "Solicitar", en: "Request" },
    loginRequired: { es: "Inicia sesión", en: "Sign in" },
    loginRequiredDesc: {
      es: "Necesitas estar registrado para contratar un plan.",
      en: "You need to be registered to subscribe to a plan.",
    },
    loginRequiredShort: { es: "Necesitas estar registrado.", en: "You need to be registered." },
    errorCheckout: {
      es: "No se pudo iniciar el proceso de pago.",
      en: "Could not start the payment process.",
    },
    errorPurchase: {
      es: "No se pudo procesar la compra.",
      en: "Could not process the purchase.",
    },
    // Plan names
    planArranque: { es: "Quincenal", en: "Biweekly" },
    planBasico: { es: "Básico", en: "Basic" },
    planAvanzado: { es: "Avanzado", en: "Advanced" },
    planProfesional: { es: "Profesional", en: "Professional" },
    planCrucero: { es: "Semanal", en: "Weekly" },
    planPartner: { es: "Intensivo", en: "Intensive" },
    // Plan data
    planDescBasico: {
      es: "Dirección y corrección de rumbo. Auditoría de salud financiera y desbloqueo operativo para sacar tu negocio del estancamiento.",
      en: "Direction and course correction. Financial health audit and operational unblocking to pull your business out of stagnation.",
    },
    planDescAvanzado: {
      es: "Optimización continua y protección del margen. Ajuste constante de compras, precios y rotación con acompañamiento directo en el día a día.",
      en: "Continuous optimization and margin protection. Ongoing adjustment of purchasing, pricing and rotation with direct day-to-day support.",
    },
    planDescProfesional: {
      es: "Implicación estratégica total. Nos metemos a trabajar codo a codo en tu operativa como tu Director de Operaciones externo.",
      en: "Total strategic involvement. We roll up our sleeves and work side-by-side in your operations as your external COO.",
    },
    modalityOnline: { es: "Online", en: "Online" },
    modalityHybrid: { es: "Presencial o híbrido", en: "On-site or hybrid" },
    footnoteTravel: {
      es: "Gastos de desplazamiento no incluidos.",
      en: "Travel expenses not included.",
    },
    // Frequency subtext per tier
    freqArranque: { es: "Frecuencia recomendada: 1 sesión cada 15 días.", en: "Recommended frequency: 1 session every 15 days." },
    freqCrucero:  { es: "Frecuencia recomendada: 1 sesión semanal.", en: "Recommended frequency: 1 session per week." },
    freqPartner:  { es: "Frecuencia recomendada: 2 sesiones semanales.", en: "Recommended frequency: 2 sessions per week." },
    // Upgrade benefits
    upgradeBenefitsBrujula: {
      es: ["2h/mes (2 sesiones de 1h)", "280€/mes", "1 sesión cada 15 días"],
      en: ["2h/month (2 x 1h sessions)", "€280/mo", "1 session every 15 days"],
    },
    upgradeBenefitsSherpa: {
      es: ["4h/mes (4 sesiones de 1h)", "480€/mes", "1 sesión semanal"],
      en: ["4h/month (4 x 1h sessions)", "€480/mo", "1 session per week"],
    },
    upgradeBenefitsFractional: {
      es: ["8h/mes (8 sesiones de 1h)", "800€/mes", "2 sesiones semanales", "Director de Operaciones externo"],
      en: ["8h/month (8 x 1h sessions)", "€800/mo", "2 sessions per week", "External COO"],
    },
    // Retention mode (cancellation scheduled)
    cancellationScheduledTitle: {
      es: "Tu mentoría termina pronto",
      en: "Your mentoring ends soon",
    },
    cancellationDaysLeft: { es: "días restantes", en: "days left" },
    cancellationDayLeft: { es: "día restante", en: "day left" },
    cancellationLastDay: { es: "Hoy es tu último día", en: "Today is your last day" },
    cancellationAccessUntil: { es: "Acceso hasta el {date}", en: "Access until {date}" },
    cancellationFomoMessage: {
      es: "Sin tu mentor, los próximos meses dependerán solo de tu intuición. Reactiva ahora y no pierdas el ritmo que has construido.",
      en: "Without your mentor, the next months will rely only on your intuition. Reactivate now and keep the momentum you've built.",
    },
    cancellationReactivateCta: { es: "Reactivar mi plan", en: "Reactivate my plan" },
    cancellationDetailsCta: { es: "Ver detalles", en: "View details" },
    cancellationBadgeShort: { es: "Termina el {date}", en: "Ends {date}" },
    cancellationToastSuccessTitle: { es: "Plan reactivado", en: "Plan reactivated" },
    cancellationToastSuccessDesc: {
      es: "Bienvenido de vuelta. Tu mentoría sigue activa.",
      en: "Welcome back. Your mentoring stays active.",
    },
    cancellationToastErrorTitle: { es: "No se pudo reactivar", en: "Could not reactivate" },
  },

  // ── Session Modal ──
  sessionModal: {
    title: { es: "🍋 Reservar con tu Mentor", en: "🍋 Book with your Mentor" },
    description: {
      es: "Cuéntame brevemente qué necesitas revisar y te propondré los mejores huecos en mi agenda.",
      en: "Briefly tell me what you need to review and I'll suggest the best slots in my calendar.",
    },
    labelTopic: { es: "¿De qué tema principal quieres que hablemos?", en: "What main topic would you like to discuss?" },
    labelDuration: {
      es: "Tiempo estimado que crees que necesitaremos",
      en: "Estimated time you think we'll need",
    },
    labelSchedule: {
      es: "¿Qué días o franjas horarias te suelen venir mejor?",
      en: "What days or time slots work best for you?",
    },
    optional: { es: "(Opcional)", en: "(Optional)" },
    required: { es: "*", en: "*" },
    placeholderTopic: {
      es: "Ej: Necesito revisar el escandallo de la nueva colección de verano...",
      en: "E.g.: I need to review the cost breakdown of the new summer collection...",
    },
    placeholderSchedule: {
      es: "Ej: Martes por la mañana o Jueves a última hora.",
      en: "E.g.: Tuesday morning or Thursday late afternoon.",
    },
    duration30: { es: "Resolución rápida (Aprox. 30 min)", en: "Quick resolution (Approx. 30 min)" },
    duration60: { es: "Sesión de trabajo (Aprox. 1 hora)", en: "Working session (Approx. 1 hour)" },
    duration120: { es: "Auditoría profunda (Aprox. 2 horas)", en: "Deep audit (Approx. 2 hours)" },
    submitBtn: { es: "Enviar Solicitud", en: "Send Request" },
    valTopic: { es: "Campo obligatorio", en: "Required field" },
    valTopicDesc: {
      es: "Describe brevemente el tema de la sesión.",
      en: "Briefly describe the session topic.",
    },
    successTitle: { es: "✅ Solicitud enviada", en: "✅ Request sent" },
    successDesc: {
      es: "Carlos se pondrá en contacto contigo muy pronto para confirmar la cita.",
      en: "Carlos will contact you very soon to confirm the appointment.",
    },
    errorSend: {
      es: "No se pudo enviar la solicitud.",
      en: "Could not send the request.",
    },
    notAuthenticated: { es: "No estás autenticado", en: "You are not authenticated" },
  },

  // ── Mentoring Booking (new calendar flow) ──
  mentoringBooking: {
    title: { es: "🍋 Reservar sesión con tu mentor", en: "🍋 Book a session with your mentor" },
    quotaLabel: { es: "Horas disponibles este mes", en: "Hours available this month" },
    quotaRemaining: { es: "Te quedan {h} h de {total} h", en: "You have {h} h left of {total} h" },
    sessionUnit: { es: "Las sesiones son de 1 hora.", en: "Sessions are 1 hour long." },
    tipArranque: {
      es: "Recomendamos 1 sesión de 1h cada 15 días para asimilar el Método Lemon, pero si estás en una semana clave, ¡puedes agendar las 2 de golpe si hay disponibilidad!",
      en: "We recommend one 1h session every 15 days, but if you're in a key week feel free to book both back-to-back if there's availability!",
    },
    tipCrucero: {
      es: "Tu ritmo ideal es de 1 sesión de 1h por semana para mantener la tracción total de tu negocio. ¡A por ello!",
      en: "Your ideal pace is one 1h session per week to keep your business on track. Let's go!",
    },
    tipPartner: {
      es: "Dispones de 2 horas semanales de máximo rendimiento. Puedes agendarlas en un único bloque de 2h o repartirlas en dos sesiones de 1h. ¡Tú mandas!",
      en: "You get 2 high-impact hours per week. Take them as one 2h block or split into two 1h sessions. Your call!",
    },
    tipGeneric: {
      es: "Reserva el hueco que mejor te encaje. Si necesitas más tiempo, agenda dos sesiones seguidas.",
      en: "Pick the slot that fits you best. Need more time? Book two sessions back-to-back.",
    },
    tipArranqueRollover: {
      es: "¡Tienes {h}h acumuladas del mes pasado! Normalmente recomendamos 1 sesión cada 15 días, pero con este colchón extra es el momento perfecto para agendar una sesión doble y revisar tu estrategia a fondo.",
      en: "You have {h}h rolled over from last month! We usually suggest one session every 15 days, but with this extra cushion it's the perfect moment to book a double session and review your strategy in depth.",
    },
    tipCruceroRollover: {
      es: "Tienes {h}h extra acumuladas. A tu ritmo de 1 sesión semanal, esto nos da margen para una sesión intensiva de 2 horas o atacar de golpe ese cuello de botella pendiente.",
      en: "You have {h}h extra rolled over. At your weekly pace this gives us room for an intensive 2-hour session or to tackle that pending bottleneck head-on.",
    },
    tipPartnerRollover: {
      es: "¡Acumulas {h}h del mes anterior! Aparte de tus 2h semanales habituales, podemos usar este extra para una auditoría profunda o acelerar la operativa de tus tiendas.",
      en: "You have {h}h rolled over from last month! On top of your usual 2 weekly hours we can use this extra for a deep audit or to accelerate your store operations.",
    },
    breakdownTotals: { es: "{h} / {total} h totales ({base}h plan + {roll}h acumuladas)", en: "{h} / {total} h total ({base}h plan + {roll}h rolled over)" },
    pickDay: { es: "Elige el día", en: "Pick a day" },
    pickSlot: { es: "Elige la hora (Madrid)", en: "Pick a time (Madrid)" },
    noSlotsDay: { es: "Sin huecos libres este día. Prueba otro.", en: "No free slots that day. Try another." },
    loadingSlots: { es: "Buscando huecos en la agenda…", en: "Looking for open slots…" },
    confirmBtn: { es: "Confirmar reserva", en: "Confirm booking" },
    confirmingBtn: { es: "Reservando…", en: "Booking…" },
    successTitle: { es: "✅ ¡Sesión reservada!", en: "✅ Session booked!" },
    successDesc: {
      es: "Solicitud recibida. La verás en tu cabecera como pendiente hasta que confirmemos el Meet.",
      en: "Request received. You’ll see it in your header as pending until we confirm the Meet.",
    },
    noQuotaTitle: { es: "Has exprimido tus horas de este mes", en: "You've squeezed all your hours this month" },
    noQuotaDesc: {
      es: "Has exprimido tus horas de mentoría de este mes. Si necesitas un empujón extra para tu negocio, puedes comprar 1 hora adicional o pasar al plan superior.",
      en: "You've used all your mentoring hours this month. If you need an extra push for your shop, buy 1 extra hour or upgrade your plan.",
    },
    buyExtra: { es: "🍋 Comprar 1 hora extra", en: "🍋 Buy 1 extra hour" },
    upgradePlan: { es: "Escoge tu plan", en: "Choose your plan" },
    topicOptional: { es: "¿Qué quieres tratar? (opcional)", en: "What do you want to discuss? (optional)" },
    topicPh: {
      es: "Ej: Revisar márgenes de la nueva colección…",
      en: "E.g.: Review margins of the new collection…",
    },
    noPlanTitle: { es: "Necesitas el apoyo de un experto", en: "You need expert support" },
    noPlanDesc: {
      es: "Aún no tienes un plan de mentoría activo. Escoge uno para reservar tus sesiones directamente desde el calendario.",
      en: "You don't have an active mentoring plan yet. Choose one to book sessions directly from the calendar.",
    },
    noPlanPickCta: { es: "Escoger este plan", en: "Choose this plan" },
    plans: {
      arranque: {
        es: { name: "Quincenal", pace: "1 sesión de 1h cada 15 días", extra: "Ideal para asentar el método y tomar decisiones clave sin agobios." },
        en: { name: "Biweekly", pace: "One 1h session every 15 days", extra: "Ideal to embed the method and take key decisions without pressure." },
      },
      crucero: {
        es: { name: "Semanal", pace: "1 sesión de 1h a la semana", extra: "Ritmo semanal para mantener la tracción y avanzar sin frenar." },
        en: { name: "Weekly", pace: "One 1h session per week", extra: "Weekly cadence to keep traction and move forward without slowing down." },
      },
      partner: {
        es: { name: "Intensivo", pace: "2h a la semana con tu mentor", extra: "Máxima intensidad para expansión, M&A o momentos críticos." },
        en: { name: "Intensive", pace: "2h per week with your mentor", extra: "Maximum intensity for expansion, M&A or critical moments." },
      },
    },
    errorBooking: { es: "No se pudo reservar la sesión.", en: "Could not book the session." },
    bookingErrorHuman: {
      es: "Error de conexión con el calendario. Verifica los permisos del conector.",
      en: "Calendar connection error. Check the connector permissions.",
    },
    durationLabel: { es: "Duración de la sesión", en: "Session duration" },
    duration1h: { es: "1 hora", en: "1 hour" },
    duration2h: { es: "2 horas", en: "2 hours" },
    durationHint: {
      es: "Nota: La duración máxima por reserva es de 2 horas consecutivas.",
      en: "Note: Maximum booking length is 2 consecutive hours.",
    },
    duration2hDisabled: {
      es: "Necesitas al menos 2 h de saldo disponible para reservar una sesión doble.",
      en: "You need at least 2 h of available balance to book a double session.",
    },
    nextMonthCancellationWarning: {
      es: "Tu mentoría finaliza el {date}. Confirma o mantén tu suscripción para poder reservar sesiones en {month}.",
      en: "Your mentoring ends on {date}. Confirm or keep your subscription to book sessions in {month}.",
    },
    manageSubscription: { es: "Gestionar suscripción", en: "Manage subscription" },
  },

  // ── Expert support sidebar popover ──
  expertSupport: {
    title: { es: "Pregunta a un experto", en: "Ask an expert" },
    guestPopoverPitch: {
      es: "Si en algún momento necesitas ayuda, tienes la opción de preguntarle a un experto, que te ayudará a resolver tus dudas y acompañarte en tu negocio.",
      en: "If you ever need help, you have the option to ask an expert, who will help you resolve your doubts and support your business.",
    },
    oneOffHours: { es: "Consultas puntuales", en: "One-off consultations" },
    neverExpire: { es: "No caducan", en: "Never expire" },
    monthlyMentoring: { es: "Mentoría del mes", en: "Monthly mentoring" },
    renewsOnFirst: { es: "se renuevan el día 1", en: "renew on the 1st" },
    activePlan: { es: "Plan activo", en: "Active plan" },
    yourPlan: { es: "Tu plan", en: "Your plan" },
    accompanimentPitch: {
      es: "Una sesión cada 15 días para avanzar a tu ritmo, sin agobios y acompañado.",
      en: "One session every 15 days to move at your pace, without overwhelm and accompanied.",
    },
    startAccompaniment: { es: "Empezar acompañamiento", en: "Start accompaniment" },
    bookSession: { es: "Reservar cita", en: "Book a session" },
    moreHoursOrCustomPlan: {
      es: "¿Necesitas más horas o un plan a medida?",
      en: "Need more hours or a tailored plan?",
    },
    buyOneOffHours: { es: "Comprar horas puntuales", en: "Buy one-off hours" },
    buyOneOffHoursHint: {
      es: "Resuelve una duda concreta sin contratar plan. No caducan.",
      en: "Solve a specific doubt without hiring a plan. They never expire.",
    },
    oneHour: { es: "1 hora", en: "1 hour" },
    twoHours: { es: "2 horas", en: "2 hours" },
    otherPaces: { es: "Otros ritmos de acompañamiento", en: "Other accompaniment paces" },
    switchToThis: { es: "Cambiar a este", en: "Switch to this" },
    chooseThis: { es: "Elegir este", en: "Choose this" },
    noHoursMessage: {
      es: "Sin horas disponibles ahora mismo. Compra una consulta puntual o empieza un plan.",
      en: "No hours available right now. Buy a one-off consultation or start a plan.",
    },
  },

  // ── Locked module gate card ──
  lockedModuleGate: {
    extraModuleLabel: { es: "Módulo extra", en: "Extra module" },
    extraDescription: {
      es: "Este es un módulo premium. Solo los socios del Club Pro pueden adquirirlo a través de su panel.",
      en: "This is a premium module. Only Club Pro members can purchase it through their panel.",
    },
    proLine1: { es: "Este módulo está disponible", en: "This module is available" },
    proLine2: { es: "para todos los miembros del Club Pro.", en: "to every Club Pro member." },
    liteDescription: {
      es: "Los primeros pasos son gratuitos: regístrate y pruébalos.",
      en: "First steps are free: sign up and try them.",
    },
  },


  upcomingSession: {
    title: { es: "Próxima sesión 1:1", en: "Next 1:1 session" },
    pendingAria: { es: "Por confirmar", en: "Pending confirmation" },
    pendingTooltip: {
      es: "(Sesión reservada: Pendiente de confirmar por el administrador)",
      en: "(Session reserved: Pending confirmation by the administrator)",
    },
    confirmedTooltip: {
      es: "(¡Confirmado por tu mentor!)",
      en: "(Confirmed by your mentor!)",
    },
    countdownPrefix: { es: "Quedan:", en: "Left:" },
    meetCta: { es: "Google Meet", en: "Google Meet" },
    meetTooltip: {
      es: "Hacer clic te llevará directo a tu reunión",
      en: "Clicking will take you straight into your meeting",
    },
    statusPending: { es: "Pendiente de confirmar", en: "Pending confirmation" },
    statusConfirmed: { es: "Confirmada", en: "Confirmed" },
    disclaimer: {
      es: "Entiendo que esta es una sesión informativa y acepto las condiciones del diagnóstico.",
      en: "I understand this is an informational session and I accept the diagnosis terms.",
    },
  },

  // ── Admin VIP Calendar feed ──
  vipCalendarAdmin: {
    title: { es: "Agenda mentor", en: "Live Mentor Agenda" },
    subtitle: {
      es: "Próximas sesiones sincronizadas con Google Calendar.",
      en: "Upcoming sessions synced with Google Calendar.",
    },
    refresh: { es: "Actualizar", en: "Refresh" },
    empty: { es: "Sin sesiones próximas.", en: "No upcoming sessions." },
    joinMeet: { es: "Unirme al Meet", en: "Join Meet" },
    openInCalendar: { es: "Ver en Calendar", en: "View in Calendar" },
    loadError: { es: "No se pudo cargar la agenda.", en: "Could not load the agenda." },
    loadErrorHuman: {
      es: "Error de conexión con el calendario. Verifica los permisos del conector.",
      en: "Calendar connection error. Check the connector permissions.",
    },
    sessionAdjustTitle: { es: "Ajuste de Tiempos Mentor", en: "Mentor Time Adjustment" },
    sessionAdjustDesc: {
      es: "Edita la duración real de cada sesión. El saldo del cliente se recalcula al instante.",
      en: "Edit the real duration of each session. The client's balance recalculates instantly.",
    },
    durationReal: { es: "Duración real (h)", en: "Real duration (h)" },
    save: { es: "Guardar", en: "Save" },
    saved: { es: "Guardado", en: "Saved" },
    statusScheduled: { es: "Agendada", en: "Scheduled" },
    statusCompleted: { es: "Realizada", en: "Completed" },
    statusCancelled: { es: "Cancelada", en: "Cancelled" },
    noSessions: { es: "Aún no hay sesiones registradas.", en: "No sessions registered yet." },
    tabAgenda: { es: "Mi Agenda", en: "My Agenda" },
    tabAvailability: { es: "Disponibilidad", en: "Availability" },
    availabilityTitle: { es: "Configuración de disponibilidad", en: "Availability settings" },
    availabilitySubtitle: {
      es: "Define los días y franjas en los que aceptas sesiones de mentoría. Se cruzan con tu Google Calendar para mostrar solo huecos libres.",
      en: "Set the days and time ranges when you accept mentoring sessions. They are crossed with your Google Calendar to show only free slots.",
    },
    addSlot: { es: "+ Añadir franja", en: "+ Add slot" },
    removeSlot: { es: "Eliminar", en: "Remove" },
    saveAvailability: { es: "Guardar disponibilidad", en: "Save availability" },
    availabilitySaved: { es: "Disponibilidad actualizada", en: "Availability updated" },
    dayMon: { es: "Lunes", en: "Monday" },
    dayTue: { es: "Martes", en: "Tuesday" },
    dayWed: { es: "Miércoles", en: "Wednesday" },
    dayThu: { es: "Jueves", en: "Thursday" },
    dayFri: { es: "Viernes", en: "Friday" },
    daySat: { es: "Sábado", en: "Saturday" },
    daySun: { es: "Domingo", en: "Sunday" },
  },



  // ── Time Wallet (mentoring credits) ──
  timeWallet: {
    title: { es: "Mi Bolsa de Horas", en: "My Hours Wallet" },
    inactiveTitle: { es: "Bolsa de Horas Inactiva", en: "Hours Wallet Inactive" },
    inactiveDesc: {
      es: "Desbloquea el acceso directo a un experto retail para que revise tus números y valide tus ideas.",
      en: "Unlock direct access to a retail expert to review your numbers and validate your ideas.",
    },
    viewPlans: { es: "Ver Planes de Tu Mentor", en: "View Mentor Plans" },
    requestSession: { es: "Reservar", en: "Book" },
    remainingLabel: { es: "Te quedan", en: "You have" },
    ofTotal: { es: "de", en: "of" },
    thisMonth: { es: "este mes", en: "this month" },
    overConsumed: { es: "Has superado tu bolsa de horas", en: "You've exceeded your hours wallet" },
    rowPlan: { es: "Horas del plan", en: "Plan hours" },
    rowPlanSub: { es: "Se reinician en {{n}} días", en: "Reset in {{n}} days" },
    rowRollover: { es: "Acumuladas (Rollover)", en: "Rollover Accumulated" },
    rowRolloverSub: { es: "Horas no usadas del mes anterior", en: "Unused hours from previous month" },
    rowRolloverExpiry: { es: "Caducan el {{date}}", en: "Expire on {{date}}" },
    rowExtras: { es: "Horas adicionales", en: "Additional hours" },
    rowExtrasSub: { es: "Sin caducidad", en: "No expiration" },
    rowPromoSub: { es: "Bono", en: "Bonus" },
    rowPromoExpires: { es: "Caducan el {{date}}", en: "Expire on {{date}}" },
    tooltipPlan: { es: "Plan mensual", en: "Monthly plan" },
    tooltipRollover: { es: "Horas extra del mes anterior", en: "Extra hours from previous month" },
    tooltipPromo: { es: "Bono regalo", en: "Bonus gift" },
    tooltipUsed: { es: "{{used}} usadas de {{total}}", en: "{{used}} used of {{total}}" },
    legalDisclaimer: {
      es: "Las horas no consumidas caducan según los Términos.",
      en: "Unused hours expire as per the Terms.",
    },
    showDetails: { es: "Ver detalle", en: "Show detail" },
    hideDetails: { es: "Ocultar detalle", en: "Hide detail" },
    upsellNotContracted: { es: "No contratado", en: "Not subscribed" },
    upsellDiscover: { es: "Descubrir Mentoría", en: "Discover Mentoring" },
    upsellActivePlan: { es: "Plan Activo: Ninguno", en: "Active Plan: None" },
    upsellSubtitle: { es: "Gestionando en solitario", en: "Managing solo" },
    upsellBannerTitle: {
      es: "El Panel te da los datos. Un Mentor te da el mapa.",
      en: "The Panel gives you data. A Mentor gives you the map.",
    },
    upsellBannerBody: {
      es: "Los negocios que escalan no improvisan. Suma un mentor como extra desde el plan Avanzado. Optimiza tus márgenes y recupera tu tiempo.",
      en: "Businesses that scale don't improvise. Add a mentor as an extra from the Advanced plan. Optimize margins and recover your time.",
    },
    upsellCta: { es: "Activar Tu Mentor", en: "Activate Your Mentor" },
    popoverTitle: { es: "TU SALDO DE MENTORÍA", en: "YOUR MENTORING BALANCE" },
    popoverSubtitle: { es: "de apoyo profesional", en: "of professional support" },
    popoverTotalSuffix: { es: "totales", en: "total" },
    popoverConsumedSuffix: { es: "consumidas", en: "consumed" },
  },

  // ── Auth Error Page ──
  authError: {
    title: { es: "Error al iniciar sesión", en: "Sign-in Error" },
    description: {
      es: "Ha ocurrido un error al iniciar sesión. Por favor inténtalo de nuevo.",
      en: "An error occurred while signing in. Please try again.",
    },
    retryGoogle: { es: "Reintentar con Google", en: "Try again with Google" },
    backHome: { es: "Volver al inicio", en: "Back to Home" },
  },

  // ── Quiz (inline component) ──
  quizInline: {
    title: { es: "El", en: "The" },
    titleAccent: { es: "To-Do List", en: "To-Do List" },
    subtitle: {
      es: "¿No sabes por dónde empezar? Descubre en qué punto está tu marca.",
      en: "Don't know where to start? Discover where your brand stands.",
    },
    back: { es: "← Volver", en: "← Back" },
    stepOf: { es: "Paso", en: "Step" },
    of: { es: "de", en: "of" },
    leadTitle: {
      es: "¡Genial! Vemos que tienes lagunas en algunas áreas.",
      en: "Great! We can see you have gaps in some areas.",
    },
    leadSubtitle: {
      es: "Déjanos tu email y te enviamos un presupuesto exacto de cómo Retail Lemon puede solucionarlo.",
      en: "Leave us your email and we'll send you an exact quote on how Retail Lemon can fix it.",
    },
    sendDiagnosis: { es: "Enviar Diagnóstico", en: "Send Diagnosis" },
    sent: { es: "¡Enviado!", en: "Sent!" },
    sentDesc: {
      es: "Revisaremos tu diagnóstico y te contactaremos con un plan personalizado.",
      en: "We'll review your diagnosis and contact you with a personalized plan.",
    },
    repeat: { es: "Repetir", en: "Repeat" },
    toastSuccess: {
      es: "¡Diagnóstico enviado! Te contactaremos pronto.",
      en: "Diagnosis sent! We'll contact you soon.",
    },
    valEmail: { es: "Introduce un email válido", en: "Enter a valid email" },
    // Quiz questions & options
    categories: {
      es: ["Legal", "Fabricación", "Retail", "Ventas"],
      en: ["Legal", "Manufacturing", "Retail", "Sales"],
    },
    questions: {
      es: [
        "¿Tienes la estructura fiscal y la marca registrada?",
        "¿Tienes los patrones, fichas técnicas y proveedores de tejidos?",
        "¿Tienes local, proyecto de reforma y marketing sensorial?",
        "¿Sabes cómo liquidar stock sin perder dinero ni hipotecarte?",
      ],
      en: [
        "Do you have the tax structure and registered trademark?",
        "Do you have patterns, tech packs and fabric suppliers?",
        "Do you have a location, renovation project and sensory marketing?",
        "Do you know how to clear stock without losing money?",
      ],
    },
    options: {
      es: [
        ["Sí, lo tengo", "No, ayuda"],
        ["Todo listo", "Me falta esto"],
        ["Sí", "Busco local", "Quiero que huela bien"],
        ["Lo domino", "Las mates no son lo mío"],
      ],
      en: [
        ["Yes, I have it", "No, help"],
        ["All set", "I'm missing this"],
        ["Yes", "Looking for a location", "I want it to smell good"],
        ["I've got it", "Math isn't my thing"],
      ],
    },
  },

  // ── Pricing toggle / VIP fixed copy ──
  pricing: {
    toggleMonthly: {
      es: "Pago mensual · Sin permanencia",
      en: "Monthly payment · No commitment",
    },
    toggleAnnual: { es: "Pago Anual", en: "Annual Payment" },
    toggleBadge: { es: "", en: "" },
    savingsAnnualPro: { es: "", en: "" },
    termsLite: {
      es: "Sin tarjeta de crédito y sin permanencia.",
      en: "No credit card and no minimum term.",
    },
    termsPro: {
      es: "Sin permanencia: los planes de pago son mensuales y puedes cancelar cuando quieras; la baja surte efecto al final del mes ya pagado.",
      en: "No commitment: paid plans are monthly and you can cancel anytime; cancellation takes effect at the end of the month already paid.",
    },
    termsVip: {
      es: "Los mentores son un extra de pago disponible desde el plan Avanzado. Verás el precio antes de pagar.",
      en: "Mentors are a paid extra available from the Advanced plan. You'll see the price before paying.",
    },
    proExpansionNote: {
      es: "Capacidad de incorporar Módulos de Expansión Premium según las necesidades de tu negocio.",
      en: "Ability to add Premium Expansion Modules based on your business's needs.",
    },
    vipCta: {
      es: "Pedir Mentor",
      en: "Request a Mentor",
    },
    vipFixed1: {
      es: "Mes a mes; el panel se contrata aparte",
      en: "Month to month; the panel is purchased separately",
    },
    vipFixed2: {
      es: "Auditoría de números y estrategia personalizada",
      en: "Numbers audit and personalized strategy",
    },
    vipFixed3: {
      es: "Contacto directo para decisiones críticas",
      en: "Direct contact for critical decisions",
    },
  },

  // ── Profesionales retail (panel cliente + back office) ──
  expertsPanel: {
    tl_whoClient: { es: "Cliente", en: "Client" },
    tl_whoPro: { es: "Profesional", en: "Professional" },
    tl_whoBoth: { es: "Todos", en: "Everyone" },
    tl_1: { es: "Solicitud recibida", en: "Request received" },
    tl_1d: { es: "El cliente cuenta lo que necesita. Solo lo ve Retail Lemon.", en: "The client explains what they need. Only Retail Lemon sees it." },
    tl_2: { es: "Revisada y asignada", en: "Reviewed and assigned" },
    tl_2d: { es: "Retail Lemon la revisa y elige al profesional adecuado. Nada sale sin este paso.", en: "Retail Lemon reviews it and picks the right professional. Nothing goes out without this step." },
    tl_3: { es: "Propuesta del profesional", en: "Professional's proposal" },
    tl_3d: { es: "El profesional manda precio y alcance a Retail Lemon, no al cliente.", en: "The professional sends price and scope to Retail Lemon, not to the client." },
    tl_4: { es: "Validada y enviada al cliente", en: "Validated and sent to the client" },
    tl_4d: { es: "Retail Lemon comprueba que no lleve contactos y la publica al cliente.", en: "Retail Lemon checks there are no contact details and publishes it to the client." },
    tl_5: { es: "Señal pagada", en: "Deposit paid" },
    tl_5d: { es: "El cliente acepta y paga la señal, que se descuenta del precio final.", en: "The client accepts and pays the deposit, deducted from the final price." },
    tl_6: { es: "Contactos liberados", en: "Contacts released" },
    tl_6d: { es: "Cliente y profesional reciben los datos del otro para empezar.", en: "Client and professional get each other's details to get started." },
    tl_pending: { es: "Pendiente", en: "Pending" },
    tl_done: { es: "Hecho", en: "Done" },
    f_case: { es: "Expediente", en: "Case" },
    f_sector: { es: "Sector", en: "Sector" },
    f_tenure: { es: "Local", en: "Premises" },
    f_tenant: { es: "Inquilino", en: "Tenant" },
    f_owner: { es: "Propietario", en: "Owner" },
    f_city: { es: "Ciudad", en: "City" },
    f_date: { es: "Fecha", en: "Date" },
    f_unknown: { es: "Sin dato", en: "Not given" },
    f_timeline: { es: "Cronología del caso", en: "Case timeline" },
    f_internalStatus: { es: "Estado interno", en: "Internal status" },
    f_proposal: { es: "Profesional y propuesta", en: "Professional and proposal" },
    f_waiting: { es: "Esperando la propuesta de {name} desde su portal.", en: "Waiting for {name}'s proposal from their portal." },
    f_signal: { es: "señal", en: "deposit" },
    f_manual: { es: "Cargar propuesta a mano", en: "Add proposal manually" },
    f_paid: { es: "Señal y contactos", en: "Deposit and contacts" },
    f_paidText: { es: "La señal se descuenta del presupuesto final del profesional.", en: "The deposit is deducted from the professional's final quote." },
    f_need: { es: "Lo que necesita", en: "What they need" },
    f_hidden: { es: "Nombre y contacto protegidos", en: "Name and contact protected" },
    f_hiddenText: { es: "Se liberan cuando el cliente paga la señal.", en: "Released once the client pays the deposit." },
    f_clientContact: { es: "Contacto del cliente", en: "Client contact" },
    pt_kAssigned: { es: "Casos asignados", en: "Assigned cases" },
    pt_kSent: { es: "Propuestas enviadas", en: "Proposals sent" },
    pt_kPaid: { es: "Con señal pagada", en: "Deposit paid" },
    pt_brand: { es: "Colaboradores", en: "Partners" },
    pt_yourProposal: { es: "Tu propuesta para Retail Lemon", en: "Your proposal for Retail Lemon" },
    lockedBadge: { es: "Exclusivo plan Avanzado", en: "Advanced plan only" },
    lockedTitle: { es: "Profesionales retail cuando toca firmar", en: "Retail professionals when it's time to sign" },
    lockedText: { es: "Sara IA te orienta. Para contratos, licencias, laboral, fiscal u obra del local, Retail Lemon busca un especialista en comercio, revisa su propuesta y te la enseña con un precio acotado.", en: "Sara AI guides you. For leases, licences, employment, tax or shop works, Retail Lemon finds a retail specialist, reviews their proposal and shows it to you with a tight price range." },
    lockedCta: { es: "Ver Plan Avanzado", en: "See Advanced plan" },
    hintsTitle: { es: "Para que te respondan mejor, cuenta:", en: "To get a better answer, tell us:" },
    hint_mercantil: { es: "Tipo de contrato o local, qué cláusula te preocupa y fechas clave.", en: "Type of contract or premises, which clause worries you and key dates." },
    hint_licencias: { es: "Actividad, municipio, qué te han pedido y si hay plazo o requerimiento.", en: "Activity, town, what they've asked for and any deadline or notice." },
    hint_laboral: { es: "Cuántas personas, tipo de contrato y qué ha pasado (sin nombres).", en: "How many people, contract type and what happened (no names)." },
    hint_fiscal: { es: "Forma jurídica, qué impuesto o trámite y qué plazo tienes.", en: "Legal form, which tax or filing and your deadline." },
    hint_reformas: { es: "Metros aproximados, qué quieres hacer y cuándo te gustaría abrir.", en: "Approximate size, what you want to do and when you'd like to open." },
    previewBadge: { es: "Envío con Plan Avanzado", en: "Sending with Advanced plan" },
    previewNote: { es: "Prepara tu caso con calma: lo guardamos en este dispositivo. El envío a profesionales es del Plan Avanzado.", en: "Prepare your case calmly: we keep it on this device. Sending to professionals is part of the Advanced plan." },
    advancedOnlyTitle: { es: "Envío y propuestas: exclusivo del Plan Avanzado", en: "Sending and proposals: Advanced plan only" },
    advancedOnlyBody: { es: "Redacta tu caso y déjalo preparado. El envío al profesional y los presupuestos se activan con el Plan Avanzado.", en: "Write your case and keep it ready. Sending it to a professional and receiving quotes unlock with the Advanced plan." },
    charsLeft: { es: "Faltan {n} caracteres para poder enviar", en: "{n} more characters needed to send" },
    upTitle: { es: "Tu caso está listo para enviarse", en: "Your case is ready to send" },
    upText: { es: "Con el Plan Avanzado lo mandamos a un especialista en retail, revisamos su propuesta y te la enseñamos con un precio acotado. No pierdes lo que has escrito.", en: "With the Advanced plan we send it to a retail specialist, review their proposal and show it to you with a tight price range. You won't lose what you wrote." },
    upCta: { es: "Pasar a Avanzado · 99 €/mes", en: "Go Advanced · €99/month" },
    upLater: { es: "Ahora no", en: "Not now" },
    pt_title: { es: "Portal de colaboradores", en: "Partner portal" },
    pt_intro: { es: "Acceso para profesionales homologados por Retail Lemon.", en: "Access for professionals approved by Retail Lemon." },
    pt_signin: { es: "Entrar", en: "Sign in" },
    pt_signinText: { es: "Entra con el email con el que Retail Lemon te dio de alta.", en: "Sign in with the email Retail Lemon registered you with." },
    pt_notProvider: { es: "Esta cuenta no está dada de alta como colaborador o está pendiente de verificar. Escríbenos a hola@retaillemon.com.", en: "This account isn't registered as a partner or is pending verification. Write to hola@retaillemon.com." },
    pt_termsTitle: { es: "Condiciones de colaboración", en: "Partnership terms" },
    pt_term1: { es: "No contacto directo ni cobros fuera de Retail Lemon con clientes recibidos por la plataforma.", en: "No direct contact or payments outside Retail Lemon with clients received through the platform." },
    pt_term2: { es: "Sin teléfonos, emails ni webs en las propuestas.", en: "No phones, emails or websites in proposals." },
    pt_term3: { es: "La horquilla de precio no supera un 25 % sobre el mínimo.", en: "The price range never exceeds the minimum by more than 25%." },
    pt_term4: { es: "Retail Lemon revisa cada propuesta antes de que el cliente la vea.", en: "Retail Lemon reviews every proposal before the client sees it." },
    pt_accept: { es: "Acepto las condiciones", en: "I accept the terms" },
    pt_acceptBtn: { es: "Continuar", en: "Continue" },
    pt_cases: { es: "Casos asignados", en: "Assigned cases" },
    pt_noCases: { es: "Aún no tienes casos asignados.", en: "You have no assigned cases yet." },
    pt_send: { es: "Enviar a revisión", en: "Send for review" },
    pt_sent: { es: "Propuesta enviada. Retail Lemon la revisa antes de enseñarla.", en: "Proposal sent. Retail Lemon reviews it before showing it." },
    pt_paid: { es: "Señal pagada: encargo confirmado", en: "Deposit paid: job confirmed" },
    acceptPay: { es: "Aceptar y pagar señal", en: "Accept and pay deposit" },
    depositNote: { es: "Se descuenta de la factura final del profesional.", en: "Deducted from the professional's final invoice." },
    depositPaid: { es: "Señal pagada", en: "Deposit paid" },
    depositOk: { es: "¡Hecho! Señal recibida. Ya tienes el contacto del profesional.", en: "Done! Deposit received. You now have the professional's contact." },
    depositPending: { es: "El pago aún no figura como completado. Vuelve a mirar en un momento.", en: "The payment isn't completed yet. Check again in a moment." },
    depositError: { es: "No hemos podido abrir el pago. Inténtalo otra vez.", en: "We couldn't open the payment. Please try again." },
    contactSoon: { es: "Cargando contacto…", en: "Loading contact…" },
    adm_lastNotice: { es: "Último aviso", en: "Last notice" },
    adm_ok: { es: "enviado", en: "sent" },
    adm_failed: { es: "falló", en: "failed" },
    adm_ev_request_new: { es: "Nueva solicitud", en: "New request" },
    adm_ev_assigned: { es: "Aviso al profesional", en: "Provider notice" },
    adm_ev_proposal_review: { es: "Propuesta a revisar", en: "Proposal to review" },
    adm_ev_proposal_ready: { es: "Propuesta al cliente", en: "Proposal to client" },
    adm_ev_deposit: { es: "Contactos mutuos", en: "Mutual contacts" },
    adm_ev_clarify: { es: "Aclaración pedida por el profesional", en: "Clarification requested by the professional" },
    adm_clarifyHint: { es: "La pregunta te ha llegado por email a hola@retaillemon.com.", en: "The question was emailed to hola@retaillemon.com." },
    pt_modeProposal: { es: "Enviar propuesta", en: "Send proposal" },
    pt_modeClarify: { es: "Pedir aclaración", en: "Ask for clarification" },
    pt_fees: { es: "Honorarios estimados", en: "Estimated fees" },
    pt_serviceHint: { es: "Explica qué harás, qué incluye y plazos. Usa una línea por punto; empieza con «- » para hacer una lista.", en: "Explain what you'll do, what's included and timing. One line per point; start with \"- \" for a list." },
    pt_previewLabel: { es: "Así lo verá el cliente", en: "How the client will see it" },
    pt_avgLabel: { es: "Precio medio", en: "Average price" },
    pt_depositDeducted: { es: "se descuenta del pago final al profesional", en: "deducted from the final payment to the professional" },
    pt_formatBar: { es: "Formato del texto", en: "Text formatting" },
    pt_fmt_bold: { es: "Negrita", en: "Bold" },
    pt_fmt_h: { es: "Título", en: "Heading" },
    pt_fmt_ul: { es: "Viñetas", en: "Bullet list" },
    pt_fmt_ol: { es: "Lista numerada", en: "Numbered list" },
    pt_formatHint: { es: "Selecciona texto y pulsa un botón. También puedes pegar desde Word: cada línea se respeta.", en: "Select text and press a button. You can also paste from Word: every line is kept." },
    pt_previewBtn: { es: "Previsualizar", en: "Preview" },
    pt_hidePreview: { es: "Ocultar vista previa", en: "Hide preview" },
    pt_previewFirst: { es: "Previsualiza tu propuesta antes de enviarla a revisión.", en: "Preview your proposal before sending it for review." },
    adm_clientSaid: { es: "Cliente indicó", en: "Client said" },
    adm_backToBoard: { es: "Volver al tablero", en: "Back to board" },
    adm_notesTitle: { es: "Notas internas RL", en: "RL internal notes" },
    adm_notesHint: { es: "Solo las ve el equipo de Retail Lemon. Ni cliente ni profesional.", en: "Only the Retail Lemon team sees these. Never the client or the professional." },
    adm_notesPh: { es: "Lo hablado, sensaciones, condiciones especiales, recordatorios…", en: "What was discussed, impressions, special terms, reminders…" },
    adm_notesSaved: { es: "Nota guardada", en: "Note saved" },
    adm_searchProv: { es: "Buscar por nombre, empresa, email o especialidad", en: "Search by name, company, email or specialty" },
    adm_allStatuses: { es: "Todos los estados", en: "All statuses" },
    adm_noMatch: { es: "Ningún profesional coincide con el filtro", en: "No professional matches the filter" },
    adm_pageTitle: { es: "Página del colaborador", en: "Partner page" },
    adm_unassigned: { es: "Sin asignar", en: "Unassigned" },
    turn_all: { es: "Abiertos", en: "Open" },
    turn_rl: { es: "Te toca a ti", en: "Your turn" },
    turn_provider: { es: "Esperando profesional", en: "Waiting for professional" },
    turn_client: { es: "Esperando pago cliente", en: "Waiting for client payment" },
    turn_active: { es: "En marcha", en: "In progress" },
    turn_closed: { es: "Cerrados", en: "Closed" },
    board_allAreas: { es: "Todas las áreas", en: "All areas" },
    board_sort: { es: "Ordenar", en: "Sort" },
    board_sortNew: { es: "Más recientes", en: "Newest" },
    board_sortOld: { es: "Más antiguos", en: "Oldest" },
    board_sortArea: { es: "Por área", en: "By area" },
    board_hint: { es: "Arrastra las tarjetas entre columnas para fijar vuestra prioridad. La urgencia del cliente no cambia. Punto: gris < 24 h, ámbar < 72 h, rojo parado.", en: "Drag cards between columns to set your priority. The client's urgency never changes. Dot: grey < 24 h, amber < 72 h, red stalled." },
    board_emptyCol: { es: "Nada por aquí", en: "Nothing here" },
    board_idle: { es: "Sin movimiento", en: "Idle" },
    board_reclassified: { es: "Reclasificado", en: "Reclassified" },
    board_internal: { es: "Prioridad interna", en: "Internal priority" },
    pt_clarifyHint: { es: "¿Te falta algún dato para dar precio? Escríbelo: llega a Retail Lemon, se lo preguntamos al cliente y te pasamos la respuesta.", en: "Missing something to quote? Write it: it goes to Retail Lemon, we ask the client and pass the answer on." },
    pt_clarifySend: { es: "Enviar a Retail Lemon", en: "Send to Retail Lemon" },
    pt_clarifySent: { es: "Aclaración enviada a Retail Lemon", en: "Clarification sent to Retail Lemon" },
    pt_clarifyPending: { es: "Aclaración pedida: esperando respuesta de Retail Lemon", en: "Clarification requested: waiting for Retail Lemon" },
    pt_sortUrgent: { es: "Urgentes primero", en: "Urgent first" },
    pt_sortDate: { es: "Más recientes", en: "Newest" },
    pt_expand: { es: "Abrir caso", en: "Open case" },
    pt_collapse: { es: "Minimizar", en: "Minimize" },
    pt_previewDisabled: { es: "Vista previa: el envío está desactivado.", en: "Preview: sending is disabled." },
    adm_ev_null: { es: "—", en: "—" },
    adm_resendProvider: { es: "Reenviar aviso al profesional", en: "Resend to professional" },
    adm_resendClient: { es: "Reenviar propuesta al cliente", en: "Resend proposal to client" },
    adm_resendContacts: { es: "Reenviar contactos mutuos", en: "Resend mutual contacts" },
    adm_noticeSent: { es: "Aviso enviado por email", en: "Email notice sent" },
    adm_noticeFail: { es: "El aviso no ha salido. Revisa el email del destinatario y reintenta.", en: "The notice didn't go out. Check the recipient email and retry." },
    adm_markManual: { es: "Marcar señal cobrada a mano", en: "Mark deposit as paid manually" },
    adm_manualConfirm: { es: "¿Confirmas que la señal está cobrada? Se desbloquean los contactos y se avisa a ambos.", en: "Confirm the deposit is paid? Contacts unlock and both parties get notified." },
    adm_manual: { es: "manual", en: "manual" },
    pt_myProposals: { es: "Tus propuestas", en: "Your proposals" },
    pt_signout: { es: "Salir", en: "Sign out" },
    title: { es: "Pide ayuda a un profesional retail", en: "Ask a retail professional" },
    intro: { es: "Cuéntanos tu caso. Buscamos al especialista, revisamos su propuesta y te la enseñamos. Pedirla no cuesta nada.", en: "Tell us your case. We find the specialist, review their proposal and show it to you. Asking is free." },
    area: { es: "Área", en: "Area" },
    description: { es: "Tu caso", en: "Your case" },
    descriptionPh: { es: "Explícalo como se lo contarías a alguien de confianza (mínimo 20 caracteres). No pongas teléfonos ni emails.", en: "Explain it as you would to someone you trust (at least 20 characters). No phone numbers or emails." },
    urgency: { es: "Urgencia", en: "Urgency" },
    urgNormal: { es: "Normal", en: "Normal" },
    urgPronto: { es: "Urgente", en: "Urgent" },
    urgUrgente: { es: "Muy urgente", en: "Very urgent" },
    city: { es: "Ciudad (opcional)", en: "City (optional)" },
    short_mercantil: { es: "Legal y contratos", en: "Legal & contracts" },
    short_licencias: { es: "Licencias", en: "Licences" },
    short_laboral: { es: "Laboral", en: "Employment" },
    short_fiscal: { es: "Fiscal", en: "Tax" },
    short_reformas: { es: "Reformas y obras", en: "Works & fit-out" },
    tabServices: { es: "Servicios profesionales", en: "Professional services" },
    tabProducts: { es: "Productos y compras", en: "Products & purchasing" },
    send: { es: "Enviar solicitud", en: "Send request" },
    sent: { es: "Solicitud enviada. Te avisamos cuando haya propuesta revisada.", en: "Request sent. We'll let you know when a reviewed proposal is ready." },
    sendError: { es: "No se ha podido enviar. Inténtalo otra vez.", en: "Couldn't send it. Please try again." },
    draftLoaded: { es: "Hemos recuperado el caso que escribiste en la web.", en: "We've recovered the case you wrote on the website." },
    myRequests: { es: "Mis solicitudes", en: "My requests" },
    none: { es: "Aún no has pedido ayuda a un profesional.", en: "You haven't asked a professional yet." },
    loadError: { es: "No hemos podido cargar tus solicitudes.", en: "We couldn't load your requests." },
    retry: { es: "Reintentar", en: "Retry" },
    proposalsTitle: { es: "Propuestas revisadas por Retail Lemon", en: "Proposals reviewed by Retail Lemon" },
    priceRange: { es: "Precio orientativo", en: "Estimated price" },
    deposit: { es: "Señal de reserva (se descuenta del total)", en: "Booking deposit (deducted from total)" },
    why: { es: "Por qué este profesional", en: "Why this professional" },
    st_new: { es: "Recibida", en: "Received" },
    st_searching: { es: "Buscando profesional", en: "Finding a professional" },
    st_proposals_ready: { es: "Propuesta lista", en: "Proposal ready" },
    st_accepted: { es: "Aceptada", en: "Accepted" },
    st_closed: { es: "Cerrada", en: "Closed" },
    st_discarded: { es: "Descartada", en: "Discarded" },
    adm_title: { es: "Profesionales retail", en: "Retail professionals" },
    adm_requests: { es: "Solicitudes", en: "Requests" },
    adm_providers: { es: "Profesionales", en: "Professionals" },
    adm_areas: { es: "Áreas y % de señal", en: "Areas and deposit %" },
    adm_newProvider: { es: "Añadir profesional", en: "Add professional" },
    adm_name: { es: "Nombre o despacho", en: "Name or firm" },
    adm_specialty: { es: "Especialidad", en: "Specialty" },
    adm_experience: { es: "Experiencia en retail (casos)", en: "Retail experience (cases)" },
    adm_email: { es: "Email interno (no se muestra al cliente)", en: "Internal email (never shown to client)" },
    adm_commission: { es: "Comisión %", en: "Commission %" },
    adm_save: { es: "Guardar", en: "Save" },
    adm_status: { es: "Estado", en: "Status" },
    adm_pending: { es: "Pendiente", en: "Pending" },
    adm_verified: { es: "Verificado", en: "Verified" },
    adm_suspended: { es: "Suspendido", en: "Suspended" },
    adm_addProposal: { es: "Añadir propuesta del profesional", en: "Add professional's proposal" },
    adm_min: { es: "Precio mínimo (€)", en: "Min price (€)" },
    adm_max: { es: "Precio máximo (€)", en: "Max price (€)" },
    adm_rangeHint: { es: "Horquilla máxima: el máximo no puede superar el mínimo en más de un 25 %.", en: "Max range: the top price can't exceed the minimum by more than 25%." },
    adm_advantages: { es: "Propuesta del servicio y qué incluye", en: "Service proposal and what's included" },
    adm_scope: { es: "Qué incluye", en: "What's included" },
    adm_depositPct: { es: "% de señal (vacío = el del área)", en: "Deposit % (empty = area default)" },
    adm_publish: { es: "Validar y publicar al cliente", en: "Validate and publish to client" },
    adm_inReview: { es: "En revisión", en: "In review" },
    adm_published: { es: "Publicada", en: "Published" },
    adm_flagged: { es: "Contiene teléfono, email o web: edítalo antes de publicar.", en: "Contains a phone, email or website: edit before publishing." },
    adm_errRange: { es: "La horquilla supera el 25 % o el máximo es menor que el mínimo.", en: "Range over 25% or max below min." },
    adm_errContact: { es: "No se puede publicar: hay datos de contacto en el texto.", en: "Can't publish: contact details found in the text." },
    adm_saved: { es: "Guardado", en: "Saved" },
    adm_assign: { es: "Profesional asignado", en: "Assigned professional" },
    adm_client: { es: "Cliente", en: "Client" },
    adm_empty: { es: "Todavía no hay solicitudes.", en: "No requests yet." },
    adm_noProviders: { es: "Todavía no hay profesionales.", en: "No professionals yet." },
    adm_none: { es: "Sin asignar", en: "Unassigned" },
    pt_badge: { es: "Solo profesionales homologados", en: "Approved professionals only" },
    pt_email: { es: "Email profesional", en: "Professional email" },
    pt_password: { es: "Contraseña", en: "Password" },
    pt_loginBtn: { es: "Acceder a mis casos", en: "Open my cases" },
    pt_forgot: { es: "¿Has olvidado tu contraseña?", en: "Forgot your password?" },
    pt_forgotSent: { es: "Si el email está dado de alta, te llegará un enlace para crear una contraseña nueva.", en: "If the email is registered, you'll get a link to set a new password." },
    pt_needEmail: { es: "Escribe primero tu email profesional.", en: "Type your professional email first." },
    pt_loginError: { es: "Email o contraseña incorrectos. Si es tu primera vez, usa el enlace que te enviamos.", en: "Wrong email or password. First time? Use the link we emailed you." },
    pt_firstTime: { es: "¿Primera vez? Abre el enlace que te enviamos por email para crear tu contraseña.", en: "First time? Open the link we emailed you to set your password." },
    ap_title: { es: "¿Quieres colaborar con Retail Lemon?", en: "Want to partner with Retail Lemon?" },
    ap_text: { es: "Si eres profesional del comercio (abogado, gestor, arquitecto, reformas…), cuéntanos quién eres. Revisamos cada solicitud a mano y te escribimos.", en: "If you're a retail professional (lawyer, advisor, architect, fit-out…), tell us who you are. We review every request by hand and get back to you." },
    ap_open: { es: "Solicitar ser colaborador", en: "Apply as a partner" },
    ap_name: { es: "Nombre o despacho", en: "Name or firm" },
    ap_area: { es: "Área", en: "Area" },
    ap_city: { es: "Ciudad", en: "City" },
    ap_phone: { es: "Teléfono (opcional)", en: "Phone (optional)" },
    ap_exp: { es: "Experiencia con comercios (breve)", en: "Retail experience (short)" },
    ap_send: { es: "Enviar solicitud", en: "Send request" },
    ap_sent: { es: "¡Recibido! Te escribiremos en cuanto la revisemos.", en: "Got it! We'll write as soon as we review it." },
    ap_error: { es: "No se ha podido enviar. Revisa el email y prueba otra vez.", en: "Couldn't send. Check the email and try again." },
    adm_applications: { es: "Solicitudes de colaboradores", en: "Partner applications" },
    adm_noApplications: { es: "No hay solicitudes de colaboradores.", en: "No partner applications." },
    adm_approve: { es: "Aprobar y enviar acceso", en: "Approve and send access" },
    adm_reject: { es: "Descartar", en: "Discard" },
    adm_approved: { es: "Aprobada", en: "Approved" },
    adm_rejected: { es: "Descartada", en: "Discarded" },
    adm_user: { es: "Usuario de acceso", en: "Login user" },
    adm_accActive: { es: "Activo: ya ha entrado", en: "Active: has signed in" },
    adm_accPending: { es: "Sin acceso enviado", en: "No access sent" },
    adm_accSent: { es: "Enlace enviado, pendiente de entrar", en: "Link sent, not signed in yet" },
    adm_sendAccess: { es: "Enviar acceso", en: "Send access" },
    adm_resendAccess: { es: "Reenviar enlace / nueva contraseña", en: "Resend link / new password" },
    adm_accessSent: { es: "Enlace de acceso enviado", en: "Access link sent" },
    adm_accessFail: { es: "No se ha podido enviar el enlace", en: "Couldn't send the link" },
    adm_noEmail: { es: "Falta un email válido del profesional", en: "The professional needs a valid email" },
    adm_edit: { es: "Editar", en: "Edit" },
    adm_cancel: { es: "Cancelar", en: "Cancel" },
    adm_noLoginEmail: { es: "Falta indicar el email de acceso", en: "Login email missing" },
    adm_password: { es: "Contraseña", en: "Password" },
    adm_passwordPh: { es: "Escribe una contraseña (mín. 8)", en: "Type a password (min. 8)" },
    adm_generate: { es: "Generar segura", en: "Generate secure" },
    adm_setPassword: { es: "Guardar contraseña", en: "Save password" },
    adm_passwordSaved: { es: "Contraseña guardada. Cópiala ahora: luego no se podrá volver a ver.", en: "Password saved. Copy it now: it can't be shown again." },
    adm_passwordFail: { es: "No se ha podido guardar la contraseña", en: "Couldn't save the password" },
    adm_passwordShort: { es: "La contraseña necesita al menos 8 caracteres", en: "Password needs at least 8 characters" },
    adm_copyCreds: { es: "Copiar usuario y contraseña", en: "Copy user and password" },
    adm_copied: { es: "Copiado", en: "Copied" },
    adm_credsHint: { es: "Por seguridad la contraseña no se guarda legible: puedes cambiarla cuando quieras.", en: "For security the password isn't stored readable: you can change it anytime." },
    pv_banner: { es: "Vista previa de administrador: viendo como {name} (solo lectura)", en: "Admin preview: viewing as {name} (read-only)" },
    pv_back: { es: "Volver al Back Office", en: "Back to back office" },
    pv_formHidden: { es: "En la vista previa no se pueden enviar propuestas.", en: "Proposals can't be sent in preview." },
    pv_menu: { es: "Ver como colaborador", en: "View as partner" },
    pv_open: { es: "Ver página", en: "View page" },
    adm_welcomeToggle: { es: "Enviarle email de bienvenida con su acceso", en: "Send welcome email with access" },
    adm_welcomeSent: { es: "Guardado y email de bienvenida enviado", en: "Saved and welcome email sent" },
    adm_signalBtn: { es: "Señal por área", en: "Deposit by area" },
    adm_errNoProvider: { es: "Selecciona primero a qué profesional asignas la propuesta.", en: "First pick which professional this proposal belongs to." },
    adm_errNoAdvantages: { es: "Escribe la propuesta del servicio antes de guardar.", en: "Write the service proposal before saving." },
    adm_pickProvider: { es: "Elige un profesional…", en: "Pick a professional…" },
    adm_clear: { es: "Limpiar", en: "Clear" },
    step_1: { es: "Recibida", en: "Received" },
    step_2: { es: "Con el profesional", en: "With the professional" },
    step_3: { es: "Propuesta al cliente", en: "Proposal sent" },
    step_4: { es: "Señal pagada · contactos", en: "Deposit paid · contacts" },
    stepOf: { es: "Paso {n} de 4", en: "Step {n} of 4" },
    adm_editRequest: { es: "Editar solicitud", en: "Edit request" },
    adm_area: { es: "Área", en: "Area" },
    adm_urgency: { es: "Urgencia", en: "Urgency" },
    adm_otherArea: { es: "Otras áreas", en: "Other areas" },
    adm_sameArea: { es: "Misma área", en: "Same area" },
    remainLabel: { es: "Pagarás al profesional", en: "You'll pay the professional" },
    discountNote: { es: "La señal de {dep} queda reservada y se resta del total. Al profesional solo le pagas la diferencia.", en: "The {dep} deposit is reserved and deducted from the total. You only pay the professional the difference." },
    totalLabel: { es: "Precio total orientativo", en: "Estimated total price" },
    contactNow: { es: "Ya puedes contactar con tu profesional", en: "You can now contact your professional" },
    downloadPdf: { es: "Descargar ficha y comprobante (PDF)", en: "Download sheet and receipt (PDF)" },
    pdfTitle: { es: "Ficha de propuesta y comprobante de señal", en: "Proposal sheet and deposit receipt" },
    pdfRef: { es: "Referencia", en: "Reference" },
    pdfDate: { es: "Fecha", en: "Date" },
    pdfRequest: { es: "Tu solicitud", en: "Your request" },
    pdfScope: { es: "Qué incluye", en: "What's included" },
    pdfEconomy: { es: "Constancia económica", en: "Payment record" },
    pdfPaidOn: { es: "Señal pagada el", en: "Deposit paid on" },
    pdfClause: { es: "Retail Lemon certifica que esta señal se ha pagado y debe descontarse del importe final que facture el profesional.", en: "Retail Lemon certifies this deposit has been paid and must be deducted from the professional's final invoice." },
    pdfContact: { es: "Contacto del profesional", en: "Professional's contact" },
    pdfError: { es: "No hemos podido crear el PDF.", en: "We couldn't create the PDF." },
    adm_signalHint: { es: "Lo que paga el cliente al aceptar un presupuesto. Se aplica por defecto a cada propuesta del área.", en: "What the client pays when accepting a quote. Default for each proposal in the area." },
    adm_colName: { es: "Profesional", en: "Professional" },
    adm_colArea: { es: "Área", en: "Area" },
    adm_colAccess: { es: "Acceso", en: "Access" },
    adm_show: { es: "Mostrar", en: "Show" },
    adm_hide: { es: "Ocultar", en: "Hide" },
    adm_commissionHint: { es: "Comisión %: lo que el profesional paga a Retail Lemon (privado). La señal del cliente se fija en Áreas.", en: "Commission %: what the professional pays Retail Lemon (private). The client's deposit is set in Areas." },
  },

  adminCopilot: {
    today: { es: "¿Qué hay pendiente hoy?", en: "What's pending today?" },
    todayPrompt: { es: "Dame el parte operativo de hoy: ordena lo pendiente en Urgente, Comercial y Gestión, y dime qué hago primero.", en: "Give me today's operations brief: sort pending items into Urgent, Sales and Admin, and tell me what to do first." },
    draft: { es: "Redactar respuesta", en: "Draft a reply" },
    draftPrompt: { es: "Ayúdame a redactar una respuesta. Te pego el mensaje del cliente o proveedor a continuación:", en: "Help me draft a reply. Here's the client or supplier message:" },
    copy: { es: "Copiar borrador", en: "Copy draft" },
    copied: { es: "Copiado", en: "Copied" },
    attach: { es: "Adjuntar foto", en: "Attach photo" },
    imageTooBig: { es: "La imagen supera 5 MB", en: "Image is over 5 MB" },
    placeholder: { es: "Pregunta, pega un mensaje o sube una foto del local…", en: "Ask, paste a message or upload a store photo…" },
    imageOnly: { es: "Analiza esta foto con ojo de retail.", en: "Analyse this photo with a retail eye." },
    neverSends: { es: "Prepara borradores; nunca envía nada por ti.", en: "Prepares drafts; never sends anything for you." },
    title: { es: "Copiloto Operativo", en: "Operations Copilot" },
    subtitle: { es: "Tu día ordenado: urgente, comercial y colaboradores.", en: "Your day sorted: urgent, sales and partners." },
    back: { es: "Volver", en: "Back" },
    urgent: { es: "Urgente hoy", en: "Urgent today" },
    sales: { es: "Comercial", en: "Sales" },
    partners: { es: "Colaboradores", en: "Partners" },
    allClear: { es: "Todo al día", en: "All clear" },
    noData: { es: "No se han podido leer las cifras", en: "Couldn't read the figures" },
    guided: { es: "Guíame paso a paso", en: "Guide me step by step" },
    other: { es: "Ayuda de configuración", en: "Setup help" },
    go: { es: "Ir", en: "Go" },
    goTo: { es: "Ir a", en: "Go to" },
    iProposals: { es: "Propuestas de profesionales por revisar", en: "Partner proposals to review" },
    iRequests: { es: "Solicitudes de clientes sin asignar", en: "Client requests to assign" },
    iVip: { es: "Sesiones VIP por confirmar", en: "VIP sessions to confirm" },
    iEscalations: { es: "Preguntas de clientes sin responder", en: "Unanswered client questions" },
    iLeads: { es: "Leads de contacto nuevos", en: "New contact leads" },
    iWaitlist: { es: "Personas en lista de espera", en: "People on the waitlist" },
    iSignups: { es: "Altas en las últimas 24 h", en: "Sign-ups in the last 24 h" },
    iApplications: { es: "Solicitudes para ser colaborador", en: "Partner applications" },
    gInsights: { es: "Publicar un artículo en Insights", en: "Publish an Insights article" },
    gInsightsPrompt: { es: "Estoy en /admin/insights. Guíame paso a paso, con pasos numerados y cortos, para publicar un artículo nuevo.", en: "I'm on /admin/insights. Guide me with short numbered steps to publish a new article." },
    gWaitlist: { es: "Gestionar la lista de espera", en: "Manage the waitlist" },
    gWaitlistPrompt: { es: "Estoy en /admin/waitlist. Guíame paso a paso, con pasos numerados y cortos, para revisar y dar acceso a quien espera.", en: "I'm on /admin/waitlist. Guide me with short numbered steps to review and grant access." },
    gExperts: { es: "Revisar propuestas de profesionales", en: "Review partner proposals" },
    gExpertsPrompt: { es: "Estoy en /admin/profesionales. Guíame paso a paso, con pasos numerados y cortos, para revisar y publicar una propuesta o asignar una solicitud.", en: "I'm on /admin/profesionales. Guide me with short numbered steps to review a proposal or assign a request." },
  },

  // ── Localized routes ──
  routes: {
    calcPublic:        { es: "/herramientas/calculadora", en: "/en/tools/calculator" },
    locationDiagnosis: { es: "/diagnostico-locales-comerciales", en: "/en/retail-location-analysis" },
    thermometer:       { es: "/detector-de-fugas",                 en: "/en/leak-detector" },
    mentoring:         { es: "/mentoria-retail",                  en: "/en/mentoring" },
    howItWorks:        { es: "/como-funciona",                    en: "/en/how-it-works" },
    survivalTest:      { es: "/lp/test-supervivencia",               en: "/en/retail-survival-test" },
    strategy:          { es: "/estrategia",                       en: "/en/strategy" },
    aiAgent:           { es: "/agente-retail-ia",                 en: "/en/retail-ai-agent" },
    aiAgentInfo:       { es: "/que-es-el-agente-retail-ia",       en: "/en/what-is-the-retail-ai-agent" },
    pricing:           { es: "/tarifas",                          en: "/en/pricing" },
    everythingForShop: { es: "/todo-para-tu-comercio",             en: "/en/everything-for-your-store" },
    storeProblems:     { es: "/problemas-en-mi-tienda",            en: "/en/store-problems" },
    openStoreSpain:    { es: "/abrir-tienda-en-espana",            en: "/en/open-a-store-in-spain" },


    chains:            { es: "/cadenas-y-franquicias",            en: "/en/chains-and-franchises" },
    familyOffices:     { es: "/family-offices-inversores",        en: "/en/family-offices-investors" },
    insights:          { es: "/insights",                          en: "/en/insights" },
    tips:              { es: "/consejos",                          en: "/en/tips" },
    cases:             { es: "/casos-reales",                      en: "/en/real-cases" },
    answers:           { es: "/consultas-resueltas",               en: "/en/answers" },
    retailExperts:     { es: "/profesionales-retail",              en: "/en/retail-experts" },
    partners:          { es: "/colaboradores",                     en: "/en/partners" },
    contact:           { es: "/contacto",                          en: "/en/contact" },
    faq:               { es: "/faq",                                en: "/en/faq" },
    grants:            { es: "/recursos/subvenciones",             en: "/en/resources/subsidies" },
    legal:             { es: "/aviso-legal",                       en: "/en/legal-notice" },
    privacy:           { es: "/privacidad",                        en: "/en/privacy-policy" },
    cookies:           { es: "/cookies",                           en: "/en/cookies" },
    terms:             { es: "/condiciones-contratacion",          en: "/en/terms" },
  },

  // ── Onboarding flow (full-page) ──
  onboardingPage: {
    stepLabel: { es: "Paso {step} de {total}", en: "Step {step} of {total}" },
    welcome: { es: "Bienvenido a tu Panel de Retail", en: "Welcome to your Retail Panel" },
    welcomeSub: { es: "Vamos a personalizar tu experiencia. Empecemos por lo básico.", en: "Let's personalize your experience. Let's start with the basics." },
    fullName: { es: "Nombre y Apellidos *", en: "Full name *" },
    companyName: { es: "Nombre de la Empresa o Marca *", en: "Company or brand name *" },
    websiteLabel: { es: "Página Web", en: "Website" },
    noWebsite: { es: "Aún no tengo página web", en: "I don't have a website yet" },
    continue: { es: "Continuar", en: "Continue" },
    roleQuestion: { es: "¿Cuál es tu rol principal en el negocio?", en: "What is your main role in the business?" },
    physicalQuestion: { es: "¿Operáis actualmente con tiendas físicas?", en: "Do you currently operate physical stores?" },
    challengeQuestion: { es: "¿Dónde necesitas poner el foco ahora mismo?", en: "Where do you need to focus right now?" },
    back: { es: "← Volver", en: "← Back" },
    saving: { es: "Guardando...", en: "Saving..." },
    finish: { es: "Guardar y entrar al Panel ➔", en: "Save and enter the Panel ➔" },
    skipForNow: { es: "Saltar por ahora", en: "Skip for now" },
    errFullName: { es: "Introduce tu nombre y apellidos.", en: "Please enter your full name." },
    errCompany: { es: "Introduce el nombre de tu empresa o marca.", en: "Please enter your company or brand name." },
    errSave: { es: "Error al guardar. Inténtalo de nuevo.", en: "Failed to save. Please try again." },
    roles: {
      es: ["CEO / Propietario", "Operaciones / Tienda", "Emprendedor (Nueva marca)", "Digital / Ecommerce", "Otro"],
      en: ["CEO / Owner", "Operations / Store", "Entrepreneur (New brand)", "Digital / Ecommerce", "Other"],
    },
    physicalOptions: {
      es: ["Próxima apertura (Proyecto)", "1 local", "2 a 5 locales", "Más de 5 locales"],
      en: ["Upcoming opening (Project)", "1 store", "2 to 5 stores", "More than 5 stores"],
    },
    challenges: {
      es: [
        { key: "trafico", label: "Tráfico y Clientes", desc: "Atraer más tráfico y clientes al local" },
        { key: "rentabilidad", label: "Rentabilidad", desc: "Aumentar la rentabilidad y los márgenes" },
        { key: "equipo", label: "Equipo", desc: "Mejorar la gestión y motivación del equipo" },
        { key: "compras", label: "Compras y Stock", desc: "Optimizar compras, stock y proveedores" },
        { key: "expansion", label: "Expansión", desc: "Expansión y apertura de nuevas tiendas" },
      ],
      en: [
        { key: "trafico", label: "Traffic & Customers", desc: "Drive more traffic and customers to the store" },
        { key: "rentabilidad", label: "Profitability", desc: "Increase profitability and margins" },
        { key: "equipo", label: "Team", desc: "Improve team management and motivation" },
        { key: "compras", label: "Purchasing & Stock", desc: "Optimize purchasing, stock and suppliers" },
        { key: "expansion", label: "Expansion", desc: "Expansion and opening of new stores" },
      ],
    },
  },

  // ── Profile page extras ──
  profilePage: {
    noName: { es: "Sin nombre", en: "No name" },
    memberSince: { es: "Miembro desde", en: "Member since" },
    tabPersonal: { es: "Información Personal", en: "Personal Info" },
    tabCommercial: { es: "Perfil Comercial", en: "Business Profile" },
    tabBilling: { es: "Facturación", en: "Billing" },
    tabHours: { es: "Horas", en: "Hours" },
    tabNotifications: { es: "Notificaciones", en: "Notifications" },
    tabInvoices: { es: "Facturas", en: "Invoices" },
    headingPersonal: { es: "Información Personal", en: "Personal Info" },
    headingCommercial: { es: "Perfil Comercial", en: "Business Profile" },
    companyOrBrand: { es: "Empresa o Marca", en: "Company or Brand" },
    companyPlaceholder: { es: "Mi Marca S.L.", en: "My Brand Inc." },
    sectorLabel: { es: "Sector Comercial", en: "Business Sector" },
    sectorPlaceholder: { es: "Selecciona tu sector", en: "Select your sector" },
    websiteLabel: { es: "Página Web", en: "Website" },
    noWebsite: { es: "Aún no tengo página web", en: "I don't have a website yet" },
    roleLabel: { es: "Rol Principal", en: "Main Role" },
    rolePlaceholder: { es: "Selecciona tu rol", en: "Select your role" },
    physicalLabel: { es: "Presencia Física", en: "Physical Presence" },
    physicalPlaceholder: { es: "Selecciona una opción", en: "Select an option" },
    challengeLabel: { es: "Reto Principal", en: "Main Challenge" },
    challengePlaceholder: { es: "Selecciona tu reto actual", en: "Select your current challenge" },
    pendingComplete: { es: "Pendiente de completar", en: "Pending to complete" },
    invoicesTitle: { es: "Facturas y Pagos", en: "Invoices & Payments" },
    invoicesDesc: { es: "Accede al portal de facturación para consultar y descargar tus facturas, actualizar tu método de pago o gestionar tu suscripción.", en: "Access the billing portal to view and download your invoices, update your payment method, or manage your subscription." },
    portalOpen: { es: "Abrir portal de facturación", en: "Open billing portal" },
    portalOpening: { es: "Abriendo...", en: "Opening..." },
    portalError: { es: "Error al abrir el portal", en: "Failed to open portal" },
  },

  // ── Billing form ──
  billingForm: {
    title: { es: "Datos de Facturación", en: "Billing Information" },
    desc: { es: "Estos datos se usarán para generar tus facturas y calcular el IVA correctamente.", en: "This information will be used to generate your invoices and calculate VAT correctly." },
    company: { es: "Empresa / Razón Social", en: "Company / Legal Name" },
    companyPlaceholder: { es: "Mi Empresa S.L.", en: "My Company Inc." },
    taxId: { es: "NIF / CIF / VAT ID", en: "Tax ID / VAT ID" },
    taxIdPlaceholder: { es: "B12345678 o ES12345678", en: "B12345678 or ES12345678" },
    taxIdNote: { es: "Para clientes UE intracomunitarios usa el formato con prefijo de país (ej: FR12345678)", en: "For intra-EU customers, use the country-prefix format (e.g. FR12345678)" },
    billingEmail: { es: "Email de facturación", en: "Billing email" },
    billingEmailPlaceholder: { es: "facturacion@empresa.com", en: "billing@company.com" },
    addressTitle: { es: "Dirección fiscal", en: "Fiscal address" },
    addressLine1: { es: "Dirección", en: "Address" },
    addressLine1Placeholder: { es: "Calle Mayor 1, Planta 3", en: "123 Main St, Floor 3" },
    addressLine2: { es: "Dirección (línea 2)", en: "Address (line 2)" },
    addressLine2Placeholder: { es: "Oficina 5 (opcional)", en: "Suite 5 (optional)" },
    city: { es: "Ciudad", en: "City" },
    postalCode: { es: "Código Postal", en: "Postal Code" },
    state: { es: "Provincia / Estado", en: "Province / State" },
    country: { es: "País", en: "Country" },
    save: { es: "Guardar datos de facturación", en: "Save billing details" },
    saving: { es: "Guardando...", en: "Saving..." },
    errSave: { es: "Error al guardar datos de facturación", en: "Failed to save billing details" },
    okSave: { es: "Datos de facturación guardados", en: "Billing details saved" },
    countries: {
      es: { ES: "España", PT: "Portugal", FR: "Francia", DE: "Alemania", IT: "Italia", NL: "Países Bajos", BE: "Bélgica", AT: "Austria", IE: "Irlanda", GB: "Reino Unido", US: "Estados Unidos", OTHER: "Otro" },
      en: { ES: "Spain", PT: "Portugal", FR: "France", DE: "Germany", IT: "Italy", NL: "Netherlands", BE: "Belgium", AT: "Austria", IE: "Ireland", GB: "United Kingdom", US: "United States", OTHER: "Other" },
    },
  },

  // ── Edit business profile modal ──
  editBiz: {
    title: { es: "Editar Perfil Comercial", en: "Edit Business Profile" },
    logoLabel: { es: "Logo del negocio", en: "Business logo" },
    onlyImages: { es: "Solo se permiten imágenes", en: "Only images are allowed" },
    maxSize: { es: "La imagen no puede superar 2MB", en: "Image cannot exceed 2MB" },
    uploadErr: { es: "Error al subir logo", en: "Failed to upload logo" },
    uploading: { es: "Subiendo...", en: "Uploading..." },
    uploadImg: { es: "Subir imagen", en: "Upload image" },
    nameLabel: { es: "Nombre del Negocio", en: "Business Name" },
    namePlaceholder: { es: "Mi Tienda", en: "My Store" },
    sectorLabel: { es: "Sector", en: "Sector" },
    sectorPlaceholder: { es: "Selecciona un sector", en: "Select a sector" },
    save: { es: "Guardar Cambios", en: "Save Changes" },
    saving: { es: "Guardando...", en: "Saving..." },
    errSave: { es: "Error al guardar", en: "Failed to save" },
    okSave: { es: "Perfil actualizado ✓", en: "Profile updated ✓" },
  },

  // ── Reset password ──
  resetPassword: {
    minLen: { es: "La contraseña debe tener al menos 6 caracteres", en: "Password must be at least 6 characters" },
    noMatch: { es: "Las contraseñas no coinciden", en: "Passwords do not match" },
    okUpdated: { es: "Contraseña actualizada correctamente", en: "Password updated successfully" },
    successTitle: { es: "¡Contraseña actualizada!", en: "Password updated!" },
    redirecting: { es: "Redirigiendo al panel...", en: "Redirecting to dashboard..." },
    title: { es: "Nueva contraseña", en: "New password" },
    sub: { es: "Elige tu nueva contraseña para RetailLemon", en: "Choose your new password for RetailLemon" },
    newPassword: { es: "Nueva contraseña", en: "New password" },
    confirm: { es: "Confirmar contraseña", en: "Confirm password" },
    updating: { es: "Actualizando...", en: "Updating..." },
    update: { es: "Actualizar contraseña", en: "Update password" },
  },

  // ── Mentoria page ──
  mentoriaPage: {
    seoDesc: { es: "Mentoría retail como extra desde el plan Avanzado (Básico 39 €, Club Pro 69 €, Avanzado 99 €/mes, sin permanencia). Verás el precio antes de pagar.", en: "Retail mentoring as an extra from the Advanced plan (Basic €39, Club Pro €69, Advanced €99/month, no commitment). You see the price before paying." },
    heroSub: { es: "Acompañamiento experto y permanente para tu negocio retail. Planes de mentoría adaptados a cada fase.", en: "Expert and ongoing support for your retail business. Mentoring plans tailored to each phase." },
    intro: { es: "Elige el plan que se adapta a tu fase de negocio. Desde validación de ideas hasta dirección retail externalizada.", en: "Choose the plan that fits your business phase. From idea validation to outsourced retail management." },
    benefit1Title: { es: "Para cualquier fase", en: "For any phase" },
    benefit1Desc: { es: "Desde la idea inicial hasta la expansión multi-tienda.", en: "From the initial idea to multi-store expansion." },
  },

  // ── Dashboard hero ──
  dashboardHero: {
    myBusiness: { es: "Mi Negocio", en: "My Business" },
  },

  // ── Library section ──
  libraryPage: {
    intro: { es: "Todo el conocimiento estratégico, manuales y herramientas para tu negocio.", en: "All strategic knowledge, manuals and tools for your business." },
    savePrefs: { es: "Guardar preferencias", en: "Save preferences" },
    errSavePrefs: { es: "Error al guardar preferencias", en: "Failed to save preferences" },
    catEstrategia: { es: "Estrategia y Modelos", en: "Strategy & Models" },
    catEstrategiaDesc: { es: "Planificación estratégica, modelos de negocio y análisis competitivo.", en: "Strategic planning, business models and competitive analysis." },
    catOperaciones: { es: "Operativa y Gestión", en: "Operations & Management" },
    catOperacionesDesc: { es: "Inventario, logística, KPIs y eficiencia operativa.", en: "Inventory, logistics, KPIs and operational efficiency." },
  },

  // ── Insights page ──
  insightsPage: {
    seoDesc: { es: "Artículos, análisis y guías tácticas sobre operaciones retail, M&A y estrategia para cadenas de tiendas, inversores y PYMEs.", en: "Articles, analysis and tactical guides on retail operations, M&A and strategy for store chains, investors and SMEs." },
    keywords: { es: "insights retail, artículos retail, guías retail, consultoría tiendas, M&A retail, operaciones retail", en: "retail insights, retail articles, retail guides, store consulting, retail M&A, retail operations" },
    headerSub: { es: "Artículos, análisis y guías tácticas para tomar mejores decisiones en tu negocio retail.", en: "Articles, analysis and tactical guides to make better decisions in your retail business." },
  },

  // ── Lead capture modal ──
  leadModal: {
    optRetailChain: { es: "Empresa / Cadena Retail", en: "Company / Retail Chain" },
    nextStep: { es: "Hablemos de tu próximo paso.", en: "Let's talk about your next step." },
    intro: { es: "Déjanos tus datos y nos pondremos en contacto contigo para evaluar cómo podemos aportar valor a tu proyecto.", en: "Leave us your details and we will contact you to evaluate how we can add value to your project." },
    review24: { es: "Revisaré tu caso personalmente y me pondré en contacto contigo en las próximas 24 horas para evaluar el alcance.", en: "I will personally review your case and contact you within the next 24 hours to evaluate the scope." },
  },

  // ── Delegate modal ──
  delegateModal: {
    errSend: { es: "Error al enviar", en: "Failed to send" },
    placeholder: { es: "Cuéntanos más detalles sobre tu necesidad para prepararte una propuesta a medida...", en: "Tell us more details about your need so we can prepare a tailored proposal..." },
    sendRequest: { es: "Enviar Solicitud a mi Mentor", en: "Send Request to my Mentor" },
  },

  // ── Common toasts ──
  commonToasts: {
    errSend: { es: "Error al enviar", en: "Failed to send" },
    errSave: { es: "Error al guardar", en: "Failed to save" },
  },

  // ── Business cases tab ──
  businessCasesTab: {
    similar: { es: "¿Tu negocio se enfrenta a un reto similar?", en: "Is your business facing a similar challenge?" },
    nextStep: { es: "Hablemos de tu próximo paso.", en: "Let's talk about your next step." },
  },

  // ── Legal pages ──
  legalPages: {
    backHome: { es: "Volver al inicio", en: "Back to home" },
    lastUpdated: { es: "Última actualización", en: "Last updated" },
  },

  // ── Privacy policy ──
  privacyPolicy: {
    title: { es: "Política de Privacidad", en: "Privacy Policy" },
    intro: { es: "En Retail Lemon nos comprometemos a proteger la privacidad de nuestros usuarios y clientes. Esta política explica cómo recopilamos, usamos y protegemos tus datos personales conforme al Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018 de Protección de Datos Personales y Garantía de los Derechos Digitales (LOPDGDD).", en: "At Retail Lemon we are committed to protecting the privacy of our users and customers. This policy explains how we collect, use and protect your personal data in accordance with the General Data Protection Regulation (GDPR) and Spanish Organic Law 3/2018 on Personal Data Protection and Digital Rights (LOPDGDD)." },
    h1Title: { es: "1. Responsable del tratamiento", en: "1. Data controller" },
    h1Body: { es: "El responsable del tratamiento de los datos personales es WP Media LLC (marca Retail Lemon), con domicilio en 8 The Green, Suite A, Dover, DE 19901, Estados Unidos. Para cualquier cuestión relacionada con la privacidad puedes contactarnos en hola@retaillemon.com.", en: "The data controller is WP Media LLC (trading as Retail Lemon), 8 The Green, Suite A, Dover, DE 19901, United States. For any privacy-related matters you can contact us at hola@retaillemon.com." },
    h2Title: { es: "2. Finalidad del tratamiento", en: "2. Purpose of processing" },
    h2Body: { es: "Los datos personales que recopilamos se utilizan para las siguientes finalidades:", en: "The personal data we collect is used for the following purposes:" },
    h2Items: {
      es: [
        "Gestionar el acceso y uso de la plataforma Retail Lemon.",
        "Atender tus consultas y solicitudes a través del formulario de contacto.",
        "Enviar comunicaciones comerciales relacionadas con nuestros servicios, solo si el usuario ha dado su consentimiento expreso.",
        "Cumplir con obligaciones legales aplicables.",
      ],
      en: [
        "Manage access and use of the Retail Lemon platform.",
        "Handle your inquiries and requests through the contact form.",
        "Send commercial communications related to our services, only if the user has given express consent.",
        "Comply with applicable legal obligations.",
      ],
    },
    h3Title: { es: "3. Base legal", en: "3. Legal basis" },
    h3Items: {
      es: [
        "Consentimiento del interesado (art. 6.1.a RGPD): al enviar el formulario de contacto o registrarse en la plataforma.",
        "Ejecución de un contrato (art. 6.1.b RGPD): cuando el usuario contrata uno de nuestros servicios.",
        "Cumplimiento de una obligación legal (art. 6.1.c RGPD).",
      ],
      en: [
        "Consent of the data subject (art. 6.1.a GDPR): when submitting the contact form or registering on the platform.",
        "Performance of a contract (art. 6.1.b GDPR): when the user contracts one of our services.",
        "Compliance with a legal obligation (art. 6.1.c GDPR).",
      ],
    },
    h4Title: { es: "4. Datos recopilados", en: "4. Data collected" },
    h4Body: { es: "Podemos recopilar los siguientes datos:", en: "We may collect the following data:" },
    h4Items: {
      es: ["Nombre y apellidos.", "Correo electrónico.", "Empresa u organización (opcional).", "Mensaje o información proporcionada en el formulario de contacto.", "Datos técnicos: dirección IP, navegador, dispositivo y cookies (ver política de cookies)."],
      en: ["First and last name.", "Email address.", "Company or organization (optional).", "Message or information provided in the contact form.", "Technical data: IP address, browser, device and cookies (see cookie policy)."],
    },
    h5Title: { es: "5. Conservación de los datos", en: "5. Data retention" },
    h5Body: { es: "Los datos serán conservados durante el tiempo necesario para cumplir las finalidades indicadas y, en cualquier caso, no más de 2 años desde la última interacción, salvo que exista una relación contractual vigente.", en: "Data will be retained for the time necessary to fulfill the stated purposes and, in any case, no longer than 2 years from the last interaction, unless there is an ongoing contractual relationship." },
    h6Title: { es: "6. Cesión de datos", en: "6. Data transfers" },
    h6Body: { es: "No cedemos tus datos a terceros, salvo obligación legal o cuando sea estrictamente necesario para la prestación del servicio (por ejemplo, proveedores de hosting o herramientas analíticas que cumplen con el RGPD).", en: "We do not transfer your data to third parties, except by legal obligation or when strictly necessary to provide the service (for example, hosting providers or analytics tools that comply with GDPR)." },
    h7Title: { es: "7. Derechos del usuario", en: "7. User rights" },
    h7Body: { es: "De conformidad con el RGPD, el usuario puede ejercer los siguientes derechos:", en: "In accordance with GDPR, the user may exercise the following rights:" },
    h7Items: {
      es: ["Acceso: conocer qué datos personales tratamos.", "Rectificación: corregir datos inexactos.", "Supresión: solicitar la eliminación de los datos cuando ya no sean necesarios.", "Oposición y limitación: oponerse al tratamiento o solicitar su limitación.", "Portabilidad: recibir tus datos en formato estructurado."],
      en: ["Access: know what personal data we process.", "Rectification: correct inaccurate data.", "Erasure: request deletion of data when no longer necessary.", "Objection and restriction: object to processing or request its restriction.", "Portability: receive your data in a structured format."],
    },
    h7Foot: { es: "Para ejercer estos derechos, escribe a hola@retaillemon.com indicando la solicitud y adjuntando una copia de tu DNI o documento identificativo.", en: "To exercise these rights, write to hola@retaillemon.com indicating the request and attaching a copy of your ID document." },
    h7AEPD: { es: "También tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD) si considera que sus derechos no han sido atendidos correctamente.", en: "You also have the right to file a complaint with the Spanish Data Protection Agency (AEPD) if you believe your rights have not been properly addressed." },
    h8Title: { es: "8. Seguridad de los datos", en: "8. Data security" },
    h8Body: { es: "Aplicamos medidas técnicas y organizativas para garantizar la confidencialidad e integridad de los datos personales tratados.", en: "We apply technical and organizational measures to ensure the confidentiality and integrity of the personal data processed." },
    h9Title: { es: "9. Modificaciones de la política", en: "9. Policy changes" },
    h9Body: { es: "Retail Lemon se reserva el derecho a actualizar esta política para adaptarla a cambios legales o de funcionamiento. Recomendamos revisarla periódicamente.", en: "Retail Lemon reserves the right to update this policy to adapt to legal or operational changes. We recommend reviewing it periodically." },
  },

  // ── Legal notice ──
  legalNotice: {
    title: { es: "Aviso Legal", en: "Legal Notice" },
    h1Title: { es: "1. Datos identificativos", en: "1. Identification data" },
    h1Body: { es: "Este sitio web es titularidad de WP Media LLC (8 The Green, Suite A, Dover, DE 19901, Estados Unidos), que opera bajo la marca Retail Lemon, dedicada a la consultoría, mentoría y servicios profesionales en el ámbito retail para clientes de todo el mundo. Para cualquier consulta puede contactar en hola@retaillemon.com.", en: "This website is owned by WP Media LLC (8 The Green, Suite A, Dover, DE 19901, United States), operating under the Retail Lemon brand, dedicated to consulting, mentoring and professional services in retail for clients worldwide. For any inquiries you can contact us at hola@retaillemon.com." },
    h2Title: { es: "2. Objeto", en: "2. Purpose" },
    h2Body: { es: "El presente sitio web tiene por objeto informar sobre los servicios de consultoría, mentoría, fabricación y gestión de marcas de moda que presta Retail Lemon, así como facilitar el contacto con potenciales clientes y colaboradores.", en: "This website aims to inform about the consulting, mentoring, manufacturing and fashion brand management services provided by Retail Lemon, as well as to facilitate contact with potential clients and collaborators." },
    h3Title: { es: "3. Propiedad intelectual e industrial", en: "3. Intellectual and industrial property" },
    h3Body: { es: "Todos los contenidos del sitio web, incluyendo textos, imágenes, diseños, logotipos, marcas y demás elementos, son propiedad de Retail Lemon o de sus legítimos titulares y están protegidos por la legislación nacional e internacional vigente. Queda prohibida su reproducción, distribución, comunicación pública o transformación sin autorización expresa.", en: "All website content, including texts, images, designs, logos, trademarks and other elements, is the property of Retail Lemon or its legitimate owners and is protected by current national and international legislation. Reproduction, distribution, public communication or transformation without express authorization is prohibited." },
    h4Title: { es: "4. Condiciones de uso", en: "4. Terms of use" },
    h4Body: { es: "El usuario se compromete a utilizar el sitio conforme a la ley, la moral y el orden público, evitando cualquier actividad que pueda dañar o sobrecargar los sistemas, así como introducir contenidos ilícitos o lesivos.", en: "The user agrees to use the site in accordance with the law, morality and public order, avoiding any activity that may damage or overload the systems, as well as introducing illegal or harmful content." },
    h5Title: { es: "5. Responsabilidad", en: "5. Liability" },
    h5Body: { es: "Retail Lemon no se hace responsable de los posibles daños o perjuicios derivados de interferencias, omisiones, interrupciones, virus informáticos o desconexiones del sistema electrónico, así como de daños causados por terceros mediante intromisiones ilegítimas fuera de su control.", en: "Retail Lemon is not responsible for possible damages or losses derived from interferences, omissions, interruptions, computer viruses or disconnections of the electronic system, as well as damages caused by third parties through illegitimate intrusions outside its control." },
    h6Title: { es: "6. Enlaces", en: "6. Links" },
    h6Body: { es: "El sitio puede contener enlaces a otras páginas web. Retail Lemon no se responsabiliza del contenido o disponibilidad de los sitios enlazados.", en: "The site may contain links to other websites. Retail Lemon is not responsible for the content or availability of linked sites." },
    h7Title: { es: "7. Legislación aplicable y jurisdicción", en: "7. Applicable law and jurisdiction" },
    h7Body: { es: "Las relaciones derivadas del uso de este sitio se regirán por la legislación española. Para la resolución de cualquier controversia, las partes se someten a los Juzgados y Tribunales de la ciudad correspondiente al domicilio del titular, salvo que la normativa aplicable disponga otra cosa.", en: "Relations derived from the use of this site shall be governed by Spanish law. For the resolution of any dispute, the parties submit to the Courts and Tribunals of the city corresponding to the owner's domicile, unless applicable regulations provide otherwise." },
  },

  // ── Admin (kept ES only — backoffice) ──
  adminShell: {
    alerts: { es: "Avisos", en: "Alerts" },
    adminMode: { es: "Modo Administrador", en: "Admin mode" },
    viewDetails: { es: "Ver detalle", en: "View details" },
    searchSection: { es: "Buscar sección…", en: "Search section…" },
    teamCheckFailed: { es: "No se pudo cargar la lista del equipo: ningún error se cuenta como producción hasta que se recargue.", en: "Could not load the team list: no error counts as production until you reload." },
  },
  adminWaitlist: {
    loading: { es: "Cargando…", en: "Loading…" },
    enabledTitle: { es: "Waitlist activada", en: "Waitlist enabled" },
    disabledTitle: { es: "Waitlist desactivada — los usuarios ya pueden registrarse", en: "Waitlist disabled — users can now sign up" },
    desc: { es: "Controla quién puede registrarse en la plataforma.", en: "Control who can sign up to the platform." },
  },

  // ── Brainstorm / Community ──
  brainstorm: {
    newIdea: { es: "Nueva Idea", en: "New Idea" },
    newIdeaDesc: { es: "Comparte tu idea con la comunidad Lemon", en: "Share your idea with the Lemon community" },
    channel: { es: "Canal", en: "Channel" },
    selectChannel: { es: "Selecciona un canal", en: "Select a channel" },
    title: { es: "Título", en: "Title" },
    titlePlaceholder: { es: "¿Cuál es tu idea o pregunta?", en: "What is your idea or question?" },
    description: { es: "Descripción", en: "Description" },
    descriptionPlaceholder: { es: "Describe tu idea en detalle...", en: "Describe your idea in detail..." },
    requiresUnlock: { es: "Requiere desbloqueo", en: "Locked" },
    dropImage: { es: "Haz clic o arrastra una imagen aquí", en: "Click or drag an image here" },
    imageHint: { es: "JPG, PNG o WebP · Máx. 5 MB", en: "JPG, PNG or WebP · Max. 5 MB" },
    imagesPaidOnly: { es: "📸 Subir imágenes solo disponible en el Club Pro", en: "📸 Image uploads only available on Club Pro" },
    imagesPaidHint: { es: "Actualiza tu cuenta para adjuntar fotos de tus muestras, bocetos, ideas visuales o fichas técnicas y recibir un feedback mucho más preciso del club.", en: "Upgrade your account to attach photos of samples, sketches, visual ideas or tech specs and receive much more precise feedback from the club." },
    publishChannel: { es: "Canal de publicación", en: "Publishing channel" },
    channelGeneral: { es: "Canal General", en: "General Channel" },
    channelGeneralHint: { es: "Disponible para todos", en: "Available to everyone" },
    mySector: { es: "Mi Sector", en: "My Sector" },
    sectorNotSet: { es: "Configura tu sector en tu perfil para publicar aquí.", en: "Set up your sector in your profile to post here." },
    sectorLoading: { es: "Cargando tu sector…", en: "Loading your sector…" },
    mySectorLoadingLabel: { es: "Mi Sector…", en: "My Sector…" },
    sectorErrorLabel: { es: "Mi Sector — error", en: "My Sector — error" },
    sectorErrorHint: { es: "No pudimos cargar tu sector. Reintenta o publica en Canal General.", en: "We couldn't load your sector. Retry or post in the General Channel." },
    retry: { es: "Reintentar", en: "Retry" },
    rulesTitle: { es: "Normas del Club:", en: "Club rules:" },
    rulesBody: {
      es: "Por seguridad y para mantener la calidad de la plataforma, está estrictamente prohibido compartir emails, números de teléfono o enlaces a grupos externos. El sistema detecta automáticamente esta información y supondrá la expulsión inmediata y pérdida de acceso a los módulos.",
      en: "For security and to keep the platform's quality, sharing emails, phone numbers or links to external groups is strictly forbidden. The system detects this information automatically and will result in immediate removal and loss of module access.",
    },
    cancel: { es: "Cancelar", en: "Cancel" },
    publish: { es: "Publicar Idea", en: "Publish Idea" },
    emptyChannel: { es: "No hay publicaciones todavía en este canal. ¡Sé el primero en compartir una idea!", en: "No posts yet in this channel. Be the first to share an idea!" },
    signInRequired: { es: "Inicia sesión", en: "Sign in" },
    signInToLike: { es: "Debes iniciar sesión para dar like.", en: "You must sign in to like." },
    error: { es: "Error", en: "Error" },
    unexpectedError: { es: "Error inesperado.", en: "Unexpected error." },
    commentError: { es: "No se pudo publicar el comentario.", en: "Could not publish the comment." },
    imageVisualizeFail: { es: "Fallo al visualizar la imagen. Prueba con otro archivo.", en: "Could not preview the image. Try another file." },
    minutesAgo: { es: "hace {n}m", en: "{n}m ago" },
    hoursAgo: { es: "hace {n}h", en: "{n}h ago" },
    daysAgo: { es: "hace {n}d", en: "{n}d ago" },
    commentsCount: { es: "{n} comentarios", en: "{n} comments" },
    noComments: { es: "Sin comentarios aún. ¡Sé el primero!", en: "No comments yet. Be the first!" },
    unlockToRead: { es: "Desbloquea el módulo de {channel} para leer esto", en: "Unlock the {channel} module to read this" },
    replyPlaceholder: { es: "Escribe tu respuesta...", en: "Write your reply..." },
    signInToComment: { es: "Inicia sesión para comentar", en: "Sign in to comment" },
    dragHandle: { es: "Arrastrar para reordenar", en: "Drag to reorder" },
    postImageAlt: { es: "Imagen de publicación en la comunidad Retail Lemon", en: "Post image in the Retail Lemon community" },
  },

  // ── Location Diagnosis (Diagnosticador de Locales — pre-firma) ──
  locationDiagnosis: {
    faqTitle: { es: "Preguntas frecuentes sobre el Diagnóstico de Locales", en: "Location Analysis — Frequently Asked Questions" },
    faqHowQ: { es: "¿Cómo funciona el diagnóstico?", en: "How does the diagnosis work?" },
    faqHowA: {
      es: "Nuestro motor de Location Intelligence cruza el alquiler solicitado con datos públicos de renta, densidad de tráfico peatonal, mix comercial y comportamiento de compra de la zona. En segundos calculamos la tasa de esfuerzo proyectada de tu sector y la traducimos a un semáforo de riesgo financiero, junto a un objetivo de ventas diarias mínimo y óptimo para que el local sea viable.",
      en: "Our Location Intelligence engine cross-references the requested rent with public data on income, foot-traffic density, retail mix and purchasing behavior in the area. In seconds we calculate your sector's projected rent effort ratio and translate it into a financial risk semaphore, alongside the minimum and optimum daily sales target needed for the unit to be viable.",
    },
    faqVarsQ: { es: "¿Qué variables analizamos?", en: "Which variables do we analyze?" },
    faqVarsA: {
      es: "Combinamos código postal, sector retail, metros cuadrados útiles, alquiler mensual solicitado, ticket medio estimado y días de apertura mensuales con datasets externos de renta media, tráfico peatonal, presión competitiva y estacionalidad. El resultado es una tasa de esfuerzo del alquiler comparada con la horquilla saludable del sector (entre el 8% y el 15% según vertical) y un rango de unidades a vender por día para sostener el contrato.",
      en: "We combine ZIP code, retail sector, usable square meters, requested monthly rent, estimated average ticket and monthly opening days with external datasets on average income, foot traffic, competitive pressure and seasonality. The output is a rent effort ratio compared to the healthy band for your vertical (between 8% and 15% depending on the category) and a daily unit-sales range required to sustain the lease.",
    },
    faqBenefitsQ: { es: "Beneficios para propietarios e inquilinos", en: "Benefits for landlords and tenants" },
    faqBenefitsA: {
      es: "Si eres inquilino o emprendedor retail, evitas firmar contratos asfixiantes y negocias con datos reales en la mano. Si eres propietario, agencia o gestor de activos, cualificas candidatos en minutos, reduces la rotación de inquilinos y proteges la rentabilidad a largo plazo del activo. En ambos casos transformas una decisión de gut feeling en una decisión basada en evidencia financiera.",
      en: "If you're a tenant or retail entrepreneur, you avoid signing suffocating leases and negotiate with real data in hand. If you're a landlord, agency or asset manager, you qualify candidates in minutes, reduce tenant churn and protect the long-term yield of the asset. In both cases you turn a gut-feeling call into an evidence-based financial decision.",
    },
    heroTitle: { es: "Antes de firmar, que hablen los números.", en: "Before you sign, let the numbers speak." },
    heroSubtitle: {
      es: "Cruza los datos del alquiler con la economía real de la zona y descubre el riesgo antes de comprometerte — tanto si buscas local como si lo ofreces.",
      en: "Cross rent data with the real local economy and uncover the risk before you commit — whether you're looking for a unit or offering one.",
    },
    socialProof: { es: "Usado por +1.200 profesionales del retail", en: "Used by +1,200 retail professionals" },
    differentiator: {
      es: "¿Ya tienes tu negocio en marcha? Esta herramienta es para la fase pre-firma. Para controlar tus márgenes operativos usa la Calculadora de Rentabilidad",
      en: "Already running your business? This tool is for the pre-signing phase. To track operating margins use the Profitability Calculator",
    },
    tabInquilino: { es: "Soy Inquilino (Retailer)", en: "I'm a Tenant (Retailer)" },
    tabPropietario: { es: "Soy Propietario / Inmobiliaria", en: "I'm a Landlord / Agency" },
    tabInquilinoShort: { es: "Inquilino", en: "Tenant" },
    tabPropietarioShort: { es: "Propietario", en: "Landlord" },
    zipCode: { es: "Código Postal", en: "ZIP Code" },
    requestedRent: { es: "Alquiler mensual solicitado (€)", en: "Requested monthly rent (€)" },
    sqm: { es: "Metros cuadrados útiles (m²)", en: "Usable square meters (m²)" },
    sector: { es: "Sector", en: "Sector" },
    candidateSector: { es: "Sector del candidato a inquilino", en: "Candidate tenant's sector" },
    averageTicket: { es: "Ticket Medio estimado (€)", en: "Estimated average ticket (€)" },
    candidatesEvaluated: { es: "Candidatos evaluados este año", en: "Candidates evaluated this year" },
    daysOpen: { es: "Días de apertura al mes", en: "Opening days per month" },
    employees: { es: "Empleados estimados (cada empleado = 40h / semana)", en: "Estimated employees (each employee = 40h / week)" },
    calculate: { es: "Calcular mi Semáforo de Riesgo →", en: "Run my Risk Traffic-Light →" },
    // Owner-engine (landlord) results
    ownerScoreTitle: { es: "Score de solvencia del inquilino", en: "Tenant solvency score" },
    ownerScoreSub: { es: "Sobre 100 puntos · combina precio de zona, experiencia y forma jurídica", en: "Out of 100 · combines zone pricing, experience and legal form" },
    ownerGreenTitle: { es: "Perfil solvente", en: "Solvent profile" },
    ownerGreenMsg: { es: "Inquilino con bajo riesgo de impago y alquiler en precio de mercado.", en: "Tenant with low default risk and rent in line with the market." },
    ownerYellowTitle: { es: "Riesgo moderado", en: "Moderate risk" },
    ownerYellowMsg: { es: "El perfil tiene cierta inexperiencia o el alquiler está por encima del mercado. Solicita avales adicionales.", en: "The profile shows some inexperience or the rent is above market. Request additional guarantees." },
    ownerRedTitle: { es: "Alto riesgo", en: "High risk" },
    ownerRedMsg: { es: "Alta probabilidad de impago o rotación. El perfil del inquilino es frágil para las exigencias de este local.", en: "High probability of default or churn. The tenant profile is fragile for this unit's demands." },
    sectors: {
      es: ["Moda","Hostelería","Cosmética","Servicios","Alimentación"],
      en: ["Fashion","Hospitality","Cosmetics","Services","Food"],
    },
    controlCenterTitle: {
      es: "Diagnóstico de Locales",
      en: "Location Analysis",
    },
    rightColPlaceholder: {
      es: "Selecciona una dirección y aquí verás el mapa y la fachada real del local.",
      en: "Pick an address — the map and the real storefront will appear here.",
    },
    mapCardTitle: { es: "Ubicación Geográfica (Mapa 2D)", en: "Geographic Location (2D Map)" },
    streetViewCardTitle: { es: "Análisis de Fachada y Entorno (Street View)", en: "Storefront & Surroundings (Street View)" },
    processingReality: { es: "🛰️ Procesando la realidad del entorno…", en: "🛰️ Processing the surrounding reality…" },
    loading1: { es: "📍 Geolocalizando coordenadas de la dirección…", en: "📍 Geolocating address coordinates…" },
    loading2: { es: "📡 Escaneando densidad comercial en la zona…", en: "📡 Scanning commercial density in the area…" },
    loading3: { es: "📊 Cruzando renta per cápita y precio del m²…", en: "📊 Crossing per-capita income and price-per-m²…" },
    loading4: { es: "⚙️ Calculando punto de equilibrio financiero…", en: "⚙️ Calculating financial break-even point…" },
    loadingDone: { es: "✅ ¡Diagnóstico completado!", en: "✅ Diagnosis completed!" },
    addressLabel: { es: "Dirección del local", en: "Unit address" },
    addressPlaceholder: { es: "Calle, número, ciudad…", en: "Street, number, city…" },
    addressRequired: { es: "Introduce una dirección y un código postal para continuar.", en: "Enter an address and ZIP code to continue." },
    placesUnavailable: {
      es: "El buscador predictivo está temporalmente limitado por Google. Puedes continuar escribiendo el código postal manualmente.",
      en: "Predictive search is temporarily limited by Google. You can continue by entering the ZIP code manually.",
    },
    semaforoOn: { es: "Tu semáforo está encendido.", en: "Your traffic-light is on." },
    paywallTitle: { es: "🔒 Tu diagnóstico completo está listo.", en: "🔒 Your full diagnosis is ready." },
    paywallSubtitle: {
      es: "Únete a la lista de acceso anticipado para ver el punto de equilibrio exacto y el análisis por sector cuando abramos.",
      en: "Join the early access list to see the exact break-even point and sector analysis when we launch.",
    },
    paywallCta: { es: "Unirme al acceso anticipado", en: "Join early access" },
    freemiumModalTitle: {
      es: "Hemos analizado tu local 🍋",
      en: "We've analyzed your location 🍋",
    },
    freemiumModalSubtitle: {
      es: "Únete a la lista de acceso anticipado para ver el punto de equilibrio exacto y el análisis por sector cuando abramos.",
      en: "Join the early access list to see the exact break-even point and sector analysis when we launch.",
    },
    analysisLoading1: { es: "Analizando viabilidad...", en: "Analyzing viability..." },
    analysisLoading2: { es: "Cruzando datos de la zona...", en: "Cross-referencing zone data..." },
    analysisLoading3: { es: "Generando semáforo de riesgo...", en: "Generating risk traffic-light..." },
    teaserTitle: { es: "¡Hemos analizado tu local! 🍋", en: "We've analyzed your location! 🍋" },
    teaserSubtitle: {
      es: "El diagnóstico de viabilidad está disponible para usuarios con cuenta. Únete al acceso anticipado para ver tu informe y descubre el resto de herramientas que tenemos para optimizar tu día a día.",
      en: "The viability diagnosis is available to account holders. Join early access to see your report and discover the rest of the tools we have to optimize your day-to-day.",
    },
    teaserCtaSignup: { es: "Crear cuenta y ver informe", en: "Create account & view report" },
    teaserCtaLogin: { es: "Ya tengo cuenta — Iniciar sesión", en: "I have an account — Sign in" },
    viewRegisterTitle: { es: "Crea tu cuenta", en: "Create your account" },
    viewLoginTitle: { es: "Inicia sesión", en: "Sign in" },
    backToTeaser: { es: "← Volver", en: "← Back" },
    switchToLogin: { es: "¿Ya tienes cuenta?", en: "Already have an account?" },
    switchToLoginLink: { es: "Inicia sesión", en: "Sign in" },
    switchToRegister: { es: "¿No tienes cuenta?", en: "Don't have an account?" },
    switchToRegisterLink: { es: "Regístrate", en: "Sign up" },
    card1Title: { es: "Precio €/m² que te piden", en: "Price €/m² requested" },
    card1Sub: { es: "Media de la zona", en: "Zone average" },
    card2Title: { es: "Objetivo de Ventas Diarias", en: "Daily Sales Target" },
    card2Unit: { es: "uds/día", en: "units/day" },
    card2Sub: { es: "Para mantener el coste del alquiler en un margen seguro", en: "To keep rent cost within a safe margin" },
    card3Title: { es: "Viabilidad del sector en la zona", en: "Sector viability in the zone" },
    card3Viable: { es: "Sector con buena concentración aquí", en: "Sector well-established here" },
    card3NotViable: { es: "Baja concentración de este sector en la zona", en: "Low sector concentration in this area" },
    card4Title: { es: "Rango de Facturación", en: "Revenue Range" },
    card4Sub: { es: "Rango de esfuerzo del alquiler: 12% (límite) a 8% (óptimo)", en: "Rent effort range: 12% (limit) to 8% (optimal)" },
    highVolumeAlert: { es: "Volumen de ventas muy exigente para este sector", en: "Sales volume very demanding for this sector" },
    ctaRedTitle: { es: "Los números están ajustados.", en: "The numbers are tight." },
    ctaRedSub: {
      es: "Antes de firmar, revisemos juntos las cláusulas del contrato y el plan de viabilidad operativa.",
      en: "Before signing, let's review the contract clauses and the operational viability plan together.",
    },
    ctaRedBtn: { es: "Reservar Taller 1:1 →", en: "Book Workroom 1:1 →" },
    ctaGreenTitle: { es: "Los números cuadran.", en: "The numbers add up." },
    ctaGreenSub: {
      es: "Ahora prepara la operativa para que este local sea rentable desde el día 1.",
      en: "Now set up operations so this unit is profitable from day 1.",
    },
    ctaGreenBtn: { es: "Acceder al Club Pro completo →", en: "Access full Club Pro →" },
    transitionTitle: {
      es: "Este análisis es tu punto de partida pre-firma.",
      en: "This analysis is your pre-signing starting point.",
    },
    transitionSub: {
      es: "Una vez abras el negocio, el siguiente paso es controlar tus márgenes operativos semana a semana.",
      en: "Once you open, the next step is tracking your operating margins week by week.",
    },
    transitionBtn: { es: "Conocer la Calculadora de Rentabilidad →", en: "Discover the Profitability Calculator →" },
    activationTitle: {
      es: "Pásate a PRO: prueba 7 días gratis todas las herramientas avanzadas y la Calculadora de Rentabilidad de Retail Lemon.",
      en: "Go PRO: try 7 days free of all advanced tools and the Retail Lemon Profitability Calculator.",
    },
    activationBtn: { es: "Activar prueba PRO →", en: "Start PRO trial →" },
    historyTitle: { es: "Mis Diagnósticos de Locales", en: "My Location Diagnoses" },
    historyEmpty: { es: "Aún no has evaluado ningún local.", en: "You haven't evaluated any unit yet." },
    historyNew: { es: "Nuevo diagnóstico", en: "New diagnosis" },
    historyMultipleBanner: {
      es: "Estás comparando varios locales. Activa el Plan Pro para comparar en paralelo y exportar el informe en PDF.",
      en: "You're comparing several units. Activate Plan Pro to compare in parallel and export to PDF.",
    },
    nudge30Days: {
      es: "¿Ya firmaste? Es el momento de configurar tu Calculadora de Rentabilidad y controlar los números desde el primer día.",
      en: "Already signed? Time to set up your Profitability Calculator and track the numbers from day 1.",
    },
    invalidZip: { es: "Introduce un código postal español válido (5 dígitos).", en: "Enter a valid Spanish ZIP code (5 digits)." },
    zoneNotFound: { es: "Zona sin datos detallados — usamos media nacional de referencia.", en: "Zone without detailed data — using national reference average." },
    rentVsZone: { es: "{pct}% sobre la media de la zona", en: "{pct}% over zone average" },
    // Portfolio "Mis Locales" / save flow
    portfolioTitle: { es: "Mis Locales", en: "My Locations" },
    portfolioEmpty: { es: "Aún no has guardado ningún local en tu portfolio.", en: "You haven't saved any location in your portfolio yet." },
    portfolioNewBtn: { es: "+ Nuevo diagnóstico", en: "+ New diagnosis" },
    saveButton: { es: "💾 Guardar Local en mi Panel", en: "💾 Save Location to my Panel" },
    saveButtonShort: { es: "💾 Guardar en mi Panel", en: "💾 Save to my Panel" },
    savedToast: { es: "Local guardado en tu portfolio.", en: "Location saved to your portfolio." },
    updatedToast: { es: "Local actualizado en tu portfolio.", en: "Location updated in your portfolio." },
    saveFailedToast: { es: "No se pudo guardar el local. Inténtalo de nuevo.", en: "Could not save the location. Try again." },
    saveLoginRequired: { es: "Inicia sesión para guardar tu local.", en: "Sign in to save your location." },
    freemiumLimitTitle: { es: "Has alcanzado el límite de 3 locales gratuitos.", en: "You've reached the 3 free locations limit." },
    freemiumLimitMsg: {
      es: "Pásate a PRO (7 días gratis) para guardar locales ilimitados y comparar datos entre ellos.",
      en: "Go PRO (7 days free) to save unlimited locations and compare data between them.",
    },
    freemiumLimitCta: { es: "Probar PRO 7 días", en: "Try PRO 7 days" },
    saveRequiresCalc: { es: "Calcula primero el semáforo antes de guardar.", en: "Calculate the semaphore first before saving." },
    // Interactive simulator
    simTitle: { es: "Simulador interactivo: mueve la barra y descubre tu palanca", en: "Interactive simulator: move the slider and find your lever" },
    simSubtitle: {
      es: "Ajusta los tickets diarios y observa en tiempo real cómo cambia tu beneficio y el color del semáforo.",
      en: "Adjust your daily tickets and watch your profit and the traffic-light change in real time.",
    },
    simSliderLabel: { es: "Tickets diarios simulados", en: "Simulated daily tickets" },
    simCardRevenue: { es: "Facturación simulada", en: "Simulated revenue" },
    simCardTickets: { es: "Tickets / día", en: "Tickets / day" },
    simCardResult: { es: "Resultado mensual", en: "Monthly result" },
    simStatusRed: {
      es: "🔴 ESTADO: INVIABLE. Los números actuales no sostienen el negocio (Pérdidas: {amount}€). Necesitas un cambio drástico: reduce gastos en la tabla inferior, renegocia el alquiler o replantea la ubicación.",
      en: "🔴 STATUS: UNVIABLE. Current numbers don't sustain the business (Losses: {amount}€). You need a drastic change: cut costs below, renegotiate the rent or reconsider the location.",
    },
    simStatusYellow: {
      es: "🟡 ESTADO: ZONA DELICADA. Tu estimación es de {amount}€, pero cuidado: en la realidad de un local, este margen tan fino se esfuma rápidamente con impuestos (IVA, IRPF), imprevistos, roturas de stock o bajas médicas. Juega con los controles inferiores para construir un colchón real de seguridad.",
      en: "🟡 STATUS: DELICATE ZONE. Your estimate is {amount}€, but watch out: in reality this thin margin vanishes fast with taxes (VAT, income tax), surprises, stock-outs or sick leave. Play with the controls below to build a real safety cushion.",
    },
    simStatusGreen: {
      es: "🟢 ESTADO: LUZ VERDE. Margen de seguridad positivo ({amount}€). Esta estructura absorbe los imprevistos habituales y proyecta un negocio sólido.",
      en: "🟢 STATUS: GREEN LIGHT. Positive safety margin ({amount}€). This structure absorbs the usual surprises and projects a solid business.",
    },
    tipLowTicket: {
      es: "💡 Tip: Tu ticket medio es bajo. Dependes de muchísimo tráfico peatonal. Piensa en estrategias de venta cruzada.",
      en: "💡 Tip: Your average ticket is low. You depend on heavy foot traffic. Think about cross-selling strategies.",
    },
    sliderTickets: { es: "Tickets diarios", en: "Daily tickets" },
    sliderMargin: { es: "Margen bruto", en: "Gross margin" },
    sliderEmployees: { es: "Horas totales contratadas / semana", en: "Total contracted hours / week" },
    sliderEmployeesHint: { es: "(ej: 40h = 1 empleado a jornada completa)", en: "(e.g. 40h = 1 full-time employee)" },
    sliderOverhead: { es: "Suministros extra", en: "Extra utilities" },
    advancedAccordionTitle: { es: "⚙️ Ajusta tus gastos fijos (¿De dónde salen estos números?)", en: "⚙️ Adjust your fixed costs (Where do these numbers come from?)" },
    breakdownTitle: { es: "💡 ¿De dónde salen estos números?", en: "💡 Where do these numbers come from?" },
    breakdownIntro: {
      es: "Calculamos tu punto de equilibrio sumando los costes fijos mensuales y dividiéndolos entre el margen bruto de tu sector.",
      en: "We compute your break-even by adding monthly fixed costs and dividing by your sector's gross margin.",
    },
    breakdownRent: { es: "Alquiler mensual solicitado", en: "Requested monthly rent" },
    breakdownStaff: { es: "Coste laboral ({hours}h/sem · convenio {unit}/40h)", en: "Labor cost ({hours}h/wk · agreement {unit}/40h)" },
    breakdownOverhead: { es: "Suministros + gestoría (estimado)", en: "Utilities + admin (estimated)" },
    breakdownFixedTotal: { es: "Costes fijos mensuales", en: "Monthly fixed costs" },
    breakdownMargin: { es: "Margen bruto del sector", en: "Sector gross margin" },
    breakdownBreakEven: { es: "Facturación mínima de equilibrio", en: "Minimum break-even revenue" },
    breakdownTicketsSurvival: { es: "Tickets / día para sobrevivir", en: "Tickets / day to survive" },
    upsellHeading: { es: "¿Tienes dudas con estos números? No te la juegues antes de firmar.", en: "Doubts about these numbers? Don't gamble before you sign." },
    upsellQuickTitle: { es: "Contactar con un experto", en: "Talk to an expert" },
    upsellQuickText: {
      es: "Resuelve tus dudas sobre el local, los costes ocultos o la viabilidad de tu idea en una sesión privada.",
      en: "Clear up doubts about the location, hidden costs or the viability of your idea in a private session.",
    },
    upsellQuickCta: { es: "Comprar bolsa de horas", en: "Buy hour pack" },
    upsellProBadge: { es: "Descuento aplicado para usuarios Pro", en: "Pro users get a discount" },
    upsellMentoringTitle: { es: "Programas de Mentoría Retail", en: "Retail Mentoring Programs" },
    upsellMentoringText: {
      es: "Te acompañamos durante el tiempo que quieras en la gestión de tu negocio. Desde que firmas el local hasta que abres la persiana y escalas tus ventas.",
      en: "We walk with you as long as you want, from signing the lease to opening the doors and scaling sales.",
    },
    upsellMentoringPlans: { es: "Planes disponibles: Quincenal, Semanal, Equipos e Intensivo.", en: "Plans available: Biweekly, Weekly, Teams and Intensive." },
    upsellMentoringCta: { es: "Ver planes (cuota mensual / anual)", en: "See plans (monthly / annual)" },
    legalAcceptText: {
      es: "Acepto las condiciones del diagnóstico y entiendo que los resultados son estimaciones informativas no vinculantes.",
      en: "I accept the diagnosis terms and understand that results are non-binding informational estimates.",
    },
    historyDeleteConfirm: { es: "¿Borrar este diagnóstico?", en: "Delete this diagnosis?" },
    historyDeleted: { es: "Diagnóstico borrado.", en: "Diagnosis deleted." },
    historyDeleteFailed: { es: "No se pudo borrar.", en: "Could not delete." },
    upsellExpertTitle: { es: "Consulta con un experto", en: "Consult with an expert" },
    upsellExpertText: {
      es: "Resuelve tus dudas sobre el local en una sesión privada.",
      en: "Clear up your doubts about the location in a private session.",
    },
    upsellExpertPriceLite: { es: "180€ / 1 hora", en: "€180 / 1 hour" },
    upsellExpertPricePro: {
      es: "180€ / 1 hora (pago único, sin caducidad)",
      en: "€180 / 1 hour (one-time, no expiry)",
    },
    upsellExpertCta: { es: "Reserva tu sesión", en: "Book your session" },
    upsellMentoringTextV2: {
      es: "Adquiere mentoría y te acompañamos en todas las decisiones durante todo el año, con unas sesiones marcadas mensuales.",
      en: "Get mentoring and we'll guide every decision year-round, with set monthly sessions.",
    },
    upsellMentoringCtaV2: { es: "Ver planes y cuotas", en: "See plans and fees" },
    upsellActiveTitle: { es: "Asistencia de Mentoría Activa", en: "Active Mentoring Support" },
    upsellActiveText: {
      es: "Tienes horas de mentoría disponibles en tu plan. ¿Quieres que analicemos este local juntos?",
      en: "You have mentoring hours available in your plan. Want us to analyse this location together?",
    },
    upsellActiveCta: { es: "Agendar sesión con mi mentor", en: "Book a session with my mentor" },
  },

  // ── Subvenciones y Ayudas ──
  adminClientCal: {
    tab: { es: "Calendario", en: "Calendar" },
    title: { es: "Calendario comercial del cliente", en: "Client's business calendar" },
    subtitle: { es: "Lo que tiene marcado en su panel: campañas, fechas propias, sugerencias de Sara IA y subvenciones.", en: "What they have marked in their panel: campaigns, own dates, Sara AI suggestions and grants." },
    empty: { es: "Aún no ha marcado ni anotado ninguna fecha.", en: "No dates marked or noted yet." },
    upcoming: { es: "Próximas", en: "Upcoming" },
    past: { es: "Pasadas", en: "Past" },
    grant: { es: "Subvención", en: "Grant" },
    own: { es: "Propia", en: "Own" },
    sara: { es: "Sara IA", en: "Sara AI" },
    official: { es: "Calendario", en: "Calendar" },
    off: { es: "Desactivada", en: "Turned off" },
    pending: { es: "Pendiente de decidir", en: "Awaiting decision" },
    colors: { es: "Su código de colores", en: "Their colour code" },
    note: { es: "Nota", en: "Note" },
  },
  grants: {
    addedToCalendar: { es: "Apuntada en tu calendario: apertura y cierre de plazo.", en: "Added to your calendar: opening and closing dates." },
    liteListingTitle: { es: "El listado es de Básico.", en: "The directory is included in Basic." },
    liteListingPricing: { es: "Ver tarifas", en: "View pricing" },
    // Pestaña "¿Puedo pedirlas?" — wizard + motor de cruce
    tabFit: { es: "¿Puedo pedirlas?", en: "Can I apply?" },
    liteServiceBanner: { es: "Analizamos la subvención, analizamos tu perfil y te decimos en cuáles encajas mejor o peor.", en: "We analyse the grant, analyse your profile and tell you which ones you fit best or worst." },
    liteWhyLocked: { es: "Por qué encaja con tu negocio y alertas de nuevas ayudas", en: "Why it fits your business and new-grant alerts" },
    liteClubProCta: { es: "Club Pro · 69 €/mes", en: "Club Pro · €69/month" },
    liteMaxLabel: { es: "Máximo", en: "Maximum" },
    step2IntroBody: {
      es: "Hemos separado las ayudas de tu sector y tu zona, con alertas para que no se te pase ningún plazo.",
      en: "We've separated the grants for your sector and area, with alerts so you never miss a deadline.",
    },
    clubProBadge: { es: "Exclusivo usuarios Club Pro", en: "Exclusive to Club Pro members" },
    step2SampleAlerts: { es: "Alertas activas", en: "Alerts on" },
    step2SamplePrepared: { es: "Preparadas para ti", en: "Ready for you" },
    fitTeaserBody: {
      es: "Solo para usuarios Club Pro: cruzamos tu forma jurídica, antigüedad, plantilla, situación fiscal y objetivos, y te decimos a qué ayudas puedes optar y por qué.",
      en: "Club Pro members only: we match your legal form, age, headcount, tax standing and goals, and tell you which grants you can apply for and why.",
    },
    simBadge: { es: "Ejemplo de simulación · Así lo verás con Club Pro", en: "Sample simulation · How it looks with Club Pro" },
    simTitle: { es: "Ayudas a la modernización y digitalización del comercio minorista", en: "Grants for retail modernisation and digitalisation" },
    simMeta: { es: "Consejería de Comercio · Hasta 5.000 € (80 % subvencionable)", en: "Regional Trade Department · Up to €5,000 (80% eligible)" },
    simCheck1: { es: "Forma jurídica y plantilla: encaja con tu local (Autónomo / S.L., 1–5 empleados).", en: "Legal form and headcount: fits your shop (sole trader / Ltd, 1–5 staff)." },
    simCheck2: { es: "Situación tributaria: sin deudas con Hacienda ni Seguridad Social.", en: "Tax standing: no debts with the Tax Agency or Social Security." },
    simCheck3: { es: "Plazo y alerta: cierra en 19 días · alerta activada por email.", en: "Deadline and alert: closes in 19 days · email alert on." },
    simPrepare: { es: "Preparar esta subvención", en: "Prepare this grant" },
    simFooter: { es: "Este servicio es exclusivo para usuarios del Club Pro.", en: "This service is exclusive to Club Pro members." },
    trackingClubProBanner: {
      es: "Los usuarios de Club Pro tienen el listado completo: seguimiento de todas las ayudas, plazos y alertas de estado.",
      en: "Club Pro members get the full list: tracking of every grant, deadlines and status alerts.",
    },
    fitHeader: {
      es: "Unos datos de tu negocio. Las cruzamos con las ayudas de tu comercio. Cada convocatoria pide lo suyo.",
      en: "A few details about your business. We match them against the grants for your shop. Every call asks for its own things.",
    },
    fitLoading: { es: "Cargando tu perfil de ayudas…", en: "Loading your grants profile…" },
    fitLockedTitle: { es: "Cruce con tu negocio (Club Pro)", en: "Match against your business (Club Pro)" },
    fitLockedBody: {
      es: "El Club Pro cruza tu perfil con cada convocatoria y te dice si encajas, qué falta y qué mejorar.",
      en: "Club Pro matches your profile against every call and tells you if you qualify, what is missing and what to improve.",
    },
    fitQ1: { es: "¿Autónomo, sociedad u otra?", en: "Sole trader, company or other?" },
    fitQ2: { es: "¿Cuánto llevas de alta?", en: "How long have you been registered?" },
    fitQ3: { es: "¿Cuántas personas sois?", en: "How many people are you?" },
    fitQ4: { es: "¿Dónde estás?", en: "Where are you based?" },
    fitQ5: { es: "¿Al corriente con Hacienda y Seguridad Social?", en: "Up to date with tax and social security?" },
    fitQ6: { es: "¿Para qué la querrías?", en: "What would you use it for?" },
    fitQ7: { es: "¿Has cobrado ya alguna ayuda pública reciente?", en: "Have you already received a recent public grant?" },
    fitCcaaPlaceholder: { es: "Comunidad autónoma", en: "Region" },
    fitMunicipioPlaceholder: { es: "Municipio", en: "Town" },
    fitSectorPlaceholder: { es: "Sector de tu comercio", en: "Your retail sector" },
    fitAeat: { es: "Hacienda", en: "Tax office" },
    fitSs: { es: "Seguridad Social", en: "Social security" },
    optFiscal_si: { es: "Sí, al corriente", en: "Yes, up to date" },
    optFiscal_aplazado: { es: "Aplazamiento concedido y al día", en: "Approved payment plan, up to date" },
    optFiscal_no: { es: "No, tengo deuda sin regularizar", en: "No, I have unsettled debt" },
    optFiscal_no_se: { es: "No lo sé", en: "I don't know" },
    fitCrisis: { es: "¿Empresa en crisis o concurso?", en: "Business in distress or insolvency?" },
    fitCertificado: { es: "¿Tienes certificado digital o Cl@ve?", en: "Do you have a digital certificate or Cl@ve?" },
    optForma_autonomo: { es: "Autónomo", en: "Sole trader" },
    optForma_sociedad: { es: "Sociedad", en: "Company" },
    optForma_otra: { es: "Otra", en: "Other" },
    optForma_no_alta: { es: "Todavía no estoy de alta", en: "Not registered yet" },
    optAntiguedad_mas_12: { es: "Más de 12 meses", en: "More than 12 months" },
    optAntiguedad_de_6_a_12: { es: "Entre 6 y 12 meses", en: "Between 6 and 12 months" },
    optAntiguedad_menos_6: { es: "Menos de 6 meses", en: "Less than 6 months" },
    optAntiguedad_no_se: { es: "No lo sé", en: "I don't know" },
    optPlantilla_solo_yo: { es: "Solo yo", en: "Just me" },
    optPlantilla_1_2: { es: "1 o 2", en: "1 or 2" },
    optPlantilla_3_9: { es: "Entre 3 y 9", en: "3 to 9" },
    optPlantilla_10_49: { es: "Entre 10 y 49", en: "10 to 49" },
    optPlantilla_50_mas: { es: "50 o más", en: "50 or more" },
    optSiNo_si: { es: "Sí", en: "Yes" },
    optSiNo_no: { es: "No", en: "No" },
    optSiNo_no_se: { es: "No lo sé", en: "I don't know" },
    optPara_digitalizar: { es: "Digitalizar", en: "Go digital" },
    optPara_reformar: { es: "Reformar el local", en: "Refurbish the shop" },
    optPara_contratar: { es: "Contratar", en: "Hire" },
    optPara_formacion: { es: "Formación", en: "Training" },
    optPara_eficiencia: { es: "Eficiencia energética", en: "Energy efficiency" },
    optPara_circulante: { es: "Circulante", en: "Working capital" },
    optPara_no_se: { es: "Todavía no lo sé", en: "I don't know yet" },
    fitBack: { es: "Atrás", en: "Back" },
    fitNext: { es: "Siguiente", en: "Next" },
    fitSaveCta: { es: "Cruzar con mis ayudas", en: "Match my grants" },
    fitConfirmCta: { es: "Confirmar y cruzar con mis ayudas", en: "Confirm and match my grants" },
    fitPrefillIntro: {
      es: "Hemos rellenado parte del cuestionario con los datos de tu cuenta y de tus locales. Revisa lo marcado, confírmalo o cámbialo si algo no es así, y contesta solo lo que falta.",
      en: "We've filled in part of the questionnaire with your account and location details. Check what's selected, confirm it or change it if anything is different, and answer only what's missing.",
    },
    fitFromProfile: { es: "Detectado de tu perfil · cámbialo si no es así", en: "Taken from your profile · change it if it's not right" },
    fitFromLocation: { es: "Detectado de tus locales · cámbialo si no es así", en: "Taken from your locations · change it if it's not right" },
    fitDespidos: {
      es: "¿Has hecho despidos en los últimos 12 meses? Muchas ayudas exigen mantener la plantilla.",
      en: "Have you dismissed staff in the last 12 months? Many grants require keeping your headcount.",
    },
    fitSaved: { es: "Perfil de ayudas guardado", en: "Grants profile saved" },
    fitSaveError: { es: "No se pudo guardar el perfil", en: "Could not save the profile" },
    fitEditProfile: { es: "Editar perfil de ayudas", en: "Edit grants profile" },
    fitResultsCount: { es: "Hemos cruzado {n} ayudas de tu comercio.", en: "We matched {n} grants for your shop." },
    fitAnalysisEyebrow: { es: "Tu análisis de ayudas", en: "Your grant analysis" },
    fitAnalysisTitle: { es: "Te decimos cuáles encajan y por qué", en: "See which grants fit — and why" },
    fitAnalysisBody: {
      es: "Cruzamos tu negocio con cada convocatoria. Sara te explica cualquier resultado, pero la decisión final siempre corresponde al organismo oficial.",
      en: "We match your business against every call. Sara can explain any result, but the final decision always belongs to the official awarding body.",
    },
    fitFiscalRuleTitle: { es: "Primero, estar al corriente", en: "First, you must be in good standing" },
    fitFiscalRuleBody: {
      es: "Para solicitar ayudas debes estar al corriente con la Agencia Tributaria y la Seguridad Social. Un aplazamiento o fraccionamiento concedido y con los pagos al día cuenta como situación regularizada; una deuda sin acuerdo vigente bloquea la solicitud.",
      en: "To apply for grants you must be up to date with the tax office and social security. An approved payment arrangement with payments up to date counts as regularised; unsettled debt without a current agreement blocks the application.",
    },
    fitEmpty: {
      es: "Todavía no hay ayudas de tu comercio que cruzar. Revisa tu sector y tu ubicación.",
      en: "There are no grants for your shop to match yet. Check your sector and location.",
    },
    fitGroupFits: { es: "Encajan", en: "You qualify" },
    fitGroupAlmost: { es: "Casi", en: "Almost" },
    fitGroupNo: { es: "No", en: "No" },
    fitGroupMissing: { es: "Falta un dato", en: "Missing data" },
    fitGroupClosed: { es: "Cerradas", en: "Closed" },
    fitPositiveLabel: { es: "Puedes avanzar", en: "You can move forward" },
    fitNegativeLabel: { es: "Revisa antes de solicitar", en: "Review before applying" },
    fitDoesNotFit: { es: "No encajan", en: "Do not fit" },
    fitWhyYes: { es: "Por qué encaja", en: "Why it fits" },
    fitWhyNo: { es: "Por qué no encaja", en: "Why it does not fit" },
    fitNoPositive: { es: "Ahora mismo no hay ayudas que superen todos los requisitos.", en: "No grants currently pass every requirement." },
    fitNoNegative: { es: "No hay ayudas descartadas con los datos actuales.", en: "No grants are ruled out with the current details." },
    fitRecoverableAlert: { es: "Puedes activar una alerta y volver a comprobarlo cuando cambie.", en: "You can enable an alert and check again when this changes." },
    fitPrepareChecklist: { es: "Preparar esta subvención · 150 €", en: "Prepare this grant · €150" },
    fitActionsTitle: { es: "Para poder optar", en: "To be able to apply" },
    fitNextStepTitle: { es: "Siguiente paso", en: "Next step" },
    fitWeWillRemind: { es: "Te avisamos al cumplirlo.", en: "We'll email you when you meet it." },
    fitCopyFits: { es: "Cumples los requisitos estructurados de esta línea.", en: "You meet this call's structured requirements." },
    fitCopyAlmost: { es: "Casi. En esta falta: {motivo}.", en: "Almost. What's missing here: {motivo}." },
    fitCopyNoFix: {
      es: "Esta no encaja y no se arregla cambiando un dato. Mira las que sí.",
      en: "This one does not fit and no single change fixes it. Look at the ones that do.",
    },
    fitCopyNotNow: {
      es: "Hoy no: {motivo}. Cuando se cumpla, pulsa otra vez «¿Encajo en esta?».",
      en: "Not today: {motivo}. When that changes, tap “Do I qualify?” again.",
    },
    fitCopyMissing: { es: "{motivo}", en: "{motivo}" },
    fitCopyClosed: { es: "No está abierta. La dejamos en el radar.", en: "It is not open. We keep it on the radar." },
    fitViewRecord: { es: "Ver ficha", en: "View record" },
    fitAskAgent: { es: "Preguntar al agente", en: "Ask the agent" },
    fitCheckThis: { es: "¿Encajo en esta?", en: "Do I qualify for this one?" },
    fitProChecklist: { es: "Club Pro: te preparamos el checklist", en: "Club Pro: we prepare your checklist" },
    fitProPopupBody: {
      es: "Checklist y revisión humana. Sede y firma tuyas. No garantizamos concesión.",
      en: "Checklist and human review. The official filing and signature are yours. We do not guarantee any award.",
    },
    navLabel: { es: "Subvenciones y Ayudas 2026", en: "Grants & Subsidies 2026" },
    heroTitle: { es: "Subvenciones y Ayudas 2026", en: "Grants & Subsidies 2026" },
    heroSubtitle: {
      es: "Monitor actualizado de ayudas nacionales, autonómicas y locales para comercios, hostelería y servicios. Alertas personalizadas y selección de subvenciones verificadas para usuarios registrados.",
      en: "Up-to-date monitor of national, regional and local grants for shops, hospitality and services. Personalised alerts and a curated selection of verified grants for registered users.",
    },
    searchPlaceholder: { es: "Buscar por título, organismo o concepto…", en: "Search by title, body or concept…" },
    filterSector: { es: "Sector", en: "Sector" },
    filterRegion: { es: "Comunidad Autónoma", en: "Region" },
    filterProvince: { es: "Provincia", en: "Province" },
    filterCity: { es: "Ciudad", en: "City" },
    filterCityPlaceholder: { es: "Buscar municipio…", en: "Search municipality…" },
    filterStatus: { es: "Estado", en: "Status" },
    filterCountry: { es: "País", en: "Country" },
    countrySpain: { es: "España", en: "Spain" },
    countryOthersSoon: { es: "Otros países (próximamente)", en: "Other countries (coming soon)" },
    all: { es: "Todas", en: "All" },
    resultsCount: { es: "ayudas encontradas", en: "grants found" },
    noResults: { es: "No hay ayudas que encajen con estos filtros.", en: "No grants match these filters." },
    clearFilters: { es: "Limpiar filtros", en: "Clear filters" },
    mobileFilters: { es: "Filtros", en: "Filters" },
    mobileFiltersAll: { es: "Todos", en: "All" },
    mobileStep: { es: "Paso {current} de 4", en: "Step {current} of 4" },
    mobileTabCatalog: { es: "Catálogo", en: "Catalogue" },
    mobileTabSector: { es: "Tu sector", en: "Your sector" },
    mobileTabFit: { es: "¿Encajo?", en: "Do I fit?" },
    mobilePreviousPhase: { es: "Fase anterior", en: "Previous stage" },
    mobileNextPhase: { es: "Siguiente fase", en: "Next stage" },
    fitProgress: { es: "{done} de 7 bloques completos", en: "{done} of 7 sections complete" },
    seoByRegion: { es: "Ayudas a Fondo Perdido por Comunidad Autónoma", en: "Non-repayable Grants by Region" },
    seoBySector: { es: "Subvenciones por Sector de Actividad", en: "Grants by Business Sector" },
    seoOpenCalls: { es: "Convocatorias Abiertas", en: "Open Calls" },
    seoOtherCalls: { es: "Próximas y Cerradas", en: "Upcoming and Closed" },
    seoSheetTitle: { es: "Ficha Técnica de la Convocatoria", en: "Call Fact Sheet" },
    seoAmountTitle: { es: "Importe y Beneficiarios", en: "Amount and Beneficiaries" },
    seoRequirementsTitle: { es: "Requisitos y Solicitud", en: "Requirements and Application" },
    organismo: { es: "Organismo", en: "Awarding body" },
    ambito: { es: "Ámbito", en: "Scope" },
    importe: { es: "Importe", en: "Amount" },
    estado: { es: "Estado", en: "Status" },
    beneficiarios: { es: "Beneficiarios", en: "Beneficiaries" },
    categoria: { es: "Categoría", en: "Category" },
    presupuesto: { es: "Presupuesto", en: "Budget" },
    modalidad: { es: "Modalidad", en: "Type" },
    plazos: { es: "Plazos de solicitud", en: "Application dates" },
    fechaInicio: { es: "Apertura", en: "Opens" },
    fechaFin: { es: "Cierre", en: "Closes" },
    periodoGastos: { es: "Periodo de gastos elegibles", en: "Eligible expense period" },
    condiciones: { es: "Requisitos y condiciones", en: "Requirements and conditions" },
    enlace: { es: "Enlace oficial de solicitud", en: "Official application link" },
    enlaceCta: { es: "Ir a la convocatoria oficial", en: "Go to the official call" },
    notas: { es: "Notas del mentor", en: "Mentor notes" },
    sectores: { es: "Sectores a los que aplica", en: "Applicable sectors" },
    verFicha: { es: "Ver ficha", en: "View grant" },
    backToHub: { es: "Volver a subvenciones", en: "Back to grants" },
    badgeNueva: { es: "Nueva", en: "New" },
    badgeActualizada: { es: "Actualizada esta semana", en: "Updated this week" },
    lockedTitle: { es: "Contenido exclusivo del Club Pro", en: "Club Pro exclusive content" },
    proExclusiveUsers: {
      es: "Contenido exclusivo para usuarios del Club Pro",
      en: "Exclusive content for Club Pro members",
    },
    guestLockedTitle: { es: "Acceso anticipado a Subvenciones", en: "Early access to Grants" },
    guestLockedBody: {
      es: "El catálogo está abierto. Únete a la lista de acceso anticipado y te avisaremos cuando abramos, con una promoción para entrar.",
      en: "The catalogue is open. Join the early access list and we'll notify you when we launch, with a launch offer.",
    },
    guestRegisterCta: { es: "Unirme al acceso anticipado", en: "Join early access" },
    detailGuestLockedTitle: {
      es: "Acceso anticipado a la ficha completa",
      en: "Early access to full grant profile",
    },
    detailGuestLockedBody: {
      es: "Únete a la lista de acceso anticipado para ver plazos oficiales, requisitos y el estudio de viabilidad para tu comercio cuando abramos.",
      en: "Join the early access list to see official deadlines, requirements and the viability study for your business when we launch.",
    },
    detailGuestLockedNote: {
      es: "La información pública queda visible para orientarte.",
      en: "Public information remains visible to guide you.",
    },
    alertsGuestTitle: { es: "Recibe las ayudas que encajan contigo", en: "Get grants that match your business" },
    alertsGuestBody: {
      es: "Únete a la lista de acceso anticipado para ver el catálogo y descubrir cómo funcionan las alertas personalizadas.",
      en: "Join the early access list to browse the catalogue and discover personalised alerts.",
    },
    lockedCta: {
      es: "Acceder al Club Pro – 69 €/mes",
      en: "Get Club Pro – €69/month",
    },
    lockedNote: {
      es: "Incluye selección inteligente por sector, alertas de nuevas ayudas, estudio de viabilidad y seguimiento.",
      en: "Includes smart sector matching, new-grant alerts, eligibility checks and tracking.",
    },
    lockedBody: {
      es: "Club Pro selecciona las mejores ayudas para tu comercio, activa alertas y cruza tus datos para saber si puedes pedirlas.",
      en: "Club Pro selects the best grants for your business, activates alerts and checks your data to see whether you can apply.",
    },
    verificado: { es: "Verificado el", en: "Verified on" },
    fuente: { es: "Fuente", en: "Source" },
    disclaimer: {
      es: "Información orientativa elaborada a partir de fuentes oficiales. Verifica siempre las bases de la convocatoria antes de solicitar.",
      en: "Guidance compiled from official sources. Always check the official call terms before applying.",
    },
    // Panel privado
    panelTitle: { es: "Subvenciones y Ayudas", en: "Grants & Subsidies" },
    planBadge: { es: "Listado desde Básico · Las que encajan contigo desde Club Pro", en: "Directory from Basic · Grants that fit you from Club Pro" },
    panelSubtitle: {
      es: "Ayudas activas filtradas para tu comercio, y el catálogo completo cuando quieras explorar.",
      en: "Active grants filtered for your business, plus the full catalogue whenever you want to explore.",
    },
    tabForYou: { es: "Para tu sector", en: "For your sector" },
    tabCatalog: { es: "Catálogo completo", en: "Full catalogue" },
    tabTracking: { es: "Solicitadas", en: "Applied" },
    funnelHint: { es: "Avanza desde el catálogo hasta el seguimiento", en: "Move from the catalogue to tracking" },
    trackingMarkSubmitted: { es: "Marcar como solicitada", en: "Mark as applied" },
    trackingTitle: { es: "Seguimiento de esta ayuda", en: "Track this grant" },
    trackingDescription: { es: "Actualiza cómo va y guarda una nota privada para no perder ningún detalle.", en: "Update its progress and save a private note so you do not lose any detail." },
    trackingStatusLabel: { es: "Estado de la solicitud", en: "Application status" },
    trackingStatus_submitted: { es: "Solicitada", en: "Applied" },
    trackingStatus_approved: { es: "Concedida", en: "Awarded" },
    trackingStatus_rejected: { es: "Rechazada", en: "Rejected" },
    trackingNoteLabel: { es: "Mi nota", en: "My note" },
    trackingNotePlaceholder: { es: "Ej.: presentada el 18/09, falta aportar el certificado…", en: "E.g. applied on 18/09, certificate still pending…" },
    trackingSave: { es: "Guardar seguimiento", en: "Save tracking" },
    trackingSaved: { es: "Seguimiento guardado", en: "Tracking saved" },
    trackingError: { es: "No se pudo guardar el seguimiento", en: "Could not save tracking" },
    trackingRemove: { es: "Quitar del seguimiento", en: "Remove from tracking" },
    trackingRemoved: { es: "Ayuda eliminada del seguimiento", en: "Grant removed from tracking" },
    trackingEmpty: { es: "Todavía no has marcado ninguna ayuda como solicitada.", en: "You have not marked any grant as applied yet." },
    trackingSubmittedOn: { es: "Marcada el {date}", en: "Marked on {date}" },
    trackingAll: { es: "Todas", en: "All" },
    trackingFilterLabel: { es: "Filtrar solicitudes", en: "Filter applications" },
    profileIncomplete: {
      es: "Añade el sector de tu comercio en el perfil para filtrar automáticamente las ayudas que te encajan.",
      en: "Add your business sector in your profile so we can filter the grants that fit you automatically.",
    },
    goToProfile: { es: "Completar mi perfil", en: "Complete my profile" },
    noMatches: {
      es: "Ahora mismo no hay ayudas abiertas para tu sector y comunidad. Te avisaremos en cuanto salga una.",
      en: "There are no open grants for your sector and region right now. We'll notify you as soon as one appears.",
    },
    proBannerTitle: { es: "Requisitos y periodos de gasto con Club Pro", en: "Requirements and expense periods with Club Pro" },
    proBanner: {
      es: "Pásate a Club Pro (69 €/mes) para recibir asesoramiento en la preparación de documentos.",
      en: "Upgrade to Club Pro (€69/month) to get support preparing your documentation.",
    },
    proBannerCta: { es: "Activar Club Pro", en: "Activate Club Pro" },
    yourSector: { es: "Tu sector", en: "Your sector" },
    yourRegion: { es: "Tu comunidad", en: "Your region" },
    addRegionHint: {
      es: "Añade tu comunidad autónoma para afinar los resultados",
      en: "Add your region to refine these results",
    },
    searchOfficialCta: { es: "Buscar la convocatoria oficial", en: "Find the official call" },
    sourceReference: { es: "Referencia", en: "Reference" },
    regionLabel: { es: "Comunidad Autónoma", en: "Region" },
    regionPlaceholder: { es: "Selecciona tu comunidad", en: "Select your region" },
    locationSourceLabel: { es: "Ubicación según", en: "Location based on" },
    locationSourceStores: { es: "Mis locales", en: "My stores" },
    locationSourceFiscal: { es: "Dirección fiscal", en: "Registered address" },
    allStores: { es: "Todos mis locales", en: "All my stores" },
    updatedLabel: { es: "🟢 Actualizado: {month} {year}", en: "🟢 Updated: {month} {year}" },
    territoryDetected: { es: "Territorio", en: "Territory" },
    noLocationTitle: { es: "Falta tu ubicación", en: "Location missing" },
    noLocationBody: {
      es: "Para no mostrarte ayudas de otras comunidades necesitamos saber dónde está tu comercio. Añade tu local o completa tu dirección fiscal.",
      en: "To avoid showing grants from other regions we need to know where your business is. Add your store or complete your registered address.",
    },
    addStoreCta: { es: "Añadir mi local", en: "Add my store" },
    addFiscalCta: { es: "Completar dirección fiscal", en: "Complete registered address" },
    fiscalTitle: { es: "Dirección fiscal", en: "Registered address" },
    fiscalIntro: {
      es: "Usamos estos datos para tus facturas y para filtrar las ayudas de tu territorio. Se sincronizan con el portal de pagos.",
      en: "We use this data for your invoices and to filter grants for your territory. It syncs with the payment portal.",
    },
    fiscalCompany: { es: "Empresa o nombre fiscal", en: "Company or legal name" },
    fiscalTaxId: { es: "NIF / CIF / VAT", en: "Tax ID / VAT" },
    fiscalLine1: { es: "Dirección", en: "Address" },
    fiscalLine2: { es: "Dirección (línea 2)", en: "Address (line 2)" },
    fiscalPostal: { es: "Código postal", en: "Postal code" },
    fiscalCity: { es: "Ciudad", en: "City" },
    fiscalProvince: { es: "Provincia", en: "Province" },
    fiscalCountry: { es: "País", en: "Country" },
    fiscalSave: { es: "Guardar dirección fiscal", en: "Save registered address" },
    fiscalSaved: { es: "Dirección fiscal guardada", en: "Registered address saved" },
    fiscalError: { es: "No se pudo guardar la dirección fiscal", en: "Could not save the registered address" },
    fiscalAutofill: { es: "Provincia y comunidad se completan desde el código postal.", en: "Province and region are filled from the postal code." },

    // Hub alerts / conversion
    verifiedStatus: { es: "Base de datos verificada y actualizada a {month} {year}", en: "Verified database updated to {month} {year}" },
    alertButton: { es: "Activar alertas para mi sector", en: "Activate alerts for my sector" },
    alertModalTitle: { es: "Alertas exclusivas para Club Pro", en: "Exclusive alerts for Club Pro" },
    alertModalBody: {
      es: "Recibe un aviso instantáneo en tu correo electrónico en cuanto se publique una ayuda para tu sector o comunidad. El 80% de los fondos se agotan en la primera semana. Adelántate y no te quedes sin tu ayuda.",
      en: "Get an instant email alert as soon as a grant for your sector or region is published. 80% of funds run out in the first week. Stay ahead and don't miss your grant.",
    },
    alertModalCta: { es: "Suscribirme a PRO", en: "Subscribe to PRO" },
    alertModalLater: { es: "Quizás más tarde", en: "Maybe later" },
    alertEnabled: { es: "Alertas activadas", en: "Alerts enabled" },
    alertDisabled: { es: "Alertas desactivadas", en: "Alerts disabled" },
    alertToggleLabel: {
      es: "Recibir alertas por email para mi sector",
      en: "Receive email alerts for my sector",
    },
    alertToggleHint: {
      es: "Te avisamos en cuanto se publique una ayuda que encaje con tu comercio.",
      en: "We'll notify you as soon as a grant matching your business is published.",
    },
    alertProOnlyTitle: { es: "Reservado al Club Pro", en: "Club Pro only" },
    alertProOnlyBody: {
      es: "Únete al Club Pro para seleccionar las mejores para ti, activar alertas y comprobar si puedes pedirlas.",
      en: "Join Club Pro to select the best grants for you, activate alerts and check whether you can apply.",
    },
    alertProOnlyCta: { es: "Club Pro · 69 €/mes", en: "Club Pro · €69/month" },

    // Público que genera deseo / Club Pro que informa
    badgePrioridad: { es: "Prioridad alta", en: "High priority" },
    publicProHint: { es: "Ficha pública disponible. La información completa se desbloquea con acceso anticipado.", en: "Public record available. Full details unlock with early access." },
    badgeCerrada: { es: "Convocatoria cerrada", en: "Call closed" },
    closedLead: {
      es: "Cerrada por ahora. Te avisamos en cuanto se reabra o salga una equivalente.",
      en: "Closed for now. We'll alert you as soon as it reopens or an equivalent one is published.",
    },

    mentorRecommendation: { es: "Recomendación del mentor", en: "Mentor recommendation" },
    firstComeWarning: {
      es: "Por orden de llegada o hasta agotar fondos: cuanto antes solicites, más posibilidades tienes.",
      en: "First-come, first-served or until funds run out: apply as early as you can.",
    },
    proIntroTitle: { es: "Hemos priorizado y filtrado las mejores ayudas para ti", en: "We've prioritised and filtered the best grants for you" },
    proIntroBody: {
      es: "Selección para tu sector y tu ubicación. Las de Prioridad Alta aparecen primero.",
      en: "A selection for your sector and location. High priority grants appear first.",
    },
    sortLabel: { es: "Ordenar por", en: "Sort by" },
    sortPrioridad: { es: "Prioridad", en: "Priority" },
    sortCierre: { es: "Fecha de cierre", en: "Closing date" },
    sortImporte: { es: "Importe", en: "Amount" },
    sortVerificacion: { es: "Verificación reciente", en: "Recently verified" },
    filterGasto: { es: "Tipo de gasto", en: "Expense type" },
    gastoEquipos: { es: "Equipos y maquinaria", en: "Equipment" },
    gastoPersonal: { es: "Personal y contratación", en: "Staff and hiring" },
    gastoReformas: { es: "Reformas y obra", en: "Refurbishment" },
    gastoDigitalizacion: { es: "Digitalización", en: "Digitalisation" },
    gastoAlquiler: { es: "Alquiler", en: "Rent" },
    gastoOtros: { es: "Otros", en: "Other" },
    filterUrgencia: { es: "Urgencia", en: "Urgency" },
    urgenciaUrgente: { es: "Cierra en 15 días", en: "Closes in 15 days" },
    urgenciaProximo: { es: "Cierra en 45 días", en: "Closes in 45 days" },
    urgenciaSinPrisa: { es: "Sin prisa", en: "No rush" },
    urgenciaSinFecha: { es: "Sin fecha definida", en: "No date set" },
    markInteresting: { es: "Interesante", en: "Interesting" },
    markDiscarded: { es: "Descartada", en: "Discarded" },
    filterMarks: { es: "Mis marcas", en: "My marks" },
    marksAll: { es: "Todas", en: "All" },
    marksInteresting: { es: "Solo interesantes", en: "Interesting only" },
    marksDiscarded: { es: "Solo descartadas", en: "Discarded only" },

    // Panel — vista personalizada y catálogo
    forYouBannerTitle: { es: "Subvenciones recomendadas para tu negocio", en: "Grants recommended for your business" },
    forYouBannerSubtext: { es: "Filtrado según tu perfil: {profile}", en: "Filtered by your profile: {profile}" },
    editProfile: { es: "Editar perfil", en: "Edit profile" },
    alertsSectorLabel: { es: "Alertas por email para mi sector", en: "Email alerts for my sector" },

    // Pop-up de alertas (Club Pro)
    alertsPanelButton: { es: "Alertas por email", en: "Email alerts" },
    alertsNewLabel: { es: "Nuevas ayudas para mi sector", en: "New grants for my sector" },
    alertsNewHint: {
      es: "Te avisamos cuando se publica una convocatoria que encaja con tu sector y tu zona.",
      en: "We email you when a call matching your sector and area is published.",
    },
    alertsReminderLabel: { es: "Recordatorio de mis ayudas marcadas", en: "Reminder of my marked grants" },
    alertsReminderHint: {
      es: "Repaso de las ayudas que marcaste como «Me interesa», avisando de las que van a cerrar.",
      en: "A recap of the grants you marked as “Interesting”, flagging the ones about to close.",
    },
    alertsHourLabel: { es: "Hora de envío", en: "Sending time" },
    alertsTzLabel: { es: "Zona horaria", en: "Time zone" },
    alertsDayLabel: { es: "Día del recordatorio", en: "Reminder day" },
    alertsDayEveryDay: { es: "Todos los días", en: "Every day" },
    alertsEmailLabel: { es: "Enviar a otro email (sustituye al de la cuenta)", en: "Send to another email (replaces the account one)" },
    alertsEmailPlaceholder: { es: "otro@email.com", en: "other@email.com" },
    alertsSave: { es: "Guardar", en: "Save" },
    alertsSaved: { es: "Guardado", en: "Saved" },
    alertsSaveError: { es: "No se pudo guardar", en: "Could not save" },
    alertsInvalidEmail: { es: "Email no válido", en: "Invalid email" },
    alertsTestNew: { es: "Probar nuevas ayudas", en: "Test new grants" },
    alertsTestReminder: { es: "Probar recordatorio", en: "Test reminder" },
    alertsTestSent: { es: "Prueba enviada. Revisa tu bandeja de entrada.", en: "Test sent. Check your inbox." },
    alertsTestError_no_email: { es: "Añade un email para enviar la prueba.", en: "Add an email to send the test." },
    alertsTestError_recipient_suppressed: { es: "Ese email no puede recibir mensajes. Prueba con otro.", en: "That email cannot receive messages. Try another one." },
    alertsTestError_rate_limited: { es: "Espera 5 minutos antes de enviar otra prueba.", en: "Wait 5 minutes before sending another test." },
    alertsTestError_delivery_unavailable: { es: "El envío de emails todavía no está disponible. Inténtalo más tarde.", en: "Email delivery is not available yet. Try again later." },
    weekdayMonday: { es: "Lunes", en: "Monday" },
    weekdayTuesday: { es: "Martes", en: "Tuesday" },
    weekdayWednesday: { es: "Miércoles", en: "Wednesday" },
    weekdayThursday: { es: "Jueves", en: "Thursday" },
    weekdayFriday: { es: "Viernes", en: "Friday" },
    weekdaySaturday: { es: "Sábado", en: "Saturday" },
    weekdaySunday: { es: "Domingo", en: "Sunday" },

    // Pestaña "Para ti" bloqueada en Lite
    forYouLockedTitle: { es: "Filtrado y alertas del Club Pro", en: "Club Pro filtering and alerts" },
    forYouLockedBody: {
      es: "Con el Club Pro ves todas las ayudas de tu sector y tu zona, las marcas como interesantes y recibes avisos antes de que cierren.",
      en: "With Club Pro you see every grant for your sector and area, mark the interesting ones and get alerts before they close.",
    },
    forYouLockedSample: {
      es: "Vista de muestra: estas son 2 de las {n} ayudas que encajan con tu comercio.",
      en: "Sample view: these are 2 of the {n} grants that match your business.",
    },
    quickSearchPlaceholder: { es: "Buscar por palabra clave…", en: "Search by keyword…" },
    catalogCount: { es: "Mostrando {n} ayudas encontradas en el catálogo general", en: "Showing {n} grants found in the general catalogue" },
    filterLocation: { es: "Ubicación", en: "Location" },
    filterCategory: { es: "Tipo de gasto / Categoría", en: "Expense type / Category" },
    statusAll: { es: "Todas", en: "All" },
    statusOpen: { es: "Abiertas", en: "Open" },
    statusUpcoming: { es: "Próxima apertura", en: "Opening soon" },
    statusClosingSoon: { es: "Próximo cierre", en: "Closing soon" },
    badgeProximaApertura: { es: "Próxima apertura", en: "Opening soon" },
    badgeAbierta: { es: "Abierta", en: "Open" },
    badgeUltimosDias: { es: "Últimos días", en: "Final days" },
    amountUpTo: { es: "Hasta {amount}", en: "Up to {amount}" },
    fullyFunded: { es: "100% subv.", en: "100% funded" },
    opensOn: { es: "Abre el {date}", en: "Opens on {date}" },
    opensInDays: { es: "Abre en {n} días", en: "Opens in {n} days" },
    closesOn: { es: "Cierra el {date}", en: "Closes on {date}" },
    closesInDays: { es: "Quedan {n} días", en: "{n} days left" },
    toggleDetails: { es: "Ver detalles", en: "View details" },
    viewDetail: { es: "Ver detalle", en: "View details" },
    hideDetail: { es: "Ocultar detalle", en: "Hide details" },
    amountMissing: { es: "Consultar cuantía", en: "Check amount" },
    eligibleInvestment: { es: "Inversión elegible", en: "Eligible investment" },
    officialBasesCta: { es: "Ver bases oficiales", en: "View official terms" },
    pillAll: { es: "Todas", en: "All" },
    pillInteresting: { es: "Interesantes", en: "Interesting" },
    pillUrgent: { es: "Urgentes", en: "Urgent" },
    pillDiscarded: { es: "Descartadas", en: "Discarded" },
    tooltipMarkInteresting: { es: "Marcar como interesante", en: "Mark as interesting" },
    tooltipUnmarkInteresting: { es: "Quitar de interesantes", en: "Remove from interesting" },
    tooltipDiscard: { es: "Descartar esta ayuda", en: "Discard this grant" },
    tooltipRestore: { es: "Restaurar esta ayuda", en: "Restore this grant" },
    restoreGrant: { es: "Restaurar", en: "Restore" },
    actionMarkInteresting: { es: "Guardar como interesante", en: "Save as interesting" },
    actionDiscard: { es: "Descartar", en: "Discard" },
    actionRestore: { es: "Restaurar", en: "Restore" },
    emptyInteresting: { es: "Aún no has marcado ninguna ayuda como interesante.", en: "You haven't marked any grant as interesting yet." },
    emptyUrgent: { es: "No hay ayudas que cierren en los próximos 15 días.", en: "No grants closing within the next 15 days." },
    emptyDiscarded: { es: "No has descartado ninguna ayuda.", en: "You haven't discarded any grant." },
    intensityLabel: { es: "Cuantía e intensidad", en: "Amount & funding intensity" },
    intensityFull: { es: "100% subvencionable", en: "100% funded" },
    intensityUpTo: { es: "Hasta el {pct}", en: "Up to {pct}" },
    copyLink: { es: "Copiar enlace público", en: "Copy public link" },
    copied: { es: "¡Copiado!", en: "Copied!" },
    sourceLabel: { es: "Fuente", en: "Source" },
    advisoryCta: { es: "Pedir asesoría con esta subvención", en: "Request help with this grant" },
    advisoryTitle: { es: "Solicitar información o ayuda", en: "Request information or help" },
    advisoryDesc: {
      es: "Cuéntanos tu caso y el equipo de Retail Lemon lo revisa para decirte si encaja y cómo presentarla.",
      en: "Tell us about your case and the Retail Lemon team will review whether it fits and how to apply.",
    },
    advisoryPlaceholder: {
      es: "Ej.: tengo una panadería en Sevilla y quiero renovar el obrador...",
      en: "E.g.: I run a bakery in Seville and want to renovate the workshop...",
    },
    advisorySend: { es: "Enviar solicitud", en: "Send request" },
    advisorySending: { es: "Enviando solicitud...", en: "Sending request..." },
    advisorySent: {
      es: "¡Solicitud enviada! El equipo de mentoría de Retail Lemon revisará tu caso y se pondrá en contacto contigo.",
      en: "Request sent! The Retail Lemon mentoring team will review your case and get in touch with you.",
    },
    advisoryError: { es: "No hemos podido enviar tu solicitud. Inténtalo de nuevo.", en: "We couldn't send your request. Please try again." },


  },

  // ── Envío de Casos Reales ──
  realCaseSubmit: {
    successTitle: { es: "¡Gracias por enviar tu caso!", en: "Thank you for sending your case!" },
    successReview: {
      es: "Tu vídeo será revisado por nuestro equipo. Si cumple con nuestras condiciones de uso y políticas de publicación, será aprobado y publicado próximamente.",
      en: "Your video will be reviewed by our team. If it meets our terms of use and publishing policies, it will be approved and published soon.",
    },
    successNotify: {
      es: "Te avisaremos por correo electrónico en cuanto tu caso esté publicado.",
      en: "We'll notify you by email as soon as your case is published.",
    },
    prizeBadgeTitle: { es: "💡 ¡Tu vídeo puede tener premio!", en: "💡 Your video could win a prize!" },
    prizeBadgeBody: {
      es: "Los mejores vídeos publicados participarán en la selección de la comunidad y podrán ganar de 1 a 6 meses de suscripción gratuita.",
      en: "The best published videos will enter the community selection and can win from 1 to 6 months of free subscription.",
    },
    close: { es: "Cerrar", en: "Close" },
  },
} as const;

export type TranslationKey = keyof typeof translations;


